import {useMutation as $iPNDK$useMutation, useQuery as $iPNDK$useQuery, useInfiniteQuery as $iPNDK$useInfiniteQuery, useQueryClient as $iPNDK$useQueryClient, useQueries as $iPNDK$useQueries} from "react-query";
import {jsx as $iPNDK$jsx} from "react/jsx-runtime";
import $iPNDK$react, {createContext as $iPNDK$createContext, useState as $iPNDK$useState, useCallback as $iPNDK$useCallback, useMemo as $iPNDK$useMemo, useEffect as $iPNDK$useEffect} from "react";
import $iPNDK$dayjs from "dayjs";
import $iPNDK$dayjspluginadvancedFormat from "dayjs/plugin/advancedFormat";
import $iPNDK$dayjsplugincustomParseFormat from "dayjs/plugin/customParseFormat";
import $iPNDK$dayjspluginrelativeTime from "dayjs/plugin/relativeTime";
import $iPNDK$dayjsplugintimezone from "dayjs/plugin/timezone";
import $iPNDK$dayjspluginutc from "dayjs/plugin/utc";
import {Formik as $iPNDK$Formik} from "formik";
import {object as $iPNDK$object, string as $iPNDK$string, boolean as $iPNDK$boolean, number as $iPNDK$number, array as $iPNDK$array, bool as $iPNDK$bool, date as $iPNDK$date, ref as $iPNDK$ref} from "yup";
import {isValidPhoneNumber as $iPNDK$isValidPhoneNumber, parsePhoneNumber as $iPNDK$parsePhoneNumber, isPossiblePhoneNumber as $iPNDK$isPossiblePhoneNumber, getCountries as $iPNDK$getCountries, getCountryCallingCode as $iPNDK$getCountryCallingCode, isSupportedCountry as $iPNDK$isSupportedCountry} from "libphonenumber-js";
import $iPNDK$bigjs from "big.js";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $6a5610d21c7de291$exports = {};
var $363f6af70c77384a$exports = {};

$parcel$export($363f6af70c77384a$exports, "useCustomMessageMutation", () => $363f6af70c77384a$export$67934ae0be5ada9e);
var $1980288893925d89$exports = {};

$parcel$export($1980288893925d89$exports, "useAppMutation", () => $1980288893925d89$export$b3678598e95ca24f);

var $581d20e8b41cc3bb$exports = {};

$parcel$export($581d20e8b41cc3bb$exports, "QueryContext", () => $581d20e8b41cc3bb$export$a0101e127fc31d1d);
$parcel$export($581d20e8b41cc3bb$exports, "useQueryContext", () => $581d20e8b41cc3bb$export$919315ccd62888e6);
$parcel$export($581d20e8b41cc3bb$exports, "QueryContextProvider", () => $581d20e8b41cc3bb$export$96e4d538f00fbce1);


const $581d20e8b41cc3bb$export$a0101e127fc31d1d = /*#__PURE__*/ (0, $iPNDK$react).createContext(null);
const $581d20e8b41cc3bb$export$919315ccd62888e6 = ()=>{
    const context = (0, $iPNDK$react).useContext($581d20e8b41cc3bb$export$a0101e127fc31d1d);
    if (!context) throw new Error("useQueryContext must be used within a QueryContext provider");
    return context;
};
const $581d20e8b41cc3bb$export$96e4d538f00fbce1 = ({ children: children , isOffline: isOffline , onErrorToast: onErrorToast , onSuccessToast: onSuccessToast , queryFn: queryFn  })=>{
    // Since these are functions they will cause re-renders on each app re-render
    // https://dmitripavlutin.com/dont-overuse-react-usecallback/
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoErrorToast = (0, $iPNDK$react).useCallback(onErrorToast, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoSuccessToast = (0, $iPNDK$react).useCallback(onSuccessToast, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoQueryFn = (0, $iPNDK$react).useCallback(queryFn, []);
    const value = (0, $iPNDK$react).useMemo(()=>({
            isOffline: isOffline,
            onErrorToast: memoErrorToast,
            onSuccessToast: memoSuccessToast,
            queryFn: memoQueryFn
        }), [
        isOffline,
        memoQueryFn,
        memoErrorToast,
        memoSuccessToast
    ]);
    return /*#__PURE__*/ (0, $iPNDK$jsx)($581d20e8b41cc3bb$export$a0101e127fc31d1d.Provider, {
        value: value,
        children: children
    });
};


const $1980288893925d89$export$b3678598e95ca24f = ({ url: url , method: method , isCustomSendData: isCustomSendData = false , isSubform: isSubform = false , onSuccess: onSuccess = ()=>undefined , onError: onError = ()=>undefined , onSettled: onSettled = ()=>undefined , onMutate: onMutate = ()=>undefined , hasToastsEnabled: hasToastsEnabled = true , mutationKey: mutationKey , hasSuccessToastEnabled: hasSuccessToastEnabled = true , hasErrorToastEnabled: hasErrorToastEnabled = true , modifySendDataFn: modifySendDataFn  })=>{
    const { isOffline: isOffline , onSuccessToast: onSuccessToast , onErrorToast: onErrorToast , queryFn: queryFn  } = (0, $581d20e8b41cc3bb$export$919315ccd62888e6)();
    return (0, $iPNDK$useMutation)((values)=>{
        const sendData = modifySendDataFn ? modifySendDataFn(values) : values;
        const sendUrl = typeof url === "string" ? url : url(...values?.urlArgs);
        return queryFn(sendUrl, {
            values: sendData,
            method: method,
            isOffline: isOffline,
            isSubform: isSubform,
            isCustomSendData: isCustomSendData
        });
    }, {
        mutationKey: mutationKey,
        onSuccess: (response, variables)=>{
            if (hasToastsEnabled && hasSuccessToastEnabled) onSuccessToast(response);
            return onSuccess(response, variables);
        },
        onError: (response, variables, context)=>{
            if (hasToastsEnabled && hasErrorToastEnabled) onErrorToast(response);
            return onError(response, variables, context);
        },
        onSettled: (data, error, variables, context)=>{
            return onSettled(data, error, variables, context);
        },
        onMutate: (response)=>{
            onMutate(response);
        }
    });
};


var $2026a49d34582011$exports = {};

$parcel$export($2026a49d34582011$exports, "bookingEndpoint", () => $2026a49d34582011$export$4eff5337e639f954);
$parcel$export($2026a49d34582011$exports, "bookingQuoteEndpoint", () => $2026a49d34582011$export$be4ce9f65a783fe3);
$parcel$export($2026a49d34582011$exports, "bookingNotesEndpoint", () => $2026a49d34582011$export$fe72c2cca9c0efc0);
$parcel$export($2026a49d34582011$exports, "reviewPublishEndPoint", () => $2026a49d34582011$export$cd47697ca6b0c965);
$parcel$export($2026a49d34582011$exports, "reviewDisputeEndpoint", () => $2026a49d34582011$export$7a9d8f51f9e82763);
$parcel$export($2026a49d34582011$exports, "reviewResponseEndpoint", () => $2026a49d34582011$export$502a2dc2cf1f85f2);
$parcel$export($2026a49d34582011$exports, "bookingEmailEndpoint", () => $2026a49d34582011$export$77dfc151169acd17);
$parcel$export($2026a49d34582011$exports, "bookingcustomMessageEndpoint", () => $2026a49d34582011$export$cdb91b539d7cd16);
$parcel$export($2026a49d34582011$exports, "generateBookingEmailEndpoint", () => $2026a49d34582011$export$fa1702fe7cb16046);
$parcel$export($2026a49d34582011$exports, "generateBookingCancellationDetailEndpoint", () => $2026a49d34582011$export$9e5d0db7a2a8bc81);
$parcel$export($2026a49d34582011$exports, "generateQuoteEndPoint", () => $2026a49d34582011$export$cfbf8165a63f0c4d);
$parcel$export($2026a49d34582011$exports, "generateBookingContactTracingEndpoint", () => $2026a49d34582011$export$4eeb9e22ca0d3a6e);
$parcel$export($2026a49d34582011$exports, "generateBookingNotesEndpoint", () => $2026a49d34582011$export$eee602f57fd7f01e);
$parcel$export($2026a49d34582011$exports, "generateBookingPropertyGuidebook", () => $2026a49d34582011$export$dfed71235557e883);
$parcel$export($2026a49d34582011$exports, "generateBookingPropertyGuidebookBinaryEndpoint", () => $2026a49d34582011$export$7a3b2809807a6102);
$parcel$export($2026a49d34582011$exports, "generateBookingGuestExists", () => $2026a49d34582011$export$d5f69b706430230d);
const $2026a49d34582011$export$4eff5337e639f954 = "/RESTAUTH/booking/";
const $2026a49d34582011$export$be4ce9f65a783fe3 = "/RESTAUTH/booking/quote/";
const $2026a49d34582011$export$fe72c2cca9c0efc0 = "/RESTAUTH/booking/notes/";
const $2026a49d34582011$export$cd47697ca6b0c965 = "/RESTAUTH/booking/review/publish/";
const $2026a49d34582011$export$7a9d8f51f9e82763 = "/RESTAUTH/booking/review/dispute/";
const $2026a49d34582011$export$502a2dc2cf1f85f2 = "/RESTAUTH/booking/review/response/";
const $2026a49d34582011$export$77dfc151169acd17 = `/RESTAUTH/booking/email/`;
const $2026a49d34582011$export$cdb91b539d7cd16 = "/RESTAUTH/booking/custommessage/";
const $2026a49d34582011$export$fa1702fe7cb16046 = (reservationId, emailTemplate, cc_emails = "")=>{
    return `${$2026a49d34582011$export$77dfc151169acd17}?id=${reservationId}&email_template=${emailTemplate}&cc_emails=${cc_emails}`;
};
const $2026a49d34582011$export$9e5d0db7a2a8bc81 = (bookingId)=>`/RESTAUTH/booking/cancellationDetails/?id=${bookingId}`;
const $2026a49d34582011$export$cfbf8165a63f0c4d = ()=>`/RESTAUTH/booking/quote/`;
const $2026a49d34582011$export$4eeb9e22ca0d3a6e = ()=>`/RESTAUTH/booking/contacttracing/`;
const $2026a49d34582011$export$eee602f57fd7f01e = (notesParamString)=>`/RESTAUTH/booking/notes?${notesParamString}`;
const $2026a49d34582011$export$dfed71235557e883 = (ownerId)=>{
    return `/RESTAUTH/booking/propertyguidebook/?id=${ownerId}`;
};
const $2026a49d34582011$export$7a3b2809807a6102 = ({ bookingId: bookingId  })=>`/RESTAUTH/booking/propertyguidebook/pdf/binary/?id=${bookingId}`;
const $2026a49d34582011$export$d5f69b706430230d = (guestEmail)=>{
    return `/RESTAUTH/booking/guest/exists/?email=${guestEmail}`;
};


const $363f6af70c77384a$export$67934ae0be5ada9e = (args)=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $2026a49d34582011$export$cdb91b539d7cd16),
        method: "PUT",
        ...args
    });
};


var $616614d9d4651c1d$exports = {};

$parcel$export($616614d9d4651c1d$exports, "useBookingGuestExistsQuery", () => $616614d9d4651c1d$export$5809f48c0e16e123);
var $db8cb6799be9e216$exports = {};

$parcel$export($db8cb6799be9e216$exports, "useAppQuery", () => $db8cb6799be9e216$export$bbc6c3c0724463f0);


function $db8cb6799be9e216$export$bbc6c3c0724463f0({ endpoint: endpoint , enabled: enabled = true , select: select , onSuccess: onSuccess = (_data)=>undefined , onError: onError = (_err)=>undefined , onSettled: onSettled = (_data, _error)=>undefined , staleTime: staleTime , cacheTime: cacheTime , retry: retry = 3 , refetchOnWindowFocus: refetchOnWindowFocus , queryKey: queryKey , refetchInterval: refetchInterval = false , hasToastsEnabled: hasToastsEnabled = true , useErrorBoundary: useErrorBoundary = false , keepPreviousData: keepPreviousData = false  }) {
    const { isOffline: isOffline , onSuccessToast: onSuccessToast , onErrorToast: onErrorToast , queryFn: queryFn  } = (0, $581d20e8b41cc3bb$export$919315ccd62888e6)();
    return (0, $iPNDK$useQuery)({
        queryKey: queryKey ?? endpoint,
        queryFn: ()=>{
            return queryFn(endpoint, {
                isOffline: isOffline
            });
        },
        enabled: enabled,
        select: select,
        onSuccess: (data)=>{
            onSuccess(data);
            if (hasToastsEnabled) onSuccessToast(data);
        },
        onError: (err)=>{
            onError(err);
            if (hasToastsEnabled) onErrorToast(err);
        },
        onSettled: (data, error)=>{
            onSettled(data, error);
        },
        staleTime: staleTime,
        cacheTime: cacheTime,
        retry: retry,
        refetchOnWindowFocus: refetchOnWindowFocus,
        refetchInterval: refetchInterval,
        useErrorBoundary: useErrorBoundary,
        keepPreviousData: keepPreviousData
    });
}



const $616614d9d4651c1d$export$5809f48c0e16e123 = ({ guestEmail: guestEmail , enabled: enabled , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $2026a49d34582011$export$d5f69b706430230d)(guestEmail),
        enabled: enabled,
        ...rest
    });
};


var $62a802691632c607$exports = {};

$parcel$export($62a802691632c607$exports, "useBookingQuery", () => $62a802691632c607$export$315a9b26340f0763);
var $7cdb244188f67081$exports = {};

$parcel$export($7cdb244188f67081$exports, "guestBookingQueryKey", () => $7cdb244188f67081$export$83801918f1dd84b2);
$parcel$export($7cdb244188f67081$exports, "useGuestBookingQuery", () => $7cdb244188f67081$export$17635debff393857);
var $39ac3dd98f21da43$exports = {};

$parcel$export($39ac3dd98f21da43$exports, "guestEndpoint", () => $39ac3dd98f21da43$export$431c9b2445140093);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingAlertsEndpoint", () => $39ac3dd98f21da43$export$2e138290fde57869);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestAlertsEndpoint", () => $39ac3dd98f21da43$export$72bd4cd413917ccb);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingEndpoint", () => $39ac3dd98f21da43$export$1140a006e21a2af);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestBookingEndpoint", () => $39ac3dd98f21da43$export$2c49104e238d15af);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingCancelEndpoint", () => $39ac3dd98f21da43$export$7b673dc6499cd01e);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestBookingCancelEndpoint", () => $39ac3dd98f21da43$export$6e345928955a18df);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingEditEndpoint", () => $39ac3dd98f21da43$export$99bed181fafc76a6);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestBookingEditEndpoint", () => $39ac3dd98f21da43$export$ce94d3e3f45206c9);
$parcel$export($39ac3dd98f21da43$exports, "guestCancellationPolicyEndpoint", () => $39ac3dd98f21da43$export$51eaaa7aa8c05f0f);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestCancellationPolicyEndpoint", () => $39ac3dd98f21da43$export$3c28bd43727dc07f);
$parcel$export($39ac3dd98f21da43$exports, "guestContactTracingEndpoint", () => $39ac3dd98f21da43$export$6a69478a03c4563);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingDateChangeEndpoint", () => $39ac3dd98f21da43$export$86c82836f6f2301f);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestMakePaymentEndpoint", () => $39ac3dd98f21da43$export$30f4744ce963faa5);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingPaymentDueEndpoint", () => $39ac3dd98f21da43$export$51566d236f9aa0f7);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestBookingPaymentDueEndpoint", () => $39ac3dd98f21da43$export$ef97ee06d59623a3);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestBookingPropertyEndpoint", () => $39ac3dd98f21da43$export$c5b10620a296ea16);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingPropertyGuidebook", () => $39ac3dd98f21da43$export$5ae04136437f5f68);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestPropertyGuidebookEndpoint", () => $39ac3dd98f21da43$export$4693b809b5fa3151);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestPropertyGuidebookPDFEndpoint", () => $39ac3dd98f21da43$export$89fd8e8460f9468c);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestPropertyGuidebookBinaryPDFEndpoint", () => $39ac3dd98f21da43$export$bc5d06324965f1dc);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingReceiptEndpoint", () => $39ac3dd98f21da43$export$15b46e351a808b77);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestBookingReceiptEndpoint", () => $39ac3dd98f21da43$export$983903b1de00bc23);
$parcel$export($39ac3dd98f21da43$exports, "guestRentalAgreementSummaryEndpoint", () => $39ac3dd98f21da43$export$94d3fffb03c2e71e);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestRentalAgreementSummaryEndpoint", () => $39ac3dd98f21da43$export$fa0677fddbd65e5a);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingReviewEndpoint", () => $39ac3dd98f21da43$export$5f323a8e516aa275);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingReviewResponseEndpoint", () => $39ac3dd98f21da43$export$98e826c89b6446ba);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestResponseEndPoint", () => $39ac3dd98f21da43$export$af8fef3389855904);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingUnavailableDatesEndpoint", () => $39ac3dd98f21da43$export$b471e52cfce3d083);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestUnavailableDatesEndpoint", () => $39ac3dd98f21da43$export$e1290e9e61b17a4f);
$parcel$export($39ac3dd98f21da43$exports, "guestBookingsEndpoint", () => $39ac3dd98f21da43$export$7b8a7ee4a641447b);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestBookingsEndpoint", () => $39ac3dd98f21da43$export$cef2c5b8f75ddc4c);
$parcel$export($39ac3dd98f21da43$exports, "guestCredentialsEndpoint", () => $39ac3dd98f21da43$export$d09e76381de27946);
$parcel$export($39ac3dd98f21da43$exports, "guestInquiryEndpoint", () => $39ac3dd98f21da43$export$1f26e963002c964e);
$parcel$export($39ac3dd98f21da43$exports, "guestFormInputEndpoint", () => $39ac3dd98f21da43$export$b022ea80b3aac2c6);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestFormInputEndPoint", () => $39ac3dd98f21da43$export$e93b0cf8761da9);
$parcel$export($39ac3dd98f21da43$exports, "guestOfferCodeEndpoint", () => $39ac3dd98f21da43$export$de6d3e112495828d);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestOfferCodeEndpoint", () => $39ac3dd98f21da43$export$4408ef2ee91572c2);
$parcel$export($39ac3dd98f21da43$exports, "guestOffersEndpoint", () => $39ac3dd98f21da43$export$d61bea2c95c3de27);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestOffersEndpoint", () => $39ac3dd98f21da43$export$d5fba4666e4d0fd5);
$parcel$export($39ac3dd98f21da43$exports, "guestLoginEndpoint", () => $39ac3dd98f21da43$export$41daf929bd7546b7);
$parcel$export($39ac3dd98f21da43$exports, "guestLogoutEndpoint", () => $39ac3dd98f21da43$export$5e0c7d69936a787e);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestNotificationsEndpoint", () => $39ac3dd98f21da43$export$8ace7b6edaa6c70);
$parcel$export($39ac3dd98f21da43$exports, "guestDismissNotificationsEndpoint", () => $39ac3dd98f21da43$export$7c08efd7afb09a9d);
$parcel$export($39ac3dd98f21da43$exports, "guestPrivacyEndpoint", () => $39ac3dd98f21da43$export$d1b11f0980cad682);
$parcel$export($39ac3dd98f21da43$exports, "guestReferralEndpoint", () => $39ac3dd98f21da43$export$e1578c6c64ea74cf);
$parcel$export($39ac3dd98f21da43$exports, "guestReviewEndpoint", () => $39ac3dd98f21da43$export$9e3fb8b6b70fe706);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestNewReviewEndpoint", () => $39ac3dd98f21da43$export$fa4f2fe03d39a121);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestReviewEndpoint", () => $39ac3dd98f21da43$export$73cdc604d713d437);
$parcel$export($39ac3dd98f21da43$exports, "guestReviewsEndpoint", () => $39ac3dd98f21da43$export$1fab7db0f6dc6c26);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestReviewsEndpoint", () => $39ac3dd98f21da43$export$4b82750e3e6f5ba3);
$parcel$export($39ac3dd98f21da43$exports, "generateGuestEligibleReviewsEndpoint", () => $39ac3dd98f21da43$export$516bda56c76382f2);
const $39ac3dd98f21da43$export$431c9b2445140093 = "/RESTAUTH/guest/";
const $39ac3dd98f21da43$export$2e138290fde57869 = `/RESTAUTH/guest/alerts/`;
const $39ac3dd98f21da43$export$72bd4cd413917ccb = (userId)=>{
    return `${$39ac3dd98f21da43$export$2e138290fde57869}?id=${userId}`;
};
const $39ac3dd98f21da43$export$1140a006e21a2af = `/RESTAUTH/guest/booking/`;
const $39ac3dd98f21da43$export$2c49104e238d15af = (bookingId, guestId, includeTimeline = false, ownerOffer, alluraOffer, alluraGiftCertificate, ownerGiftCertificate)=>{
    const timelineParam = includeTimeline ? `&include_timeline=${includeTimeline}` : "";
    const ownerOfferParam = ownerOffer ? `&owner_offer_code=${ownerOffer.code}&owner_offer_id=${ownerOffer.id}` : "";
    const alluraOfferParam = alluraOffer ? `&allura_offer_code=${alluraOffer.code}&allura_offer_id=${alluraOffer.id}` : "";
    const alluraGiftCertificateParam = alluraGiftCertificate ? `&allura_gift_certificate_code=${alluraGiftCertificate.code}&allura_gift_certificate_id=${alluraGiftCertificate.id}` : "";
    const ownerGiftCertificateParam = ownerGiftCertificate ? `&owner_gift_certificate_code=${ownerGiftCertificate.code}&owner_gift_certificate_id=${ownerGiftCertificate.id}` : "";
    return `${$39ac3dd98f21da43$export$1140a006e21a2af}/?booking_id=${bookingId}&id=${guestId}${timelineParam}${ownerOfferParam}${alluraOfferParam}${alluraGiftCertificateParam}${ownerGiftCertificateParam}`;
};
const $39ac3dd98f21da43$export$7b673dc6499cd01e = `/RESTAUTH/guest/booking/cancel/`;
const $39ac3dd98f21da43$export$6e345928955a18df = (userId, bookingId)=>{
    return `${$39ac3dd98f21da43$export$7b673dc6499cd01e}?id=${userId}&booking_id=${bookingId}`;
};
const $39ac3dd98f21da43$export$99bed181fafc76a6 = `/RESTAUTH/guest/booking/edit/`;
const $39ac3dd98f21da43$export$ce94d3e3f45206c9 = (userId, bookingId)=>{
    return `${$39ac3dd98f21da43$export$99bed181fafc76a6}?id=${userId}&booking_id=${bookingId}`;
};
const $39ac3dd98f21da43$export$51eaaa7aa8c05f0f = "/RESTAUTH/guest/booking/cancellationpolicy/";
const $39ac3dd98f21da43$export$3c28bd43727dc07f = (bookingId, guestId, isHTML = false)=>`${$39ac3dd98f21da43$export$51eaaa7aa8c05f0f}?booking_id=${bookingId}&id=${guestId}&is_html=${isHTML}`;
const $39ac3dd98f21da43$export$6a69478a03c4563 = `/RESTAUTH/guest/booking/contacttracing/`;
const $39ac3dd98f21da43$export$86c82836f6f2301f = `RESTAUTH/guest/booking/date-change/`;
const $39ac3dd98f21da43$export$30f4744ce963faa5 = ({ bookingId: bookingId , bookingType: bookingType , guestId: guestId , isFullPayment: /** Is the guest paying for the entire booking now or doing a deposit then a balance payment later */ isFullPayment = 0  })=>{
    return `/RESTAUTH/guest/booking/payment/?id=${guestId}&booking_id=${bookingId}&booking_type=${bookingType}&is_full_payment=${isFullPayment}`;
};
const $39ac3dd98f21da43$export$51566d236f9aa0f7 = "/RESTAUTH/guest/booking/paymentdue/";
const $39ac3dd98f21da43$export$ef97ee06d59623a3 = (bookingId, guestId)=>{
    return `${$39ac3dd98f21da43$export$51566d236f9aa0f7}?id=${guestId}&booking_id=${bookingId}`;
};
const $39ac3dd98f21da43$export$c5b10620a296ea16 = (bookingId, guestId)=>`/RESTAUTH/guest/booking/property/?booking_id=${bookingId}&id=${guestId}`;
const $39ac3dd98f21da43$export$5ae04136437f5f68 = "/RESTAUTH/guest/booking/propertyguidebook/";
const $39ac3dd98f21da43$export$4693b809b5fa3151 = (bookingId, guestId)=>{
    return `${$39ac3dd98f21da43$export$5ae04136437f5f68}?id=${guestId}&booking_id=${bookingId}`;
};
const $39ac3dd98f21da43$export$89fd8e8460f9468c = (bookingId, guestId)=>`${$39ac3dd98f21da43$export$5ae04136437f5f68}pdf/base64/?id=${guestId}&booking_id=${bookingId}`;
const $39ac3dd98f21da43$export$bc5d06324965f1dc = ({ guestId: guestId , bookingId: bookingId  })=>`${$39ac3dd98f21da43$export$5ae04136437f5f68}pdf/binary/?id=${guestId}&booking_id=${bookingId}`;
const $39ac3dd98f21da43$export$15b46e351a808b77 = "/RESTAUTH/guest/booking/receipt/";
const $39ac3dd98f21da43$export$983903b1de00bc23 = (bookingId, userId)=>`${$39ac3dd98f21da43$export$15b46e351a808b77}?id=${userId}&booking_id=${bookingId}`;
const $39ac3dd98f21da43$export$94d3fffb03c2e71e = "/RESTAUTH/guest/booking/rentalagreement/";
const $39ac3dd98f21da43$export$fa0677fddbd65e5a = (bookingId, guestId)=>`${$39ac3dd98f21da43$export$94d3fffb03c2e71e}?id=${guestId}&booking_id=${bookingId}`;
const $39ac3dd98f21da43$export$5f323a8e516aa275 = "/RESTAUTH/guest/booking/review/";
const $39ac3dd98f21da43$export$98e826c89b6446ba = "/RESTAUTH/guest/booking/review/response/";
const $39ac3dd98f21da43$export$af8fef3389855904 = (reviewId, guestId)=>`${$39ac3dd98f21da43$export$98e826c89b6446ba}?id=${guestId}&review_id=${reviewId}`;
const $39ac3dd98f21da43$export$b471e52cfce3d083 = "/RESTAUTH/guest/booking/unavailability/";
const $39ac3dd98f21da43$export$e1290e9e61b17a4f = (bookingId, guestId)=>`${$39ac3dd98f21da43$export$b471e52cfce3d083}?id=${guestId}&booking_id=${bookingId}`;
const $39ac3dd98f21da43$export$7b8a7ee4a641447b = `/RESTAUTH/guest/bookings/`;
const $39ac3dd98f21da43$export$cef2c5b8f75ddc4c = ({ amount: amount = 20 , direction: direction = "future" , guestId: guestId , page: page = 1 , statusIdFilter: statusIdFilter  })=>{
    const statusFilter = statusIdFilter ? `&status_id=${statusIdFilter}` : "";
    return `${$39ac3dd98f21da43$export$7b8a7ee4a641447b}?id=${guestId}&page=${page}&amount_per_page=${amount}&page_direction=${direction}${statusFilter}`;
};
const $39ac3dd98f21da43$export$d09e76381de27946 = "/RESTAUTH/guest/credentials/";
const $39ac3dd98f21da43$export$1f26e963002c964e = "/RESTAUTH/guest/inquiry/";
const $39ac3dd98f21da43$export$b022ea80b3aac2c6 = "/RESTAUTH/guest/formInput/";
const $39ac3dd98f21da43$export$e93b0cf8761da9 = (guestId)=>`${$39ac3dd98f21da43$export$b022ea80b3aac2c6}?id=${guestId}`;
const $39ac3dd98f21da43$export$de6d3e112495828d = "/RESTAUTH/guest/offer/code/";
const $39ac3dd98f21da43$export$4408ef2ee91572c2 = (userId, propertyId, arrival, departure)=>{
    const id = userId === undefined ? 0 : userId;
    const pid = propertyId === undefined ? "" : propertyId;
    const arr = arrival === undefined ? "" : arrival;
    const dep = departure === undefined ? "" : departure;
    return `${$39ac3dd98f21da43$export$de6d3e112495828d}?id=${id}&property_id=${pid}&arrival=${arr}&departure=${dep}`;
};
const $39ac3dd98f21da43$export$d61bea2c95c3de27 = "/RESTAUTH/guest/offers/";
const $39ac3dd98f21da43$export$d5fba4666e4d0fd5 = (userId, propertyId, arrival, departure)=>{
    const id = userId === undefined ? 0 : userId;
    const pid = propertyId === undefined ? "" : propertyId;
    const arr = arrival === undefined ? "" : arrival;
    const dep = departure === undefined ? "" : departure;
    return `${$39ac3dd98f21da43$export$d61bea2c95c3de27}?id=${id}&property_id=${pid}&arrival=${arr}&departure=${dep}`;
};
const $39ac3dd98f21da43$export$41daf929bd7546b7 = "/RESTAUTH/guest/login/";
const $39ac3dd98f21da43$export$5e0c7d69936a787e = "/RESTAUTH/guest/logout/";
const $39ac3dd98f21da43$export$8ace7b6edaa6c70 = ({ amountPerPage: amountPerPage , page: page , guestId: guestId , category: category , status: status  })=>{
    const statusParam = status ? `&status=${status}` : "";
    return `/RESTAUTH/guest/notifications/?id=${guestId}&amount_per_page=${amountPerPage}&page=${page}&category=${category}${statusParam}`;
};
const $39ac3dd98f21da43$export$7c08efd7afb09a9d = `/RESTAUTH/guest/notifications/dismiss/`;
const $39ac3dd98f21da43$export$d1b11f0980cad682 = `/RESTAUTH/guest/privacy/`;
const $39ac3dd98f21da43$export$e1578c6c64ea74cf = "/RESTAUTH/guest/referral/";
const $39ac3dd98f21da43$export$9e3fb8b6b70fe706 = "/RESTAUTH/guest/review/";
const $39ac3dd98f21da43$export$fa4f2fe03d39a121 = (bookingId, reviewId, guestId)=>`${$39ac3dd98f21da43$export$9e3fb8b6b70fe706}?id=${guestId}&booking_id=${bookingId}&review_id=${reviewId}`;
const $39ac3dd98f21da43$export$73cdc604d713d437 = (reviewId, guestId)=>`${$39ac3dd98f21da43$export$9e3fb8b6b70fe706}?id=${guestId}&review_id=${reviewId}`;
const $39ac3dd98f21da43$export$1fab7db0f6dc6c26 = `/RESTAUTH/guest/reviews/`;
const $39ac3dd98f21da43$export$4b82750e3e6f5ba3 = (guestId)=>`${$39ac3dd98f21da43$export$1fab7db0f6dc6c26}?id=${guestId}`;
const $39ac3dd98f21da43$export$516bda56c76382f2 = (guestId)=>`/RESTAUTH/guest/reviews/invitations/?id=${guestId}`;


var $04e57a2246bdbee0$exports = {};

$parcel$export($04e57a2246bdbee0$exports, "queryKeyFactory", () => $04e57a2246bdbee0$export$81fc3df80b283228);
function $04e57a2246bdbee0$export$81fc3df80b283228(keyName) {
    const queryKeys = {
        all: [
            keyName
        ],
        lists: ()=>[
                ...queryKeys.all,
                "list"
            ],
        list: (filters)=>[
                ...queryKeys.lists(),
                {
                    filters: filters
                }
            ],
        details: ()=>[
                ...queryKeys.all,
                "detail"
            ],
        detail: (id)=>[
                ...queryKeys.details(),
                id
            ]
    };
    return queryKeys;
}



const $7cdb244188f67081$var$select = (data)=>data.DATA.BOOKING;
const $7cdb244188f67081$export$83801918f1dd84b2 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("GUEST_BOOKING");
const $7cdb244188f67081$export$17635debff393857 = ({ bookingId: bookingId = 0 , guestId: guestId = 0 , includeTimeline: includeTimeline = false , isEnabled: isEnabled = true , onSuccess: onSuccess = ()=>null , alluraOffer: alluraOffer , ownerOffer: ownerOffer , alluraGiftCertificate: alluraGiftCertificate , ownerGiftCertificate: ownerGiftCertificate  })=>{
    // const endpoint = generateGuestBookingEndpoint(bookingId, guestId, includeTimeline, ownerOffer, alluraOffer);
    const endpoint = (0, $39ac3dd98f21da43$export$2c49104e238d15af)(bookingId, guestId, includeTimeline, ownerOffer, alluraOffer, alluraGiftCertificate, ownerGiftCertificate);
    const queryKey = $7cdb244188f67081$export$83801918f1dd84b2.detail(endpoint);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        queryKey: queryKey,
        select: $7cdb244188f67081$var$select,
        enabled: isEnabled,
        onSuccess: onSuccess
    });
};


var $8ad86f241ad28bc7$exports = {};

$parcel$export($8ad86f241ad28bc7$exports, "propertyBookingQueryKey", () => $8ad86f241ad28bc7$export$10d1544eb8be6d51);
$parcel$export($8ad86f241ad28bc7$exports, "usePropertyBookingQuery", () => $8ad86f241ad28bc7$export$24675aafedc57d7c);
var $e15de41ca5b185e2$exports = {};

$parcel$export($e15de41ca5b185e2$exports, "additionalContactEndpoint", () => $e15de41ca5b185e2$export$aadd5873ed3eb0a9);
$parcel$export($e15de41ca5b185e2$exports, "bookingsFilteredEndPoint", () => $e15de41ca5b185e2$export$3303ec1fdff02a79);
$parcel$export($e15de41ca5b185e2$exports, "bookingsPaginatedEndPoint", () => $e15de41ca5b185e2$export$1adac3ffd69c52c4);
$parcel$export($e15de41ca5b185e2$exports, "calendarDatesEndpoint", () => $e15de41ca5b185e2$export$ef60b8f88a5bae47);
$parcel$export($e15de41ca5b185e2$exports, "cancellationPoliciesEndpoint", () => $e15de41ca5b185e2$export$9d51734ff699182c);
$parcel$export($e15de41ca5b185e2$exports, "checkinEmailPreviewSendEndpoint", () => $e15de41ca5b185e2$export$63dc1bc5f6311c25);
$parcel$export($e15de41ca5b185e2$exports, "contentEndpoint", () => $e15de41ca5b185e2$export$165758497584710c);
$parcel$export($e15de41ca5b185e2$exports, "directVacationLogoEndpoint", () => $e15de41ca5b185e2$export$8a21b744be4eceec);
$parcel$export($e15de41ca5b185e2$exports, "directVacationSubdomainEndpoint", () => $e15de41ca5b185e2$export$d906595e68b25fbc);
$parcel$export($e15de41ca5b185e2$exports, "externalUrlsEndpoint", () => $e15de41ca5b185e2$export$944ab5648f9de932);
$parcel$export($e15de41ca5b185e2$exports, "formEndpoint", () => $e15de41ca5b185e2$export$6da8321ca4a496ec);
$parcel$export($e15de41ca5b185e2$exports, "instructionsEndpoint", () => $e15de41ca5b185e2$export$1e71601f89ebe16e);
$parcel$export($e15de41ca5b185e2$exports, "photoSortEndpoint", () => $e15de41ca5b185e2$export$9eb82b7824e5dd04);
$parcel$export($e15de41ca5b185e2$exports, "photosEndpoint", () => $e15de41ca5b185e2$export$3c2c60a58101835d);
$parcel$export($e15de41ca5b185e2$exports, "propertyAmenityEndpoint", () => $e15de41ca5b185e2$export$7bee553f09f3bac1);
$parcel$export($e15de41ca5b185e2$exports, "propertyBlockoffEndpoint", () => $e15de41ca5b185e2$export$fb417a0ab4848855);
$parcel$export($e15de41ca5b185e2$exports, "propertyDefaultContentEndpoint", () => $e15de41ca5b185e2$export$cddb2a04459beb7b);
$parcel$export($e15de41ca5b185e2$exports, "propertyWalkthroughGuidebookEndpoint", () => $e15de41ca5b185e2$export$f3a6164b81299928);
$parcel$export($e15de41ca5b185e2$exports, "propertyICalEndpoint", () => $e15de41ca5b185e2$export$68b9f535dd6d354c);
$parcel$export($e15de41ca5b185e2$exports, "propertyNonResidentEmail", () => $e15de41ca5b185e2$export$7fff7d6ded248882);
$parcel$export($e15de41ca5b185e2$exports, "propertyPoliciesEndpoint", () => $e15de41ca5b185e2$export$d4e84423c6d944da);
$parcel$export($e15de41ca5b185e2$exports, "propertyRateGroupEndpoint", () => $e15de41ca5b185e2$export$b845c70a33b15f42);
$parcel$export($e15de41ca5b185e2$exports, "propertyRatesScheduleGenerateEndpoint", () => $e15de41ca5b185e2$export$79b83e54141a5fed);
$parcel$export($e15de41ca5b185e2$exports, "propertyTransactionsEndpoint", () => $e15de41ca5b185e2$export$d5bcdfe94d5c1562);
$parcel$export($e15de41ca5b185e2$exports, "propertyVideosEndpoint", () => $e15de41ca5b185e2$export$7fa125c30efe2e4d);
$parcel$export($e15de41ca5b185e2$exports, "rateScheduleEndpoint", () => $e15de41ca5b185e2$export$17b51878a0a31c87);
$parcel$export($e15de41ca5b185e2$exports, "rentalAgreementSummaryEndpoint", () => $e15de41ca5b185e2$export$250c9f01051e965c);
$parcel$export($e15de41ca5b185e2$exports, "resendSubscriptionReceiptEndPoint", () => $e15de41ca5b185e2$export$121d7a716be5f06e);
$parcel$export($e15de41ca5b185e2$exports, "reservationRequestEndpoint", () => $e15de41ca5b185e2$export$58e0cb00f24cc8f3);
$parcel$export($e15de41ca5b185e2$exports, "reservationSettings", () => $e15de41ca5b185e2$export$4f25634e4176fe8a);
$parcel$export($e15de41ca5b185e2$exports, "season", () => $e15de41ca5b185e2$export$f72fb329c420e262);
$parcel$export($e15de41ca5b185e2$exports, "subformEndpoint", () => $e15de41ca5b185e2$export$eaf7e24ac4a8bddc);
$parcel$export($e15de41ca5b185e2$exports, "generateBookingsFilteredEndpoint", () => $e15de41ca5b185e2$export$cbc18e2f0f3c422f);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyGuidebookEndpoint", () => $e15de41ca5b185e2$export$ea291c08a781f86d);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyGuidebookPDFEndpoint", () => $e15de41ca5b185e2$export$677d92663e6c9702);
$parcel$export($e15de41ca5b185e2$exports, "generateLegacyCheckInHTML", () => $e15de41ca5b185e2$export$f38251b9cee2c092);
$parcel$export($e15de41ca5b185e2$exports, "generateBookingReservationEndpoint", () => $e15de41ca5b185e2$export$d7daed75cabb6158);
$parcel$export($e15de41ca5b185e2$exports, "generateRateScheduleRateGroup", () => $e15de41ca5b185e2$export$b1a019ef0b9d9c55);
$parcel$export($e15de41ca5b185e2$exports, "generateRateScheduleInsight", () => $e15de41ca5b185e2$export$b4f7dd00106f4e45);
$parcel$export($e15de41ca5b185e2$exports, "rateScheduleOptimizeEndpoint", () => $e15de41ca5b185e2$export$508b48b1fca2233e);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyCodesEndpoint", () => $e15de41ca5b185e2$export$b6332f8545187af);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyRatesScheduleGenerateEndpoint", () => $e15de41ca5b185e2$export$f5000ba6800436e4);
$parcel$export($e15de41ca5b185e2$exports, "generatePhotosEndPoint", () => $e15de41ca5b185e2$export$d05cf022d0ab7576);
$parcel$export($e15de41ca5b185e2$exports, "generateFormInputEndpoint", () => $e15de41ca5b185e2$export$f3777fcf4347a5e4);
$parcel$export($e15de41ca5b185e2$exports, "generateBookingsPaginatedEndPoint", () => $e15de41ca5b185e2$export$58ed2e7b62cd77df);
$parcel$export($e15de41ca5b185e2$exports, "generateExternalEventsEndPoint", () => $e15de41ca5b185e2$export$e6c967c7a3157c17);
$parcel$export($e15de41ca5b185e2$exports, "generateResyncICalEndPoint", () => $e15de41ca5b185e2$export$5da7f2af0f6f2866);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyEndPoint", () => $e15de41ca5b185e2$export$d439d8afdae174fa);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyEndPointQuery", () => $e15de41ca5b185e2$export$9f5725612a8acbef);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyNotificationsEndPoint", () => $e15de41ca5b185e2$export$2392f883c0d42e50);
$parcel$export($e15de41ca5b185e2$exports, "propertyDismissNotificationsEndpoint", () => $e15de41ca5b185e2$export$53e102228cc1a763);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyDismissNotificationEndpoint", () => $e15de41ca5b185e2$export$f7e2a9deba265545);
$parcel$export($e15de41ca5b185e2$exports, "generateReviewsEndPoint", () => $e15de41ca5b185e2$export$a707cd72801d58c1);
$parcel$export($e15de41ca5b185e2$exports, "generateActivationEndPoint", () => $e15de41ca5b185e2$export$21b9e07c53b03d0a);
$parcel$export($e15de41ca5b185e2$exports, "generateUnavailabilityEndpoint", () => $e15de41ca5b185e2$export$faaf651cb1c1cc08);
$parcel$export($e15de41ca5b185e2$exports, "generateLastAndNextGuestEndpoint", () => $e15de41ca5b185e2$export$9b59b882fec09fbc);
$parcel$export($e15de41ca5b185e2$exports, "generateBankDepositsEndPoint", () => $e15de41ca5b185e2$export$7acf4e877f505419);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyDefaultContentEndpoint", () => $e15de41ca5b185e2$export$d7e2dae541011158);
$parcel$export($e15de41ca5b185e2$exports, "generateExternalUrlsEndpoint", () => $e15de41ca5b185e2$export$19b0adbfaded7879);
$parcel$export($e15de41ca5b185e2$exports, "generateCheckInEmailPreviewEndpoint", () => $e15de41ca5b185e2$export$be31c437417f9eea);
$parcel$export($e15de41ca5b185e2$exports, "generateRentalAgreementSummaryEndpoint", () => $e15de41ca5b185e2$export$383708ed9a9d0e95);
$parcel$export($e15de41ca5b185e2$exports, "generateCalendarEventsEndpoint", () => $e15de41ca5b185e2$export$e4bd279bd004f6f3);
$parcel$export($e15de41ca5b185e2$exports, "generateCalendarDatesEndpoint", () => $e15de41ca5b185e2$export$76a91356b9c78084);
$parcel$export($e15de41ca5b185e2$exports, "generateReservationRequest", () => $e15de41ca5b185e2$export$7838eaf7de460919);
$parcel$export($e15de41ca5b185e2$exports, "generateRateSuggestionEndpoint", () => $e15de41ca5b185e2$export$42e2d76e5fe1e90d);
$parcel$export($e15de41ca5b185e2$exports, "generatePropertyBlockoffsEndpoint", () => $e15de41ca5b185e2$export$c3c8c105fac41d59);
var $f58c18151396e867$exports = {};

$parcel$export($f58c18151396e867$exports, "BedroomTypeIDEnum", () => $f58c18151396e867$export$7a61fe57c08abf60);
$parcel$export($f58c18151396e867$exports, "EventTypeEnum", () => $f58c18151396e867$export$2d343ad99964f7c);
$parcel$export($f58c18151396e867$exports, "JoinStatusIDEnum", () => $f58c18151396e867$export$aa113f941bb73d74);
$parcel$export($f58c18151396e867$exports, "PropertySubscriptionTierIdEnum", () => $f58c18151396e867$export$eb581bc54c390a17);
$parcel$export($f58c18151396e867$exports, "RatesSettingsWeekendPremiumId", () => $f58c18151396e867$export$4fd94061e730ad38);
$parcel$export($f58c18151396e867$exports, "RatePropertySettingEnum", () => $f58c18151396e867$export$437476ba8a9c4308);
$parcel$export($f58c18151396e867$exports, "RateAvailabilityIdEnum", () => $f58c18151396e867$export$85d9e2b1f34611d7);
$parcel$export($f58c18151396e867$exports, "RateGroupTypesIdEnum", () => $f58c18151396e867$export$1d0378704cdd8de7);
$parcel$export($f58c18151396e867$exports, "SeasonType", () => $f58c18151396e867$export$c16066753dac818b);
$parcel$export($f58c18151396e867$exports, "SurchargeId", () => $f58c18151396e867$export$52635478f64a5a51);
$parcel$export($f58c18151396e867$exports, "BookingGateWayModeIdEnum", () => $f58c18151396e867$export$3fea48cce2b57a8b);
$parcel$export($f58c18151396e867$exports, "PropertyFeesIdEnum", () => $f58c18151396e867$export$3920d96caa2fc27e);
$parcel$export($f58c18151396e867$exports, "PropertyDefaultContentTypes", () => $f58c18151396e867$export$7b9c01e6e4bc49c6);
$parcel$export($f58c18151396e867$exports, "GenerateRateMode", () => $f58c18151396e867$export$b465bf62bb901487);
$parcel$export($f58c18151396e867$exports, "PropertyInstructionsEnum", () => $f58c18151396e867$export$c51b307d7f17f9e8);
$parcel$export($f58c18151396e867$exports, "RateInsightLevelIdEnum", () => $f58c18151396e867$export$9a5f53ec1a50b124);
$parcel$export($f58c18151396e867$exports, "PricingStrategyEnum", () => $f58c18151396e867$export$eff54ef88b94774d);
$parcel$export($f58c18151396e867$exports, "GuidebookWizardFormNamesEnum", () => $f58c18151396e867$export$92ac1597760befe6);
$parcel$export($f58c18151396e867$exports, "PlatformListedId", () => $f58c18151396e867$export$13d65d67292f85af);
let $f58c18151396e867$export$7a61fe57c08abf60;
$f58c18151396e867$export$7a61fe57c08abf60 = {};
let $f58c18151396e867$export$2d343ad99964f7c;
(function(EventTypeEnum1) {
    EventTypeEnum1[// 'physically' block calendar dates
    "Blockoff"] = "blockoff";
    EventTypeEnum1["Booking"] = "booking";
    EventTypeEnum1["Cleaning"] = "cleaning";
    EventTypeEnum1["ExternalBooking"] = "external_booking";
    EventTypeEnum1["Gap"] = "gap";
    EventTypeEnum1["NewBlockoff"] = "newBlockoff";
    EventTypeEnum1["NewBooking"] = "newBooking";
    EventTypeEnum1["Quote"] = "quote";
    EventTypeEnum1["Season"] = "season";
    EventTypeEnum1[// Rate Schedule
    "RateSchedule"] = "rateSchedule";
})($f58c18151396e867$export$2d343ad99964f7c || ($f58c18151396e867$export$2d343ad99964f7c = {}));
let $f58c18151396e867$export$aa113f941bb73d74;
(function(JoinStatusIDEnum1) {
    JoinStatusIDEnum1[JoinStatusIDEnum1[// Property has not started onboarding (has not completed a single form)
    "NotStarted"] = 1] = "NotStarted";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// Some (not all) onboarding forms completed
    "InProgress"] = 2] = "InProgress";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// All required forms in onboarding completed
    "FormsCompleted"] = 3] = "FormsCompleted";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// Forms completed and activation requested
    "ActivationRequested"] = 4] = "ActivationRequested";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// After requesting activation and before approved
    "AskedForMoreInformation"] = 5] = "AskedForMoreInformation";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// Legacy property that has not started onboarding
    "SetUpInProgress"] = 6] = "SetUpInProgress";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// Property has been approved and is now 'live'
    "ListingActive"] = 7] = "ListingActive";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// After requesting activation the property has been declined
    "ApplicationDeclined"] = 8] = "ApplicationDeclined";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// After listing active, requested deactivation
    "DeactivationRequested"] = 9] = "DeactivationRequested";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// Property is fully deactivated/disabled
    "ListingDisabled"] = 10] = "ListingDisabled";
    JoinStatusIDEnum1[JoinStatusIDEnum1[// Legacy property that has not renewed subscription
    "ListingInactive"] = 11] = "ListingInactive";
})($f58c18151396e867$export$aa113f941bb73d74 || ($f58c18151396e867$export$aa113f941bb73d74 = {}));
let $f58c18151396e867$export$eb581bc54c390a17;
(function(PropertySubscriptionTierIdEnum1) {
    PropertySubscriptionTierIdEnum1[PropertySubscriptionTierIdEnum1["PREMIUM"] = 1] = "PREMIUM";
    PropertySubscriptionTierIdEnum1[PropertySubscriptionTierIdEnum1[/** Host Commission */ "STANDARD"] = 2] = "STANDARD";
    PropertySubscriptionTierIdEnum1[PropertySubscriptionTierIdEnum1["GUEST_COMMISION"] = 3] = "GUEST_COMMISION";
})($f58c18151396e867$export$eb581bc54c390a17 || ($f58c18151396e867$export$eb581bc54c390a17 = {}));
let $f58c18151396e867$export$4fd94061e730ad38;
(function(RatesSettingsWeekendPremiumId1) {
    RatesSettingsWeekendPremiumId1[RatesSettingsWeekendPremiumId1["NOT_SET"] = 0] = "NOT_SET";
    RatesSettingsWeekendPremiumId1[RatesSettingsWeekendPremiumId1["DISABLED"] = 1] = "DISABLED";
    RatesSettingsWeekendPremiumId1[RatesSettingsWeekendPremiumId1["DOLLAR"] = 2] = "DOLLAR";
    RatesSettingsWeekendPremiumId1[RatesSettingsWeekendPremiumId1["PERCENTAGE"] = 3] = "PERCENTAGE";
})($f58c18151396e867$export$4fd94061e730ad38 || ($f58c18151396e867$export$4fd94061e730ad38 = {}));
let $f58c18151396e867$export$437476ba8a9c4308;
(function(RatePropertySettingEnum1) {
    RatePropertySettingEnum1[RatePropertySettingEnum1["NOT_SET"] = 0] = "NOT_SET";
    RatePropertySettingEnum1[RatePropertySettingEnum1[// Static setting indicates single RateGroup
    "STATIC"] = 1] = "STATIC";
    RatePropertySettingEnum1[RatePropertySettingEnum1[// Dynamic setting indicates LOW, MID, HIGH, PRIME RateGroups
    "DYNAMIC"] = 2] = "DYNAMIC";
})($f58c18151396e867$export$437476ba8a9c4308 || ($f58c18151396e867$export$437476ba8a9c4308 = {}));
let $f58c18151396e867$export$85d9e2b1f34611d7;
(function(RateAvailabilityIdEnum1) {
    RateAvailabilityIdEnum1[RateAvailabilityIdEnum1["NOT_SET"] = 0] = "NOT_SET";
    RateAvailabilityIdEnum1[RateAvailabilityIdEnum1["MONTHS_12"] = 1] = "MONTHS_12";
    RateAvailabilityIdEnum1[RateAvailabilityIdEnum1["MONTHS_15"] = 2] = "MONTHS_15";
    RateAvailabilityIdEnum1[RateAvailabilityIdEnum1["MONTHS_18"] = 3] = "MONTHS_18";
    RateAvailabilityIdEnum1[RateAvailabilityIdEnum1["UNRESTRICTED"] = 4] = "UNRESTRICTED";
    RateAvailabilityIdEnum1[RateAvailabilityIdEnum1["MONTHS_6"] = 5] = "MONTHS_6";
})($f58c18151396e867$export$85d9e2b1f34611d7 || ($f58c18151396e867$export$85d9e2b1f34611d7 = {}));
let $f58c18151396e867$export$1d0378704cdd8de7;
(function(RateGroupTypesIdEnum1) {
    RateGroupTypesIdEnum1[RateGroupTypesIdEnum1["LOW"] = 1] = "LOW";
    RateGroupTypesIdEnum1[RateGroupTypesIdEnum1["MID"] = 2] = "MID";
    RateGroupTypesIdEnum1[RateGroupTypesIdEnum1["HIGH"] = 3] = "HIGH";
    RateGroupTypesIdEnum1[RateGroupTypesIdEnum1["PRIME"] = 4] = "PRIME";
    RateGroupTypesIdEnum1[RateGroupTypesIdEnum1["MANUAL"] = 7] = "MANUAL";
})($f58c18151396e867$export$1d0378704cdd8de7 || ($f58c18151396e867$export$1d0378704cdd8de7 = {}));
let $f58c18151396e867$export$c16066753dac818b;
(function(SeasonType1) {
    SeasonType1["newSeason"] = "newSeason";
    SeasonType1["alluraSeason"] = "alluraSeason";
})($f58c18151396e867$export$c16066753dac818b || ($f58c18151396e867$export$c16066753dac818b = {}));
let $f58c18151396e867$export$52635478f64a5a51;
(function(SurchargeId1) {
    SurchargeId1[SurchargeId1["SMOKING"] = 1] = "SMOKING";
    SurchargeId1[SurchargeId1["PETS"] = 2] = "PETS";
    SurchargeId1[SurchargeId1["LONG_TERM_RENTALS"] = 3] = "LONG_TERM_RENTALS";
    SurchargeId1[SurchargeId1["PARTIES_AND_EVENTS"] = 4] = "PARTIES_AND_EVENTS";
    SurchargeId1[SurchargeId1["TRAVEL_RESELLERS"] = 5] = "TRAVEL_RESELLERS";
    SurchargeId1[SurchargeId1["WHEELCHAIR_ACCESSIBLE"] = 6] = "WHEELCHAIR_ACCESSIBLE";
})($f58c18151396e867$export$52635478f64a5a51 || ($f58c18151396e867$export$52635478f64a5a51 = {}));
let $f58c18151396e867$export$3fea48cce2b57a8b;
(function(BookingGateWayModeIdEnum1) {
    BookingGateWayModeIdEnum1[BookingGateWayModeIdEnum1["closed"] = 1] = "closed";
    BookingGateWayModeIdEnum1[BookingGateWayModeIdEnum1["open"] = 2] = "open";
})($f58c18151396e867$export$3fea48cce2b57a8b || ($f58c18151396e867$export$3fea48cce2b57a8b = {}));
let $f58c18151396e867$export$3920d96caa2fc27e;
(function(PropertyFeesIdEnum1) {
    PropertyFeesIdEnum1[PropertyFeesIdEnum1["Cleaning"] = 1] = "Cleaning";
    PropertyFeesIdEnum1[PropertyFeesIdEnum1["Pets"] = 2] = "Pets";
})($f58c18151396e867$export$3920d96caa2fc27e || ($f58c18151396e867$export$3920d96caa2fc27e = {}));
let $f58c18151396e867$export$7b9c01e6e4bc49c6;
(function(PropertyDefaultContentTypes1) {
    PropertyDefaultContentTypes1["TITLE"] = "title";
    PropertyDefaultContentTypes1["SEARCHSUMMARY"] = "searchsummary";
    PropertyDefaultContentTypes1["DESCRIPTION"] = "description";
})($f58c18151396e867$export$7b9c01e6e4bc49c6 || ($f58c18151396e867$export$7b9c01e6e4bc49c6 = {}));
let $f58c18151396e867$export$b465bf62bb901487;
(function(GenerateRateMode1) {
    GenerateRateMode1["DEFAULT"] = "";
    GenerateRateMode1["BLANK"] = "blank/";
    GenerateRateMode1[// Generate from pre-existing rates (legacy property only)
    "MANUAL"] = "manual/";
})($f58c18151396e867$export$b465bf62bb901487 || ($f58c18151396e867$export$b465bf62bb901487 = {}));
let $f58c18151396e867$export$c51b307d7f17f9e8;
(function(PropertyInstructionsEnum1) {
    PropertyInstructionsEnum1["aboutTheBuilding"] = "about_the_building";
    PropertyInstructionsEnum1["checkIn"] = "check_in";
    PropertyInstructionsEnum1["checkOut"] = "check_out";
    PropertyInstructionsEnum1["toFromLifts"] = "to_from_lifts";
    PropertyInstructionsEnum1["emergencyContacts"] = "emergency_contacts";
    PropertyInstructionsEnum1["frontDesk"] = "front_desk";
    PropertyInstructionsEnum1["garbageAndRecycling"] = "garbage_recycling";
    PropertyInstructionsEnum1["gettingAround"] = "getting_around";
    PropertyInstructionsEnum1["heating"] = "heating";
    PropertyInstructionsEnum1["housekeeping"] = "housekeeping";
    PropertyInstructionsEnum1["lateCheckIn"] = "late_check_in";
    PropertyInstructionsEnum1["linensAndTowels"] = "linens_and_towels";
    PropertyInstructionsEnum1["location"] = "location";
    PropertyInstructionsEnum1["other"] = "other";
    PropertyInstructionsEnum1["parking"] = "parking";
    PropertyInstructionsEnum1["welcome"] = "welcome";
    PropertyInstructionsEnum1["restaurants"] = "restaurants";
    PropertyInstructionsEnum1["services"] = "services";
    PropertyInstructionsEnum1["skiInSkiOut"] = "ski_in_ski_out";
    PropertyInstructionsEnum1["whatToBring"] = "what_to_bring";
    PropertyInstructionsEnum1["gettingToUnit"] = "getting_to_unit";
})($f58c18151396e867$export$c51b307d7f17f9e8 || ($f58c18151396e867$export$c51b307d7f17f9e8 = {}));
let $f58c18151396e867$export$9a5f53ec1a50b124;
(function(RateInsightLevelIdEnum1) {
    RateInsightLevelIdEnum1[RateInsightLevelIdEnum1["low"] = 1] = "low";
    RateInsightLevelIdEnum1[RateInsightLevelIdEnum1["lowMid"] = 2] = "lowMid";
    RateInsightLevelIdEnum1[RateInsightLevelIdEnum1["mid"] = 3] = "mid";
    RateInsightLevelIdEnum1[RateInsightLevelIdEnum1["midHigh"] = 4] = "midHigh";
    RateInsightLevelIdEnum1[RateInsightLevelIdEnum1["high"] = 5] = "high";
})($f58c18151396e867$export$9a5f53ec1a50b124 || ($f58c18151396e867$export$9a5f53ec1a50b124 = {}));
let $f58c18151396e867$export$eff54ef88b94774d;
(function(PricingStrategyEnum1) {
    PricingStrategyEnum1[PricingStrategyEnum1["rateGroup"] = 1] = "rateGroup";
    PricingStrategyEnum1[PricingStrategyEnum1["smartPricing"] = 2] = "smartPricing";
})($f58c18151396e867$export$eff54ef88b94774d || ($f58c18151396e867$export$eff54ef88b94774d = {}));
let $f58c18151396e867$export$92ac1597760befe6;
(function(GuidebookWizardFormNamesEnum1) {
    GuidebookWizardFormNamesEnum1["amenities"] = "AmenitiesSubform";
    GuidebookWizardFormNamesEnum1["checkIn"] = "CheckinSubform";
    GuidebookWizardFormNamesEnum1["commonQuestions"] = "CommonQuestionsSubform";
    GuidebookWizardFormNamesEnum1["departure"] = "DepartureSubform";
    GuidebookWizardFormNamesEnum1["directions"] = "DirectionsSubform";
    GuidebookWizardFormNamesEnum1["frontDesk"] = "FrontDeskSubform";
    GuidebookWizardFormNamesEnum1["houseKeeping"] = "HousekeepingSubform";
    GuidebookWizardFormNamesEnum1["introduction"] = "Introduction";
    GuidebookWizardFormNamesEnum1["gettingAround"] = "GettingAroundSubform";
    GuidebookWizardFormNamesEnum1["uniqueCodes"] = "UniqueCodesSubform";
    GuidebookWizardFormNamesEnum1["welcomeMessage"] = "WelcomeMessageSubform";
})($f58c18151396e867$export$92ac1597760befe6 || ($f58c18151396e867$export$92ac1597760befe6 = {}));
let $f58c18151396e867$export$13d65d67292f85af;
(function(PlatformListedId1) {
    PlatformListedId1[PlatformListedId1["airbnb"] = 1] = "airbnb";
    PlatformListedId1[PlatformListedId1["vrbo"] = 2] = "vrbo";
    PlatformListedId1[PlatformListedId1["my_site"] = 3] = "my_site";
    PlatformListedId1[PlatformListedId1["other"] = 4] = "other";
})($f58c18151396e867$export$13d65d67292f85af || ($f58c18151396e867$export$13d65d67292f85af = {}));


var $b9fbf0da9ae592a3$exports = {};

$parcel$export($b9fbf0da9ae592a3$exports, "SurchargeIDEnum", () => $b9fbf0da9ae592a3$export$7abcfbf1506b8afd);
$parcel$export($b9fbf0da9ae592a3$exports, "SurchargeNameEnum", () => $b9fbf0da9ae592a3$export$10e2677d41a27589);
$parcel$export($b9fbf0da9ae592a3$exports, "TaxIDEnum", () => $b9fbf0da9ae592a3$export$8690e4d320ed0153);
$parcel$export($b9fbf0da9ae592a3$exports, "NotificationCategoriesEnum", () => $b9fbf0da9ae592a3$export$30eb8df08b0ba90a);
$parcel$export($b9fbf0da9ae592a3$exports, "NotificationCategoryIdEnum", () => $b9fbf0da9ae592a3$export$979471efb8d9682);
$parcel$export($b9fbf0da9ae592a3$exports, "NotificationEndpointFilterCategory", () => $b9fbf0da9ae592a3$export$14684659e132560d);
$parcel$export($b9fbf0da9ae592a3$exports, "NotificationEndpointFilterStatus", () => $b9fbf0da9ae592a3$export$443a1f41470876f9);
$parcel$export($b9fbf0da9ae592a3$exports, "NotificationLevelsEnum", () => $b9fbf0da9ae592a3$export$6f72bc6ab39ca5cd);
$parcel$export($b9fbf0da9ae592a3$exports, "DamageDepositModeId", () => $b9fbf0da9ae592a3$export$3e6477125daf98da);
$parcel$export($b9fbf0da9ae592a3$exports, "PropertyTaxIDEnum", () => $b9fbf0da9ae592a3$export$6ba288b3069f362);
$parcel$export($b9fbf0da9ae592a3$exports, "PropertyAmenityId", () => $b9fbf0da9ae592a3$export$ca089115c6d1f1f);
$parcel$export($b9fbf0da9ae592a3$exports, "LocationURLParamsEnum", () => $b9fbf0da9ae592a3$export$820ef0da71e57e4b);
$parcel$export($b9fbf0da9ae592a3$exports, "ToastVariants", () => $b9fbf0da9ae592a3$export$811d140419a2df);
$parcel$export($b9fbf0da9ae592a3$exports, "NotificationStatus", () => $b9fbf0da9ae592a3$export$ff1b23e7fbed6ad5);
let $b9fbf0da9ae592a3$export$7abcfbf1506b8afd;
(function(SurchargeIDEnum1) {
    SurchargeIDEnum1[SurchargeIDEnum1["cleaningFee"] = 1] = "cleaningFee";
    SurchargeIDEnum1[SurchargeIDEnum1["petFee"] = 2] = "petFee";
})($b9fbf0da9ae592a3$export$7abcfbf1506b8afd || ($b9fbf0da9ae592a3$export$7abcfbf1506b8afd = {}));
let $b9fbf0da9ae592a3$export$10e2677d41a27589;
(function(SurchargeNameEnum1) {
    SurchargeNameEnum1["cleaning"] = "CLEANING";
    SurchargeNameEnum1["pet"] = "PETS";
})($b9fbf0da9ae592a3$export$10e2677d41a27589 || ($b9fbf0da9ae592a3$export$10e2677d41a27589 = {}));
let $b9fbf0da9ae592a3$export$8690e4d320ed0153;
(function(TaxIDEnum1) {
    TaxIDEnum1[TaxIDEnum1["GST"] = 1] = "GST";
    TaxIDEnum1[TaxIDEnum1["PST"] = 2] = "PST";
    TaxIDEnum1[TaxIDEnum1["MRDT"] = 19] = "MRDT";
})($b9fbf0da9ae592a3$export$8690e4d320ed0153 || ($b9fbf0da9ae592a3$export$8690e4d320ed0153 = {}));
let $b9fbf0da9ae592a3$export$30eb8df08b0ba90a;
(function(NotificationCategoriesEnum1) {
    NotificationCategoriesEnum1["NEWS"] = "news";
    NotificationCategoriesEnum1["BOOKING"] = "booking";
    NotificationCategoriesEnum1["FINANCE"] = "finance";
    NotificationCategoriesEnum1["INQUIRIES"] = "inquiry";
    NotificationCategoriesEnum1["PROPERTIES"] = "properties";
    NotificationCategoriesEnum1["REVIEW"] = "review";
    NotificationCategoriesEnum1["RESERVATION_REQUEST"] = "reservation_request";
    NotificationCategoriesEnum1["SUBSCRIPTION_RENEWAL"] = "subscription_renewal";
    NotificationCategoriesEnum1["UNBOOKABLE_DATES"] = "unbookable_dates";
    NotificationCategoriesEnum1["UPDATE_LISTING"] = "update_listing";
})($b9fbf0da9ae592a3$export$30eb8df08b0ba90a || ($b9fbf0da9ae592a3$export$30eb8df08b0ba90a = {}));
let $b9fbf0da9ae592a3$export$979471efb8d9682;
(function(NotificationCategoryIdEnum1) {
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["ALLURA_NEWS"] = 1] = "ALLURA_NEWS";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["BOOKING"] = 2] = "BOOKING";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["FINANCE"] = 3] = "FINANCE";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["INQUIRY"] = 4] = "INQUIRY";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["REVIEW"] = 5] = "REVIEW";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1[/** Appears when a property is in gateway closed mode */ "RESERVATION_REQUEST"] = 6] = "RESERVATION_REQUEST";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["SUBSCRIPTION_RENEWAL"] = 7] = "SUBSCRIPTION_RENEWAL";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["UNBOOKABLE_DATES"] = 8] = "UNBOOKABLE_DATES";
    NotificationCategoryIdEnum1[NotificationCategoryIdEnum1["UPDATE_LISTING"] = 9] = "UPDATE_LISTING";
})($b9fbf0da9ae592a3$export$979471efb8d9682 || ($b9fbf0da9ae592a3$export$979471efb8d9682 = {}));
let $b9fbf0da9ae592a3$export$14684659e132560d;
(function(NotificationEndpointFilterCategory1) {
    NotificationEndpointFilterCategory1["NEWS"] = "news";
    NotificationEndpointFilterCategory1["FEATURED"] = "featured";
    NotificationEndpointFilterCategory1["PRIMARY"] = "primary";
})($b9fbf0da9ae592a3$export$14684659e132560d || ($b9fbf0da9ae592a3$export$14684659e132560d = {}));
let $b9fbf0da9ae592a3$export$443a1f41470876f9;
(function(NotificationEndpointFilterStatus1) {
    NotificationEndpointFilterStatus1["ALL"] = "all";
    NotificationEndpointFilterStatus1["DISMISSED"] = "dismissed";
    NotificationEndpointFilterStatus1["ACTIVE"] = "active";
})($b9fbf0da9ae592a3$export$443a1f41470876f9 || ($b9fbf0da9ae592a3$export$443a1f41470876f9 = {}));
let $b9fbf0da9ae592a3$export$6f72bc6ab39ca5cd;
(function(NotificationLevelsEnum1) {
    NotificationLevelsEnum1["INFORMATIONAL"] = "informational";
    NotificationLevelsEnum1["DEADLINE_APPROACHING"] = "deadline approaching";
    NotificationLevelsEnum1["REQUIRES_ACTION"] = "requires action";
    NotificationLevelsEnum1["URGENT_NOTICE"] = "urgent notice";
})($b9fbf0da9ae592a3$export$6f72bc6ab39ca5cd || ($b9fbf0da9ae592a3$export$6f72bc6ab39ca5cd = {}));
let $b9fbf0da9ae592a3$export$3e6477125daf98da;
(function(DamageDepositModeId1) {
    DamageDepositModeId1[DamageDepositModeId1[// Charge CC at guest arrival
    "COLLECT_AT_CHECKIN"] = 1] = "COLLECT_AT_CHECKIN";
    DamageDepositModeId1[DamageDepositModeId1[// Collect at a balance payment sometime starting 45 days before arrival
    "COLLECT_45_DAYS_BEFORE_ARRIVAL"] = 3] = "COLLECT_45_DAYS_BEFORE_ARRIVAL";
    DamageDepositModeId1[DamageDepositModeId1[// Charge if property is damaged
    "COLLECT_DAMAGE_UPON_DEPARTURE"] = 4] = "COLLECT_DAMAGE_UPON_DEPARTURE";
})($b9fbf0da9ae592a3$export$3e6477125daf98da || ($b9fbf0da9ae592a3$export$3e6477125daf98da = {}));
let $b9fbf0da9ae592a3$export$6ba288b3069f362;
(function(PropertyTaxIDEnum1) {
    PropertyTaxIDEnum1[PropertyTaxIDEnum1["GST"] = 1] = "GST";
    PropertyTaxIDEnum1[PropertyTaxIDEnum1["PST_BC"] = 2] = "PST_BC";
    PropertyTaxIDEnum1[PropertyTaxIDEnum1["MRDT_WHISTLER"] = 19] = "MRDT_WHISTLER";
})($b9fbf0da9ae592a3$export$6ba288b3069f362 || ($b9fbf0da9ae592a3$export$6ba288b3069f362 = {}));
let $b9fbf0da9ae592a3$export$ca089115c6d1f1f;
(function(PropertyAmenityId1) {
    PropertyAmenityId1[PropertyAmenityId1["PRIVATE_SKI_STORAGE"] = 14] = "PRIVATE_SKI_STORAGE";
    PropertyAmenityId1[PropertyAmenityId1["PRIVATE_BIKE_STORAGE"] = 15] = "PRIVATE_BIKE_STORAGE";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_BIKE_STORAGE"] = 21] = "BUILDING_BIKE_STORAGE";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_SKI_STORAGE"] = 22] = "BUILDING_SKI_STORAGE";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_HOT_TUB"] = 25] = "BUILDING_HOT_TUB";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_SAUNA"] = 26] = "BUILDING_SAUNA";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_STEAM_ROOM"] = 27] = "BUILDING_STEAM_ROOM";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_POOL"] = 28] = "BUILDING_POOL";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_FITNESS_FACILITIES"] = 30] = "BUILDING_FITNESS_FACILITIES";
    PropertyAmenityId1[PropertyAmenityId1["BUILDING_GAMES_REC_ROOM"] = 31] = "BUILDING_GAMES_REC_ROOM";
    PropertyAmenityId1[PropertyAmenityId1["WIFI"] = 93] = "WIFI";
})($b9fbf0da9ae592a3$export$ca089115c6d1f1f || ($b9fbf0da9ae592a3$export$ca089115c6d1f1f = {}));
let $b9fbf0da9ae592a3$export$820ef0da71e57e4b;
(function(LocationURLParamsEnum1) {
    LocationURLParamsEnum1["developments"] = "developments";
    LocationURLParamsEnum1["countries"] = "countries";
    LocationURLParamsEnum1["resorts"] = "resorts";
    LocationURLParamsEnum1["regions"] = "regions";
    LocationURLParamsEnum1["areas"] = "areas";
    LocationURLParamsEnum1["property_categories"] = "property_categories";
})($b9fbf0da9ae592a3$export$820ef0da71e57e4b || ($b9fbf0da9ae592a3$export$820ef0da71e57e4b = {}));
let $b9fbf0da9ae592a3$export$811d140419a2df;
(function(ToastVariants1) {
    ToastVariants1["default"] = "default";
    ToastVariants1["error"] = "error";
    ToastVariants1["success"] = "success";
    ToastVariants1["warning"] = "warning";
    ToastVariants1["info"] = "info";
})($b9fbf0da9ae592a3$export$811d140419a2df || ($b9fbf0da9ae592a3$export$811d140419a2df = {}));
let $b9fbf0da9ae592a3$export$ff1b23e7fbed6ad5;
(function(NotificationStatus1) {
    NotificationStatus1["DISMISSED"] = "dismissed";
    NotificationStatus1["ACTIVE"] = "";
})($b9fbf0da9ae592a3$export$ff1b23e7fbed6ad5 || ($b9fbf0da9ae592a3$export$ff1b23e7fbed6ad5 = {}));


const $e15de41ca5b185e2$export$aadd5873ed3eb0a9 = "/RESTAUTH/property/emergencycontact/";
const $e15de41ca5b185e2$export$3303ec1fdff02a79 = "/RESTAUTH/property/bookings/filtered/";
const $e15de41ca5b185e2$export$1adac3ffd69c52c4 = "/RESTAUTH/property/bookings/paginated/";
const $e15de41ca5b185e2$export$ef60b8f88a5bae47 = `/RESTAUTH/property/calendardates/`;
const $e15de41ca5b185e2$export$9d51734ff699182c = "/RESTAUTH/property/cancellationpolicy/";
const $e15de41ca5b185e2$export$63dc1bc5f6311c25 = `/RESTAUTH/property/checkinemail/`;
const $e15de41ca5b185e2$export$165758497584710c = "/RESTAUTH/property/content/";
const $e15de41ca5b185e2$export$8a21b744be4eceec = "/RESTAUTH/property/directvacationslogo/";
const $e15de41ca5b185e2$export$d906595e68b25fbc = "/RESTAUTH/property/directvacationssubdomain/";
const $e15de41ca5b185e2$export$944ab5648f9de932 = `/RESTAUTH/property/externalurls/`;
const $e15de41ca5b185e2$export$6da8321ca4a496ec = "/RESTAUTH/property/forminput/";
const $e15de41ca5b185e2$export$1e71601f89ebe16e = "/RESTAUTH/property/instructions/";
const $e15de41ca5b185e2$export$9eb82b7824e5dd04 = "/RESTAUTH/property/photo/sort/";
const $e15de41ca5b185e2$export$3c2c60a58101835d = `/RESTAUTH/property/photo/`;
const $e15de41ca5b185e2$export$7bee553f09f3bac1 = "/RESTAUTH/property/amenity/";
const $e15de41ca5b185e2$export$fb417a0ab4848855 = `/RESTAUTH/property/blockoff/`;
const $e15de41ca5b185e2$export$cddb2a04459beb7b = "/RESTAUTH/property/defaultcontent/";
const $e15de41ca5b185e2$export$f3a6164b81299928 = `/RESTAUTH/property/walkthrough/propertyguidebook/`;
const $e15de41ca5b185e2$export$68b9f535dd6d354c = "/RESTAUTH/property/ical/";
const $e15de41ca5b185e2$export$7fff7d6ded248882 = "/RESTAUTH/property/nonresidentsubscription/";
const $e15de41ca5b185e2$export$d4e84423c6d944da = `/RESTAUTH/property/policies/`;
const $e15de41ca5b185e2$export$b845c70a33b15f42 = "/RESTAUTH/property/rategroup/";
const $e15de41ca5b185e2$export$79b83e54141a5fed = "/RESTAUTH/property/rateschedule/generate/";
const $e15de41ca5b185e2$export$d5bcdfe94d5c1562 = "/RESTAUTH/property/transactions/";
const $e15de41ca5b185e2$export$7fa125c30efe2e4d = "/RESTAUTH/property/video/";
const $e15de41ca5b185e2$export$17b51878a0a31c87 = "/RESTAUTH/property/rateschedule/";
const $e15de41ca5b185e2$export$250c9f01051e965c = "/RESTAUTH/property/rentalagreement/";
const $e15de41ca5b185e2$export$121d7a716be5f06e = `/RESTAUTH/property/resendreceipt/`;
const $e15de41ca5b185e2$export$58e0cb00f24cc8f3 = "/RESTAUTH/property/reservationrequest/";
const $e15de41ca5b185e2$export$4f25634e4176fe8a = "/RESTAUTH/property/reservationsettings/";
const $e15de41ca5b185e2$export$f72fb329c420e262 = "/RESTAUTH/property/season/";
const $e15de41ca5b185e2$export$eaf7e24ac4a8bddc = "/RESTAUTH/property/subform/";
const $e15de41ca5b185e2$export$cbc18e2f0f3c422f = ({ propertyId: propertyId , startDate: startDate , endDate: endDate , status: status , sort: sort , source: source  })=>{
    return `/RESTAUTH/property/bookings/filtered/?start=${startDate}&end=${endDate}&filter_by=${sort}&source=${source}&id=${propertyId}&status=${status}`;
};
const $e15de41ca5b185e2$export$ea291c08a781f86d = (propertyId)=>`/RESTAUTH/property/propertyguidebook/?id=${propertyId}`;
const $e15de41ca5b185e2$export$677d92663e6c9702 = (propertyId)=>`/RESTAUTH/property/propertyguidebook/pdf/base64/?id=${propertyId}`;
const $e15de41ca5b185e2$export$f38251b9cee2c092 = (propertyId)=>`/RESTAUTH/property/checkinlegacyhtml/?id=${propertyId}`;
const $e15de41ca5b185e2$export$d7daed75cabb6158 = (bookingId, includeTimeline = false)=>{
    const timelineParam = includeTimeline ? `&include_timeline=${includeTimeline}` : "";
    return `/RESTAUTH/property/booking/?id=${bookingId}${timelineParam}`;
};
const $e15de41ca5b185e2$export$b1a019ef0b9d9c55 = ({ propertyId: propertyId , num_months: num_months , start_date: start_date , is_replace: is_replace = false  })=>{
    return `/RESTAUTH/property/rateschedule/generate/rategroup/?id=${propertyId}&num_months=${num_months}&start_date=${start_date}&is_replace=${is_replace}`;
};
const $e15de41ca5b185e2$export$b4f7dd00106f4e45 = ({ propertyId: propertyId , num_months: num_months , start_date: /** The starting date to generate insight rates. The last date of existing date ranges or today if replacing */ start_date , rate_insights_level_id: rate_insights_level_id , is_preview: /** Avoid using owner edit dates and no rates dates for graphing previews */ is_preview = false , is_replace: is_replace = false  })=>{
    return `/RESTAUTH/property/rateschedule/generate/insight/?id=${propertyId}&rate_insights_level_id=${rate_insights_level_id}&num_months=${num_months}&start_date=${start_date}&is_preview=${is_preview}&is_replace=${is_replace}`;
};
const $e15de41ca5b185e2$export$508b48b1fca2233e = "/RESTAUTH/property/rateschedule/generate/optimize/";
const $e15de41ca5b185e2$export$b6332f8545187af = (propertyId)=>`/RESTAUTH/property/codes/?id=${propertyId}`;
const $e15de41ca5b185e2$export$f5000ba6800436e4 = ({ propertyId: propertyId , mode: mode = (0, $f58c18151396e867$export$b465bf62bb901487).DEFAULT  })=>{
    return `${$e15de41ca5b185e2$export$79b83e54141a5fed}${mode ? mode : ""}?id=${propertyId}`;
};
const $e15de41ca5b185e2$export$d05cf022d0ab7576 = (propertyId)=>`/RESTAUTH/property/photos/?id=${propertyId}`;
const $e15de41ca5b185e2$export$f3777fcf4347a5e4 = (propertyId)=>`/RESTAUTH/property/formInput/?id=${propertyId}`;
const $e15de41ca5b185e2$export$58ed2e7b62cd77df = ({ amount: amount = 10 , direction: direction = "future" , page: page = 1 , status_id: status_id , propertyId: propertyId  })=>{
    const status_id_string = status_id ? `&status_id=${status_id}` : "";
    return `${$e15de41ca5b185e2$export$1adac3ffd69c52c4}?id=${propertyId}&page=${page}&amount_per_page=${amount}&page_direction=${direction}${status_id_string}`;
};
const $e15de41ca5b185e2$export$e6c967c7a3157c17 = (propertyId)=>`/RESTAUTH/property/externalbookings/?id=${propertyId}`;
const $e15de41ca5b185e2$export$5da7f2af0f6f2866 = (propertyId)=>`/RESTAUTH/property/ical/resync?id=${propertyId}`;
const $e15de41ca5b185e2$export$d439d8afdae174fa = (propertyId)=>`/RESTAUTH/property/?id=${propertyId}`;
const $e15de41ca5b185e2$export$9f5725612a8acbef = (propertyId)=>`/RESTAUTH/property/?id=${propertyId}`;
const $e15de41ca5b185e2$export$2392f883c0d42e50 = ({ amountPerPage: amountPerPage , status: status = (0, $b9fbf0da9ae592a3$export$443a1f41470876f9).ACTIVE , category: category = (0, $b9fbf0da9ae592a3$export$14684659e132560d).PRIMARY , propertyId: propertyId , page: page = 1  })=>{
    return `/RESTAUTH/property/notifications/?id=${propertyId}&page=${page}&amount_per_page=${amountPerPage}&category=${category}&status=${status}`;
};
const $e15de41ca5b185e2$export$53e102228cc1a763 = "/RESTAUTH/property/notifications/dismiss/";
const $e15de41ca5b185e2$export$f7e2a9deba265545 = (propertyId, notificationIds)=>{
    return `/RESTAUTH/property/notifications/dismiss/?id=${propertyId}&notification_ids=${notificationIds}`;
};
const $e15de41ca5b185e2$export$a707cd72801d58c1 = ({ propertyId: propertyId , page: page , amountPerPage: amountPerPage , pageDirection: pageDirection  })=>`/RESTAUTH/property/reviews/?id=${propertyId}&page=${page}&amount_per_page=${amountPerPage}&page_direction=${pageDirection}`;
const $e15de41ca5b185e2$export$21b9e07c53b03d0a = (propertyId)=>`/RESTAUTH/property/requestactivation/?id=${propertyId}`;
const $e15de41ca5b185e2$export$faaf651cb1c1cc08 = ({ bookingId: bookingId = null , propertyId: propertyId  })=>`/RESTAUTH/property/unavailability/?id=${propertyId}${bookingId ? `&booking_id=${bookingId}` : ""}`;
const $e15de41ca5b185e2$export$9b59b882fec09fbc = (propertyId)=>`/RESTAUTH/property/lastandnextguest/?id=${propertyId}`;
const $e15de41ca5b185e2$export$7acf4e877f505419 = (propertyId)=>`/RESTAUTH/property/bankdeposits/?id=${propertyId}`;
const $e15de41ca5b185e2$export$d7e2dae541011158 = (propertyId, contentType)=>{
    return `${$e15de41ca5b185e2$export$cddb2a04459beb7b}?id=${propertyId}&content=${contentType}`;
};
const $e15de41ca5b185e2$export$19b0adbfaded7879 = (propertyId)=>{
    return `${$e15de41ca5b185e2$export$944ab5648f9de932}?id=${propertyId}`;
};
const $e15de41ca5b185e2$export$be31c437417f9eea = ({ propertyId: propertyId  })=>`/RESTAUTH/property/checkinemail/?id=${propertyId}`;
const $e15de41ca5b185e2$export$383708ed9a9d0e95 = (propertyId)=>`${$e15de41ca5b185e2$export$250c9f01051e965c}?id=${propertyId}`;
const $e15de41ca5b185e2$export$e4bd279bd004f6f3 = ({ propertyId: propertyId , startDate: startDate , endDate: endDate  })=>`/RESTAUTH/property/calendarevents/?id=${propertyId}&start=${startDate}&end=${endDate}`;
const $e15de41ca5b185e2$export$76a91356b9c78084 = ({ propertyId: propertyId , startDate: startDate , endDate: endDate  })=>`/RESTAUTH/property/calendardates/?id=${propertyId}&start=${startDate}&end=${endDate}`;
const $e15de41ca5b185e2$export$7838eaf7de460919 = (propertyId)=>`/RESTAUTH/property/reservationrequest/?id=${propertyId}`;
const $e15de41ca5b185e2$export$42e2d76e5fe1e90d = ({ propertyId: propertyId  })=>{
    return `/RESTAUTH/property/ratesuggestion/?id=${propertyId}`;
};
const $e15de41ca5b185e2$export$c3c8c105fac41d59 = (propertyId)=>{
    return `/RESTAUTH/property/blockoffs/?id=${propertyId}`;
};




const $8ad86f241ad28bc7$var$select = (data)=>data.DATA.BOOKING;
const $8ad86f241ad28bc7$export$10d1544eb8be6d51 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("PROPERTY_BOOKING");
const $8ad86f241ad28bc7$export$24675aafedc57d7c = ({ isEnabled: isEnabled = true , bookingId: bookingId = 0 , includeTimeline: includeTimeline = false , onSuccess: onSuccess = ()=>null , onError: onError = ()=>null  })=>{
    const endpoint = (0, $e15de41ca5b185e2$export$d7daed75cabb6158)(bookingId, includeTimeline);
    const queryKey = $8ad86f241ad28bc7$export$10d1544eb8be6d51.detail(endpoint);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        queryKey: queryKey,
        select: $8ad86f241ad28bc7$var$select,
        enabled: isEnabled,
        onSuccess: onSuccess,
        onError: onError
    });
};


const $62a802691632c607$export$315a9b26340f0763 = ({ bookingId: bookingId , isOwnerRole: isOwnerRole , isGuestRole: isGuestRole , guestId: guestId = 0 , isEnabled: isEnabled = true , onSuccess: onSuccess = ()=>null , includeTimeline: includeTimeline = false , ownerOffer: ownerOffer , alluraOffer: alluraOffer , alluraGiftCertificate: alluraGiftCertificate , ownerGiftCertificate: ownerGiftCertificate  })=>{
    const ownerBookingQuery = (0, $8ad86f241ad28bc7$export$24675aafedc57d7c)({
        isEnabled: isOwnerRole && isEnabled,
        bookingId: bookingId,
        onSuccess: onSuccess
    });
    const guestBookingQuery = (0, $7cdb244188f67081$export$17635debff393857)({
        bookingId: bookingId,
        guestId: guestId,
        includeTimeline: includeTimeline,
        isEnabled: isGuestRole && isEnabled,
        onSuccess: onSuccess,
        alluraOffer: alluraOffer,
        ownerOffer: ownerOffer,
        alluraGiftCertificate: alluraGiftCertificate,
        ownerGiftCertificate: ownerGiftCertificate
    });
    return isOwnerRole ? ownerBookingQuery : guestBookingQuery;
};



var $b28bbbf288bb2fb3$exports = {};

$parcel$export($b28bbbf288bb2fb3$exports, "guestBookingsQueryKeys", () => $b28bbbf288bb2fb3$export$37bf5e939be3d10f);
$parcel$export($b28bbbf288bb2fb3$exports, "useGuestBookingsQuery", () => $b28bbbf288bb2fb3$export$6af04eb940943d0d);



const $b28bbbf288bb2fb3$var$select = (item)=>item.DATA.BOOKINGS;
const $b28bbbf288bb2fb3$export$37bf5e939be3d10f = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("GUEST_BOOKINGS");
const $b28bbbf288bb2fb3$export$6af04eb940943d0d = ({ direction: direction = "future" , statusId: statusId , enabled: enabled = true , guestId: guestId  })=>{
    const endpoint = (0, $39ac3dd98f21da43$export$cef2c5b8f75ddc4c)({
        guestId: guestId,
        direction: direction,
        statusIdFilter: statusId
    });
    const queryKey = $b28bbbf288bb2fb3$export$37bf5e939be3d10f.detail(endpoint);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        queryKey: queryKey,
        select: $b28bbbf288bb2fb3$var$select,
        enabled: enabled
    });
};


var $374209dcfecaa202$exports = {};

$parcel$export($374209dcfecaa202$exports, "guestPaymentDueQueryKey", () => $374209dcfecaa202$export$b04c4b3ec96dce56);
$parcel$export($374209dcfecaa202$exports, "useGuestPaymentDueQuery", () => $374209dcfecaa202$export$8e780df423e01629);



const $374209dcfecaa202$var$select = (data)=>data.DATA;
const $374209dcfecaa202$export$b04c4b3ec96dce56 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("BOOKING_PAYMENT");
const $374209dcfecaa202$export$8e780df423e01629 = ({ bookingId: bookingId , guestId: guestId , isEnabled: isEnabled = true  })=>{
    const url = (0, $39ac3dd98f21da43$export$ef97ee06d59623a3)(bookingId, guestId);
    const queryKey = $374209dcfecaa202$export$b04c4b3ec96dce56.detail(url);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: url,
        queryKey: queryKey,
        select: $374209dcfecaa202$var$select,
        enabled: isEnabled
    });
};


var $7bf8dd342faae788$exports = {};

$parcel$export($7bf8dd342faae788$exports, "rentalAgreementSummaryQueryKey", () => $7bf8dd342faae788$export$719ba319b45cf061);
$parcel$export($7bf8dd342faae788$exports, "useRentalAgreementSummaryQuery", () => $7bf8dd342faae788$export$b13ad76215175b12);



const $7bf8dd342faae788$var$select = (data)=>data?.DATA?.RENTAL_AGREEMENT;
const $7bf8dd342faae788$export$719ba319b45cf061 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("rentalAgreement");
const $7bf8dd342faae788$export$b13ad76215175b12 = ({ enabled: enabled = true , bookingId: bookingId , guestId: guestId  })=>{
    const endpoint = (0, $39ac3dd98f21da43$export$fa0677fddbd65e5a)(bookingId, guestId);
    const queryKey = $7bf8dd342faae788$export$719ba319b45cf061.detail(endpoint);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        queryKey: queryKey,
        select: $7bf8dd342faae788$var$select,
        enabled: enabled
    });
};


var $f2f669699f07846a$exports = {};

$parcel$export($f2f669699f07846a$exports, "generateBookingQuoteEndpoint", () => $f2f669699f07846a$export$26f60ad45499ead1);
$parcel$export($f2f669699f07846a$exports, "generateBookingQuoteQueryKeyDetail", () => $f2f669699f07846a$export$304258cb53ef9aa3);
$parcel$export($f2f669699f07846a$exports, "bookingQuoteQueryKey", () => $f2f669699f07846a$export$b432b9b53bfaf1dd);
$parcel$export($f2f669699f07846a$exports, "useBookingQuoteQuery", () => $f2f669699f07846a$export$2973c71a6ce395f);

var $72dc1ad4ce2b3683$exports = {};

$parcel$export($72dc1ad4ce2b3683$exports, "encodeParams", () => $72dc1ad4ce2b3683$export$59238e610c6e598a);
$parcel$export($72dc1ad4ce2b3683$exports, "generateFormData", () => $72dc1ad4ce2b3683$export$672675b98543445b);
$parcel$export($72dc1ad4ce2b3683$exports, "generateBodyParams", () => $72dc1ad4ce2b3683$export$f4336949202e6c0e);
$parcel$export($72dc1ad4ce2b3683$exports, "generateFormDataBodyParams", () => $72dc1ad4ce2b3683$export$4df535868dd446ac);
$parcel$export($72dc1ad4ce2b3683$exports, "generateURLParams", () => $72dc1ad4ce2b3683$export$f2e1282f226723ac);
$parcel$export($72dc1ad4ce2b3683$exports, "generateParamsString", () => $72dc1ad4ce2b3683$export$bb0ece766f8aad9c);
$parcel$export($72dc1ad4ce2b3683$exports, "flattenApiPages", () => $72dc1ad4ce2b3683$export$a90bfd0a4ae1116f);
var $6690144fb7fdc900$exports = {};

$parcel$export($6690144fb7fdc900$exports, "arrayMove", () => $6690144fb7fdc900$export$5d49d615ad5ea2b0);
$parcel$export($6690144fb7fdc900$exports, "createEmptyArray", () => $6690144fb7fdc900$export$bf8eb9635f3a8a5e);
$parcel$export($6690144fb7fdc900$exports, "flattenArray", () => $6690144fb7fdc900$export$2fae38c2d7691313);
function $6690144fb7fdc900$export$5d49d615ad5ea2b0(arr, oldIndex, newIndex) {
    const copy = [
        ...arr
    ];
    // Remove the element at the old index
    const cutElem = copy.splice(oldIndex, 1)[0];
    // Insert the element back into the array at the new index
    copy.splice(newIndex, 0, cutElem);
    return copy;
}
function $6690144fb7fdc900$export$bf8eb9635f3a8a5e(length) {
    return [
        ...Array(length)
    ];
}
function $6690144fb7fdc900$export$2fae38c2d7691313(arr) {
    return arr.reduce((acc, val)=>acc.concat(val), []);
}


const $72dc1ad4ce2b3683$export$59238e610c6e598a = (params)=>{
    let paramString = "";
    Object.entries(params).forEach((param)=>{
        const [key, value] = param;
        if (typeof value === "object" || Array.isArray(value) && typeof value[0] === "object") {
            paramString += `${key}=${encodeURIComponent(JSON.stringify(value))}`;
            return;
        }
        paramString += `${key}=${value}&`;
    });
    // This encodeString function will be encoded again, so have to remove the "values" part of the string. Not the cleanest but works for now
    const paramStringWithoutValuesKey = paramString.replace("values=", "");
    return paramStringWithoutValuesKey;
};
const $72dc1ad4ce2b3683$export$672675b98543445b = (params)=>{
    const urlencoded = new FormData();
    for(const key in params){
        const value = params[key];
        if (value === undefined) // This function silently fails if there is an undefined value
        // We need this throw to alert us of this problem
        throw new Error(`${key} is undefined value in your params`);
        if (value === typeof Array || value === typeof Object) urlencoded.append(key.toString(), JSON.stringify(params[key]));
        else urlencoded.append(key.toString(), params[key].toString());
    }
    return urlencoded;
};
const $72dc1ad4ce2b3683$export$f4336949202e6c0e = (params)=>{
    const urlencoded = new URLSearchParams();
    for(const key in params){
        const value = params[key];
        if (value === undefined) // This function silently fails if there is an undefined value
        // We need this throw to alert us of this problem
        throw new Error(`${key} is undefined value in your params`);
        if (value === typeof Array || value === typeof Object) urlencoded.append(key.toString(), JSON.stringify(params[key]));
        else urlencoded.append(key.toString(), params[key].toString());
    }
    return urlencoded;
};
const $72dc1ad4ce2b3683$export$4df535868dd446ac = (params)=>{
    const formData = new FormData();
    for(const key in params){
        const value = params[key];
        if (value === undefined) // This function silently fails if there is an undefined value
        // We need this throw to alert us of this problem
        throw new Error(`${key} is undefined value in your params`);
        if (value === typeof Array || value === typeof Object) formData.append(key.toString(), JSON.stringify(params[key]));
        else formData.append(key.toString(), params[key].toString());
    }
    return formData;
};
const $72dc1ad4ce2b3683$export$f2e1282f226723ac = (params)=>{
    const searchParams = new URLSearchParams({
        ...params
    });
    return searchParams.toString();
};
const $72dc1ad4ce2b3683$export$bb0ece766f8aad9c = (params)=>{
    const searchParams = new URLSearchParams({
        ...params
    });
    return searchParams.toString();
};
function $72dc1ad4ce2b3683$export$a90bfd0a4ae1116f(data, key) {
    if (!data || !data.pages) return [];
    const mappedData = data.pages.map((page)=>page.DATA[key]);
    const flattenedData = (0, $6690144fb7fdc900$export$2fae38c2d7691313)(mappedData);
    return flattenedData;
}




const $f2f669699f07846a$export$26f60ad45499ead1 = (quoteParams)=>{
    const endpoint = (0, $2026a49d34582011$export$be4ce9f65a783fe3);
    const paramsString = (0, $72dc1ad4ce2b3683$export$bb0ece766f8aad9c)(quoteParams);
    return `${endpoint}?${paramsString}`;
};
const $f2f669699f07846a$export$304258cb53ef9aa3 = (quoteParams)=>{
    const keys = Object.keys(quoteParams);
    // In order to produce a stable string for the queryKey detail, we need to sort the params that are being passed into the
    // queryKey. the sort function will produce a stable key
    const sortedKeys = keys.sort().reduce((accumulator, key)=>{
        const value = quoteParams[key];
        return {
            ...accumulator,
            [key]: value
        };
    }, {});
    return $f2f669699f07846a$export$b432b9b53bfaf1dd.detail(JSON.stringify(sortedKeys));
};
const $f2f669699f07846a$export$b432b9b53bfaf1dd = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("booking-quote");
const $f2f669699f07846a$export$2973c71a6ce395f = ({ quoteParams: quoteParams , isEnabled: isEnabled , onSuccess: onSuccess = ()=>null , onError: onError = ()=>null , onSettled: onSettled = ()=>null  })=>{
    const url = $f2f669699f07846a$export$26f60ad45499ead1(quoteParams);
    const queryKey = $f2f669699f07846a$export$304258cb53ef9aa3(quoteParams);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: url,
        queryKey: queryKey,
        enabled: isEnabled,
        staleTime: Infinity,
        onSuccess: onSuccess,
        onError: onError,
        onSettled: onSettled,
        hasToastsEnabled: true,
        retry: 1,
        useErrorBoundary: true
    });
};


var $0bc40ca8ae52b6bb$exports = {};

$parcel$export($0bc40ca8ae52b6bb$exports, "useBookingCancellationQuery", () => $0bc40ca8ae52b6bb$export$e7394aeadb66c4b4);



const $0bc40ca8ae52b6bb$export$e7394aeadb66c4b4 = ({ bookingId: bookingId  })=>{
    const queryKey = (0, $04e57a2246bdbee0$export$81fc3df80b283228)(`cancellationDetail`);
    const endpoint = (0, $2026a49d34582011$export$9e5d0db7a2a8bc81)(String(bookingId));
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        queryKey: queryKey.detail(String(bookingId)),
        endpoint: endpoint
    });
};


var $a714c13918d8ca5b$exports = {};

$parcel$export($a714c13918d8ca5b$exports, "useGetCreditsOverviewQuery", () => $a714c13918d8ca5b$export$43431d1c7482aabf);
var $0785fd2fa3fb450c$exports = {};

$parcel$export($0785fd2fa3fb450c$exports, "generateCreditsOverviewEndpoint", () => $0785fd2fa3fb450c$export$701915a0dac701da);
const $0785fd2fa3fb450c$export$701915a0dac701da = (userId)=>{
    return `/dj/v1/credits/overview/?user_id=${userId}`;
};



const $a714c13918d8ca5b$export$43431d1c7482aabf = ({ userId: userId , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $0785fd2fa3fb450c$export$701915a0dac701da)(userId),
        ...rest
    });
};


var $89862bbf0394a4aa$exports = {};

$parcel$export($89862bbf0394a4aa$exports, "guestBookingsInfiniteQueryKeys", () => $89862bbf0394a4aa$export$bd710b640bc4fa45);
$parcel$export($89862bbf0394a4aa$exports, "useGuestBookingsInfiniteQuery", () => $89862bbf0394a4aa$export$41b8577d0926ead9);


var $5c3888846488886d$exports = {};

$parcel$export($5c3888846488886d$exports, "useAppInfiniteQuery", () => $5c3888846488886d$export$a1eb5d1bcb4f35a6);



const $5c3888846488886d$export$a1eb5d1bcb4f35a6 = (args)=>{
    const { isOffline: isOffline , queryFn: queryFn  } = (0, $581d20e8b41cc3bb$export$919315ccd62888e6)();
    const selectFn = ()=>{
        if ("defaultSelect" in args && "nextPageKey" in args) return (data)=>{
            return (0, $72dc1ad4ce2b3683$export$a90bfd0a4ae1116f)(data, args.nextPageKey);
        };
        else return undefined;
    };
    return (0, $iPNDK$useInfiniteQuery)({
        queryKey: args.queryKey,
        enabled: args.enabled ?? true,
        queryFn: ({ pageParam: pageParam = args.initialPageParam  })=>{
            const url = args.urlFn(pageParam);
            return queryFn(url, {
                isOffline: isOffline
            });
        },
        getNextPageParam: (lastPage, pages)=>{
            if ("nextPageFn" in args) return args.nextPageFn(lastPage, pages);
            else if ("nextPageKey" in args) {
                if (!lastPage) return args.initialPageParam;
                const arrayData = lastPage?.DATA[args.nextPageKey];
                if (!arrayData || arrayData?.length < args.amountPerPage) return undefined;
                return args.initialPageParam + pages.length;
            } else return undefined;
        },
        select: selectFn(),
        refetchOnWindowFocus: args.refetchOnWindowFocus ?? true,
        staleTime: args.staleTime ?? undefined,
        cacheTime: args.staleTime ?? undefined,
        useErrorBoundary: args.useErrorBoundary ?? undefined,
        refetchInterval: args.refetchInterval,
        refetchIntervalInBackground: args.refetchIntervalInBackground,
        initialData: args.initialData,
        placeholderData: args.placeholderData
    });
};


const $89862bbf0394a4aa$var$initialPageParam = 1;
const $89862bbf0394a4aa$export$bd710b640bc4fa45 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("GUEST_BOOKINGS_INFINITE_QUERY");
const $89862bbf0394a4aa$export$41b8577d0926ead9 = ({ guestId: guestId , amountPerPage: amountPerPage = 20 , enabled: enabled = true , refetchInterval: refetchInterval , statusIdFilter: statusIdFilter , direction: direction  })=>{
    function urlFunction(pageNumber) {
        return (0, $39ac3dd98f21da43$export$cef2c5b8f75ddc4c)({
            guestId: guestId,
            direction: direction,
            page: pageNumber,
            amount: amountPerPage,
            statusIdFilter: statusIdFilter
        });
    }
    const queryKey = $89862bbf0394a4aa$export$bd710b640bc4fa45.detail(`${guestId}${statusIdFilter}`);
    return (0, $5c3888846488886d$export$a1eb5d1bcb4f35a6)({
        queryKey: queryKey,
        urlFn: urlFunction,
        amountPerPage: amountPerPage,
        initialPageParam: $89862bbf0394a4aa$var$initialPageParam,
        nextPageKey: "BOOKINGS",
        enabled: enabled,
        refetchInterval: refetchInterval
    });
};


var $27b49d9012873ecf$exports = {};

$parcel$export($27b49d9012873ecf$exports, "useGuestNotificationsQueryKeys", () => $27b49d9012873ecf$export$2092bec22ac4a458);
$parcel$export($27b49d9012873ecf$exports, "useGuestNotificationsInfiniteQuery", () => $27b49d9012873ecf$export$b373cc7a722a4698);



const $27b49d9012873ecf$export$2092bec22ac4a458 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("GUEST_NOTIFICATIONS");
const $27b49d9012873ecf$var$AMOUNT_PER_PAGE = 25;
const $27b49d9012873ecf$var$INITIAL_PAGE = 1;
const $27b49d9012873ecf$export$b373cc7a722a4698 = ({ guestId: guestId , category: category , status: status , enabled: enabled = true , refetchInterval: refetchInterval  })=>{
    function urlFunction(pageNumber) {
        return (0, $39ac3dd98f21da43$export$8ace7b6edaa6c70)({
            page: pageNumber,
            amountPerPage: $27b49d9012873ecf$var$AMOUNT_PER_PAGE,
            category: category,
            guestId: guestId,
            status: status
        });
    }
    return (0, $5c3888846488886d$export$a1eb5d1bcb4f35a6)({
        queryKey: $27b49d9012873ecf$export$2092bec22ac4a458.list(`${guestId}${category}${status}`),
        urlFn: urlFunction,
        amountPerPage: $27b49d9012873ecf$var$AMOUNT_PER_PAGE,
        initialPageParam: $27b49d9012873ecf$var$INITIAL_PAGE,
        nextPageKey: "NOTIFICATIONS",
        enabled: enabled,
        refetchInterval: refetchInterval
    });
};


var $a000ed2b98d1b055$exports = {};

$parcel$export($a000ed2b98d1b055$exports, "useGuestDismissNotificationsMutation", () => $a000ed2b98d1b055$export$83c15cdde3bc18b2);

var $d900f4229f04c942$exports = {};

$parcel$export($d900f4229f04c942$exports, "FetchMethods", () => $d900f4229f04c942$export$ce2cf70c431e0802);
let $d900f4229f04c942$export$ce2cf70c431e0802;
(function(FetchMethods1) {
    FetchMethods1["GET"] = "GET";
    FetchMethods1["PUT"] = "PUT";
    FetchMethods1["POST"] = "POST";
    FetchMethods1["DELETE"] = "DELETE";
})($d900f4229f04c942$export$ce2cf70c431e0802 || ($d900f4229f04c942$export$ce2cf70c431e0802 = {}));



const $a000ed2b98d1b055$export$83c15cdde3bc18b2 = (args)=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: (0, $d900f4229f04c942$export$ce2cf70c431e0802).PUT,
        url: (0, $39ac3dd98f21da43$export$7c08efd7afb09a9d),
        ...args
    });
};


var $404122bf60b7304e$exports = {};

$parcel$export($404122bf60b7304e$exports, "useGuestBookingCancellationPolicyObject", () => $b0f838d5b44f66ab$export$42ae2102072fab);
$parcel$export($404122bf60b7304e$exports, "useGuestBookingCancellationPolicyHTML", () => $39d3b0fc1156b169$export$b34a244469b3e532);


const $b0f838d5b44f66ab$var$select = (data)=>data.DATA.CANCELLATION_POLICY;
const $b0f838d5b44f66ab$export$42ae2102072fab = (bookingId, guestId)=>{
    const endpoint = (0, $39ac3dd98f21da43$export$3c28bd43727dc07f)(bookingId, guestId);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        select: $b0f838d5b44f66ab$var$select
    });
};




const $39d3b0fc1156b169$var$select = (data)=>data.DATA.CANCELLATION_POLICY;
const $39d3b0fc1156b169$export$b34a244469b3e532 = (bookingId, guestId)=>{
    const endpoint = (0, $39ac3dd98f21da43$export$3c28bd43727dc07f)(bookingId, guestId, true);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        select: $39d3b0fc1156b169$var$select
    });
};




var $d7bf2ec125c1c282$exports = {};

$parcel$export($d7bf2ec125c1c282$exports, "guestPropertyQueryKey", () => $d7bf2ec125c1c282$export$a8e3a42cb8c7b1f0);
$parcel$export($d7bf2ec125c1c282$exports, "useGuestPropertyQuery", () => $d7bf2ec125c1c282$export$26358f9ea012a247);



const $d7bf2ec125c1c282$var$select = (data)=>data.DATA.PROPERTY;
const $d7bf2ec125c1c282$export$a8e3a42cb8c7b1f0 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("GUEST_PROPERTY");
const $d7bf2ec125c1c282$export$26358f9ea012a247 = ({ bookingId: bookingId , guestId: guestId , isEnabled: isEnabled = true  })=>{
    const endpoint = (0, $39ac3dd98f21da43$export$c5b10620a296ea16)(bookingId, guestId);
    const queryKey = $d7bf2ec125c1c282$export$a8e3a42cb8c7b1f0.detail(endpoint);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        queryKey: queryKey,
        select: $d7bf2ec125c1c282$var$select,
        enabled: isEnabled
    });
};


var $2ad90413c6f0c2b1$exports = {};

$parcel$export($2ad90413c6f0c2b1$exports, "useGuestUnavailableDates", () => $2ad90413c6f0c2b1$export$412f8941319a94ae);


const $2ad90413c6f0c2b1$export$412f8941319a94ae = ({ isEnabled: isEnabled = true , bookingId: bookingId = 0 , guestId: guestId = 0 , onSuccess: onSuccess = ()=>null  })=>{
    const queryKey = (0, $39ac3dd98f21da43$export$e1290e9e61b17a4f)(bookingId, guestId);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: queryKey,
        enabled: isEnabled,
        onSuccess: onSuccess
    });
};


var $c66030fb6906ecdb$exports = {};

$parcel$export($c66030fb6906ecdb$exports, "useOwnerNotificationsQueryKeys", () => $c66030fb6906ecdb$export$b7f0d5387f8fb762);
$parcel$export($c66030fb6906ecdb$exports, "useOwnerNotificationsInfiniteQuery", () => $c66030fb6906ecdb$export$843e98672cf858ea);
var $0c891e3f27143fe8$exports = {};

$parcel$export($0c891e3f27143fe8$exports, "ownerContactAlluraEndpoint", () => $0c891e3f27143fe8$export$ed8d54e9436be243);
$parcel$export($0c891e3f27143fe8$exports, "ownerCredentialsEndpoint", () => $0c891e3f27143fe8$export$7979dca97c4a09b);
$parcel$export($0c891e3f27143fe8$exports, "ownerLoginEndpoint", () => $0c891e3f27143fe8$export$c770570593a173d0);
$parcel$export($0c891e3f27143fe8$exports, "ownerLogoutEndpoint", () => $0c891e3f27143fe8$export$2a393b37f8b198ee);
$parcel$export($0c891e3f27143fe8$exports, "ownerMobileWalkthroughEndpoint", () => $0c891e3f27143fe8$export$9235c67a4f2b682d);
$parcel$export($0c891e3f27143fe8$exports, "ownerPutEndpoint", () => $0c891e3f27143fe8$export$81924240aba23827);
$parcel$export($0c891e3f27143fe8$exports, "ownerReferalEndpoint", () => $0c891e3f27143fe8$export$f07044789965acd3);
$parcel$export($0c891e3f27143fe8$exports, "requestPropertyDeactivationEndPoint", () => $0c891e3f27143fe8$export$a58d3a8266032e2d);
$parcel$export($0c891e3f27143fe8$exports, "ownerPropertyLoginEndpoint", () => $0c891e3f27143fe8$export$cbb6979bebb9c571);
$parcel$export($0c891e3f27143fe8$exports, "ownerPropertyCreateEndpoint", () => $0c891e3f27143fe8$export$62fddebcf9c8ee80);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerGuestsEndpoint", () => $0c891e3f27143fe8$export$17c44cdd06f5526a);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerMobileWalkthroughEndpoint", () => $0c891e3f27143fe8$export$ee629c1d04058cc1);
$parcel$export($0c891e3f27143fe8$exports, "generatePriorityBookingsEndpoint", () => $0c891e3f27143fe8$export$290bc0139a69679c);
$parcel$export($0c891e3f27143fe8$exports, "membershipRenewalInfo", () => $0c891e3f27143fe8$export$c9fca87eceae683d);
$parcel$export($0c891e3f27143fe8$exports, "renewalTransaction", () => $0c891e3f27143fe8$export$3a91b6c05252a0f5);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerNotificationsEndPoint", () => $0c891e3f27143fe8$export$8165800ff7472bbe);
$parcel$export($0c891e3f27143fe8$exports, "ownerDismissNotificationsEndpoint", () => $0c891e3f27143fe8$export$f64735ab134c9251);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerPropertiesEndPoint", () => $0c891e3f27143fe8$export$a08e46af354b77bc);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerBookingsEndpoint", () => $0c891e3f27143fe8$export$804d8d9adcc0aed5);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerFinancesSummaryEndpoint", () => $0c891e3f27143fe8$export$5402b107bf6810ed);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerFinancesTransactionsEndpoint", () => $0c891e3f27143fe8$export$560d9adc42c6c267);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerFinancesReservationsEndpoint", () => $0c891e3f27143fe8$export$9c2202ac817af1a4);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerFinancesReservationsCsvEndpoint", () => $0c891e3f27143fe8$export$aa9620ac32411108);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerFinancesTransactionsCsvEndpoint", () => $0c891e3f27143fe8$export$4325e7de7bbf5f05);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerExternalBookingsEndpoint", () => $0c891e3f27143fe8$export$44786126ffe5dc29);
$parcel$export($0c891e3f27143fe8$exports, "generateOwnerUnbookableDates", () => $0c891e3f27143fe8$export$21f5d1e2f3030631);
const $0c891e3f27143fe8$export$ed8d54e9436be243 = `/RESTAUTH/owner/contact/allura/`;
const $0c891e3f27143fe8$export$7979dca97c4a09b = `/RESTAUTH/owner/credentials/`;
const $0c891e3f27143fe8$export$c770570593a173d0 = "/RESTAUTH/owner/login/";
const $0c891e3f27143fe8$export$2a393b37f8b198ee = `/RESTAUTH/owner/logout/`;
const $0c891e3f27143fe8$export$9235c67a4f2b682d = `/RESTAUTH/owner/walkthrough/mobile/complete/`;
const $0c891e3f27143fe8$export$81924240aba23827 = `/RESTAUTH/owner/`;
const $0c891e3f27143fe8$export$f07044789965acd3 = "/RESTAUTH/owner/referral/";
const $0c891e3f27143fe8$export$a58d3a8266032e2d = `/RESTAUTH/owner/property/requestdeactivation/`;
const $0c891e3f27143fe8$export$cbb6979bebb9c571 = "/RESTAUTH/owner/property/login/";
const $0c891e3f27143fe8$export$62fddebcf9c8ee80 = "/RESTAUTH/owner/property/create/";
const $0c891e3f27143fe8$export$17c44cdd06f5526a = (ownerId)=>`/RESTAUTH/owner/guests/?id=${ownerId}`;
const $0c891e3f27143fe8$export$ee629c1d04058cc1 = (id)=>`/RESTAUTH/owner/walkthrough/mobile/?id=${id}`;
const $0c891e3f27143fe8$export$290bc0139a69679c = (ownerId)=>`/RESTAUTH/owner/prioritybookings/?id=${ownerId}`;
const $0c891e3f27143fe8$export$c9fca87eceae683d = (propertyId, ownerId)=>{
    return `/RESTAUTH/owner/property/renewalinfo/?id=${ownerId}&property_id=${propertyId}`;
};
const $0c891e3f27143fe8$export$3a91b6c05252a0f5 = (propertyId, ownerId)=>`/RESTAUTH/owner/property/renewaltransaction/?property_id=${propertyId}&id=${ownerId}`;
const $0c891e3f27143fe8$export$8165800ff7472bbe = ({ amountPerPage: amountPerPage , page: page , category: category , ownerId: ownerId , status: status , propertyId: propertyId  })=>{
    const propertyIdParam = propertyId ? `&property_id=${propertyId}` : "";
    const statusParam = status ? `&status=${status}` : "";
    return `/RESTAUTH/owner/notifications/?id=${ownerId}&amount_per_page=${amountPerPage}&page=${page}&category=${category}${statusParam}${propertyIdParam}`;
};
const $0c891e3f27143fe8$export$f64735ab134c9251 = "/RESTAUTH/owner/notifications/dismiss/";
const $0c891e3f27143fe8$export$a08e46af354b77bc = (ownerId)=>`/RESTAUTH/owner/properties/?id=${ownerId}`;
const $0c891e3f27143fe8$export$804d8d9adcc0aed5 = ({ page: page = 1 , ownerId: ownerId , status_id: status_id , amountPerPage: amountPerPage = 10 , direction: direction = "future" , propertyIds: propertyIds = []  })=>{
    const status_id_string = status_id ? `&status_id=${status_id}` : "";
    return `/RESTAUTH/owner/bookings/?page_direction=${direction}&property_ids=${propertyIds.join()}${status_id_string}&amount_per_page=${amountPerPage}&page=${page}&id=${ownerId}`;
};
const $0c891e3f27143fe8$export$5402b107bf6810ed = ({ ownerId: ownerId , year: year , fromMonth: fromMonth , toMonth: toMonth , sortOrder: sortOrder , propertyId: propertyId  })=>{
    const pid = propertyId === undefined ? "" : `&property_id=${propertyId}`;
    return `/RESTAUTH/owner/finances/summary/?id=${ownerId}&year=${year}&from_month=${fromMonth}&to_month=${toMonth}&sort_order=${sortOrder}${pid}`;
};
const $0c891e3f27143fe8$export$560d9adc42c6c267 = ({ ownerId: ownerId , year: year , fromMonth: fromMonth , toMonth: toMonth , sortOrder: sortOrder , propertyId: propertyId , filter: filter  })=>{
    const pid = propertyId === undefined ? "" : `&property_id=${propertyId}`;
    return `/RESTAUTH/owner/finances/transactions/?id=${ownerId}&year=${year}&from_month=${fromMonth}&to_month=${toMonth}&sort_order=${sortOrder}&filter=${filter}${pid}`;
};
const $0c891e3f27143fe8$export$9c2202ac817af1a4 = ({ ownerId: ownerId , year: year , fromMonth: fromMonth , toMonth: toMonth , sortOrder: sortOrder , propertyId: propertyId  })=>{
    const pid = propertyId === undefined ? "" : `&property_id=${propertyId}`;
    return `/RESTAUTH/owner/finances/reservations/?id=${ownerId}&year=${year}&from_month=${fromMonth}&to_month=${toMonth}&sort_order=${sortOrder}${pid}`;
};
const $0c891e3f27143fe8$export$aa9620ac32411108 = ({ ownerId: ownerId , year: year , fromMonth: fromMonth , toMonth: toMonth , sortOrder: sortOrder , propertyId: propertyId  })=>{
    const pid = propertyId === undefined ? "" : `&property_id=${propertyId}`;
    return `/RESTAUTH/owner/finances/reservations/csv/?id=${ownerId}&year=${year}&from_month=${fromMonth}&to_month=${toMonth}&sort_order=${sortOrder}${pid}`;
};
const $0c891e3f27143fe8$export$4325e7de7bbf5f05 = ({ ownerId: ownerId , year: year , fromMonth: fromMonth , toMonth: toMonth , sortOrder: sortOrder , propertyId: propertyId  })=>{
    const pid = propertyId === undefined ? "" : `&property_id=${propertyId}`;
    return `/RESTAUTH/owner/finances/transactions/csv/?id=${ownerId}&year=${year}&from_month=${fromMonth}&to_month=${toMonth}&sort_order=${sortOrder}${pid}`;
};
const $0c891e3f27143fe8$export$44786126ffe5dc29 = ({ ownerId: ownerId , propertyId: propertyId , numMonths: numMonths  })=>{
    const pid = propertyId === undefined ? "" : `&property_id=${propertyId}`;
    return `/RESTAUTH/owner/externalbookings/?id=${ownerId}&num_months=${numMonths}${pid}`;
};
const $0c891e3f27143fe8$export$21f5d1e2f3030631 = ({ ownerId: ownerId , numMonths: numMonths , propertyId: propertyId  })=>{
    const pid = propertyId === undefined ? "" : `&property_id=${propertyId}`;
    return `/RESTAUTH/owner/unbookabledates/?id=${ownerId}&num_months=${numMonths}${pid}`;
};




const $c66030fb6906ecdb$export$b7f0d5387f8fb762 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("OWNER_NOTIFICATIONS");
const $c66030fb6906ecdb$var$AMOUNT_PER_PAGE = 25;
const $c66030fb6906ecdb$var$INITIAL_PAGE = 1;
const $c66030fb6906ecdb$export$843e98672cf858ea = ({ ownerId: ownerId , category: category , status: status , enabled: enabled = true , refetchInterval: refetchInterval , propertyId: propertyId  })=>{
    function urlFunction(pageNumber) {
        return (0, $0c891e3f27143fe8$export$8165800ff7472bbe)({
            page: pageNumber,
            amountPerPage: $c66030fb6906ecdb$var$AMOUNT_PER_PAGE,
            category: category,
            ownerId: ownerId,
            status: status,
            propertyId: propertyId
        });
    }
    const queryKey = $c66030fb6906ecdb$export$b7f0d5387f8fb762.list(`${ownerId}${category}${status}${propertyId}`);
    return (0, $5c3888846488886d$export$a1eb5d1bcb4f35a6)({
        queryKey: queryKey,
        urlFn: urlFunction,
        amountPerPage: $c66030fb6906ecdb$var$AMOUNT_PER_PAGE,
        initialPageParam: $c66030fb6906ecdb$var$INITIAL_PAGE,
        nextPageKey: "NOTIFICATIONS",
        enabled: enabled,
        refetchInterval: refetchInterval
    });
};


var $da2dd51e17e61b33$exports = {};

$parcel$export($da2dd51e17e61b33$exports, "useOwnerMobileWalkthroughMutation", () => $da2dd51e17e61b33$export$73c8238fbf22dcba);


const $da2dd51e17e61b33$export$73c8238fbf22dcba = ()=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $0c891e3f27143fe8$export$9235c67a4f2b682d),
        method: "PUT"
    });
};


var $6a726573b91359e1$exports = {};

$parcel$export($6a726573b91359e1$exports, "useOwnerDismissNotificationsMutation", () => $6a726573b91359e1$export$59c65495fb6e5793);



const $6a726573b91359e1$export$59c65495fb6e5793 = (args)=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: (0, $d900f4229f04c942$export$ce2cf70c431e0802).PUT,
        url: (0, $0c891e3f27143fe8$export$f64735ab134c9251),
        ...args
    });
};


var $4d249cfc08a921f0$exports = {};

$parcel$export($4d249cfc08a921f0$exports, "useOwnerPropertyLoginMutation", () => $4d249cfc08a921f0$export$35495b639fd2eb12);


const $4d249cfc08a921f0$export$35495b639fd2eb12 = (reactQueryOptions = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $0c891e3f27143fe8$export$cbb6979bebb9c571),
        method: "POST",
        ...reactQueryOptions
    });
};


var $1402c0a484a6f252$exports = {};

$parcel$export($1402c0a484a6f252$exports, "useOwnerUnavailableDates", () => $1402c0a484a6f252$export$fb94651c0721a416);


const $1402c0a484a6f252$export$fb94651c0721a416 = ({ isEnabled: isEnabled = true , bookingId: bookingId = 0 , propertyId: propertyId = 0 , onSuccess: onSuccess = ()=>null  })=>{
    const queryKey = (0, $e15de41ca5b185e2$export$faaf651cb1c1cc08)({
        bookingId: bookingId,
        propertyId: propertyId
    });
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: queryKey,
        enabled: isEnabled,
        onSuccess: onSuccess
    });
};


var $c6d76554d8e1e29d$exports = {};

$parcel$export($c6d76554d8e1e29d$exports, "usePropertiesQuery", () => $c6d76554d8e1e29d$export$b2849d2da3a2e0fa);


const $c6d76554d8e1e29d$export$b2849d2da3a2e0fa = ({ ownerId: ownerId , ...rest })=>{
    const endpoint = (0, $0c891e3f27143fe8$export$a08e46af354b77bc)(ownerId);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        queryKey: endpoint,
        ...rest
    });
};


var $f648da45e8e76d84$exports = {};

$parcel$export($f648da45e8e76d84$exports, "useOwnerFinancesSummaryQuery", () => $f648da45e8e76d84$export$45812cc6610fb11);


const $f648da45e8e76d84$export$45812cc6610fb11 = ({ ownerId: ownerId , year: year , fromMonth: fromMonth , toMonth: toMonth , sortOrder: sortOrder , propertyId: propertyId , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $0c891e3f27143fe8$export$5402b107bf6810ed)({
            ownerId: ownerId,
            year: year,
            toMonth: toMonth,
            fromMonth: fromMonth,
            sortOrder: sortOrder,
            propertyId: propertyId
        }),
        ...rest
    });
};


var $a38ffcb37f95a152$exports = {};

$parcel$export($a38ffcb37f95a152$exports, "useOwnerFinancesTransactionsQuery", () => $a38ffcb37f95a152$export$ab5a2ccf22696a5b);


const $a38ffcb37f95a152$export$ab5a2ccf22696a5b = ({ ownerId: ownerId , year: year , toMonth: toMonth , fromMonth: fromMonth , propertyId: propertyId , sortOrder: sortOrder , filter: filter , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $0c891e3f27143fe8$export$560d9adc42c6c267)({
            ownerId: ownerId,
            year: year,
            toMonth: toMonth,
            fromMonth: fromMonth,
            propertyId: propertyId,
            sortOrder: sortOrder,
            filter: filter
        }),
        ...rest
    });
};


var $ccee87f383d87bf3$exports = {};

$parcel$export($ccee87f383d87bf3$exports, "useOwnerFinancesReservationsQuery", () => $ccee87f383d87bf3$export$6477c4f33d88ece4);


const $ccee87f383d87bf3$export$6477c4f33d88ece4 = ({ ownerId: ownerId , year: year , fromMonth: fromMonth , toMonth: toMonth , sortOrder: sortOrder , propertyId: propertyId , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $0c891e3f27143fe8$export$9c2202ac817af1a4)({
            ownerId: ownerId,
            year: year,
            fromMonth: fromMonth,
            toMonth: toMonth,
            sortOrder: sortOrder,
            propertyId: propertyId
        }),
        ...rest
    });
};


var $d48a70f9706ee2e2$exports = {};

$parcel$export($d48a70f9706ee2e2$exports, "ownerExternalEventsQueryKey", () => $d48a70f9706ee2e2$export$88d20f026bb28a9f);
$parcel$export($d48a70f9706ee2e2$exports, "useOwnerExternalEventsQuery", () => $d48a70f9706ee2e2$export$4f88fb668729a2a6);



const $d48a70f9706ee2e2$export$88d20f026bb28a9f = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("owner-external-events-query");
const $d48a70f9706ee2e2$export$4f88fb668729a2a6 = ({ ownerId: ownerId , propertyId: propertyId , numMonths: numMonths , ...rest })=>{
    const queryKey = $d48a70f9706ee2e2$export$88d20f026bb28a9f.detail(`${ownerId}-${propertyId}-${numMonths}`);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $0c891e3f27143fe8$export$44786126ffe5dc29)({
            ownerId: ownerId,
            propertyId: propertyId,
            numMonths: numMonths
        }),
        queryKey: queryKey,
        ...rest
    });
};


var $d00676120cc96262$exports = {};

$parcel$export($d00676120cc96262$exports, "ownerUnbookableDatesQueryKey", () => $d00676120cc96262$export$d390c8dc0ef1c1de);
$parcel$export($d00676120cc96262$exports, "useOwnerUnbookableDatesQuery", () => $d00676120cc96262$export$a0007444547f1f2f);



const $d00676120cc96262$export$d390c8dc0ef1c1de = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("owner-external-events-query");
const $d00676120cc96262$export$a0007444547f1f2f = ({ ownerId: ownerId , propertyId: propertyId , numMonths: numMonths , ...rest })=>{
    const queryKey = $d00676120cc96262$export$d390c8dc0ef1c1de.detail(`${ownerId}${propertyId}${numMonths}`);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $0c891e3f27143fe8$export$21f5d1e2f3030631)({
            ownerId: ownerId,
            propertyId: propertyId,
            numMonths: numMonths
        }),
        queryKey: queryKey,
        ...rest
    });
};


var $65e33642a42747d2$exports = {};

$parcel$export($65e33642a42747d2$exports, "useOwnerMobileWalkthroughQuery", () => $65e33642a42747d2$export$f247437efa5dd173);


const $65e33642a42747d2$export$f247437efa5dd173 = ({ id: id  })=>{
    const endpoint = (0, $0c891e3f27143fe8$export$ee629c1d04058cc1)(id);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint
    });
};


var $4c1d61297d95031f$exports = {};

$parcel$export($4c1d61297d95031f$exports, "propertyReviewsInfiniteQueryKey", () => $4c1d61297d95031f$export$3aa3eabda9a6011);
$parcel$export($4c1d61297d95031f$exports, "usePropertyReviewsInfiniteQuery", () => $4c1d61297d95031f$export$29bea406db5e298b);



const $4c1d61297d95031f$export$3aa3eabda9a6011 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("PROPERTY_REVIEWS_INFINTE_QUERY");
const $4c1d61297d95031f$export$29bea406db5e298b = ({ propertyId: propertyId , pageDirection: pageDirection = "past" , amountPerPage: amountPerPage = 10 , initialPageParam: initialPageParam = 1 , ...rest })=>{
    function urlFunction(page) {
        return (0, $e15de41ca5b185e2$export$a707cd72801d58c1)({
            propertyId: propertyId,
            page: page,
            pageDirection: pageDirection,
            amountPerPage: amountPerPage
        });
    }
    const queryKey = $4c1d61297d95031f$export$3aa3eabda9a6011.detail(`${propertyId}${pageDirection}${amountPerPage}${initialPageParam}`);
    return (0, $5c3888846488886d$export$a1eb5d1bcb4f35a6)({
        queryKey: queryKey,
        urlFn: urlFunction,
        nextPageKey: "REVIEWS",
        amountPerPage: amountPerPage,
        initialPageParam: initialPageParam,
        ...rest
    });
};



var $21bebe11e6996a77$exports = {};

$parcel$export($21bebe11e6996a77$exports, "generateUpdatedSendValues", () => $21bebe11e6996a77$export$ce9cdd12c2a530a0);
var $9f770fb655db2e69$exports = {};

$parcel$export($9f770fb655db2e69$exports, "RequiredSubformsEnum", () => $9f770fb655db2e69$export$9dab6df2a66c141e);
$parcel$export($9f770fb655db2e69$exports, "OptionalSubformsEnum", () => $9f770fb655db2e69$export$d78bec73c06e8a45);
let $9f770fb655db2e69$export$9dab6df2a66c141e;
(function(RequiredSubformsEnum1) {
    RequiredSubformsEnum1["AccessToUnitForm"] = "AccessToUnitForm";
    RequiredSubformsEnum1["AccountOwnerForm"] = "AccountOwnerForm";
    RequiredSubformsEnum1["ActivationForm"] = "ActivationForm";
    RequiredSubformsEnum1["AdvancedBookingSettingsForm"] = "AdvancedBookingSettingsForm";
    RequiredSubformsEnum1["BankingForm"] = "BankingForm";
    RequiredSubformsEnum1["BathroomsForm"] = "BathroomsForm";
    RequiredSubformsEnum1["BedroomsForm"] = "BedroomsForm";
    RequiredSubformsEnum1["BuildingAmenitiesForm"] = "BuildingAmenitiesForm";
    RequiredSubformsEnum1["BusinessLicenceForm"] = "BusinessLicenceForm";
    RequiredSubformsEnum1["CalendarBlockOffsForm"] = "CalendarBlockOffsForm";
    RequiredSubformsEnum1["CancellationPoliciesForm"] = "CancellationPoliciesForm";
    RequiredSubformsEnum1["CheckInOutForm"] = "CheckInOutForm";
    RequiredSubformsEnum1["CleaningProtocolForm"] = "CleaningProtocolForm";
    RequiredSubformsEnum1["DamageDepositForm"] = "DamageDepositForm";
    RequiredSubformsEnum1["EmergencyContactsForm"] = "EmergencyContactsForm";
    RequiredSubformsEnum1["EssentialAmenitiesForm"] = "EssentialAmenitiesForm";
    RequiredSubformsEnum1["KitchenAmenitiesForm"] = "KitchenAmenitiesForm";
    RequiredSubformsEnum1["LocationForm"] = "LocationForm";
    RequiredSubformsEnum1["MembershipForm"] = "MembershipForm";
    RequiredSubformsEnum1["NewListingOfferForm"] = "NewListingOfferForm";
    RequiredSubformsEnum1["NonResidentStatusForm"] = "NonResidentStatusForm";
    RequiredSubformsEnum1["ParkingForm"] = "ParkingForm";
    RequiredSubformsEnum1["PartnersForm"] = "PartnersForm";
    RequiredSubformsEnum1["PhotosForm"] = "PhotosForm";
    RequiredSubformsEnum1["PrivateSafetyAmenitiesForm"] = "PrivateSafetyAmenitiesForm";
    RequiredSubformsEnum1["PropertyAddressForm"] = "PropertyAddressForm";
    RequiredSubformsEnum1["PropertyContactForm"] = "PropertyContactForm";
    RequiredSubformsEnum1["RateGroupForm"] = "RateGroupForm";
    RequiredSubformsEnum1["RateSettingsForm"] = "RateSettingsForm";
    RequiredSubformsEnum1["RatesScheduleForm"] = "RatesScheduleForm";
    RequiredSubformsEnum1["ReservationSettingsInstantBookingForm"] = "ReservationSettingsInstantBookingForm";
    RequiredSubformsEnum1["ReservationSettingsPaymentScheduleForm"] = "ReservationSettingsPaymentScheduleForm";
    RequiredSubformsEnum1["SetupQuestionsForm"] = "SetupQuestionsForm";
    RequiredSubformsEnum1["StyleSquareFootageForm"] = "StyleSquareFootageForm";
    RequiredSubformsEnum1["SuitabilitiesForm"] = "SuitabilitiesForm";
    RequiredSubformsEnum1["SurchargesForm"] = "SurchargesForm";
    RequiredSubformsEnum1["TaxesForm"] = "TaxesForm";
})($9f770fb655db2e69$export$9dab6df2a66c141e || ($9f770fb655db2e69$export$9dab6df2a66c141e = {}));
let $9f770fb655db2e69$export$d78bec73c06e8a45;
(function(OptionalSubformsEnum1) {
    OptionalSubformsEnum1["AllAmenitiesFormOptional"] = "AllAmenitiesForm";
    OptionalSubformsEnum1["PropertyTitleSummaryFormOptional"] = "PropertyTitleSummaryFormOptional";
    OptionalSubformsEnum1["BedroomsFormOptional"] = "BedroomsFormOptional";
    OptionalSubformsEnum1["BathroomsFormOptional"] = "BathroomsFormOptional";
    OptionalSubformsEnum1["LocationFormOptional"] = "LocationFormOptional";
    OptionalSubformsEnum1["EssentialAmenitiesFormOptional"] = "EssentialAmenitiesFormOptional";
    OptionalSubformsEnum1["PrivateSafetyAmenitiesFormOptional"] = "PrivateSafetyAmenitiesFormOptional";
    OptionalSubformsEnum1["KitchenAmenitiesFormOptional"] = "KitchenAmenitiesFormOptional";
    OptionalSubformsEnum1["BuildingAmenitiesFormOptional"] = "BuildingAmenitiesFormOptional";
    OptionalSubformsEnum1["CheckInOutFormOptional"] = "CheckInOutFormOptional";
    OptionalSubformsEnum1["CheckInEmailFormOptional"] = "CheckInEmailFormOptional";
    OptionalSubformsEnum1["ExtendedDescriptionFormOptional"] = "ExtendedDescriptionFormOptional";
    OptionalSubformsEnum1["PropertyPoliciesForm"] = "PropertyPoliciesForm";
})($9f770fb655db2e69$export$d78bec73c06e8a45 || ($9f770fb655db2e69$export$d78bec73c06e8a45 = {}));


var $3a8449e3b3bae2ba$exports = {};

$parcel$export($3a8449e3b3bae2ba$exports, "convertDateToGMTDate", () => $3a8449e3b3bae2ba$export$dfbcccfd0b783b29);
$parcel$export($3a8449e3b3bae2ba$exports, "handleAddDay", () => $3a8449e3b3bae2ba$export$fb38eb2839474437);
$parcel$export($3a8449e3b3bae2ba$exports, "handleAddDays", () => $3a8449e3b3bae2ba$export$ef91e323752a1558);
$parcel$export($3a8449e3b3bae2ba$exports, "handleRemoveDay", () => $3a8449e3b3bae2ba$export$4f52513b2a0e963e);
$parcel$export($3a8449e3b3bae2ba$exports, "daysInCurrentMonth", () => $3a8449e3b3bae2ba$export$b218f86596dcef41);
$parcel$export($3a8449e3b3bae2ba$exports, "calculateIsDateInPast", () => $3a8449e3b3bae2ba$export$246e2c3053735ba3);
$parcel$export($3a8449e3b3bae2ba$exports, "calculateIsDateBeforeMandatoryGST", () => $3a8449e3b3bae2ba$export$86745c327318cfef);
$parcel$export($3a8449e3b3bae2ba$exports, "convertDateStringToDate", () => $3a8449e3b3bae2ba$export$ce4502cb3021386c);
$parcel$export($3a8449e3b3bae2ba$exports, "isValidDate", () => $3a8449e3b3bae2ba$export$c03bb0116ee09d4b);
$parcel$export($3a8449e3b3bae2ba$exports, "checkIsValidDate", () => $3a8449e3b3bae2ba$export$c7544b58e05b90ad);
$parcel$export($3a8449e3b3bae2ba$exports, "calculateIsFinalMonthOfData", () => $3a8449e3b3bae2ba$export$7b2837d688734df9);
$parcel$export($3a8449e3b3bae2ba$exports, "hourOrDayDifferenceString", () => $3a8449e3b3bae2ba$export$8fc89e286906ac02);
$parcel$export($3a8449e3b3bae2ba$exports, "calculateDayDifference", () => $3a8449e3b3bae2ba$export$8145d95a6751dce);
$parcel$export($3a8449e3b3bae2ba$exports, "calculateMonthDifference", () => $3a8449e3b3bae2ba$export$5e38aa4b8ee31f00);
$parcel$export($3a8449e3b3bae2ba$exports, "calculateNights", () => $3a8449e3b3bae2ba$export$24939cc9aa7cde05);
$parcel$export($3a8449e3b3bae2ba$exports, "numberOfDaysUntil", () => $3a8449e3b3bae2ba$export$f72884f4f37b25df);
$parcel$export($3a8449e3b3bae2ba$exports, "calculateDifferenceInDays", () => $3a8449e3b3bae2ba$export$46c8e772a237695f);
$parcel$export($3a8449e3b3bae2ba$exports, "serverDaysFromToday", () => $3a8449e3b3bae2ba$export$f81342be94e50812);
$parcel$export($3a8449e3b3bae2ba$exports, "serverStringFormat", () => $3a8449e3b3bae2ba$export$826220848dd188cb);
$parcel$export($3a8449e3b3bae2ba$exports, "convert24HourTo12Hour", () => $3a8449e3b3bae2ba$export$e829c2c099c8711a);
$parcel$export($3a8449e3b3bae2ba$exports, "parseDOB", () => $3a8449e3b3bae2ba$export$dd2fd71f811b2d7a);
$parcel$export($3a8449e3b3bae2ba$exports, "convertDateToUTCSeconds", () => $3a8449e3b3bae2ba$export$9e8556f36139d5f6);
$parcel$export($3a8449e3b3bae2ba$exports, "isDayWithinRange", () => $3a8449e3b3bae2ba$export$7ca0fdd3000f8fb4);
$parcel$export($3a8449e3b3bae2ba$exports, "isRangeWithinRange", () => $3a8449e3b3bae2ba$export$eecb2aa703319c46);
$parcel$export($3a8449e3b3bae2ba$exports, "isWeekendDate", () => $3a8449e3b3bae2ba$export$74dd93fa2faa7936);
$parcel$export($3a8449e3b3bae2ba$exports, "getRelativeTime", () => $3a8449e3b3bae2ba$export$493c11ff22f45a24);
$parcel$export($3a8449e3b3bae2ba$exports, "getDateTime", () => $3a8449e3b3bae2ba$export$2364d538c15eb8db);
$parcel$export($3a8449e3b3bae2ba$exports, "shortMonthDayFormat", () => $3a8449e3b3bae2ba$export$bb0419111572148b);
$parcel$export($3a8449e3b3bae2ba$exports, "shortMonthFormat", () => $3a8449e3b3bae2ba$export$9dd9ebdffb2edf89);
$parcel$export($3a8449e3b3bae2ba$exports, "longMonthYearFormat", () => $3a8449e3b3bae2ba$export$e2addb5d619b4ab1);
$parcel$export($3a8449e3b3bae2ba$exports, "longMonthFormat", () => $3a8449e3b3bae2ba$export$167143d4db8c79b7);
$parcel$export($3a8449e3b3bae2ba$exports, "longMonthOrdinalFormat", () => $3a8449e3b3bae2ba$export$918574f3886b1a3);
$parcel$export($3a8449e3b3bae2ba$exports, "shortMonthOrdinalFormat", () => $3a8449e3b3bae2ba$export$996c3039b022a9b1);
$parcel$export($3a8449e3b3bae2ba$exports, "longStringFormat", () => $3a8449e3b3bae2ba$export$ee82dd2f959db81f);
$parcel$export($3a8449e3b3bae2ba$exports, "handleDateObjToStringYYYMMDD", () => $3a8449e3b3bae2ba$export$f19b0e4313ec40d5);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatShortMonthDay", () => $3a8449e3b3bae2ba$export$c7ac8b61d985977f);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatDialog", () => $3a8449e3b3bae2ba$export$9eaae163d77bc50f);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatLong", () => $3a8449e3b3bae2ba$export$863d5be618fefbf3);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatLongMonth", () => $3a8449e3b3bae2ba$export$dffa7941d4d22046);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatLongString", () => $3a8449e3b3bae2ba$export$b724f82ddfaf7047);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatMontDay", () => $3a8449e3b3bae2ba$export$abe814fcd065a580);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatMonthDayYearDayOfWeek", () => $3a8449e3b3bae2ba$export$253f51d00c3c150b);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatMonthYear", () => $3a8449e3b3bae2ba$export$c9efe0c3d34a02f4);
$parcel$export($3a8449e3b3bae2ba$exports, "dateFormatServer", () => $3a8449e3b3bae2ba$export$160d2a3734a06909);
$parcel$export($3a8449e3b3bae2ba$exports, "dayjsFormatServer", () => $3a8449e3b3bae2ba$export$64486ae5ea8a9faf);
$parcel$export($3a8449e3b3bae2ba$exports, "dayjsFormatLongOrdinal", () => $3a8449e3b3bae2ba$export$68cfbbb172c7e133);
$parcel$export($3a8449e3b3bae2ba$exports, "dayjsFormatShortOrdinal", () => $3a8449e3b3bae2ba$export$757a5dfffbfdba69);

var $be705db4a89c6c13$exports = {};

$parcel$export($be705db4a89c6c13$exports, "dayjsInitializer", () => $be705db4a89c6c13$export$1631253861b5faaa);






function $be705db4a89c6c13$export$1631253861b5faaa() {
    (0, $iPNDK$dayjs).extend((0, $iPNDK$dayjspluginadvancedFormat));
    (0, $iPNDK$dayjs).extend((0, $iPNDK$dayjspluginutc));
    (0, $iPNDK$dayjs).extend((0, $iPNDK$dayjsplugincustomParseFormat));
    (0, $iPNDK$dayjs).extend((0, $iPNDK$dayjspluginrelativeTime));
    (0, $iPNDK$dayjs).extend((0, $iPNDK$dayjsplugintimezone));
}


(0, $be705db4a89c6c13$export$1631253861b5faaa)();
const $3a8449e3b3bae2ba$export$dfbcccfd0b783b29 = (date)=>{
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
const $3a8449e3b3bae2ba$export$fb38eb2839474437 = (date)=>(0, $iPNDK$dayjs)(date).add(1, "day");
const $3a8449e3b3bae2ba$export$ef91e323752a1558 = (date, daysToAdd)=>(0, $iPNDK$dayjs)(date).add(daysToAdd, "day");
const $3a8449e3b3bae2ba$export$4f52513b2a0e963e = (date)=>(0, $iPNDK$dayjs)(date).subtract(1, "day");
const $3a8449e3b3bae2ba$export$b218f86596dcef41 = (year, month)=>{
    return new Date(year, month, 0).getDate();
};
const $3a8449e3b3bae2ba$export$246e2c3053735ba3 = (date)=>(0, $iPNDK$dayjs)(date).isBefore((0, $iPNDK$dayjs)(), "day");
const $3a8449e3b3bae2ba$export$86745c327318cfef = ()=>(0, $iPNDK$dayjs)("2021-07-01").isBefore((0, $iPNDK$dayjs)());
const $3a8449e3b3bae2ba$export$ce4502cb3021386c = (dateString)=>{
    const splitDate = dateString.split("-");
    const year = Number(splitDate[0]);
    const month = Number(splitDate[1]) - 1;
    const day = Number(splitDate[2]);
    const newDate = new Date(year, month, day);
    return newDate;
};
function $3a8449e3b3bae2ba$export$c03bb0116ee09d4b(d) {
    if (Object.prototype.toString.call(d) === "[object Date]") {
        // it is a date
        if (isNaN(d.getTime())) // d.valueOf() could also work
        // date is not valid
        return false;
        else // date is valid
        return true;
    } else // not a date
    return false;
}
const $3a8449e3b3bae2ba$export$c7544b58e05b90ad = (date)=>{
    return (0, $iPNDK$dayjs)(date).isValid();
};
const $3a8449e3b3bae2ba$export$7b2837d688734df9 = (date, finalMonth)=>(0, $iPNDK$dayjs)(date).isSame((0, $iPNDK$dayjs)(finalMonth), "month");
const $3a8449e3b3bae2ba$var$hoursDifference = ({ fromDateTime: fromDateTime , toDateTime: toDateTime  })=>toDateTime.diff(fromDateTime, "hour");
const $3a8449e3b3bae2ba$var$hoursDifferenceToString = (hours)=>{
    const days = Math.round(hours / 24);
    return days >= 1 ? `${days} day${days > 1 ? "s" : ""}` : `${hours} hour${hours > 1 || hours === 0 ? "s" : ""}`;
};
const $3a8449e3b3bae2ba$export$8fc89e286906ac02 = ({ fromDateTime: fromDateTime , toDateTime: toDateTime  })=>{
    return $3a8449e3b3bae2ba$var$hoursDifferenceToString($3a8449e3b3bae2ba$var$hoursDifference({
        fromDateTime: fromDateTime,
        toDateTime: toDateTime
    }));
};
const $3a8449e3b3bae2ba$export$8145d95a6751dce = (start, end)=>{
    const startDate = (0, $iPNDK$dayjs)(start).hour(0);
    const endDate = (0, $iPNDK$dayjs)(end).hour(0);
    return startDate.diff(endDate, "day");
};
const $3a8449e3b3bae2ba$export$5e38aa4b8ee31f00 = (start, end)=>{
    const startDate = (0, $iPNDK$dayjs)(start).hour(0);
    const endDate = (0, $iPNDK$dayjs)(end).hour(0);
    return startDate.diff(endDate, "month");
};
const $3a8449e3b3bae2ba$export$24939cc9aa7cde05 = ({ date1: date1 , date2: date2  })=>{
    return $3a8449e3b3bae2ba$export$8145d95a6751dce(date2, date1);
};
const $3a8449e3b3bae2ba$export$f72884f4f37b25df = (date)=>{
    return $3a8449e3b3bae2ba$export$8145d95a6751dce(date, (0, $iPNDK$dayjs)());
};
const $3a8449e3b3bae2ba$export$46c8e772a237695f = (start, end)=>{
    return $3a8449e3b3bae2ba$export$8145d95a6751dce(end, start);
};
function $3a8449e3b3bae2ba$export$f81342be94e50812(numDays) {
    return `${(0, $iPNDK$dayjs)().add(numDays, "day").format($3a8449e3b3bae2ba$export$826220848dd188cb)}`;
}
const $3a8449e3b3bae2ba$export$e829c2c099c8711a = (time)=>{
    // Check correct time format and split into components
    let splitTime = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
        time
    ];
    if (splitTime.length > 1) {
        // If time format correct
        splitTime = splitTime.slice(1); // Remove full string match value
        splitTime[5] = +splitTime[0] < 12 ? " AM" : " PM"; // Set AM/PM
        splitTime[0] = (+splitTime[0] % 12 || 12).toString(); // Adjust hours
    }
    return splitTime.join(""); // return adjusted time or original string
};
const $3a8449e3b3bae2ba$export$dd2fd71f811b2d7a = (dob)=>{
    if (!dob || dob.length === 0) return {
        year: "",
        month: "",
        day: ""
    };
    const dates = dob.split("-");
    const year = dates[0];
    const month = parseInt(dates[1]).toString();
    const day = parseInt(dates[2]).toString();
    return {
        year: year,
        month: month,
        day: day
    };
};
const $3a8449e3b3bae2ba$export$9e8556f36139d5f6 = (date)=>{
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
};
const $3a8449e3b3bae2ba$export$7ca0fdd3000f8fb4 = ({ day: day , start: start , end: end  })=>{
    return start.isSame(day, "day") || start.isBefore(day, "day") && end.isAfter(day, "day") || end.isSame(day, "day");
};
const $3a8449e3b3bae2ba$export$eecb2aa703319c46 = ({ checked: checked , comparator: comparator  })=>{
    const isCheckedStartWithinComparatorStart = checked.start.isSame(comparator.start, "day") || checked.start.isAfter(comparator.start, "day");
    const isCheckedEndWithinComparatorEnd = checked.end.isSame(comparator.end, "day") || checked.end.isBefore(comparator.end, "day");
    return isCheckedEndWithinComparatorEnd && isCheckedStartWithinComparatorStart;
};
const $3a8449e3b3bae2ba$export$74dd93fa2faa7936 = (date)=>{
    const friday = 5;
    const saturday = 6;
    const calendarDayNumber = date.toDate().getDay();
    const isWeekend = calendarDayNumber === friday || calendarDayNumber === saturday;
    return isWeekend;
};
function $3a8449e3b3bae2ba$export$493c11ff22f45a24(dateSent, timeSent) {
    const [hour, minute] = timeSent.split(":");
    const pacificDateSent = (0, $iPNDK$dayjs)(`${dateSent} ${parseInt(hour)}:${parseInt(minute)}`).tz("Canada/Pacific");
    const sentDateTime = pacificDateSent.hour(parseInt(hour)).minute(parseInt(minute)).local();
    return sentDateTime.fromNow();
}
function $3a8449e3b3bae2ba$export$2364d538c15eb8db(date, time) {
    const [hour, minute] = time.split(":");
    return (0, $iPNDK$dayjs).tz(`${date}T${hour}:${minute}`, "America/Los_Angeles");
}
const $3a8449e3b3bae2ba$export$826220848dd188cb = "YYYY-MM-DD";
const $3a8449e3b3bae2ba$export$bb0419111572148b = "MMM D";
const $3a8449e3b3bae2ba$export$9dd9ebdffb2edf89 = "MMM D, YYYY";
const $3a8449e3b3bae2ba$export$e2addb5d619b4ab1 = "MMMM YYYY";
const $3a8449e3b3bae2ba$export$167143d4db8c79b7 = "MMMM D, YYYY";
const $3a8449e3b3bae2ba$export$918574f3886b1a3 = "MMMM Do, YYYY";
const $3a8449e3b3bae2ba$export$996c3039b022a9b1 = "MMM Do, YYYY";
const $3a8449e3b3bae2ba$export$ee82dd2f959db81f = "dddd, MMMM D, YYYY";
const $3a8449e3b3bae2ba$export$f19b0e4313ec40d5 = (date)=>{
    const dateToConvert = new Date(date);
    const offset = dateToConvert.getTimezoneOffset();
    const convertedDate = new Date(dateToConvert.getTime() + offset * 60000);
    return convertedDate.toISOString().split("T")[0];
};
const $3a8449e3b3bae2ba$export$c7ac8b61d985977f = (date)=>date.format($3a8449e3b3bae2ba$export$bb0419111572148b);
const $3a8449e3b3bae2ba$export$9eaae163d77bc50f = (date)=>(0, $iPNDK$dayjs)(date).format($3a8449e3b3bae2ba$export$9dd9ebdffb2edf89);
const $3a8449e3b3bae2ba$export$863d5be618fefbf3 = (date)=>(0, $iPNDK$dayjs)(date).format($3a8449e3b3bae2ba$export$9dd9ebdffb2edf89);
const $3a8449e3b3bae2ba$export$dffa7941d4d22046 = (date)=>(0, $iPNDK$dayjs)(date).format($3a8449e3b3bae2ba$export$167143d4db8c79b7);
const $3a8449e3b3bae2ba$export$b724f82ddfaf7047 = (date)=>(0, $iPNDK$dayjs)(date).format($3a8449e3b3bae2ba$export$ee82dd2f959db81f);
const $3a8449e3b3bae2ba$export$abe814fcd065a580 = (date)=>(0, $iPNDK$dayjs)(date).format("MMMM D");
const $3a8449e3b3bae2ba$export$253f51d00c3c150b = (date)=>(0, $iPNDK$dayjs)(date).format("MMMM D, YYYY (dddd)");
const $3a8449e3b3bae2ba$export$c9efe0c3d34a02f4 = (date)=>(0, $iPNDK$dayjs)(date).format("MMMM YYYY");
const $3a8449e3b3bae2ba$export$160d2a3734a06909 = (date)=>(0, $iPNDK$dayjs)(date).format($3a8449e3b3bae2ba$export$826220848dd188cb);
const $3a8449e3b3bae2ba$export$64486ae5ea8a9faf = (date)=>(0, $iPNDK$dayjs)(date).format($3a8449e3b3bae2ba$export$826220848dd188cb);
const $3a8449e3b3bae2ba$export$68cfbbb172c7e133 = (date)=>(0, $iPNDK$dayjs)(date).format($3a8449e3b3bae2ba$export$918574f3886b1a3);
const $3a8449e3b3bae2ba$export$757a5dfffbfdba69 = (date)=>date.format($3a8449e3b3bae2ba$export$996c3039b022a9b1);


const $21bebe11e6996a77$export$ce9cdd12c2a530a0 = (pid)=>(values)=>{
        // values sent in format: { [subformName]: { ...data} }
        const subformName = Object.keys(values)[0];
        let valueToSubmit = {
            ...values
        };
        if (subformName === (0, $9f770fb655db2e69$export$9dab6df2a66c141e).NonResidentStatusForm) {
            const { [subformName]: { NON_RESIDENT: { IS_NON_RESIDENT: IS_NON_RESIDENT , ITN_INFO: ITN_INFO  } ,  } ,  } = values;
            if (!IS_NON_RESIDENT) valueToSubmit = {
                [subformName]: {
                    NON_RESIDENT: {
                        IS_NON_RESIDENT: IS_NON_RESIDENT,
                        ITN_INFO: []
                    }
                }
            };
            else {
                const serverITNInfo = ITN_INFO.map((info)=>{
                    const { ID: ID , YEAR: YEAR , MONTH: MONTH , DAY: DAY , PERCENTAGE_OWNERSHIP: PERCENTAGE_OWNERSHIP , FIRST_NAME: FIRST_NAME , LAST_NAME: LAST_NAME , ITN: ITN  } = info;
                    let serverDate = "";
                    if (YEAR !== "" && MONTH !== "" && DAY !== "") {
                        const date = new Date(YEAR, MONTH - 1, DAY);
                        serverDate = (0, $3a8449e3b3bae2ba$export$c03bb0116ee09d4b)(date) ? (0, $3a8449e3b3bae2ba$export$160d2a3734a06909)(date) : "";
                    }
                    return {
                        FIRST_NAME: FIRST_NAME,
                        LAST_NAME: LAST_NAME,
                        PERCENTAGE_OWNERSHIP: PERCENTAGE_OWNERSHIP,
                        ITN: ITN,
                        ID: ID,
                        DOB: serverDate,
                        YEAR: YEAR,
                        MONTH: MONTH,
                        DAY: DAY
                    };
                });
                const serverVals = {
                    NON_RESIDENT: {
                        IS_NON_RESIDENT: IS_NON_RESIDENT,
                        ITN_INFO: serverITNInfo
                    }
                };
                valueToSubmit = {
                    [subformName]: serverVals
                };
            }
        }
        // Server has legacy surcharges format, map to old format before submission
        if (subformName === (0, $9f770fb655db2e69$export$9dab6df2a66c141e).SurchargesForm) {
            const { IS_SUITABILITY_PETS_ENABLED: IS_SUITABILITY_PETS_ENABLED , SURCHARGES: SURCHARGES  } = values[subformName];
            const submitSurcharges = Object.keys(SURCHARGES).map((key)=>({
                    ...SURCHARGES[key]
                }));
            valueToSubmit = {
                [subformName]: {
                    IS_SUITABILITY_PETS_ENABLED: IS_SUITABILITY_PETS_ENABLED,
                    SURCHARGES: submitSurcharges
                }
            };
        }
        // Server has legacy suitabilities format, map to old format before submission
        if (subformName === (0, $9f770fb655db2e69$export$9dab6df2a66c141e).SuitabilitiesForm) {
            const { RULES: RULES , SUITABILITIES: SUITABILITIES  } = values[subformName];
            const submitSuitabilities = Object.keys(SUITABILITIES).map((key)=>SUITABILITIES[key]);
            valueToSubmit = {
                [subformName]: {
                    RULES: RULES,
                    SUITABILITIES: submitSuitabilities
                }
            };
        }
        valueToSubmit.property_id = pid;
        return valueToSubmit;
    };


var $a21b1a44f2f656cf$exports = {};

$parcel$export($a21b1a44f2f656cf$exports, "useWalkthroughGuidebookMutation", () => $a21b1a44f2f656cf$export$b7b7717fa94cf2f2);


const $a21b1a44f2f656cf$export$b7b7717fa94cf2f2 = ()=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $e15de41ca5b185e2$export$f3a6164b81299928),
        method: "PUT"
    });
};


var $30ce8504169fa6b7$exports = {};

$parcel$export($30ce8504169fa6b7$exports, "usePropertySubformMutation", () => $30ce8504169fa6b7$export$8601a0af9fe53966);




const $30ce8504169fa6b7$export$8601a0af9fe53966 = ({ onSuccess: onSuccess , propertyId: propertyId , ...rest })=>{
    const queryClient = (0, $iPNDK$useQueryClient)();
    const propertyQueryString = (0, $e15de41ca5b185e2$export$d439d8afdae174fa)(propertyId);
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $e15de41ca5b185e2$export$eaf7e24ac4a8bddc),
        method: "PUT",
        isSubform: true,
        // capture pid in the enclosing scope so that its always sent
        modifySendDataFn: (0, $21bebe11e6996a77$export$ce9cdd12c2a530a0)(propertyId),
        onSuccess: async (responseData)=>{
            await queryClient.refetchQueries(propertyQueryString);
            onSuccess && onSuccess(responseData);
        },
        ...rest
    });
};


var $a5e7a518b63dd2b5$exports = {};

$parcel$export($a5e7a518b63dd2b5$exports, "useErrorMutation", () => $a5e7a518b63dd2b5$export$deda107c1edcdea4);
var $7c2cdfac8d14e30c$exports = {};

$parcel$export($7c2cdfac8d14e30c$exports, "defaultLocationURLParams", () => $7c2cdfac8d14e30c$export$35c5726ddc6b8970);
$parcel$export($7c2cdfac8d14e30c$exports, "generateOwnerLocationEndPoint", () => $7c2cdfac8d14e30c$export$b3606ef5d5040c9c);
$parcel$export($7c2cdfac8d14e30c$exports, "generateGuestLocationEndPoint", () => $7c2cdfac8d14e30c$export$e325af78336489eb);
$parcel$export($7c2cdfac8d14e30c$exports, "errorsEndPoint", () => $7c2cdfac8d14e30c$export$8f4c3ade4819c760);
$parcel$export($7c2cdfac8d14e30c$exports, "generateCancellationPolicyEndpoint", () => $7c2cdfac8d14e30c$export$9b362cc650f43180);
$parcel$export($7c2cdfac8d14e30c$exports, "generateTermsOfServiceAgreementEndpoint", () => $7c2cdfac8d14e30c$export$ccdd533040c6e3b3);

const $7c2cdfac8d14e30c$export$35c5726ddc6b8970 = Object.keys((0, $b9fbf0da9ae592a3$export$820ef0da71e57e4b)).map((param)=>(0, $b9fbf0da9ae592a3$export$820ef0da71e57e4b)[param]);
const $7c2cdfac8d14e30c$export$b3606ef5d5040c9c = (requirements = $7c2cdfac8d14e30c$export$35c5726ddc6b8970)=>`/RESTAUTH/location/?categories=${requirements}`;
const $7c2cdfac8d14e30c$export$e325af78336489eb = (userId, requirements = $7c2cdfac8d14e30c$export$35c5726ddc6b8970)=>`/RESTAUTH/guest/location/?categories=${requirements}&ID=${userId}`;
const $7c2cdfac8d14e30c$export$8f4c3ade4819c760 = `/RESTAUTH/error/`;
const $7c2cdfac8d14e30c$export$9b362cc650f43180 = ({ policy_id: policy_id , is_credit_only_refund: is_credit_only_refund , is_refund_rebooked_dates: is_refund_rebooked_dates , is_special_circumstance: is_special_circumstance , special_circumstance_id: special_circumstance_id , special_circumstance_description: special_circumstance_description , admin_penalty: admin_penalty , admin_penalty_unit: admin_penalty_unit  })=>{
    const searchParams = new URLSearchParams({
        policy_id: policy_id,
        is_credit_only_refund: is_credit_only_refund,
        is_refund_rebooked_dates: is_refund_rebooked_dates,
        is_special_circumstance: is_special_circumstance,
        special_circumstance_id: special_circumstance_id,
        special_circumstance_description: special_circumstance_description,
        admin_penalty: admin_penalty,
        admin_penalty_unit: admin_penalty_unit
    });
    return `/RESTAUTH/cancellationpolicy/generate/?${searchParams.toString()}`;
};
const $7c2cdfac8d14e30c$export$ccdd533040c6e3b3 = (userTypeId)=>`/RESTAUTH/tossa/?user_type_id=${userTypeId}`;



const $a5e7a518b63dd2b5$export$deda107c1edcdea4 = ()=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: "POST",
        url: (0, $7c2cdfac8d14e30c$export$8f4c3ade4819c760),
        hasToastsEnabled: false
    });
};


var $f21ebe6183911aea$exports = {};

$parcel$export($f21ebe6183911aea$exports, "useTermsOfServiceQuery", () => $f21ebe6183911aea$export$552a2317b4e6a2f0);


const $f21ebe6183911aea$export$552a2317b4e6a2f0 = ({ userTypeId: userTypeId , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $7c2cdfac8d14e30c$export$ccdd533040c6e3b3)(userTypeId),
        ...rest
    });
};


var $34ca7670912c6cc0$exports = {};

$parcel$export($34ca7670912c6cc0$exports, "useMessageSubjectInfiniteQuery", () => $34ca7670912c6cc0$export$d3892141c8750b9c);

var $f5973776ce302c7e$exports = {};

$parcel$export($f5973776ce302c7e$exports, "userMessageSubjectsQueryKeys", () => $f5973776ce302c7e$export$886559c3a9a985c0);
$parcel$export($f5973776ce302c7e$exports, "useUserMessageSubjectsInfiniteQuery", () => $f5973776ce302c7e$export$85602b57ec5d14ea);
var $3b54348c5bf92caa$exports = {};

$parcel$export($3b54348c5bf92caa$exports, "userPutEndpoint", () => $3b54348c5bf92caa$export$97e2f39d4877deae);
$parcel$export($3b54348c5bf92caa$exports, "userEndpoint", () => $3b54348c5bf92caa$export$7119b2a4f38d2087);
$parcel$export($3b54348c5bf92caa$exports, "userCredentialsEndpoint", () => $3b54348c5bf92caa$export$fb9bc9df7f34e09f);
$parcel$export($3b54348c5bf92caa$exports, "userLoginEndpoint", () => $3b54348c5bf92caa$export$99c2d64e1a90b7df);
$parcel$export($3b54348c5bf92caa$exports, "userPasswordSyncEndpoint", () => $3b54348c5bf92caa$export$11facad7913bda02);
$parcel$export($3b54348c5bf92caa$exports, "userProfilePhotoEndpoint", () => $3b54348c5bf92caa$export$30289506872908c9);
$parcel$export($3b54348c5bf92caa$exports, "userMessageEndpoint", () => $3b54348c5bf92caa$export$2655fe4540b8b94e);
$parcel$export($3b54348c5bf92caa$exports, "twilioSendCodeEndpoint", () => $3b54348c5bf92caa$export$a77d5295244c0a1c);
$parcel$export($3b54348c5bf92caa$exports, "twilioSendCodeEndpointCheck", () => $3b54348c5bf92caa$export$27f9c16834747437);
$parcel$export($3b54348c5bf92caa$exports, "userPasswordResetEndpoint", () => $3b54348c5bf92caa$export$877778df9bf039fc);
$parcel$export($3b54348c5bf92caa$exports, "generateUserProfilePhotoEndpoint", () => $3b54348c5bf92caa$export$349b71c505d5f05);
$parcel$export($3b54348c5bf92caa$exports, "generateUserMessageUnreadEndpoint", () => $3b54348c5bf92caa$export$e728a9a3f4a78bd6);
$parcel$export($3b54348c5bf92caa$exports, "userMessageMarkAsReadEndpoint", () => $3b54348c5bf92caa$export$ca1429d0689bce78);
$parcel$export($3b54348c5bf92caa$exports, "generateUserMessageContactEndpoint", () => $3b54348c5bf92caa$export$265b5cd3b0e616c2);
$parcel$export($3b54348c5bf92caa$exports, "generateUserMessageSubjectEndpoint", () => $3b54348c5bf92caa$export$18a10673c8c4007);
$parcel$export($3b54348c5bf92caa$exports, "generateUserMessageSubjectsEndpoint", () => $3b54348c5bf92caa$export$b6c148a6971eb44b);
$parcel$export($3b54348c5bf92caa$exports, "generateUserMessageOverviewEndpoint", () => $3b54348c5bf92caa$export$73e2fb10e909740c);
$parcel$export($3b54348c5bf92caa$exports, "generateUserMessageThreadEndpoint", () => $3b54348c5bf92caa$export$529514ed8c56265c);
$parcel$export($3b54348c5bf92caa$exports, "userExpoTokenEndpoint", () => $3b54348c5bf92caa$export$d69cdda500787bd6);
$parcel$export($3b54348c5bf92caa$exports, "generateUserCheckEmailTaken", () => $3b54348c5bf92caa$export$ebb0629ebb761139);
$parcel$export($3b54348c5bf92caa$exports, "generateUserCheckEmailExists", () => $3b54348c5bf92caa$export$e9ae87c929cf0520);
const $3b54348c5bf92caa$export$97e2f39d4877deae = "/RESTAUTH/user/";
const $3b54348c5bf92caa$export$7119b2a4f38d2087 = "/RESTAUTH/user/checklogin/";
const $3b54348c5bf92caa$export$fb9bc9df7f34e09f = "/RESTAUTH/user/credentials/";
const $3b54348c5bf92caa$export$99c2d64e1a90b7df = "/RESTAUTH/user/login/";
const $3b54348c5bf92caa$export$11facad7913bda02 = "/RESTAUTH/user/accountsync/";
const $3b54348c5bf92caa$export$30289506872908c9 = "/RESTAUTH/user/profilephoto/";
const $3b54348c5bf92caa$export$2655fe4540b8b94e = "/RESTAUTH/user/message/";
const $3b54348c5bf92caa$export$a77d5295244c0a1c = `/RESTAUTH/user/verification/`;
const $3b54348c5bf92caa$export$27f9c16834747437 = `/RESTAUTH/user/verification/check/`;
const $3b54348c5bf92caa$export$877778df9bf039fc = "/RESTAUTH/user/passwordreset/";
const $3b54348c5bf92caa$export$349b71c505d5f05 = (userId, userTypeId)=>{
    return `/RESTAUTH/user/profilephoto/?id=${userId}&user_type_id=${userTypeId}`;
};
const $3b54348c5bf92caa$export$e728a9a3f4a78bd6 = (id, userTypeId)=>`/RESTAUTH/user/message/unreadcount/?id=${id}&user_type_id=${userTypeId}`;
const $3b54348c5bf92caa$export$ca1429d0689bce78 = `/RESTAUTH/user/message/thread/markasread/`;
const $3b54348c5bf92caa$export$265b5cd3b0e616c2 = ({ contactUserTypeId: contactUserTypeId , contactUserId: contactUserId , propertyId: propertyId  })=>{
    const pid = propertyId ? `&property_id=${propertyId}` : "";
    return `/RESTAUTH/user/message/contact/?contact_user_id=${contactUserId}&contact_user_type_id=${contactUserTypeId}${pid}`;
};
const $3b54348c5bf92caa$export$18a10673c8c4007 = ({ id: id , userTypeId: userTypeId , bookingId: /** For reservation messages, guidebook messages etc */ bookingId , messageId: /** Used for getting the last subject as an owner */ messageId  })=>{
    const bid = bookingId !== undefined ? `&booking_id=${bookingId}` : "";
    const mid = messageId !== undefined ? `&message_id=${messageId}` : "";
    return `/RESTAUTH/user/message/subject/?id=${id}&user_type_id=${userTypeId}${bid}${mid}`;
};
const $3b54348c5bf92caa$export$b6c148a6971eb44b = ({ id: id , userTypeId: userTypeId , page: page , page_direction: page_direction , amountPerPage: amountPerPage , subjectType: subjectType , filterUserId: /** Filter on a specific user (thread) */ filterUserId , filterUserTypeId: filterUserTypeId , searchFilter: /** unused, may be used when search is added */ searchFilter  })=>{
    const filterId = filterUserId !== undefined ? `&filter_user_id=${filterUserId}` : "";
    const filterTypeId = filterUserTypeId !== undefined ? `&filter_user_type_id=${filterUserTypeId}` : "";
    const search = searchFilter !== undefined ? `&search_filter=${searchFilter}` : "";
    return `/RESTAUTH/user/message/subjects/?id=${id}&user_type_id=${userTypeId}&page=${page}&page_direction=${page_direction}&amount_per_page=${amountPerPage}&subject_type=${subjectType}${filterId}${filterTypeId}${search}`;
};
const $3b54348c5bf92caa$export$73e2fb10e909740c = ({ id: id , userTypeId: userTypeId , page: page , amountPerPage: amountPerPage , propertyId: propertyId  })=>{
    const optionalPropertyFilter = propertyId ? `&property_id=${propertyId}` : "";
    return `/RESTAUTH/user/message/overview/?id=${id}&user_type_id=${userTypeId}&page=${page}&amount_per_page=${amountPerPage}${optionalPropertyFilter}`;
};
const $3b54348c5bf92caa$export$529514ed8c56265c = ({ id: id , userTypeId: userTypeId , page: page , amountPerPage: amountPerPage , contactUserId: contactUserId , contactUserTypeId: contactUserTypeId  })=>{
    return `/RESTAUTH/user/message/thread/?id=${id}&user_type_id=${userTypeId}&page=${page}&amount_per_page=${amountPerPage}&contact_user_id=${contactUserId}&contact_user_type_id=${contactUserTypeId}`;
};
const $3b54348c5bf92caa$export$d69cdda500787bd6 = "/RESTAUTH/user/expopushtoken/";
const $3b54348c5bf92caa$export$ebb0629ebb761139 = (email)=>{
    return `/RESTAUTH/user/email/taken/?email=${email}`;
};
const $3b54348c5bf92caa$export$e9ae87c929cf0520 = (email)=>{
    return `/RESTAUTH/user/email/exists/?email=${email}`;
};




const $f5973776ce302c7e$var$SUBJECTS = "SUBJECTS";
const $f5973776ce302c7e$export$886559c3a9a985c0 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)(`USER_MESSAGE_${$f5973776ce302c7e$var$SUBJECTS}`);
const $f5973776ce302c7e$var$amountPerPage = 15;
const $f5973776ce302c7e$var$initialPageParam = 1;
const $f5973776ce302c7e$export$85602b57ec5d14ea = ({ id: id , userTypeId: userTypeId , subjectType: subjectType , searchFilter: searchFilter , filterUserId: filterUserId , filterUserTypeId: filterUserTypeId , pageDirection: pageDirection = "future" , enabled: enabled = true  })=>{
    function urlFunction(pageNumber) {
        return (0, $3b54348c5bf92caa$export$b6c148a6971eb44b)({
            id: id,
            userTypeId: userTypeId,
            subjectType: subjectType,
            searchFilter: searchFilter,
            filterUserId: filterUserId,
            filterUserTypeId: filterUserTypeId,
            page: pageNumber,
            page_direction: pageDirection,
            amountPerPage: $f5973776ce302c7e$var$amountPerPage
        });
    }
    const queryKey = $f5973776ce302c7e$export$886559c3a9a985c0.detail(`${id}${userTypeId}${subjectType}${searchFilter}${filterUserId}${filterUserTypeId}${pageDirection}`);
    return (0, $5c3888846488886d$export$a1eb5d1bcb4f35a6)({
        queryKey: queryKey,
        amountPerPage: $f5973776ce302c7e$var$amountPerPage,
        initialPageParam: $f5973776ce302c7e$var$initialPageParam,
        urlFn: urlFunction,
        nextPageKey: $f5973776ce302c7e$var$SUBJECTS,
        enabled: enabled
    });
};


const $34ca7670912c6cc0$export$d3892141c8750b9c = ({ userId: userId , userTypeId: userTypeId , contactId: contactId , contactUserTypeId: contactUserTypeId  })=>{
    const upcomingBookingsQuery = (0, $f5973776ce302c7e$export$85602b57ec5d14ea)({
        id: userId,
        userTypeId: userTypeId,
        pageDirection: "future",
        subjectType: "future_bookings",
        filterUserId: contactId,
        filterUserTypeId: contactUserTypeId
    });
    const pastBookingsQuery = (0, $f5973776ce302c7e$export$85602b57ec5d14ea)({
        id: userId,
        userTypeId: userTypeId,
        pageDirection: "future",
        subjectType: "past_bookings",
        filterUserId: contactId,
        filterUserTypeId: contactUserTypeId
    });
    const upcomingBookings = upcomingBookingsQuery.data ? (0, $72dc1ad4ce2b3683$export$a90bfd0a4ae1116f)(upcomingBookingsQuery.data, "SUBJECTS") : [];
    const pastBookings = pastBookingsQuery.data ? (0, $72dc1ad4ce2b3683$export$a90bfd0a4ae1116f)(pastBookingsQuery.data, "SUBJECTS") : [];
    const isLoading = upcomingBookingsQuery.isLoading || pastBookingsQuery.isLoading;
    return {
        upcomingBookings: upcomingBookings,
        pastBookings: pastBookings,
        isLoading: isLoading,
        upcomingBookingsQuery: upcomingBookingsQuery,
        pastBookingsQuery: pastBookingsQuery
    };
};


var $075f45b3096494c7$exports = {};

$parcel$export($075f45b3096494c7$exports, "userMessageOverviewQueryKeys", () => $075f45b3096494c7$export$1606b956841c586b);
$parcel$export($075f45b3096494c7$exports, "useUserMessageOverviewInfiniteQuery", () => $075f45b3096494c7$export$21dbcbd9ba734e84);



const $075f45b3096494c7$export$1606b956841c586b = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("USER_MESSAGE_OVERVIEW");
const $075f45b3096494c7$var$amountPerPage = 15;
const $075f45b3096494c7$var$initialPageParam = 1;
const $075f45b3096494c7$export$21dbcbd9ba734e84 = ({ id: id , userTypeId: userTypeId , propertyId: propertyId , refetchInterval: refetchInterval , enabled: enabled = true  })=>{
    function urlFunction(pageNumber) {
        return (0, $3b54348c5bf92caa$export$73e2fb10e909740c)({
            id: id,
            amountPerPage: $075f45b3096494c7$var$amountPerPage,
            page: pageNumber,
            userTypeId: userTypeId,
            propertyId: propertyId
        });
    }
    const queryKey = $075f45b3096494c7$export$1606b956841c586b.detail(`${id}${userTypeId}${propertyId}`);
    return (0, $5c3888846488886d$export$a1eb5d1bcb4f35a6)({
        queryKey: queryKey,
        amountPerPage: $075f45b3096494c7$var$amountPerPage,
        initialPageParam: $075f45b3096494c7$var$initialPageParam,
        nextPageKey: "MESSAGES",
        urlFn: urlFunction,
        refetchInterval: refetchInterval,
        enabled: enabled
    });
};



var $156aac85a5b99e55$exports = {};

$parcel$export($156aac85a5b99e55$exports, "userMessageThreadQueryKeys", () => $156aac85a5b99e55$export$a67c45a28ec49644);
$parcel$export($156aac85a5b99e55$exports, "useUserMessageThreadInfiniteQuery", () => $156aac85a5b99e55$export$e8d4e2c458aafaf);



const $156aac85a5b99e55$export$a67c45a28ec49644 = (0, $04e57a2246bdbee0$export$81fc3df80b283228)("USER_MESSAGE_THREAD");
const $156aac85a5b99e55$var$amountPerPage = 15;
const $156aac85a5b99e55$var$initialPageParam = 1;
const $156aac85a5b99e55$export$e8d4e2c458aafaf = ({ id: id , userTypeId: userTypeId , contactUserId: contactUserId , contactUserTypeId: contactUserTypeId , ...rest })=>{
    function urlFunction(pageNumber) {
        return (0, $3b54348c5bf92caa$export$529514ed8c56265c)({
            id: id,
            amountPerPage: $156aac85a5b99e55$var$amountPerPage,
            page: pageNumber,
            userTypeId: userTypeId,
            contactUserId: contactUserId,
            contactUserTypeId: contactUserTypeId
        });
    }
    return (0, $5c3888846488886d$export$a1eb5d1bcb4f35a6)({
        queryKey: $156aac85a5b99e55$export$a67c45a28ec49644.detail(`${contactUserId}${contactUserTypeId}${id}${userTypeId}`),
        amountPerPage: $156aac85a5b99e55$var$amountPerPage,
        initialPageParam: $156aac85a5b99e55$var$initialPageParam,
        nextPageKey: "THREAD",
        urlFn: urlFunction,
        ...rest
    });
};


var $3657bbf543405025$exports = {};

$parcel$export($3657bbf543405025$exports, "generateEditReservationMessage", () => $3657bbf543405025$export$dbe0a99d01c5bff0);
$parcel$export($3657bbf543405025$exports, "generateCancelReservationMessage", () => $3657bbf543405025$export$b26d2362e032fab1);
var $af33674cdb61992e$exports = {};

$parcel$export($af33674cdb61992e$exports, "UserRoleIDEnum", () => $af33674cdb61992e$export$37c8f1bc2ef2e9b9);
$parcel$export($af33674cdb61992e$exports, "UserTypeEnum", () => $af33674cdb61992e$export$e05722a566bbc7bd);
$parcel$export($af33674cdb61992e$exports, "UserMessageType", () => $af33674cdb61992e$export$629a479ee61a4b1c);
var $de872e06841c454e$exports = {};

$parcel$export($de872e06841c454e$exports, "GUEST_PROFILE", () => $de872e06841c454e$export$b27d988044282929);
$parcel$export($de872e06841c454e$exports, "OWNER_PROFILE", () => $de872e06841c454e$export$dc285ff9a92ba8b0);
$parcel$export($de872e06841c454e$exports, "PROPERTY_MANAGER_PROFILE", () => $de872e06841c454e$export$6c893ebd2bfba6be);
$parcel$export($de872e06841c454e$exports, "COHOST_PROFILE", () => $de872e06841c454e$export$a7ce0630542bae82);
$parcel$export($de872e06841c454e$exports, "USER", () => $de872e06841c454e$export$ff09b90989b21a8);
$parcel$export($de872e06841c454e$exports, "MESSAGE", () => $de872e06841c454e$export$145c04625c32c6f3);
$parcel$export($de872e06841c454e$exports, "MESSAGE_BOOKING", () => $de872e06841c454e$export$4d6cb86fc4b48362);
$parcel$export($de872e06841c454e$exports, "MESSAGE_PROPERTY", () => $de872e06841c454e$export$3d9fef5d7039bac2);
$parcel$export($de872e06841c454e$exports, "MESSAGE_CONTACT", () => $de872e06841c454e$export$5d5414ba339996bd);
$parcel$export($de872e06841c454e$exports, "USER_LOGIN", () => $de872e06841c454e$export$62d0a6d9a23c818);
$parcel$export($de872e06841c454e$exports, "GUEST_OWNER_LOGIN", () => $de872e06841c454e$export$901f69c43e4f0a63);
$parcel$export($de872e06841c454e$exports, "USER_MESSAGE_SUBJECT", () => $de872e06841c454e$export$dfe369a01c7032f4);
$parcel$export($de872e06841c454e$exports, "USER_MESSAGE_OVERVIEW", () => $de872e06841c454e$export$6755bfb67f26df31);
$parcel$export($de872e06841c454e$exports, "MESSAGE_THREAD", () => $de872e06841c454e$export$41a1bfdc55d0c02a);
$parcel$export($de872e06841c454e$exports, "MESSAGE_UNREAD_COUNT", () => $de872e06841c454e$export$78f74086b8e7868a);
var $80436cd706766ba7$exports = {};

$parcel$export($80436cd706766ba7$exports, "address", () => $80436cd706766ba7$export$f7d3c097ceca6c15);
$parcel$export($80436cd706766ba7$exports, "amenity", () => $80436cd706766ba7$export$719efbeb97b07aa7);
$parcel$export($80436cd706766ba7$exports, "CANCELLATION_POLICY", () => $80436cd706766ba7$export$93fb9aa9532d819b);
$parcel$export($80436cd706766ba7$exports, "notification", () => $80436cd706766ba7$export$2adf6238a2d0dafa);
$parcel$export($80436cd706766ba7$exports, "NOTIFICATION_ENDPOINT_RESPONSE", () => $80436cd706766ba7$export$d6f542c4004796a7);
$parcel$export($80436cd706766ba7$exports, "BLACKOUT_PERIOD", () => $80436cd706766ba7$export$97035b66a86bacc7);
$parcel$export($80436cd706766ba7$exports, "OFFER", () => $80436cd706766ba7$export$997e912fc8340bdc);
$parcel$export($80436cd706766ba7$exports, "tax", () => $80436cd706766ba7$export$384165d01427152e);
$parcel$export($80436cd706766ba7$exports, "taxSurcharge", () => $80436cd706766ba7$export$b3d999cb855c93d9);
$parcel$export($80436cd706766ba7$exports, "contactTracingGuest", () => $80436cd706766ba7$export$f3e08cf4c2119893);
$parcel$export($80436cd706766ba7$exports, "surchargeTaxItem", () => $80436cd706766ba7$export$fa086120b3c0f2a);
$parcel$export($80436cd706766ba7$exports, "taxItem", () => $80436cd706766ba7$export$c778997df97e7eb9);
$parcel$export($80436cd706766ba7$exports, "BOOKING_SURCHARGES_LIST", () => $80436cd706766ba7$export$1f1fdc5cd5eff57);
$parcel$export($80436cd706766ba7$exports, "BOOKING_SURCHARGES", () => $80436cd706766ba7$export$b7ebbc687a55d27);
$parcel$export($80436cd706766ba7$exports, "DIRECT_VACATIONS", () => $80436cd706766ba7$export$82cefcd67fde3934);
$parcel$export($80436cd706766ba7$exports, "propertyGuidebookPDF", () => $80436cd706766ba7$export$20abdeb7a4a80414);
$parcel$export($80436cd706766ba7$exports, "propertyOwner", () => $80436cd706766ba7$export$bd9a90e1c91075e7);
$parcel$export($80436cd706766ba7$exports, "propertyRules", () => $80436cd706766ba7$export$a17702445465e88);
$parcel$export($80436cd706766ba7$exports, "serviceFee", () => $80436cd706766ba7$export$57f3f1ee6c8aba33);
$parcel$export($80436cd706766ba7$exports, "accommodationTaxItem", () => $80436cd706766ba7$export$595ec8374a0e527f);
$parcel$export($80436cd706766ba7$exports, "totalsPaid", () => $80436cd706766ba7$export$23542f496ff490c6);
$parcel$export($80436cd706766ba7$exports, "serviceFeeTaxItem", () => $80436cd706766ba7$export$b204ab576813c92b);
$parcel$export($80436cd706766ba7$exports, "transaction", () => $80436cd706766ba7$export$2d62d2646dd2fb3c);
$parcel$export($80436cd706766ba7$exports, "initialLocationData", () => $80436cd706766ba7$export$cd273ef51e695c33);
$parcel$export($80436cd706766ba7$exports, "RESERVATION_SETTINGS", () => $80436cd706766ba7$export$7158a8c2efc7d19a);
const $80436cd706766ba7$export$f7d3c097ceca6c15 = {
    AREA: "",
    AREA_ID: 0,
    CITY: "",
    COUNTRY: "",
    COUNTRY_CODE: "",
    COUNTRY_ID: 0,
    DEVELOPMENT: "",
    DEVELOPMENT_ID: 0,
    ID: 0,
    LATITUDE: 0,
    LONGITUDE: 0,
    POSTAL: "",
    REGION: "",
    REGION_ID: 0,
    RESORT: "",
    RESORT_ID: 0,
    STREET_NAME: "",
    STREET_NUMBER: "",
    UNIT: ""
};
const $80436cd706766ba7$export$719efbeb97b07aa7 = {
    ID: -1,
    NAME: "",
    INSTRUCTIONS: "",
    DESCRIPTION: "",
    PROPERTY_AMENITY_ID: 0,
    /** Optional field on an amenity */ ACCESS_CODE: "",
    /** Only appears when using the internet amenity */ INTERNET_PASSWORD: "",
    INTERNET_NETWORK_NAME: ""
};
const $80436cd706766ba7$var$policyDateRange = {
    DATE_ACTIVATED: "",
    DESCRIPTION: "",
    FROM_DAYS: "",
    ID: -1,
    LABEL: "",
    REFUND_PERCENTAGE: "",
    TO_DAYS: ""
};
const $80436cd706766ba7$export$93fb9aa9532d819b = {
    ADMIN_PENALTY: 0,
    ADMIN_PENALTY_UNIT: "",
    BOOKING_GRACE_PERIOD: "",
    DATE_ACTIVATED: "",
    DATE_LAST_UPDATED: "",
    DATE_RANGES: [
        $80436cd706766ba7$var$policyDateRange
    ],
    DESCRIPTION: "",
    ID: 0,
    IS_CREDIT_ONLY_REFUND: false,
    IS_REFUND_REBOOKED_DATES: false,
    IS_SPECIAL_CIRCUMSTANCE: false,
    NAME: "",
    POLICY_ID: 0,
    SERVICE_FEE_REFUND: "",
    SPECIAL_CIRCUMSTANCE_DESCRIPTION: "",
    SPECIAL_CIRCUMSTANCE_ID: 0,
    SPECIAL_CIRCUMSTANCE_NAME: "",
    SURCHARGE_REFUND: ""
};
const $80436cd706766ba7$export$2adf6238a2d0dafa = {
    CATEGORY_ID: 0,
    LEVEL_ID: 0,
    IS_DISMISSIBLE: false,
    DATE_CREATED: "",
    CATEGORY_LINK_ID: 0,
    LEVEL_NAME: "",
    LEVEL: 0,
    HTML_CONTENT: "",
    IS_FEATURED: false,
    IS_DISMISSED: false,
    CATEGORY: "",
    DATE_DISMISSED: "",
    ID: 0,
    IMAGE_URL: "",
    TITLE: "",
    DESCRIPTION: "",
    PROPERTY_ID: 0,
    PROPERTY_NAME: "",
    PROPERTY_ADDRESS: ""
};
const $80436cd706766ba7$export$d6f542c4004796a7 = {
    PROPERTY_ID: 0,
    UNREAD_COUNT: 0,
    NOTIFICATIONS: []
};
const $80436cd706766ba7$export$97035b66a86bacc7 = {
    ID: 0,
    START: "",
    END: ""
};
const $80436cd706766ba7$export$997e912fc8340bdc = {
    BLACKOUT_PERIODS: [],
    CODE: "",
    DESCRIPTION: "",
    DISTRIBUTION: "",
    DISTRIBUTION_ID: 0,
    DOLLAR: "",
    GIFT_CERTIFICATE_URL: "",
    GUEST_EMAIL: "",
    GUEST_ID: 0,
    INSTRUCTIONS: "",
    IS_ALL_PROPERTIES: false,
    IS_EDITABLE: false,
    IS_ENABLED: true,
    IS_PERMANENT_REPEAT_GUEST_OFFER: false,
    IS_PROMOTED: false,
    IS_PUBLIC: true,
    MAX_USAGE_COUNT: 1,
    MIN_NIGHTS: 0,
    NIGHTS_FREE: 0,
    NIGHTS_REQUIRED: 0,
    OFFER_AVAILABILITY_ID: 1,
    OFFER_AVAILABLE_END: "",
    OFFER_AVAILABLE_START: "",
    OFFER_CATEGORY: "",
    OFFER_CATEGORY_ID: 1,
    OFFER_END: "",
    OFFER_ID: 0,
    OFFER_START: "",
    OFFER_TYPE_ID: 1,
    OFFER_URL: "",
    PERCENTAGE: 0,
    PROMOTED_OFFER_ID: 0,
    PROPERTY_IDS: "",
    STATUS: "",
    TITLE: "",
    USAGE_COUNT: 0,
    USER_ID: 0
};
const $80436cd706766ba7$export$384165d01427152e = {
    AMOUNT: "",
    ID: 0,
    NAME: ""
};
const $80436cd706766ba7$export$b3d999cb855c93d9 = {
    ...$80436cd706766ba7$export$384165d01427152e,
    IS_PASS_THROUGH_TO_OWNER: false
};
const $80436cd706766ba7$export$f3e08cf4c2119893 = {
    EMAIL: "",
    FIRST_NAME: "",
    ID: 0,
    IS_CHILD: false,
    LAST_NAME: "",
    PHONE: ""
};
const $80436cd706766ba7$export$fa086120b3c0f2a = {
    ACCOUNT: "",
    STRING: ""
};
const $80436cd706766ba7$export$c778997df97e7eb9 = {
    AMOUNT: "",
    ID: 0,
    IS_PASS_THROUGH_TO_OWNER: false,
    NAME: "",
    RATE: 0
};
const $80436cd706766ba7$var$BOOKING_SURCHARGE = {
    IS_ENABLED: false,
    TAX: "",
    TAXES: {},
    FEE: "",
    NAME: "",
    ID: 0,
    TOTAL: ""
};
const $80436cd706766ba7$export$1f1fdc5cd5eff57 = {};
const $80436cd706766ba7$export$b7ebbc687a55d27 = {
    GROSS: "",
    LIST: $80436cd706766ba7$export$1f1fdc5cd5eff57,
    NET: "",
    TAXES_TOTAL: "",
    TAXES_TOTALS: [
        $80436cd706766ba7$export$c778997df97e7eb9
    ]
};
const $80436cd706766ba7$export$82cefcd67fde3934 = {
    ID: 0,
    IS_ACTIVE: false,
    LOGO: "",
    NAME: "",
    URL: ""
};
const $80436cd706766ba7$export$20abdeb7a4a80414 = {
    PROPERTY_GUIDEBOOK_PDF: "",
    BOOKING_ID: 0,
    ID: 0
};
const $80436cd706766ba7$export$bd9a90e1c91075e7 = {
    COMPANY_NAME: "",
    FIRST_NAME: "",
    ID: 0,
    IS_COMPANY: false,
    LAST_NAME: "",
    EMAIL: "",
    THUMBNAIL: ""
};
const $80436cd706766ba7$export$a17702445465e88 = {
    CHECK_IN_TIME: "",
    CHECK_OUT_TIME: "",
    MAX_GUESTS: 0,
    QUIET_TIME: ""
};
const $80436cd706766ba7$export$57f3f1ee6c8aba33 = {
    DESCRIPTION: "",
    FEE: "",
    ID: 0,
    NAME: "",
    TAX: "",
    TAXES: [
        $80436cd706766ba7$export$c778997df97e7eb9
    ],
    TAXES_STRING: "",
    TOTAL: ""
};
const $80436cd706766ba7$export$595ec8374a0e527f = {
    AMOUNT: "",
    NAME: ""
};
const $80436cd706766ba7$export$23542f496ff490c6 = {
    ACCOMMODATION_NET: "",
    ACCOMMODATION_TAXES: [
        $80436cd706766ba7$export$595ec8374a0e527f
    ],
    BANK_DEPOSIT: "",
    COMMISSION: "",
    COMMISSION_PARTNER: "",
    CREDIT_CARD_FEE: "",
    DAMAGE_DEPOSIT: "",
    NR6: "",
    OWNER_PASS_THROUGH_TAXES: [
        $80436cd706766ba7$export$c778997df97e7eb9
    ],
    REVENUE_NET: "",
    PROPERTY_MANAGER_SERVICE_FEE: {
        IS_FEE_ON_SUBTOTAL_TO_OWNER: false,
        NET: "",
        TAXES: [
            $80436cd706766ba7$export$c778997df97e7eb9
        ],
        TOTAL: ""
    },
    SURCHARGE: {
        TAXES: [
            $80436cd706766ba7$export$c778997df97e7eb9
        ],
        NET: ""
    },
    SURCHARGE_NET: "",
    SURCHARGE_TAXES: [
        $80436cd706766ba7$export$c778997df97e7eb9
    ],
    TAX: ""
};
const $80436cd706766ba7$export$b204ab576813c92b = {
    AMOUNT: 0,
    ID: 0,
    NAME: "",
    RATE: 0
};
const $80436cd706766ba7$export$2d62d2646dd2fb3c = {
    AMOUNT: "",
    BANK_DEPOSIT: {
        ACCOUNT: "",
        AMOUNT: "",
        DATE: ""
    },
    BOOKING_NET: "",
    CATEGORY: "",
    COMMISSION: {
        GST: "",
        MRDT: "",
        NET: "",
        PST: "",
        TOTAL: ""
    },
    CREDIT_CARD: {
        CARDHOLDER_NAME: "",
        NAME: "",
        NUMBER: ""
    },
    CREDIT_CARD_WITHHELD: "",
    DAMAGE_DEPOSIT_AMOUNT: "",
    DATE: "",
    ID: 0,
    NR6_PERCENTAGE: 0,
    NR6_WITHHELD: "",
    SERVICE_FEE: {
        FEE: 0,
        ID: 0,
        NAME: "",
        TAX: 0,
        TAXES: [
            $80436cd706766ba7$export$b204ab576813c92b
        ],
        TOTAL: 0
    },
    SURCHARGES: $80436cd706766ba7$export$b7ebbc687a55d27,
    TAX: {
        TAXES: [
            $80436cd706766ba7$export$c778997df97e7eb9
        ],
        TOTAL: "0.00",
        WITHHELD: {
            MRDT: "0.00",
            PST: "0.00"
        }
    },
    TYPE: "charge"
};
const $80436cd706766ba7$export$cd273ef51e695c33 = {
    COUNTRIES: [],
    REGIONS: [],
    AREAS: [],
    RESORTS: [],
    DEVELOPMENTS: [],
    PROPERTY_CATEGORIES: []
};
const $80436cd706766ba7$export$7158a8c2efc7d19a = {
    DEPOSIT_PERCENTAGE: 0,
    BALANCE_DAYS_BEFORE_ARRIVAL: 0,
    BOOKING_GATEWAY_MODE_ID: 0
};


const $de872e06841c454e$export$b27d988044282929 = {
    MEMBER_SINCE: "YYYY-MM-DD",
    PERMISSIONS: {
        SHOW_NUM_REVIEWS: false,
        SHOW_MEMBER_SINCE: false,
        SHOW_NUM_RECOMMENDS: false
    },
    NUM_BOOKINGS: 0,
    NUM_RECOMMENDATIONS: 0,
    NUM_REVIEWS: 0
};
const $de872e06841c454e$export$dc285ff9a92ba8b0 = {
    PROPERTY_IDS: [],
    MEMBER_SINCE: "YYYY-MM-DD"
};
const $de872e06841c454e$export$6c893ebd2bfba6be = {
    PERMISSIONS: [],
    PROPERTY_IDS: []
};
const $de872e06841c454e$export$a7ce0630542bae82 = {
    PERMISSIONS: [],
    PROPERTY_IDS: []
};
const $de872e06841c454e$export$ff09b90989b21a8 = {
    ID: 0,
    FIRST_NAME: "",
    LAST_NAME: "",
    IS_COMPANY: false,
    COMPANY_NAME: "",
    THUMBNAIL: "",
    PHONE: "",
    EMAIL: "",
    CREATED_DATE: "",
    DATE_LAST_LOGIN: "",
    DATE_UPDATED: "",
    ADDRESS: (0, $80436cd706766ba7$export$f7d3c097ceca6c15),
    IS_SMS_VERIFIED: false,
    IS_EMAIL_VERIFIED: false,
    DATE_EMAIL_VERIFIED: "",
    DATE_SMS_VERIFIED: "",
    DATE_OF_BIRTH: "",
    /** Django-compatibility fields */ IS_ACTIVE: false,
    IS_STAFF: false,
    IS_SUPERUSER: false,
    IS_DUE_DILIGENCE_REQUIRED: false
};
const $de872e06841c454e$export$145c04625c32c6f3 = {
    MESSAGE: "",
    SUBJECT: "",
    TO_EMAILS: "",
    DATE_SENT: "",
    FROM_EMAIL: "",
    RECIPIENT: "",
    THUMBNAIL: "",
    TIME_SENT: "",
    ID: 0,
    RECIPIENT_ID: 0,
    IS_READ: false,
    READ_DATE: "",
    READ_TIME: "",
    NUM_UNREAD: 0,
    ARRIVAL_DATE: "",
    DEPARTURE_DATE: "",
    CREATED_DATE: "",
    NUM_BEDS: 0,
    NUM_GUESTS: 0,
    IS_INQUIRY: false
};
const $de872e06841c454e$export$4d6cb86fc4b48362 = {
    ID: 0,
    ARRIVAL_DATE: "",
    DEPARTURE_DATE: "",
    CREATED_DATE: "",
    REFERENCE: ""
};
const $de872e06841c454e$export$3d9fef5d7039bac2 = {
    ID: 0,
    THUMBNAIL: "",
    NAME: "",
    SIZE_CATEGORY: ""
};
const $de872e06841c454e$export$5d5414ba339996bd = {
    ID: 0,
    THUMBNAIL: "",
    NAME: "",
    USER_TYPE_ID: 0,
    EMAIL: ""
};
const $de872e06841c454e$export$62d0a6d9a23c818 = {
    IS_AUTHENTICATED_GUEST: false,
    IS_AUTHENTICATED_OWNER: false,
    GUEST_ID: 0,
    OWNER_ID: 0,
    HAS_GUEST_AND_OWNER_ACCOUNTS: false,
    IS_PASSWORDS_SYNCED: false,
    OLD_PASSWORD_USER_ROLE_ID: 0
};
const $de872e06841c454e$export$901f69c43e4f0a63 = {
    USER_ROLE_ID: 0,
    JSESSIONID: "",
    ID: 0
};
const $de872e06841c454e$export$dfe369a01c7032f4 = {
    ID: 0,
    CONTACT: $de872e06841c454e$export$5d5414ba339996bd,
    BOOKING: $de872e06841c454e$export$4d6cb86fc4b48362,
    PROPERTY: $de872e06841c454e$export$3d9fef5d7039bac2,
    MESSAGE: $de872e06841c454e$export$145c04625c32c6f3
};
const $de872e06841c454e$export$6755bfb67f26df31 = {
    ID: 0,
    MESSAGE: {
        MESSAGE: "",
        SUBJECT: "",
        TO_EMAILS: "",
        DATE_SENT: "",
        FROM_EMAIL: "",
        RECIPIENT: "",
        THUMBNAIL: "",
        TIME_SENT: "",
        ID: 0,
        RECIPIENT_ID: 0,
        IS_READ: false,
        READ_DATE: "",
        READ_TIME: "",
        NUM_UNREAD: 0
    },
    PROPERTY: $de872e06841c454e$export$3d9fef5d7039bac2,
    CONTACT: {
        DETAILS: {
            NEXT_RESERVATION_DATE: "",
            MEMBER_SINCE: "",
            HAS_NEXT_RESERVATION: false,
            HAS_MEMBER_SINCE: false,
            DETAILS_NUMBER_OF_RESERVATIONS: 0,
            HAS_NUMBER_OF_RESERVATIONS: false,
            HAS_LAST_RESERVATION: false,
            LAST_RESERVATION_DATE: ""
        },
        ...$de872e06841c454e$export$5d5414ba339996bd
    }
};
const $de872e06841c454e$export$41a1bfdc55d0c02a = {
    MESSAGE: {
        MESSAGE: "",
        IS_READ: false,
        SUBJECT: "",
        TO_EMAILS: "",
        FROM_EMAIL: "",
        THUMBNAIL: "",
        SENT_DATE: "",
        SENT_TIME: "",
        BOOKING_ID: 0,
        ID: 0,
        READ_DATE: "",
        READ_TIME: "",
        INQUIRY_ID: 0,
        SENDER_USER_ID: 0,
        SENDER_USER_TYPE_ID: 0,
        RECEIVER_USER_ID: 0,
        RECEIVER_USER_TYPE_ID: 0,
        ARRIVAL_DATE: "",
        DEPARTURE_DATE: "",
        IS_INQUIRY: false,
        NUM_BEDS: 0,
        NUM_GUESTS: 0
    },
    PROPERTY: $de872e06841c454e$export$3d9fef5d7039bac2,
    BOOKING: $de872e06841c454e$export$4d6cb86fc4b48362
};
const $de872e06841c454e$export$78f74086b8e7868a = {
    USER_MESSAGE_COUNT: 0
};


let $af33674cdb61992e$export$37c8f1bc2ef2e9b9;
(function(UserRoleIDEnum1) {
    UserRoleIDEnum1[UserRoleIDEnum1["allura"] = 1] = "allura";
    UserRoleIDEnum1[UserRoleIDEnum1["owner"] = 2] = "owner";
    UserRoleIDEnum1[UserRoleIDEnum1["guest"] = 3] = "guest";
    UserRoleIDEnum1[UserRoleIDEnum1["propertyContact"] = 5] = "propertyContact";
})($af33674cdb61992e$export$37c8f1bc2ef2e9b9 || ($af33674cdb61992e$export$37c8f1bc2ef2e9b9 = {}));
let $af33674cdb61992e$export$e05722a566bbc7bd;
(function(UserTypeEnum1) {
    UserTypeEnum1["GUEST"] = "GUEST";
    UserTypeEnum1["OWNER"] = "OWNER";
    UserTypeEnum1["USER"] = "USER";
})($af33674cdb61992e$export$e05722a566bbc7bd || ($af33674cdb61992e$export$e05722a566bbc7bd = {}));
let $af33674cdb61992e$export$629a479ee61a4b1c;
(function(UserMessageType1) {
    UserMessageType1[UserMessageType1["generalInquiry"] = 1] = "generalInquiry";
    UserMessageType1[UserMessageType1["dateChange"] = 2] = "dateChange";
    UserMessageType1[UserMessageType1["cancellation"] = 3] = "cancellation";
    UserMessageType1[UserMessageType1["booking"] = 4] = "booking";
    UserMessageType1[UserMessageType1["property"] = 5] = "property";
    UserMessageType1[UserMessageType1["alluraInquiry"] = 6] = "alluraInquiry";
})($af33674cdb61992e$export$629a479ee61a4b1c || ($af33674cdb61992e$export$629a479ee61a4b1c = {}));


const $3657bbf543405025$export$dbe0a99d01c5bff0 = ({ guestId: guestId , propertyOwnerId: propertyOwnerId , message: message , booking_id: booking_id , start: start , end: end  })=>({
        id: guestId,
        user_type_id: (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).guest,
        receiver_user_id: propertyOwnerId,
        receiver_user_type_id: (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).owner,
        message: message,
        message_type_id: (0, $af33674cdb61992e$export$629a479ee61a4b1c).dateChange,
        booking_id: booking_id,
        start: start,
        end: end
    });
const $3657bbf543405025$export$b26d2362e032fab1 = ({ guestId: guestId , propertyOwnerId: propertyOwnerId , message: message , booking_id: booking_id  })=>({
        id: guestId,
        user_type_id: (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).guest,
        receiver_user_id: propertyOwnerId,
        receiver_user_type_id: (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).owner,
        message: message,
        message_type_id: (0, $af33674cdb61992e$export$629a479ee61a4b1c).cancellation,
        booking_id: booking_id
    });


var $1629d937777f52d0$exports = {};

$parcel$export($1629d937777f52d0$exports, "useUserCreateMessageMutation", () => $1629d937777f52d0$export$3d9d06124536f20);



const $1629d937777f52d0$export$3d9d06124536f20 = ()=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $3b54348c5bf92caa$export$2655fe4540b8b94e),
        method: (0, $d900f4229f04c942$export$ce2cf70c431e0802).POST
    });
};


var $f8c5cddd3f76ba08$exports = {};

$parcel$export($f8c5cddd3f76ba08$exports, "useUserMessageMarkAsReadMutation", () => $f8c5cddd3f76ba08$export$36482d2dcbe38d19);



const $f8c5cddd3f76ba08$export$36482d2dcbe38d19 = (args)=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $3b54348c5bf92caa$export$ca1429d0689bce78),
        method: (0, $d900f4229f04c942$export$ce2cf70c431e0802).PUT,
        ...args
    });
};


var $965e1643685356ab$exports = {};

$parcel$export($965e1643685356ab$exports, "useUserUploadProfilePhotoMutation", () => $965e1643685356ab$export$885f7157479ef947);



const $965e1643685356ab$export$885f7157479ef947 = (props)=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: (0, $d900f4229f04c942$export$ce2cf70c431e0802).POST,
        url: (0, $3b54348c5bf92caa$export$30289506872908c9),
        ...props
    });
};


var $5e8aa9a857d42b8f$exports = {};

$parcel$export($5e8aa9a857d42b8f$exports, "useUserLoginMutation", () => $5e8aa9a857d42b8f$export$513635a79aae0fb7);



const $5e8aa9a857d42b8f$export$513635a79aae0fb7 = (args = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: (0, $d900f4229f04c942$export$ce2cf70c431e0802).POST,
        url: (0, $3b54348c5bf92caa$export$99c2d64e1a90b7df),
        ...args
    });
};


var $6ae600d9fcc74b3e$exports = {};

$parcel$export($6ae600d9fcc74b3e$exports, "useUserLogoutLuceeMutation", () => $6ae600d9fcc74b3e$export$5eb61a3b8edb5a1a);


const $6ae600d9fcc74b3e$export$5eb61a3b8edb5a1a = (args = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $0c891e3f27143fe8$export$2a393b37f8b198ee),
        method: "POST",
        ...args
    });
};


var $b7fef110d856d6b3$exports = {};

$parcel$export($b7fef110d856d6b3$exports, "useUserCreateExpoToken", () => $b7fef110d856d6b3$export$73b670c952acc441);


const $b7fef110d856d6b3$export$73b670c952acc441 = (args = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: "POST",
        url: (0, $3b54348c5bf92caa$export$d69cdda500787bd6),
        ...args
    });
};


var $4056446910bacec4$exports = {};

$parcel$export($4056446910bacec4$exports, "useUserUpdateExpoToken", () => $4056446910bacec4$export$fe3878a75eeabbad);


const $4056446910bacec4$export$fe3878a75eeabbad = (args = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: "PUT",
        url: (0, $3b54348c5bf92caa$export$d69cdda500787bd6),
        ...args
    });
};


var $4e2a54ea9d0e29c4$exports = {};

$parcel$export($4e2a54ea9d0e29c4$exports, "useUserPutMutation", () => $4e2a54ea9d0e29c4$export$3976ce58344f1dfa);



var $bd3a5490fcd3ceba$exports = {};

$parcel$export($bd3a5490fcd3ceba$exports, "userQueryKey", () => $bd3a5490fcd3ceba$export$66d3ed5c3fac1540);
$parcel$export($bd3a5490fcd3ceba$exports, "useUserQuery", () => $bd3a5490fcd3ceba$export$68dae0b0cacaa18a);


const $bd3a5490fcd3ceba$export$66d3ed5c3fac1540 = "USER";
const $bd3a5490fcd3ceba$export$68dae0b0cacaa18a = ({ isReloadUser: isReloadUser = false , ...useQueryOptions } = {})=>{
    /** When using select, you need to pass in the Type of the select value.
   * Using the API response type will not work.
   *
   * The return value is actually a user object or an empty object. However it
   * appears that the return signature for useAppQuery is incorrect since we cannot override the
   * return type from the select function.
   *
   * The actual response is USER:User | {}  */ const endpoint = isReloadUser ? `${0, $3b54348c5bf92caa$export$7119b2a4f38d2087}?is_reload_user=${isReloadUser}` : (0, $3b54348c5bf92caa$export$7119b2a4f38d2087);
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        queryKey: $bd3a5490fcd3ceba$export$66d3ed5c3fac1540,
        // Typing is still wrong here, I need to be able to type the actual response from the server
        // and then manipulate it. I cannot use USER: User | {} without throwing a TS error.
        select: (data)=>{
            const isLoggedIn = Object.keys(data.DATA.USER).length > 0;
            return {
                ...data,
                DATA: {
                    USER: isLoggedIn ? data.DATA.USER : false
                }
            };
        },
        ...useQueryOptions
    });
};


const $4e2a54ea9d0e29c4$export$3976ce58344f1dfa = (args = {})=>{
    const queryClient = (0, $iPNDK$useQueryClient)();
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: "PUT",
        url: (0, $3b54348c5bf92caa$export$97e2f39d4877deae),
        ...args,
        onSuccess: ()=>{
            queryClient.invalidateQueries((0, $bd3a5490fcd3ceba$export$66d3ed5c3fac1540));
        }
    });
};


var $6e5878536e063d8a$exports = {};

$parcel$export($6e5878536e063d8a$exports, "useUserCredentialsPutMutation", () => $6e5878536e063d8a$export$575e4d5aa4fad33);


const $6e5878536e063d8a$export$575e4d5aa4fad33 = (args = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        method: "PUT",
        url: (0, $3b54348c5bf92caa$export$fb9bc9df7f34e09f),
        ...args
    });
};


var $af857901a110569f$exports = {};

$parcel$export($af857901a110569f$exports, "TwilioVerificationChannelEnum", () => $af857901a110569f$export$e1d3e038274f49cd);
let $af857901a110569f$export$e1d3e038274f49cd;
(function(TwilioVerificationChannelEnum1) {
    TwilioVerificationChannelEnum1["email"] = "email";
    TwilioVerificationChannelEnum1["sms"] = "sms";
    TwilioVerificationChannelEnum1["call"] = "call";
})($af857901a110569f$export$e1d3e038274f49cd || ($af857901a110569f$export$e1d3e038274f49cd = {}));


var $56754d72d2bf6761$exports = {};

$parcel$export($56754d72d2bf6761$exports, "useTwilioSendCodeMutation", () => $56754d72d2bf6761$export$6dc0e37052f4ea45);


const $56754d72d2bf6761$export$6dc0e37052f4ea45 = (args = {})=>(0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $3b54348c5bf92caa$export$a77d5295244c0a1c),
        method: "POST",
        ...args
    });


var $9586a10a8051110f$exports = {};

$parcel$export($9586a10a8051110f$exports, "useTwilioCheckCodeMutation", () => $9586a10a8051110f$export$795df53f186f50fd);


const $9586a10a8051110f$export$795df53f186f50fd = (args = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $3b54348c5bf92caa$export$27f9c16834747437),
        method: "POST",
        ...args
    });
};


var $5ed9a20c40ee3c8c$exports = {};

$parcel$export($5ed9a20c40ee3c8c$exports, "useUserPasswordResetMutation", () => $5ed9a20c40ee3c8c$export$8210442e82e33457);



const $5ed9a20c40ee3c8c$export$8210442e82e33457 = ()=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $3b54348c5bf92caa$export$877778df9bf039fc),
        method: (0, $d900f4229f04c942$export$ce2cf70c431e0802).POST
    });
};


var $3be0ab077497ea85$exports = {};

$parcel$export($3be0ab077497ea85$exports, "useUserCheckEmailExistsMutation", () => $3be0ab077497ea85$export$16505e160c92454d);


const $3be0ab077497ea85$export$16505e160c92454d = (props = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $3b54348c5bf92caa$export$e9ae87c929cf0520),
        method: "GET",
        ...props
    });
};


var $54158e5d8ac3a9aa$exports = {};

$parcel$export($54158e5d8ac3a9aa$exports, "useUserCheckEmailTakenMutation", () => $54158e5d8ac3a9aa$export$6141e3360eff91bb);


const $54158e5d8ac3a9aa$export$6141e3360eff91bb = (props = {})=>{
    return (0, $1980288893925d89$export$b3678598e95ca24f)({
        url: (0, $3b54348c5bf92caa$export$ebb0629ebb761139),
        method: "GET",
        ...props
    });
};


var $e81d666e9ab3330a$exports = {};

$parcel$export($e81d666e9ab3330a$exports, "useUnavailableDates", () => $e81d666e9ab3330a$export$b69a94c2c9e70ac6);


const $e81d666e9ab3330a$export$b69a94c2c9e70ac6 = ({ isOwnerRole: isOwnerRole , isGuestRole: isGuestRole , bookingId: bookingId = 0 , propertyId: propertyId = 0 , guestId: guestId = 0 , isEnabled: isEnabled = true , onSuccess: onSuccess = ()=>null  })=>{
    const ownerUnavailableDates = (0, $1402c0a484a6f252$export$fb94651c0721a416)({
        isEnabled: isOwnerRole && isEnabled,
        bookingId: bookingId,
        propertyId: propertyId,
        onSuccess: onSuccess
    });
    const guestUnavailableDates = (0, $2ad90413c6f0c2b1$export$412f8941319a94ae)({
        isEnabled: isGuestRole && isEnabled,
        bookingId: bookingId,
        guestId: guestId,
        onSuccess: onSuccess
    });
    return isOwnerRole ? ownerUnavailableDates : guestUnavailableDates;
};


var $9ba3881267ff62de$exports = {};

$parcel$export($9ba3881267ff62de$exports, "useUserMessageContactQuery", () => $9ba3881267ff62de$export$aad7a107d20654a8);


const $9ba3881267ff62de$export$aad7a107d20654a8 = ({ contactUserId: contactUserId , contactUserTypeId: contactUserTypeId , propertyId: propertyId , enabled: enabled = true , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $3b54348c5bf92caa$export$265b5cd3b0e616c2)({
            propertyId: propertyId,
            contactUserId: contactUserId,
            contactUserTypeId: contactUserTypeId
        }),
        enabled: enabled,
        ...rest
    });
};


var $5efb488ac8f43282$exports = {};

$parcel$export($5efb488ac8f43282$exports, "useUserMessageSubject", () => $5efb488ac8f43282$export$e4e15d044a2c569e);


const $5efb488ac8f43282$export$e4e15d044a2c569e = ({ userId: userId , userTypeId: userTypeId , bookingId: bookingId , messageId: messageId , enabled: enabled = true , onSuccess: onSuccess  })=>{
    const endpoint = (0, $3b54348c5bf92caa$export$18a10673c8c4007)({
        id: userId,
        userTypeId: userTypeId,
        bookingId: bookingId,
        messageId: messageId
    });
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: endpoint,
        enabled: enabled,
        onSuccess: onSuccess
    });
};


var $7ca7363463b01d4a$exports = {};

$parcel$export($7ca7363463b01d4a$exports, "useUserMessageUnreadQuery", () => $7ca7363463b01d4a$export$ee1c0bbe3aedd554);


const $7ca7363463b01d4a$export$ee1c0bbe3aedd554 = ({ id: id , userTypeId: userTypeId , enabled: enabled = true , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $3b54348c5bf92caa$export$e728a9a3f4a78bd6)(id, userTypeId),
        enabled: enabled,
        ...rest
    });
};



var $157b262af7a409fd$exports = {};

$parcel$export($157b262af7a409fd$exports, "useUserCheckEmailTaken", () => $157b262af7a409fd$export$64501d246f4befe7);


const $157b262af7a409fd$export$64501d246f4befe7 = ({ email: email , ...rest })=>{
    return (0, $db8cb6799be9e216$export$bbc6c3c0724463f0)({
        endpoint: (0, $3b54348c5bf92caa$export$ebb0629ebb761139)(email),
        ...rest
    });
};




var $09cc91e025cb54f0$exports = {};




var $30c1da10c566c284$exports = {};

$parcel$export($30c1da10c566c284$exports, "useAppQueries", () => $30c1da10c566c284$export$38db90c50e69cb38);


const $30c1da10c566c284$export$38db90c50e69cb38 = ({ queries: queries  })=>{
    const { isOffline: isOffline , onSuccessToast: onSuccessToast , onErrorToast: onErrorToast , queryFn: queryFn  } = (0, $581d20e8b41cc3bb$export$919315ccd62888e6)();
    const mappedQueries = queries.map((query)=>{
        return {
            ...query,
            queryFn: ()=>{
                return queryFn(query.endpoint, {
                    isOffline: isOffline
                });
            },
            onSuccess: (data)=>{
                query.onSuccess && query.onSuccess(data);
                if (query.hasToastsEnabled) onSuccessToast(data);
            },
            onError: (err)=>{
                query.onError && query.onError(err);
            },
            onSettled: (data, error)=>{
                query.onSettled && query.onSettled(data, error);
                if (query.hasToastsEnabled) onErrorToast(data);
            }
        };
    });
    return (0, $iPNDK$useQueries)(mappedQueries);
};



var $396bc124d7d12353$exports = {};

$parcel$export($396bc124d7d12353$exports, "contextFactory", () => $396bc124d7d12353$export$dad5d7c6ba8790d4);



function $396bc124d7d12353$export$dad5d7c6ba8790d4() {
    const Context = /*#__PURE__*/ (0, $iPNDK$createContext)(null);
    const useContext = ()=>{
        const ctx = (0, $iPNDK$react).useContext(Context);
        if (ctx === null) throw new Error("ctx must be used inside its related provider");
        return ctx;
    };
    const ContextProvider = ({ children: children , value: value  })=>{
        return /*#__PURE__*/ (0, $iPNDK$jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    return {
        Context: Context,
        useContext: useContext,
        ContextProvider: ContextProvider
    };
}



var $92a2c5a765476c50$exports = {};

$parcel$export($92a2c5a765476c50$exports, "useSelectedToggle", () => $92a2c5a765476c50$export$183e3865afd77c73);

var $6a87b8ff1330cbde$exports = {};

$parcel$export($6a87b8ff1330cbde$exports, "useToggle", () => $6a87b8ff1330cbde$export$cbe85ee05b554577);

const $6a87b8ff1330cbde$export$cbe85ee05b554577 = (defaultState = {
    isOpen: false
})=>{
    const [isOpen, setIsOpen] = (0, $iPNDK$useState)(defaultState.isOpen);
    const toggle = (0, $iPNDK$useCallback)(()=>setIsOpen(!isOpen), [
        isOpen
    ]);
    const close = (0, $iPNDK$useCallback)(()=>setIsOpen(false), []);
    const open = (0, $iPNDK$useCallback)(()=>setIsOpen(true), []);
    return {
        isOpen: isOpen,
        toggle: toggle,
        close: close,
        open: open
    };
};


function $92a2c5a765476c50$export$183e3865afd77c73(initialValue) {
    const [selectedValue, setSelectedValue] = (0, $iPNDK$react).useState(initialValue ?? null);
    const { open: toggleOpen , isOpen: isOpen , close: close  } = (0, $6a87b8ff1330cbde$export$cbe85ee05b554577)();
    const openWith = (val)=>{
        setSelectedValue(val);
    };
    const closeWith = ()=>{
        close();
        setSelectedValue(null);
    };
    (0, $iPNDK$react).useEffect(()=>{
        if (selectedValue !== null) toggleOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedValue
    ]);
    return {
        isOpen: isOpen,
        openWith: openWith,
        close: closeWith,
        selectedValue: selectedValue
    };
}



var $d5e96504640a735e$exports = {};

$parcel$export($d5e96504640a735e$exports, "useDateRangePicker", () => $d5e96504640a735e$export$12fd5f0e9f4bb192);



var $2c1ba4272f0dcaed$exports = {};

$parcel$export($2c1ba4272f0dcaed$exports, "calculateDisabledAfterDateSelectingEnd", () => $2c1ba4272f0dcaed$export$fc83baa36627246e);
$parcel$export($2c1ba4272f0dcaed$exports, "isUnbookableGapBetweenStartAndEnd", () => $2c1ba4272f0dcaed$export$441a38b3fd512aa5);
$parcel$export($2c1ba4272f0dcaed$exports, "handleDayClick", () => $2c1ba4272f0dcaed$export$68f2995330d10b72);
$parcel$export($2c1ba4272f0dcaed$exports, "calculateDisabledDates", () => $2c1ba4272f0dcaed$export$be33aa2c3017344e);
$parcel$export($2c1ba4272f0dcaed$exports, "calculateMinNightsDates", () => $2c1ba4272f0dcaed$export$9396e56d0eac0c1e);
$parcel$export($2c1ba4272f0dcaed$exports, "calculateModifiers", () => $2c1ba4272f0dcaed$export$d89b9b11c568aede);


const $2c1ba4272f0dcaed$export$fc83baa36627246e = (unavailabilityDepartureDates, selectedEndDate)=>{
    for (const unavailableDepartureDate of unavailabilityDepartureDates){
        if (unavailableDepartureDate.getTime() >= selectedEndDate.getTime()) return (0, $iPNDK$dayjs)(unavailableDepartureDate).subtract(1, "day").toDate();
    }
    return undefined;
};
const $2c1ba4272f0dcaed$export$441a38b3fd512aa5 = ({ arrival: arrival , departure: departure , unavailabilityDepartureDates: unavailabilityDepartureDates  })=>{
    for (const unavailableDepartureDate of unavailabilityDepartureDates){
        if (((0, $3a8449e3b3bae2ba$export$7ca0fdd3000f8fb4)({
            day: (0, $iPNDK$dayjs)(unavailableDepartureDate),
            start: (0, $iPNDK$dayjs)(arrival),
            end: (0, $iPNDK$dayjs)(departure)
        }) || (0, $3a8449e3b3bae2ba$export$7ca0fdd3000f8fb4)({
            day: (0, $iPNDK$dayjs)(unavailableDepartureDate),
            start: (0, $iPNDK$dayjs)(departure),
            end: (0, $iPNDK$dayjs)(arrival)
        })) && !(0, $iPNDK$dayjs)(unavailableDepartureDate).isSame((0, $iPNDK$dayjs)(arrival), "day")) return true;
    }
    return false;
};
const $2c1ba4272f0dcaed$export$68f2995330d10b72 = ({ day: day , currentlySelecting: currentlySelecting , setStartDate: setStartDate , endDate: endDate , setEndDate: setEndDate , callback: callback , setCurrentlySelecting: setCurrentlySelecting , unavailabilityDeparture: unavailabilityDeparture , onClickEnd: onClickEnd , onClickStart: onClickStart  })=>{
    if (currentlySelecting === "start") {
        setStartDate(day);
        let outerUnbookableGap = false;
        if (endDate) {
            const hasUnbookableGap = $2c1ba4272f0dcaed$export$441a38b3fd512aa5({
                arrival: (0, $3a8449e3b3bae2ba$export$64486ae5ea8a9faf)((0, $iPNDK$dayjs)(day)),
                departure: (0, $3a8449e3b3bae2ba$export$64486ae5ea8a9faf)((0, $iPNDK$dayjs)(endDate)),
                unavailabilityDepartureDates: unavailabilityDeparture
            });
            if (hasUnbookableGap) {
                outerUnbookableGap = true;
                setEndDate(day);
            }
        }
        setCurrentlySelecting("end");
        onClickStart && onClickStart(day, outerUnbookableGap);
        callback && callback("end", day);
    } else if (currentlySelecting === "end") {
        setEndDate(day);
        setCurrentlySelecting("start");
        onClickEnd && onClickEnd(day);
        callback && callback("start", day);
    }
};
const $2c1ba4272f0dcaed$export$be33aa2c3017344e = ({ currentlySelecting: currentlySelecting , unavailabilityArrival: unavailabilityArrival , unavailabilityDeparture: unavailabilityDeparture , canSelectPastDates: canSelectPastDates , endDate: endDate , startDate: startDate  })=>{
    if (currentlySelecting === "start") {
        if (canSelectPastDates) return {
            disabledDays: [
                ...unavailabilityArrival
            ]
        };
        else return {
            disabledDays: [
                ...unavailabilityArrival
            ],
            before: new Date()
        };
    } else if (currentlySelecting === "end") {
        const after = unavailabilityDeparture && startDate ? $2c1ba4272f0dcaed$export$fc83baa36627246e(unavailabilityDeparture, endDate ?? startDate) : undefined;
        return {
            disabledDays: startDate ? [
                ...unavailabilityDeparture,
                startDate
            ] : [
                ...unavailabilityDeparture
            ],
            before: startDate,
            after: after
        };
    }
    return {
        disabledDays: []
    };
};
const $2c1ba4272f0dcaed$export$9396e56d0eac0c1e = ({ startDate: startDate , minNightsDates: minNightsDates  })=>{
    const minNights = [];
    if (!startDate) return minNights;
    for(let i = 0; i < minNightsDates.length; i++){
        const currMinNightDate = minNightsDates[i];
        const date = Object.keys(currMinNightDate)[0];
        const days = Object.values(currMinNightDate)[0];
        if (date === (0, $3a8449e3b3bae2ba$export$160d2a3734a06909)(startDate)) for(let j = 1; j < days; j++){
            const disabledMinNightDate = (0, $iPNDK$dayjs)(startDate).add(j, "day").toDate();
            minNights.push((0, $iPNDK$dayjs)(disabledMinNightDate).toDate());
        }
    }
    return minNights;
};
const $2c1ba4272f0dcaed$export$d89b9b11c568aede = ({ startDate: startDate , minNightsDates: minNightsDates , endDate: endDate  })=>{
    // Min nights dates are not selectable but appear as a special form of date with modifier --minNight css class
    const minNightMods = $2c1ba4272f0dcaed$export$9396e56d0eac0c1e({
        minNightsDates: minNightsDates,
        startDate: startDate
    });
    const modifiers = {
        start: startDate,
        end: endDate,
        minNight: minNightMods
    };
    return modifiers;
};


const $d5e96504640a735e$export$12fd5f0e9f4bb192 = ({ initialStart: initialStart , initialEnd: initialEnd , initialMonth: initialMonth = new Date() , initialCurrentlySelecting: initialCurrentlySelecting = "start" , minNightsDates: minNightsDates = [] , unavailabilityDeparture: unavailabilityDeparture = [] , unavailabilityArrival: unavailabilityArrival = [] , canSelectPastDates: canSelectPastDates = false , onClickStart: onClickStart , onClickEnd: onClickEnd  })=>{
    const [startDate, setStartDate] = (0, $iPNDK$useState)(initialStart);
    const [endDate, setEndDate] = (0, $iPNDK$useState)(initialEnd);
    const nights = (0, $iPNDK$useMemo)(()=>{
        return (0, $3a8449e3b3bae2ba$export$24939cc9aa7cde05)({
            date1: startDate ?? (0, $iPNDK$dayjs)(),
            date2: endDate ?? (0, $iPNDK$dayjs)()
        });
    }, [
        endDate,
        startDate
    ]);
    const [currentlySelecting, setCurrentlySelecting] = (0, $iPNDK$useState)(initialCurrentlySelecting);
    const onDayClick = (0, $iPNDK$useCallback)((day, callback)=>{
        return (0, $2c1ba4272f0dcaed$export$68f2995330d10b72)({
            currentlySelecting: currentlySelecting,
            day: day,
            endDate: endDate,
            setStartDate: setStartDate,
            setEndDate: setEndDate,
            unavailabilityDeparture: unavailabilityDeparture,
            setCurrentlySelecting: setCurrentlySelecting,
            callback: callback,
            onClickEnd: onClickEnd,
            onClickStart: onClickStart
        });
    }, [
        currentlySelecting,
        endDate,
        onClickEnd,
        onClickStart,
        unavailabilityDeparture
    ]);
    const disabledDates = (0, $iPNDK$useMemo)(()=>{
        return (0, $2c1ba4272f0dcaed$export$be33aa2c3017344e)({
            canSelectPastDates: canSelectPastDates,
            currentlySelecting: currentlySelecting,
            endDate: endDate,
            startDate: startDate,
            unavailabilityArrival: unavailabilityArrival,
            unavailabilityDeparture: unavailabilityDeparture
        });
    }, [
        canSelectPastDates,
        currentlySelecting,
        endDate,
        startDate,
        unavailabilityArrival,
        unavailabilityDeparture
    ]);
    const modifiers = (0, $iPNDK$useMemo)(()=>{
        return (0, $2c1ba4272f0dcaed$export$d89b9b11c568aede)({
            minNightsDates: minNightsDates,
            endDate: endDate,
            startDate: startDate
        });
    }, [
        endDate,
        minNightsDates,
        startDate
    ]);
    return {
        startDate: startDate,
        setStartDate: setStartDate,
        endDate: endDate,
        setEndDate: setEndDate,
        currentlySelecting: currentlySelecting,
        setCurrentlySelecting: setCurrentlySelecting,
        onDayClick: onDayClick,
        disabledDates: disabledDates,
        modifiers: modifiers,
        initialMonth: initialMonth,
        nights: nights,
        unavailabilityArrival: /** Re-export so we can pass the return of this hook to the component */ unavailabilityArrival,
        unavailabilityDeparture: unavailabilityDeparture,
        canSelectPastDates: canSelectPastDates
    };
};



var $81cae684d7d7e63e$exports = {};

$parcel$export($81cae684d7d7e63e$exports, "AccessToUnitFormikForm", () => $81cae684d7d7e63e$export$e320e9d6fbe30e5a);



const $81cae684d7d7e63e$export$e320e9d6fbe30e5a = ({ children: children  })=>{
    const onSubmit = (values)=>{
        console.log(values);
        console.log("submitted form!");
    };
    return /*#__PURE__*/ (0, $iPNDK$jsx)((0, $iPNDK$Formik), {
        onSubmit: onSubmit,
        initialValues: {
            test: "hello world!"
        },
        children: children
    });
};


var $854fa44a86ca5c27$exports = {};

$parcel$export($854fa44a86ca5c27$exports, "accessToUnitFields", () => $854fa44a86ca5c27$export$d688d54275248905);
const $046001b603cb87a9$export$8b36a81183d879f4 = "Building Entry";
const $046001b603cb87a9$export$ca3f34c9b7b143e5 = "Garbage/Recycling";
const $046001b603cb87a9$export$e7419043208684dd = "Garage/Parking";
const $046001b603cb87a9$export$caac80c1ba1f3050 = "Wifi Name";
const $046001b603cb87a9$export$cba230409d40f85e = "Wifi Password";



const $854fa44a86ca5c27$var$subformName = (0, $9f770fb655db2e69$export$9dab6df2a66c141e).AccessToUnitForm;
const $854fa44a86ca5c27$var$subformPrefix = `${$854fa44a86ca5c27$var$subformName}.ACCESS_TO_UNIT`;
const $854fa44a86ca5c27$export$d688d54275248905 = {
    /** Main access to unit settings */ type: {
        label: "Property Access Type",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.TYPE.ID`
    },
    method: {
        label: "Access Delivery",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.METHOD.ID`
    },
    code: {
        label: "Access Code Type",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODE.ID`
    },
    standardCode: {
        label: "Standard Code",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.STANDARD_CODE`
    },
    /** Additional access codes */ bike: {
        label: "Bike Locker",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.BIKE_LOCKER_CODE`
    },
    /** building/development are used interchangeably here */ building: {
        label: (0, $046001b603cb87a9$export$8b36a81183d879f4),
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.DEVELOPMENT_DOOR_CODE`
    },
    gym: {
        label: "Gym Access",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.DEVELOPMENT_GYM_CODE`
    },
    hottub: {
        label: "Hot Tub Access",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.DEVELOPMENT_HOT_TUB_CODE`
    },
    pool: {
        label: "Pool",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.DEVELOPMENT_POOL_CODE`
    },
    sauna: {
        label: "Sauna Room",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.DEVELOPMENT_SAUNA_CODE`
    },
    steamroom: {
        label: "Steam Room",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.DEVELOPMENT_STEAM_ROOM_CODE`
    },
    recRoom: {
        label: "Games/Rec Room",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.GAMES_REC_ROOM_CODE`
    },
    garage: {
        label: (0, $046001b603cb87a9$export$e7419043208684dd),
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.GARAGE_DOOR_CODE`
    },
    garbage: {
        label: (0, $046001b603cb87a9$export$ca3f34c9b7b143e5),
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.GARBAGE_RECYCLING_CODE`
    },
    ski: {
        label: "Ski Locker",
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.SKI_LOCKER_CODE`
    },
    /** Internet codes */ internetName: {
        label: (0, $046001b603cb87a9$export$caac80c1ba1f3050),
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.INTERNET_NETWORK_NAME`
    },
    internetPassword: {
        label: (0, $046001b603cb87a9$export$cba230409d40f85e),
        field: `${$854fa44a86ca5c27$var$subformPrefix}.CODES.INTERNET_PASSWORD`
    }
};


var $d9623ccf96fc189a$exports = {};

$parcel$export($d9623ccf96fc189a$exports, "generateAccessToUnitValues", () => $d9623ccf96fc189a$export$f0a7afbc9486c67a);

const $d9623ccf96fc189a$export$f0a7afbc9486c67a = (property)=>({
        [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).AccessToUnitForm]: {
            ACCESS_TO_UNIT: {
                ...property.ACCESS_TO_UNIT,
                CODES: property.CODES,
                CHECK_IN_PROCEDURE: property.INSTRUCTIONS.CHECK_IN
            }
        }
    });


var $b8a85190e7afe5ad$exports = {};

$parcel$export($b8a85190e7afe5ad$exports, "amenityEditFields", () => $b8a85190e7afe5ad$export$a8ba56523d2ea31c);

const $b8a85190e7afe5ad$export$a8ba56523d2ea31c = {
    wifiName: {
        label: (0, $046001b603cb87a9$export$caac80c1ba1f3050),
        field: "INTERNET_NETWORK_NAME"
    },
    wifiPassword: {
        label: (0, $046001b603cb87a9$export$cba230409d40f85e),
        field: "INTERNET_PASSWORD"
    }
};


var $555db87d060751cc$exports = {};

$parcel$export($555db87d060751cc$exports, "generateCheckInOutFields", () => $555db87d060751cc$export$28cb29761c5547e7);

const $555db87d060751cc$export$28cb29761c5547e7 = (subformName)=>({
        buildingCode: {
            label: (0, $046001b603cb87a9$export$8b36a81183d879f4),
            field: `${subformName}.CODES.DEVELOPMENT_DOOR_CODE`
        },
        garbageCode: {
            label: (0, $046001b603cb87a9$export$ca3f34c9b7b143e5),
            field: `${subformName}.CODES.GARBAGE_RECYCLING_CODE`
        },
        checkIn: {
            label: "Check-In Time",
            field: `${subformName}.RULES.CHECK_IN`
        },
        checkOut: {
            label: "Check-Out Time",
            field: `${subformName}.RULES.CHECK_OUT`
        },
        /** RTE fields */ checkInProcedure: {
            label: "Check-In Procedure",
            field: `${subformName}.INSTRUCTIONS.CHECK_IN`
        },
        lateCheckInProcedure: {
            label: "Late / After Hours Arrival",
            field: `${subformName}.INSTRUCTIONS.LATE_CHECK_IN`
        },
        checkOutProcedure: {
            label: "Check-Out Procedure",
            field: `${subformName}.INSTRUCTIONS.CHECK_OUT`
        },
        garbageRecyclingInstructions: {
            label: "Garbage / Recycling Disposal Instructions",
            field: `${subformName}.INSTRUCTIONS.GARBAGE_RECYCLING`
        }
    });


var $083131879a09f840$exports = {};

$parcel$export($083131879a09f840$exports, "generateCheckInOutValues", () => $083131879a09f840$export$63f01bb595c680ca);
const $083131879a09f840$export$63f01bb595c680ca = (propertyObject, subformName)=>({
        [subformName]: {
            RULES: propertyObject.RULES,
            INSTRUCTIONS: {
                LATE_CHECK_IN: propertyObject.INSTRUCTIONS.LATE_CHECK_IN,
                CHECK_IN: propertyObject.INSTRUCTIONS.CHECK_IN,
                CHECK_OUT: propertyObject.INSTRUCTIONS.CHECK_OUT,
                GARBAGE_RECYCLING: propertyObject.INSTRUCTIONS.GARBAGE_RECYCLING
            },
            CODES: {
                DEVELOPMENT_DOOR_CODE: propertyObject.CODES.DEVELOPMENT_DOOR_CODE,
                GARBAGE_RECYCLING_CODE: propertyObject.CODES.GARBAGE_RECYCLING_CODE
            }
        }
    });


var $b23d16d7784d62b4$exports = {};

$parcel$export($b23d16d7784d62b4$exports, "CreateMessageForm", () => $b23d16d7784d62b4$export$cdb9dcad09c1a4fc);




var $525aff1e51b16df1$exports = {};

$parcel$export($525aff1e51b16df1$exports, "email", () => $525aff1e51b16df1$export$d290fa47940df19d);
$parcel$export($525aff1e51b16df1$exports, "boolean", () => $525aff1e51b16df1$export$4a21f16c33752377);
$parcel$export($525aff1e51b16df1$exports, "MAX_ACCESS_CODE_LENGTH", () => $525aff1e51b16df1$export$759bcd7d78580e80);
$parcel$export($525aff1e51b16df1$exports, "accessCode", () => $525aff1e51b16df1$export$d22eb2ddbe14c2fa);
$parcel$export($525aff1e51b16df1$exports, "streetName", () => $525aff1e51b16df1$export$6bd1d80ada69ee91);
$parcel$export($525aff1e51b16df1$exports, "streetNumber", () => $525aff1e51b16df1$export$23220bf251c847db);
$parcel$export($525aff1e51b16df1$exports, "city", () => $525aff1e51b16df1$export$733b5a3fd94b8a0d);
$parcel$export($525aff1e51b16df1$exports, "country", () => $525aff1e51b16df1$export$142596e469219c06);
$parcel$export($525aff1e51b16df1$exports, "unit", () => $525aff1e51b16df1$export$523c0b569236b342);
$parcel$export($525aff1e51b16df1$exports, "htmlNotRequired", () => $525aff1e51b16df1$export$403dd647bdfe7760);
$parcel$export($525aff1e51b16df1$exports, "htmlRequired", () => $525aff1e51b16df1$export$6dff77f5fae61e03);
$parcel$export($525aff1e51b16df1$exports, "name", () => $525aff1e51b16df1$export$a8ff84c12d48cfa6);
$parcel$export($525aff1e51b16df1$exports, "instruction", () => $525aff1e51b16df1$export$76e224aa2fb0aee8);
$parcel$export($525aff1e51b16df1$exports, "description", () => $525aff1e51b16df1$export$6d59db4903f20f7d);
$parcel$export($525aff1e51b16df1$exports, "phone", () => $525aff1e51b16df1$export$58ee0ea85d7a10b9);
$parcel$export($525aff1e51b16df1$exports, "messageSchema", () => $525aff1e51b16df1$export$7caa02bc8b4bb640);
$parcel$export($525aff1e51b16df1$exports, "currency", () => $525aff1e51b16df1$export$f4f21ed02b0ddb8f);
$parcel$export($525aff1e51b16df1$exports, "squareFeet", () => $525aff1e51b16df1$export$9d07b7162a2ef51b);
$parcel$export($525aff1e51b16df1$exports, "requiredString", () => $525aff1e51b16df1$export$8bc4fdb2734276ba);
$parcel$export($525aff1e51b16df1$exports, "id", () => $525aff1e51b16df1$export$d560c7e4a29451c2);
$parcel$export($525aff1e51b16df1$exports, "stringID", () => $525aff1e51b16df1$export$40d05a9f5a38ed35);
$parcel$export($525aff1e51b16df1$exports, "maxString2500", () => $525aff1e51b16df1$export$247f2e4dfb5a570d);
$parcel$export($525aff1e51b16df1$exports, "maxString5000", () => $525aff1e51b16df1$export$177edaa5df246fe1);
$parcel$export($525aff1e51b16df1$exports, "taxString", () => $525aff1e51b16df1$export$4ad30bab37356871);
$parcel$export($525aff1e51b16df1$exports, "time", () => $525aff1e51b16df1$export$2da9be4cfdb689b1);
$parcel$export($525aff1e51b16df1$exports, "twentyFourHourTime", () => $525aff1e51b16df1$export$c350aa5ff2b00d59);
$parcel$export($525aff1e51b16df1$exports, "positiveNumber", () => $525aff1e51b16df1$export$4ea4739d3fef092b);
$parcel$export($525aff1e51b16df1$exports, "number", () => $525aff1e51b16df1$export$98e628dec113755e);
$parcel$export($525aff1e51b16df1$exports, "minAge", () => $525aff1e51b16df1$export$337ff92ca6ee3450);
$parcel$export($525aff1e51b16df1$exports, "url", () => $525aff1e51b16df1$export$128fa18b7194ef);
$parcel$export($525aff1e51b16df1$exports, "addressValidation", () => $525aff1e51b16df1$export$5bc1108084315903);
$parcel$export($525aff1e51b16df1$exports, "buttonGroupValidation", () => $525aff1e51b16df1$export$845ceb08a7321dfe);
$parcel$export($525aff1e51b16df1$exports, "buttonGroupValidationNotRequired", () => $525aff1e51b16df1$export$4dafd644fdb75661);
$parcel$export($525aff1e51b16df1$exports, "idNameValidation", () => $525aff1e51b16df1$export$eb7087b8a7df6140);
$parcel$export($525aff1e51b16df1$exports, "numberRegExp", () => $525aff1e51b16df1$export$78791196678f97c0);
$parcel$export($525aff1e51b16df1$exports, "rateGroup", () => $525aff1e51b16df1$export$93f2e02fd5a45979);
$parcel$export($525aff1e51b16df1$exports, "suitability", () => $525aff1e51b16df1$export$3c580663c40cd0ee);
$parcel$export($525aff1e51b16df1$exports, "amenityDescription", () => $525aff1e51b16df1$export$78eb4be3c4d50156);
$parcel$export($525aff1e51b16df1$exports, "amenityInstructions", () => $525aff1e51b16df1$export$94d73d4ae52fda88);
$parcel$export($525aff1e51b16df1$exports, "amenitySchema", () => $525aff1e51b16df1$export$5a210025faae1144);
$parcel$export($525aff1e51b16df1$exports, "numericValidationRegex", () => $525aff1e51b16df1$export$47e3bb754674a243);


var $334c34aebb0650e5$exports = {};

$parcel$export($334c34aebb0650e5$exports, "messages", () => $334c34aebb0650e5$export$defe85febe8b728c);
const $334c34aebb0650e5$export$defe85febe8b728c = {
    requiredValue: "This field is required",
    requiredNumber: "You must provide a number",
    shortNumber: "The number you provided is too short",
    longNumber: "The number you provided is too long",
    longString: "The value you provided is too long",
    shortString: "The value you provided is too short",
    invalidTime: "You must provide a valid time format",
    invalidPhone: "You have provided an invalid phone number",
    invalidEmail: "You have provided an invalid email",
    unselectedOption: "You must select an option",
    maxString: "You must only provide 250 characters",
    /** You must only provide 500 characters */ maxStringDefined: (length)=>`You must only provide ${length} characters`,
    maxString2500: "You must only provide 2500 Characters",
    maxString5000: "You must only provide 5000 Characters",
    minNumber: "The number you provided is too small",
    maxNumber: "The number you provided is too large"
};


var $a8b1bbfd45d27b19$exports = {};

$parcel$export($a8b1bbfd45d27b19$exports, "stringNewlinesToBrTags", () => $a8b1bbfd45d27b19$export$4025311563f30ab2);
$parcel$export($a8b1bbfd45d27b19$exports, "toDecimal", () => $a8b1bbfd45d27b19$export$63ad841d70774900);
$parcel$export($a8b1bbfd45d27b19$exports, "hasContent", () => $a8b1bbfd45d27b19$export$7ad75c69830b76d7);
$parcel$export($a8b1bbfd45d27b19$exports, "truncate", () => $a8b1bbfd45d27b19$export$6a506b36fdea397d);
$parcel$export($a8b1bbfd45d27b19$exports, "handleStripHTML", () => $a8b1bbfd45d27b19$export$3ee3e334b3482a86);
$parcel$export($a8b1bbfd45d27b19$exports, "isStringHTMLString", () => $a8b1bbfd45d27b19$export$b5bc0899e47379a1);
$parcel$export($a8b1bbfd45d27b19$exports, "handleStripHTMLAndSpaces", () => $a8b1bbfd45d27b19$export$6abce5f3b246f7d4);
$parcel$export($a8b1bbfd45d27b19$exports, "capitalize", () => $a8b1bbfd45d27b19$export$9a00dee1beb8f576);
$parcel$export($a8b1bbfd45d27b19$exports, "snakeCaseToSpace", () => $a8b1bbfd45d27b19$export$fac90c2fb201ce9e);
$parcel$export($a8b1bbfd45d27b19$exports, "pluralize", () => $a8b1bbfd45d27b19$export$cefb40c9962541b5);
$parcel$export($a8b1bbfd45d27b19$exports, "generateCountString", () => $a8b1bbfd45d27b19$export$808d468a9674eb92);
const $a8b1bbfd45d27b19$export$4025311563f30ab2 = (text)=>{
    if (!text) return "";
    const newlineText = text.split("\n").map((textLine)=>textLine.length === 0 ? "<br/>" : textLine);
    return newlineText.join("<br/>");
};
function $a8b1bbfd45d27b19$export$63ad841d70774900(text, decimalPlaces = 2) {
    const floatValue = parseFloat(text);
    const isValid = !Number.isNaN(floatValue);
    return isValid ? floatValue.toFixed(decimalPlaces).toString() : "invalid value";
}
function $a8b1bbfd45d27b19$export$7ad75c69830b76d7(str) {
    if (!str) return false;
    return str.length !== 0;
}
const $a8b1bbfd45d27b19$export$6a506b36fdea397d = (text, length)=>{
    if (!text) return "";
    if (text.length > length) return `${text.substring(0, length)}...`;
    else return text;
};
const $a8b1bbfd45d27b19$export$3ee3e334b3482a86 = (str)=>{
    try {
        if (typeof str !== "string" || str?.length === 0) return "";
        else return str.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, "").replace(/&amp;/g, "&");
    } catch (e) {
        return "";
    }
};
const $a8b1bbfd45d27b19$export$b5bc0899e47379a1 = (str)=>{
    return /<[a-z/][\s\S]*>/i.test(str);
};
const $a8b1bbfd45d27b19$export$6abce5f3b246f7d4 = (string)=>{
    const stripHTML = $a8b1bbfd45d27b19$export$3ee3e334b3482a86(string) ?? "";
    return stripHTML.replace(/ /g, "");
};
function $a8b1bbfd45d27b19$export$9a00dee1beb8f576(str1) {
    if (!str1 || str1?.trim()?.length === 0) return "";
    const trimmedStr = str1.trim();
    const words = trimmedStr.split(" ");
    if (words.length > 1) return words.map((word)=>$a8b1bbfd45d27b19$export$9a00dee1beb8f576(word)).join(" ");
    const [first, ...rest] = trimmedStr;
    return first.toUpperCase() + rest.map((str)=>str.toLowerCase()).join("");
}
const $a8b1bbfd45d27b19$export$fac90c2fb201ce9e = (s)=>{
    return s.replace(/[_-]+/g, " ");
};
function $a8b1bbfd45d27b19$export$cefb40c9962541b5(count, text, pluralizationAffix = "s") {
    if (!text || text?.trim()?.length === 0) return "";
    const isPlural = count !== 1;
    const affix = isPlural ? pluralizationAffix : "";
    return `${text}${affix}`;
}
function $a8b1bbfd45d27b19$export$808d468a9674eb92(count, text, pluralizationAffix = "s") {
    if (!text || text?.trim()?.length === 0) return "";
    const pluralForm = $a8b1bbfd45d27b19$export$cefb40c9962541b5(count, text, pluralizationAffix);
    return `${count} ${pluralForm}`;
}


/** Re-usable validation schema pieces
 *  Ideally these should be tested thoroughly
 *  Used in multiple other validation schemas
 */ const { requiredValue: $525aff1e51b16df1$var$requiredValue , requiredNumber: $525aff1e51b16df1$var$requiredNumber , longString: $525aff1e51b16df1$var$longString , shortString: $525aff1e51b16df1$var$shortString , invalidTime: $525aff1e51b16df1$var$invalidTime , invalidPhone: $525aff1e51b16df1$var$invalidPhone , maxString: $525aff1e51b16df1$var$maxString , unselectedOption: $525aff1e51b16df1$var$unselectedOption , minNumber: $525aff1e51b16df1$var$minNumber ,  } = (0, $334c34aebb0650e5$export$defe85febe8b728c);
const $525aff1e51b16df1$export$d290fa47940df19d = $iPNDK$string().min(3, "email must be more than 3 characters").email("You must provide a valid email");
const $525aff1e51b16df1$export$4a21f16c33752377 = $iPNDK$boolean().required($525aff1e51b16df1$var$requiredValue).nullable();
const $525aff1e51b16df1$export$759bcd7d78580e80 = 50;
const $525aff1e51b16df1$export$d22eb2ddbe14c2fa = $iPNDK$string().max($525aff1e51b16df1$export$759bcd7d78580e80, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString);
const $525aff1e51b16df1$export$6bd1d80ada69ee91 = $iPNDK$string().min(1, $525aff1e51b16df1$var$shortString).max(50, $525aff1e51b16df1$var$longString).required($525aff1e51b16df1$var$requiredValue).typeError("You must provide a street name");
const $525aff1e51b16df1$export$23220bf251c847db = $iPNDK$string().min(1, $525aff1e51b16df1$var$shortString).max(50, $525aff1e51b16df1$var$longString).required($525aff1e51b16df1$var$requiredValue).typeError("You must provide a street number");
const $525aff1e51b16df1$export$733b5a3fd94b8a0d = $iPNDK$string().min(2, $525aff1e51b16df1$var$shortString).max(30, $525aff1e51b16df1$var$longString).required($525aff1e51b16df1$var$requiredValue);
const $525aff1e51b16df1$export$142596e469219c06 = $iPNDK$string().min(2, $525aff1e51b16df1$var$shortString).max(50, $525aff1e51b16df1$var$longString).required($525aff1e51b16df1$var$requiredValue);
const $525aff1e51b16df1$export$523c0b569236b342 = $iPNDK$string().max(20, $525aff1e51b16df1$var$longString);
const $525aff1e51b16df1$export$403dd647bdfe7760 = (maxLength = 5000)=>{
    return $iPNDK$string().test("max-length", (0, $334c34aebb0650e5$export$defe85febe8b728c).maxStringDefined(maxLength), // Subtract 20 to cover the face that there may be a difference between front end length and server length
    (val)=>(0, $a8b1bbfd45d27b19$export$6abce5f3b246f7d4)(val ?? "").length < maxLength - 20);
};
const $525aff1e51b16df1$export$6dff77f5fae61e03 = (maxLength = 5000)=>{
    return $525aff1e51b16df1$export$403dd647bdfe7760(maxLength).test("min-length", "Field Cannot be empty", (val)=>(0, $a8b1bbfd45d27b19$export$6abce5f3b246f7d4)(val ?? "").length > 0);
};
const $525aff1e51b16df1$export$a8ff84c12d48cfa6 = $iPNDK$string().max(100, $525aff1e51b16df1$var$longString);
const $525aff1e51b16df1$export$76e224aa2fb0aee8 = $iPNDK$string().max(5000, (0, $334c34aebb0650e5$export$defe85febe8b728c).maxString5000);
const $525aff1e51b16df1$export$6d59db4903f20f7d = $iPNDK$string().max(5000, $525aff1e51b16df1$var$maxString);
const $525aff1e51b16df1$export$58ee0ea85d7a10b9 = $iPNDK$string().test("is-jimmy", $525aff1e51b16df1$var$invalidPhone, (value)=>{
    return value ? (0, $iPNDK$isValidPhoneNumber)(value) : false;
});
const $525aff1e51b16df1$var$maxMessageLength = 8000;
const $525aff1e51b16df1$export$7caa02bc8b4bb640 = $iPNDK$string().min(1, (0, $334c34aebb0650e5$export$defe85febe8b728c).shortString).max($525aff1e51b16df1$var$maxMessageLength, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString).typeError($525aff1e51b16df1$var$requiredValue);
const $525aff1e51b16df1$export$f4f21ed02b0ddb8f = $iPNDK$number().typeError($525aff1e51b16df1$var$requiredNumber).required($525aff1e51b16df1$var$requiredNumber).test("is-decimal", "Only Include 2 Decimals", (value)=>{
    const strValue = !value ? "" : value.toString();
    const match = strValue?.match(/^[0-9]+(\.[0-9]{1,2})?$/);
    if (match) return match.length > 0;
    return true;
});
const $525aff1e51b16df1$export$9d07b7162a2ef51b = $iPNDK$number().typeError("You must specify a number").required($525aff1e51b16df1$var$requiredNumber).min(1, "Square Footage must be greater than 1").max(32765, "Square footage must be less than 32766");
const $525aff1e51b16df1$export$8bc4fdb2734276ba = $iPNDK$string().required($525aff1e51b16df1$var$requiredValue);
const $525aff1e51b16df1$export$d560c7e4a29451c2 = $iPNDK$number().min(0, "Error");
const $525aff1e51b16df1$export$40d05a9f5a38ed35 = $iPNDK$string();
const $525aff1e51b16df1$export$247f2e4dfb5a570d = $iPNDK$string().max(2500, $525aff1e51b16df1$var$maxString);
const $525aff1e51b16df1$export$177edaa5df246fe1 = $iPNDK$string().max(5000, $525aff1e51b16df1$var$maxString);
const $525aff1e51b16df1$export$4ad30bab37356871 = $iPNDK$string().max(100, $525aff1e51b16df1$var$longString).required($525aff1e51b16df1$var$requiredValue);
const $525aff1e51b16df1$export$2da9be4cfdb689b1 = $iPNDK$string().matches(/\b((1[0-2]|0?[1-9]):([0-5][0-9])([AaPp][Mm]))/, $525aff1e51b16df1$var$invalidTime).required($525aff1e51b16df1$var$requiredValue);
const $525aff1e51b16df1$export$c350aa5ff2b00d59 = $iPNDK$string().matches(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, "You must provide a valid time in the 24 Hour Format 00:00");
const $525aff1e51b16df1$export$4ea4739d3fef092b = $iPNDK$number().positive().integer("Only numbers are valid") // To do: This is not working correctly at the moment
.required($525aff1e51b16df1$var$requiredNumber);
const $525aff1e51b16df1$export$98e628dec113755e = $iPNDK$number().min(1, "Must be value greater than 0").integer("Only numbers are valid") // To do: This is not working correctly at the moment
.required($525aff1e51b16df1$var$requiredNumber);
const $525aff1e51b16df1$export$337ff92ca6ee3450 = $iPNDK$number().min(18, "Must be value greater than 18").integer("Only numbers are valid") // To do: This is not working correctly at the moment
.required($525aff1e51b16df1$var$requiredNumber);
const $525aff1e51b16df1$export$128fa18b7194ef = $iPNDK$string().matches(/https?:\/\/.+\..+/, "Link should start with http:// or https:// and have at least one character after");
const $525aff1e51b16df1$export$5bc1108084315903 = {
    STREET_NAME: $525aff1e51b16df1$export$6bd1d80ada69ee91,
    STREET_NUMBER: $525aff1e51b16df1$export$23220bf251c847db,
    UNIT: $525aff1e51b16df1$export$523c0b569236b342,
    CITY: $525aff1e51b16df1$export$733b5a3fd94b8a0d,
    POSTAL: $iPNDK$string().required($525aff1e51b16df1$var$requiredValue),
    REGION: $iPNDK$string().max(50, $525aff1e51b16df1$var$longString).required($525aff1e51b16df1$var$requiredValue),
    COUNTRY: $525aff1e51b16df1$export$142596e469219c06
};
const $525aff1e51b16df1$export$845ceb08a7321dfe = {
    ID: $iPNDK$number().positive($525aff1e51b16df1$var$unselectedOption),
    NAME: $iPNDK$string()
};
const $525aff1e51b16df1$export$4dafd644fdb75661 = {
    ID: $iPNDK$number(),
    NAME: $iPNDK$string()
};
const $525aff1e51b16df1$export$eb7087b8a7df6140 = {
    ID: $525aff1e51b16df1$export$8bc4fdb2734276ba,
    NAME: $525aff1e51b16df1$export$8bc4fdb2734276ba
};
const $525aff1e51b16df1$export$78791196678f97c0 = /^[0-9]*$/;
const $525aff1e51b16df1$export$93f2e02fd5a45979 = {
    BASE_RATE: $iPNDK$number().min(1, $525aff1e51b16df1$var$requiredValue).required($525aff1e51b16df1$var$requiredValue),
    MIN_NIGHTS: $iPNDK$number().min(1, $525aff1e51b16df1$var$requiredValue).required($525aff1e51b16df1$var$requiredValue)
};
const $525aff1e51b16df1$export$3c580663c40cd0ee = $iPNDK$object().shape({
    IS_SUITABLE: $iPNDK$boolean().required($525aff1e51b16df1$var$requiredValue),
    NAME: $iPNDK$string(),
    DESCRIPTION: $iPNDK$string().max(1000, $525aff1e51b16df1$var$longString),
    ID: $iPNDK$number().min(1, $525aff1e51b16df1$var$minNumber).required($525aff1e51b16df1$var$requiredValue)
});
const $525aff1e51b16df1$export$78eb4be3c4d50156 = $iPNDK$string().max(1000, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString);
const $525aff1e51b16df1$export$94d73d4ae52fda88 = $iPNDK$string().max(8000, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString);
const $525aff1e51b16df1$export$5a210025faae1144 = $iPNDK$object().shape({
    INSTRUCTIONS: $525aff1e51b16df1$export$94d73d4ae52fda88,
    DESCRIPTION: $525aff1e51b16df1$export$78eb4be3c4d50156,
    ACCESS_CODE: $525aff1e51b16df1$export$d22eb2ddbe14c2fa,
    INTERNET_NETWORK_NAME: $525aff1e51b16df1$export$d22eb2ddbe14c2fa,
    INTERNET_PASSWORD: $525aff1e51b16df1$export$d22eb2ddbe14c2fa
});
const $525aff1e51b16df1$export$47e3bb754674a243 = new RegExp(/^(\d+)?([.]?\d{1,2})?$/);


var $62a04ac1851f901e$exports = {};


var $85913e27ce62cabd$exports = {};

$parcel$export($85913e27ce62cabd$exports, "accountOwner", () => $85913e27ce62cabd$export$f4fee419a4a6cfef);
$parcel$export($85913e27ce62cabd$exports, "rentalManagerCoHost", () => $85913e27ce62cabd$export$d3e8ab45a4e662f7);
$parcel$export($85913e27ce62cabd$exports, "minPhotos", () => $85913e27ce62cabd$export$cbfa78e5d20f3083);
$parcel$export($85913e27ce62cabd$exports, "photos", () => $85913e27ce62cabd$export$3b2217e45a573556);
$parcel$export($85913e27ce62cabd$exports, "parkingFormSchema", () => $85913e27ce62cabd$export$a11e4d33e3a5bc12);
$parcel$export($85913e27ce62cabd$exports, "schema", () => $85913e27ce62cabd$export$4902baddc787debb);
$parcel$export($85913e27ce62cabd$exports, "generateSchema", () => $85913e27ce62cabd$export$4972db2450399ff);
$parcel$export($85913e27ce62cabd$exports, "formSchemas", () => $85913e27ce62cabd$export$eef420758b40d13d);



var $4c2910318d75849f$exports = {};

$parcel$export($4c2910318d75849f$exports, "ResortIdEnum", () => $4c2910318d75849f$export$7b9501c439aced6c);
$parcel$export($4c2910318d75849f$exports, "PartnerIdEnum", () => $4c2910318d75849f$export$e8f93f3aa2f4c8a4);
$parcel$export($4c2910318d75849f$exports, "CancellationPolicySpecicalCircumstanceIDEnum", () => $4c2910318d75849f$export$b3c0ba35fe2b3a94);
$parcel$export($4c2910318d75849f$exports, "SearchFilterSourceEnum", () => $4c2910318d75849f$export$2ecac916542a0065);
$parcel$export($4c2910318d75849f$exports, "SearchFiltersSortEnum", () => $4c2910318d75849f$export$a7e77b20da627286);
$parcel$export($4c2910318d75849f$exports, "SearchFiltersStatusEnum", () => $4c2910318d75849f$export$b257d594d204b130);
$parcel$export($4c2910318d75849f$exports, "AccessCodeTypeIDEnum", () => $4c2910318d75849f$export$c8de32477f2ff66f);
$parcel$export($4c2910318d75849f$exports, "AccessMethodIdEnum", () => $4c2910318d75849f$export$2d4a0ecba6f74b61);
$parcel$export($4c2910318d75849f$exports, "AccessCodeIdEnum", () => $4c2910318d75849f$export$a0dd5d6028487596);
let $4c2910318d75849f$export$7b9501c439aced6c;
(function(ResortIdEnum1) {
    ResortIdEnum1[ResortIdEnum1["Whistler"] = 1] = "Whistler";
    ResortIdEnum1[ResortIdEnum1["SunPeaks"] = 2] = "SunPeaks";
    ResortIdEnum1[ResortIdEnum1["BigWhite"] = 3] = "BigWhite";
})($4c2910318d75849f$export$7b9501c439aced6c || ($4c2910318d75849f$export$7b9501c439aced6c = {}));
let $4c2910318d75849f$export$e8f93f3aa2f4c8a4;
(function(PartnerIdEnum1) {
    PartnerIdEnum1[PartnerIdEnum1["Whistler"] = 4] = "Whistler";
    PartnerIdEnum1[PartnerIdEnum1["WhistlerBlackomb"] = 26] = "WhistlerBlackomb";
})($4c2910318d75849f$export$e8f93f3aa2f4c8a4 || ($4c2910318d75849f$export$e8f93f3aa2f4c8a4 = {}));
let $4c2910318d75849f$export$b3c0ba35fe2b3a94;
(function(CancellationPolicySpecicalCircumstanceIDEnum1) {
    CancellationPolicySpecicalCircumstanceIDEnum1[CancellationPolicySpecicalCircumstanceIDEnum1["OneHundredPercentRefund"] = 1] = "OneHundredPercentRefund";
    CancellationPolicySpecicalCircumstanceIDEnum1[CancellationPolicySpecicalCircumstanceIDEnum1["OneHundredPercentCredit"] = 2] = "OneHundredPercentCredit";
    CancellationPolicySpecicalCircumstanceIDEnum1[CancellationPolicySpecicalCircumstanceIDEnum1["Other"] = 3] = "Other";
})($4c2910318d75849f$export$b3c0ba35fe2b3a94 || ($4c2910318d75849f$export$b3c0ba35fe2b3a94 = {}));
let $4c2910318d75849f$export$2ecac916542a0065;
(function(SearchFilterSourceEnum1) {
    SearchFilterSourceEnum1["ALL"] = "all";
    SearchFilterSourceEnum1["AD"] = "ad";
    SearchFilterSourceEnum1["DV"] = "dv";
    SearchFilterSourceEnum1["WC"] = "wc";
    SearchFilterSourceEnum1["VAIL"] = "vail";
})($4c2910318d75849f$export$2ecac916542a0065 || ($4c2910318d75849f$export$2ecac916542a0065 = {}));
let $4c2910318d75849f$export$a7e77b20da627286;
(function(SearchFiltersSortEnum1) {
    SearchFiltersSortEnum1["ARRIVAL"] = "arrival";
    SearchFiltersSortEnum1["ARRIVAL_DATE"] = "arrival_date";
    SearchFiltersSortEnum1["BOOKING_DATE"] = "booking_date";
})($4c2910318d75849f$export$a7e77b20da627286 || ($4c2910318d75849f$export$a7e77b20da627286 = {}));
let $4c2910318d75849f$export$b257d594d204b130;
(function(SearchFiltersStatusEnum1) {
    SearchFiltersStatusEnum1["ALL"] = "all";
    SearchFiltersStatusEnum1["ACTIVE"] = "active";
    SearchFiltersStatusEnum1["CANCELLED"] = "cancelled";
})($4c2910318d75849f$export$b257d594d204b130 || ($4c2910318d75849f$export$b257d594d204b130 = {}));
let $4c2910318d75849f$export$c8de32477f2ff66f;
(function(AccessCodeTypeIDEnum1) {
    AccessCodeTypeIDEnum1[AccessCodeTypeIDEnum1["AccessCode"] = 1] = "AccessCode";
    AccessCodeTypeIDEnum1[AccessCodeTypeIDEnum1["PhysicalKeyCard"] = 2] = "PhysicalKeyCard";
})($4c2910318d75849f$export$c8de32477f2ff66f || ($4c2910318d75849f$export$c8de32477f2ff66f = {}));
let $4c2910318d75849f$export$2d4a0ecba6f74b61;
(function(AccessMethodIdEnum1) {
    AccessMethodIdEnum1[AccessMethodIdEnum1["FrontDesk"] = 1] = "FrontDesk";
    AccessMethodIdEnum1[AccessMethodIdEnum1["Email"] = 2] = "Email";
    AccessMethodIdEnum1[AccessMethodIdEnum1["LockBox"] = 3] = "LockBox";
    AccessMethodIdEnum1[AccessMethodIdEnum1["Other"] = 4] = "Other";
})($4c2910318d75849f$export$2d4a0ecba6f74b61 || ($4c2910318d75849f$export$2d4a0ecba6f74b61 = {}));
let $4c2910318d75849f$export$a0dd5d6028487596;
(function(AccessCodeIdEnum1) {
    AccessCodeIdEnum1[AccessCodeIdEnum1["NO_CODE"] = 0] = "NO_CODE";
    AccessCodeIdEnum1[AccessCodeIdEnum1["STANDARD_CODE"] = 1] = "STANDARD_CODE";
    AccessCodeIdEnum1[AccessCodeIdEnum1["UNIQUE_PER_GUEST"] = 2] = "UNIQUE_PER_GUEST";
})($4c2910318d75849f$export$a0dd5d6028487596 || ($4c2910318d75849f$export$a0dd5d6028487596 = {}));








/** Used for subform validation schemas only
 *  Subform schemas are 'currently' used in onboarding and dashboard
 */ const { requiredValue: $85913e27ce62cabd$var$requiredValue , longString: $85913e27ce62cabd$var$longString , requiredNumber: $85913e27ce62cabd$var$requiredNumber , minNumber: $85913e27ce62cabd$var$minNumber , unselectedOption: $85913e27ce62cabd$var$unselectedOption , maxString5000: $85913e27ce62cabd$var$maxString5000 , maxString2500: $85913e27ce62cabd$var$maxString2500  } = (0, $334c34aebb0650e5$export$defe85febe8b728c);
const $85913e27ce62cabd$var$styleSquareFootage = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).StyleSquareFootageForm]: $iPNDK$object().shape({
        SQUARE_FEET: (0, $525aff1e51b16df1$export$9d07b7162a2ef51b),
        STYLE: $iPNDK$object().shape((0, $525aff1e51b16df1$export$845ceb08a7321dfe)),
        SIZE_CATEGORY: $iPNDK$object().shape((0, $525aff1e51b16df1$export$845ceb08a7321dfe))
    })
};
const $85913e27ce62cabd$export$f4fee419a4a6cfef = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).AccountOwnerForm]: $iPNDK$object().shape({
        [(0, $af33674cdb61992e$export$e05722a566bbc7bd).USER]: $iPNDK$object().shape({
            IS_COMPANY: (0, $525aff1e51b16df1$export$4a21f16c33752377),
            COMPANY_NAME: $iPNDK$string().when("IS_COMPANY", {
                is: true,
                then: $iPNDK$string().max(75).required($85913e27ce62cabd$var$requiredValue)
            }),
            FIRST_NAME: $iPNDK$string().when("IS_COMPANY", {
                is: false,
                then: $iPNDK$string().max(50).required($85913e27ce62cabd$var$requiredValue)
            }),
            LAST_NAME: $iPNDK$string().when("IS_COMPANY", {
                is: false,
                then: $iPNDK$string().max(50, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue)
            }),
            EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d).required($85913e27ce62cabd$var$requiredValue),
            PHONE: (0, $525aff1e51b16df1$export$8bc4fdb2734276ba),
            IS_SMS_VERIFIED: $iPNDK$boolean().isTrue().required().label("SMS Verified"),
            IS_EMAIL_VERIFIED: $iPNDK$boolean().isTrue().required().label("Email Verified"),
            ADDRESS: $iPNDK$object().shape((0, $525aff1e51b16df1$export$5bc1108084315903))
        })
    })
};
const $85913e27ce62cabd$var$amenityArray = $iPNDK$array().of((0, $525aff1e51b16df1$export$5a210025faae1144));
// This form is only on Dashboard;
const $85913e27ce62cabd$var$allAmenitiesForm = {
    [(0, $9f770fb655db2e69$export$d78bec73c06e8a45).AllAmenitiesFormOptional]: $iPNDK$object().shape({
        BuildingAmenitiesForm: $iPNDK$object().shape({
            AMENITIES_BUILDING: $85913e27ce62cabd$var$amenityArray
        }),
        EssentialAmenitiesForm: $iPNDK$object().shape({
            AMENITIES_ESSENTIAL: $85913e27ce62cabd$var$amenityArray
        }),
        KitchenAmenitiesForm: $iPNDK$object().shape({
            AMENITIES_KITCHEN: $85913e27ce62cabd$var$amenityArray
        }),
        PrivateSafetyAmenitiesForm: $iPNDK$object().shape({
            AMENITIES_PRIVATE: $85913e27ce62cabd$var$amenityArray,
            AMENITIES_ESSENTIAL: $85913e27ce62cabd$var$amenityArray
        })
    })
};
const $85913e27ce62cabd$var$setUpQuestions = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).SetupQuestionsForm]: $iPNDK$object().shape({
        NUM_PROPERTIES: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).max(4, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue).nullable(),
        PLATFORMS_LISTED: $iPNDK$array().of($iPNDK$object().shape({
            ID: $iPNDK$number().required("Platform Id"),
            URL: $iPNDK$string().max(500)
        }))
    })
};
const $85913e27ce62cabd$var$essentialAmenities = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).EssentialAmenitiesForm]: $iPNDK$object().shape({
        AMENITIES_ESSENTIAL: $85913e27ce62cabd$var$amenityArray
    })
};
const $85913e27ce62cabd$var$essentialAmenitiesOptional = {
    [(0, $9f770fb655db2e69$export$d78bec73c06e8a45).EssentialAmenitiesFormOptional]: $iPNDK$object().shape({
        AMENITIES_ESSENTIAL: $85913e27ce62cabd$var$amenityArray
    })
};
const $85913e27ce62cabd$var$privateSafetyAmenities = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).PrivateSafetyAmenitiesForm]: $iPNDK$object().shape({
        AMENITIES_PRIVATE: $iPNDK$array().of($iPNDK$object().shape({
            ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$minNumber),
            DESCRIPTION: $iPNDK$string().max(1000, $85913e27ce62cabd$var$longString),
            INSTRUCTIONS: $iPNDK$string().max(5000, $85913e27ce62cabd$var$maxString5000)
        })),
        AMENITIES_SAFETY: $iPNDK$array().of($iPNDK$object().shape({
            ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$minNumber),
            DESCRIPTION: $iPNDK$string().max(1000, $85913e27ce62cabd$var$longString),
            INSTRUCTIONS: $iPNDK$string().max(5000, $85913e27ce62cabd$var$maxString5000)
        }))
    })
};
const $85913e27ce62cabd$var$generateBedrooms = (subformName)=>({
        [subformName]: $iPNDK$object().shape({
            BEDROOMS: $iPNDK$array().required($85913e27ce62cabd$var$requiredValue).of($iPNDK$object().shape({
                BEDS: $iPNDK$array().of($iPNDK$object().shape({
                    ID: $iPNDK$number().positive($85913e27ce62cabd$var$unselectedOption).required($85913e27ce62cabd$var$requiredValue),
                    NAME: $iPNDK$string()
                })).min(1, "You must add at least one bed"),
                HAS_ENSUITE: (0, $525aff1e51b16df1$export$4a21f16c33752377),
                HAS_STAIRS: (0, $525aff1e51b16df1$export$4a21f16c33752377),
                ID: (0, $525aff1e51b16df1$export$d560c7e4a29451c2),
                SLEEPS: (0, $525aff1e51b16df1$export$98e628dec113755e),
                TYPE: $iPNDK$object().shape({
                    ID: $iPNDK$number().positive($85913e27ce62cabd$var$unselectedOption),
                    NAME: $iPNDK$string()
                }),
                NAME: (0, $525aff1e51b16df1$export$a8ff84c12d48cfa6).required($85913e27ce62cabd$var$requiredValue),
                DESCRIPTION: $iPNDK$string().max(2500, $85913e27ce62cabd$var$longString)
            })).min(1),
            RULES: $iPNDK$object().shape({
                MAX_GUESTS: (0, $525aff1e51b16df1$export$98e628dec113755e)
            })
        })
    });
const $85913e27ce62cabd$var$bedroomsRequired = {
    ...$85913e27ce62cabd$var$generateBedrooms((0, $9f770fb655db2e69$export$9dab6df2a66c141e).BedroomsForm)
};
const $85913e27ce62cabd$var$bedroomsOptional = {
    ...$85913e27ce62cabd$var$generateBedrooms((0, $9f770fb655db2e69$export$d78bec73c06e8a45).BedroomsFormOptional)
};
const $85913e27ce62cabd$var$propertyAddress = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).PropertyAddressForm]: $iPNDK$object().shape({
        ADDRESS: $iPNDK$object().shape({
            ...(0, $525aff1e51b16df1$export$5bc1108084315903),
            DEVELOPMENT_ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue),
            RESORT_ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue),
            // TODO: min should be set to 1 when we actually implement AREA_ID
            // Area and Area Id are not used in the frontend
            AREA_ID: $iPNDK$number().min(0, $85913e27ce62cabd$var$minNumber),
            COUNTRY_ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$minNumber),
            REGION_ID: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue),
            UNIT: (0, $525aff1e51b16df1$export$523c0b569236b342),
            CITY: (0, $525aff1e51b16df1$export$733b5a3fd94b8a0d),
            STREET_NAME: (0, $525aff1e51b16df1$export$6bd1d80ada69ee91),
            STREET_NUMBER: (0, $525aff1e51b16df1$export$23220bf251c847db),
            ID: $iPNDK$number(),
            LATITUDE: $iPNDK$number(),
            LONGITUDE: $iPNDK$number()
        })
    })
};
const $85913e27ce62cabd$var$generateBathrooms = (subformName)=>({
        [subformName]: $iPNDK$object().shape({
            BATHROOMS: $iPNDK$array().of($iPNDK$object().shape({
                HAS_BATH: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue).nullable(),
                HAS_SHOWER: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue).nullable(),
                IS_ENSUITE: (0, $525aff1e51b16df1$export$4a21f16c33752377),
                NAME: (0, $525aff1e51b16df1$export$a8ff84c12d48cfa6).required($85913e27ce62cabd$var$requiredValue),
                DESCRIPTION: $iPNDK$string().max(2500, $85913e27ce62cabd$var$maxString2500),
                ID: (0, $525aff1e51b16df1$export$d560c7e4a29451c2).required($85913e27ce62cabd$var$requiredValue)
            }))
        })
    });
const $85913e27ce62cabd$var$bathroomsRequired = {
    ...$85913e27ce62cabd$var$generateBathrooms((0, $9f770fb655db2e69$export$9dab6df2a66c141e).BathroomsForm)
};
const $85913e27ce62cabd$var$bathroomsOptional = {
    ...$85913e27ce62cabd$var$generateBathrooms((0, $9f770fb655db2e69$export$d78bec73c06e8a45).BathroomsFormOptional)
};
const $85913e27ce62cabd$var$rateSettings = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).RateSettingsForm]: $iPNDK$object().shape({
        IS_AVAILABILITY_AUTOMATION_ENABLED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
        IS_OPTIMIZED_PRICING_ENABLED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
        PRICING_STRATEGY: $iPNDK$object().shape({
            ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue),
            RATE_INSIGHTS_LEVEL_ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue)
        }),
        NO_RATES_DATES: $iPNDK$array().required($85913e27ce62cabd$var$requiredValue),
        RATE_GROUPS: $iPNDK$object().when("PRICING_STRATEGY.ID", {
            is: (0, $f58c18151396e867$export$eff54ef88b94774d).rateGroup,
            then: $iPNDK$object().shape({
                HIGH: $iPNDK$object().shape((0, $525aff1e51b16df1$export$93f2e02fd5a45979)),
                LOW: $iPNDK$object().shape((0, $525aff1e51b16df1$export$93f2e02fd5a45979)),
                MID: $iPNDK$object().shape((0, $525aff1e51b16df1$export$93f2e02fd5a45979)),
                PRIME: $iPNDK$object().shape((0, $525aff1e51b16df1$export$93f2e02fd5a45979))
            })
        }).when("PRICING_STRATEGY.ID", {
            is: (0, $f58c18151396e867$export$eff54ef88b94774d).smartPricing,
            then: $iPNDK$object().shape({
                HIGH: $iPNDK$object().shape({
                    MIN_NIGHTS: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue)
                }),
                LOW: $iPNDK$object().shape({
                    MIN_NIGHTS: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue)
                }),
                MID: $iPNDK$object().shape({
                    MIN_NIGHTS: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue)
                }),
                PRIME: $iPNDK$object().shape({
                    MIN_NIGHTS: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue)
                })
            })
        }),
        WEEKEND_PREMIUM: $iPNDK$object().shape({
            ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue),
            DOLLAR_AMOUNT: $iPNDK$number().when("ID", {
                is: (0, $f58c18151396e867$export$4fd94061e730ad38).DOLLAR,
                then: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredNumber).required($85913e27ce62cabd$var$requiredValue)
            }),
            PERCENTAGE_AMOUNT: $iPNDK$number().when("ID", {
                is: (0, $f58c18151396e867$export$4fd94061e730ad38).PERCENTAGE,
                then: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredNumber).required($85913e27ce62cabd$var$requiredValue)
            })
        }),
        DISCOUNT_GROUP: $iPNDK$object().shape({
            FIVE_DAY: $iPNDK$number().required($85913e27ce62cabd$var$requiredValue),
            SEVEN_DAY: $iPNDK$number().required($85913e27ce62cabd$var$requiredValue),
            TEN_DAY: $iPNDK$number().required($85913e27ce62cabd$var$requiredValue)
        }),
        AVAILABILITY_WINDOW: $iPNDK$object().shape({
            ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue)
        })
    })
};
const $85913e27ce62cabd$var$ratesSchedule = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).RatesScheduleForm]: $iPNDK$object().shape({
        RATES_SCHEDULE: $iPNDK$array().min(1, "You must create at least one Rate Schedule").required("You must create at least one Rate Schedule")
    })
};
const $85913e27ce62cabd$export$d3e8ab45a4e662f7 = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).PropertyContactForm]: $iPNDK$object().shape({
        IS_CUSTOM_PROPERTY_CONTACT: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
        PROPERTY_CONTACT: $iPNDK$object().when("IS_CUSTOM_PROPERTY_CONTACT", {
            is: true,
            then: $iPNDK$object().shape({
                EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d).required($85913e27ce62cabd$var$requiredValue),
                PHONE: (0, $525aff1e51b16df1$export$58ee0ea85d7a10b9).required().label("Phone Number"),
                /**  0 when new property contact, <ID> when existing contact */ ID: $iPNDK$number().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_CHECKIN_REMINDER: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                IS_COMPANY: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                COMPANY_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: true,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                FIRST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                LAST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                })
            })
        }),
        IS_CO_HOST_MANAGER_ENABLED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
        CO_HOST: $iPNDK$object().when("IS_CO_HOST_MANAGER_ENABLED", {
            is: true,
            then: $iPNDK$object().shape({
                EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d).required($85913e27ce62cabd$var$requiredValue),
                IS_COMPANY: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                COMPANY_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: true,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                FIRST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                LAST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                /**  0 when new co-host, <ID> when existing co-host */ ID: $iPNDK$number().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_RESORT_SPECIFIC: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_GENERAL_INQUIRIES: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_ALL_OWNERS: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_RESERVATION_REQUESTS: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_RENEWALS: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_RESERVATIONS_CANCELLED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                NOTIFY_RESERVATIONS_ADDED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue)
            })
        })
    })
};
const $85913e27ce62cabd$var$calendarBlockoffs = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).CalendarBlockOffsForm]: $iPNDK$object().shape({
        CALENDAR_SYNC_CONFIRMED: $iPNDK$boolean().required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue).isTrue("You must agree to the terms"),
        BLOCKOFFS: $iPNDK$array().of($iPNDK$object().shape({
            START: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue),
            END: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue).when("START", (START, schema1)=>{
                return schema1.test({
                    test: (END)=>{
                        const start = (0, $iPNDK$dayjs)(START);
                        const end = (0, $iPNDK$dayjs)(END);
                        return end.isAfter(start, "day") || end.isSame(start, "day");
                    },
                    message: "Invalid start and end dates entered"
                });
            })
        })),
        ICALS: $iPNDK$object().shape({
            HAS_ICALS: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
            EXTERNAL: $iPNDK$array().when("HAS_ICALS", {
                is: true,
                then: $iPNDK$array().min(1, "You must add at least one external calender when this option is selected").of($iPNDK$object().shape({
                    ID: $iPNDK$number().required($85913e27ce62cabd$var$requiredValue),
                    LISTING_URL: (0, $525aff1e51b16df1$export$128fa18b7194ef),
                    NAME: $iPNDK$string().max(200, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue),
                    URL: (0, $525aff1e51b16df1$export$128fa18b7194ef).required($85913e27ce62cabd$var$requiredValue)
                }))
            })
        })
    })
};
const $85913e27ce62cabd$var$commonBuildingSchema = $iPNDK$object().shape({
    CONTENT: $iPNDK$object().shape({
        ABOUT_THE_BUILDING: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8)
    }),
    AMENITIES_BUILDING: $iPNDK$array().of((0, $525aff1e51b16df1$export$5a210025faae1144))
});
const $85913e27ce62cabd$var$buildingAmenities = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).BuildingAmenitiesForm]: $85913e27ce62cabd$var$commonBuildingSchema
};
const $85913e27ce62cabd$var$buildingAmenitiesOptional = {
    [(0, $9f770fb655db2e69$export$d78bec73c06e8a45).BuildingAmenitiesFormOptional]: $85913e27ce62cabd$var$commonBuildingSchema
};
const $85913e27ce62cabd$var$locationRequired = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).LocationForm]: $iPNDK$object().shape({
        CONTENT: $iPNDK$object().shape({
            LOCATION: (0, $525aff1e51b16df1$export$6d59db4903f20f7d)
        }),
        IS_SKI_IN_SKI_OUT: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue)
    })
};
const $85913e27ce62cabd$var$locationOptional = {
    [(0, $9f770fb655db2e69$export$d78bec73c06e8a45).LocationFormOptional]: $iPNDK$object().shape({
        IS_SKI_IN_SKI_OUT: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
        CONTENT: $iPNDK$object().shape({
            LOCATION: (0, $525aff1e51b16df1$export$6d59db4903f20f7d)
        }),
        INSTRUCTIONS: $iPNDK$object().shape({
            SKI_IN_SKI_OUT: (0, $525aff1e51b16df1$export$6d59db4903f20f7d),
            TO_FROM_LIFTS: (0, $525aff1e51b16df1$export$6d59db4903f20f7d),
            GETTING_AROUND: (0, $525aff1e51b16df1$export$6d59db4903f20f7d),
            GETTING_TO_UNIT: (0, $525aff1e51b16df1$export$6d59db4903f20f7d)
        })
    })
};
const $85913e27ce62cabd$var$accessToUnit = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).AccessToUnitForm]: $iPNDK$object().shape({
        ACCESS_TO_UNIT: $iPNDK$object().shape({
            TYPE: $iPNDK$object().shape((0, $525aff1e51b16df1$export$845ceb08a7321dfe)),
            METHOD: $iPNDK$object().when("TYPE", {
                is: (val)=>{
                    return val.ID === 0;
                },
                then: $iPNDK$object().shape((0, $525aff1e51b16df1$export$4dafd644fdb75661)),
                otherwise: $iPNDK$object().shape((0, $525aff1e51b16df1$export$845ceb08a7321dfe))
            }),
            CODE: $iPNDK$object().when("METHOD", {
                is: (val)=>{
                    return val.ID === 2 || val.ID === 3;
                },
                then: $iPNDK$object().shape((0, $525aff1e51b16df1$export$845ceb08a7321dfe)),
                otherwise: $iPNDK$object().shape((0, $525aff1e51b16df1$export$4dafd644fdb75661))
            }),
            STANDARD_CODE: $iPNDK$string().when("CODE", {
                is: (val)=>{
                    return val.ID === 1;
                },
                then: (0, $525aff1e51b16df1$export$8bc4fdb2734276ba),
                otherwise: $iPNDK$string()
            }),
            CHECK_IN_PROCEDURE: $iPNDK$string().min(1).required().label("Check In Procedure"),
            CODES: $iPNDK$object().shape({
                INTERNET_NETWORK_NAME: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                INTERNET_PASSWORD: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                GARAGE_DOOR_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                DEVELOPMENT_DOOR_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                DEVELOPMENT_GYM_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                DEVELOPMENT_HOT_TUB_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                DEVELOPMENT_POOL_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                DEVELOPMENT_SAUNA_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                DEVELOPMENT_STEAM_ROOM_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                SKI_LOCKER_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                BIKE_LOCKER_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                GARBAGE_RECYCLING_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
                GAMES_REC_ROOM_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa)
            })
        })
    })
};
const $85913e27ce62cabd$var$propertyTitle = {
    [(0, $9f770fb655db2e69$export$d78bec73c06e8a45).PropertyTitleSummaryFormOptional]: $iPNDK$object().shape({
        CONTENT: $iPNDK$object().shape({
            SUMMARY: $iPNDK$string().max(500, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue),
            TITLE: $iPNDK$string().max(75, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue),
            DESCRIPTION: $iPNDK$string().max(25000, "Maximum 25000 characters allowed").required($85913e27ce62cabd$var$requiredValue)
        })
    })
};
const $85913e27ce62cabd$var$instructions = {
    [(0, $9f770fb655db2e69$export$d78bec73c06e8a45).CheckInEmailFormOptional]: $iPNDK$object().shape({
        INSTRUCTIONS: $iPNDK$object().shape({
            WELCOME: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            HOUSEKEEPING: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            LINENS_AND_TOWELS: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            GARBAGE_RECYCLING: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            FRONT_DESK: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            TO_FROM_LIFTS: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            SKI_IN_SKI_OUT: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            GETTING_AROUND: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            WHAT_TO_BRING: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            RESTAURANTS: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            SERVICES: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8),
            OTHER: (0, $525aff1e51b16df1$export$76e224aa2fb0aee8)
        })
    })
};
const $85913e27ce62cabd$export$cbfa78e5d20f3083 = 5;
const $85913e27ce62cabd$export$3b2217e45a573556 = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).PhotosForm]: $iPNDK$object().shape({
        EXTERNAL_URLS: $iPNDK$object().shape({
            URL_AIRBNB: $iPNDK$string().trim().url("Field must be a valid url"),
            URL_VRBO: $iPNDK$string().trim().url("Field must be a valid url"),
            URL_OTHER: $iPNDK$string().trim().url("Field must be a valid url")
        }),
        NUM_PHOTOS: $iPNDK$number().when("EXTERNAL_URLS", (externalUrls)=>{
            const hasExternalUrl = Object.keys(externalUrls).some((key)=>{
                if (!externalUrls[key]) return false;
                return externalUrls[key].length !== 0;
            });
            if (hasExternalUrl) return $iPNDK$number().min(0, "No photos are required");
            else return $iPNDK$number().min($85913e27ce62cabd$export$cbfa78e5d20f3083, "Please enter at least 5 photos").required($85913e27ce62cabd$var$requiredValue);
        })
    })
};
const $85913e27ce62cabd$var$cancellationPolicy = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).CancellationPoliciesForm]: $iPNDK$object().shape({
        CANCELLATION_POLICY: $iPNDK$object().shape({
            IS_CREDIT_ONLY_REFUND: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue),
            IS_REFUND_REBOOKED_DATES: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue),
            IS_SPECIAL_CIRCUMSTANCE: $iPNDK$boolean().required($85913e27ce62cabd$var$unselectedOption),
            SPECIAL_CIRCUMSTANCE_ID: $iPNDK$number().when("IS_SPECIAL_CIRCUMSTANCE", {
                is: true,
                then: $iPNDK$number().min(1, $85913e27ce62cabd$var$unselectedOption).max(6, $85913e27ce62cabd$var$unselectedOption).required($85913e27ce62cabd$var$requiredValue)
            }),
            // @ts-ignore
            SPECIAL_CIRCUMSTANCE_DESCRIPTION: $iPNDK$string().test({
                message: $85913e27ce62cabd$var$requiredValue,
                test: function(value) {
                    const isCustomSelected = Number(this.parent.SPECIAL_CIRCUMSTANCE_ID) === (0, $4c2910318d75849f$export$b3c0ba35fe2b3a94).Other;
                    const isValid = value && value.length > 0;
                    return isCustomSelected ? isValid : true;
                }
            }),
            ADMIN_PENALTY_UNIT: $iPNDK$string().matches(/^$|\$|%/, "Must enter percentage or dollar amount"),
            ADMIN_PENALTY: $iPNDK$number().test({
                message: "Must Be Greater Than Zero",
                test: function(value) {
                    const hasSelectedAdminPenalty = this.parent.ADMIN_PENALTY_UNIT;
                    const isGreaterThanZero = value !== undefined && value > 0;
                    return hasSelectedAdminPenalty ? isGreaterThanZero : true;
                }
            }).test({
                message: "Cannot exceed 100%",
                test: function(value) {
                    const hasSelectedPercentage = this.parent.ADMIN_PENALTY_UNIT === "%";
                    const isValid = value !== undefined && value <= 100;
                    return hasSelectedPercentage ? isValid : true;
                }
            }),
            POLICY_ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$unselectedOption).max(4, $85913e27ce62cabd$var$unselectedOption).required($85913e27ce62cabd$var$requiredValue)
        })
    })
};
const $85913e27ce62cabd$var$suitabilities = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).SuitabilitiesForm]: $iPNDK$object().shape({
        RULES: $iPNDK$object().shape({
            MIN_AGE_TO_BOOK: (0, $525aff1e51b16df1$export$337ff92ca6ee3450),
            QUIET_TIME: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
        }),
        SUBMIT_OK: $iPNDK$bool().oneOf([
            true
        ], "All fields must be selected"),
        SUITABILITIES: $iPNDK$object().shape({
            LONG_TERM_RENTALS: (0, $525aff1e51b16df1$export$3c580663c40cd0ee),
            PARTIES_EVENTS: (0, $525aff1e51b16df1$export$3c580663c40cd0ee),
            PETS: (0, $525aff1e51b16df1$export$3c580663c40cd0ee),
            SMOKING: (0, $525aff1e51b16df1$export$3c580663c40cd0ee),
            TRAVEL_RESELLERS: (0, $525aff1e51b16df1$export$3c580663c40cd0ee),
            WHEELCHAIR_ACCESSIBLE: (0, $525aff1e51b16df1$export$3c580663c40cd0ee)
        })
    })
};
const $85913e27ce62cabd$var$checkInOut = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).CheckInOutForm]: $iPNDK$object().shape({
        RULES: $iPNDK$object().shape({
            CHECK_IN: (0, $525aff1e51b16df1$export$c350aa5ff2b00d59),
            CHECK_OUT: (0, $525aff1e51b16df1$export$c350aa5ff2b00d59)
        }),
        INSTRUCTIONS: $iPNDK$object().shape({
            LATE_CHECK_IN: $iPNDK$string().max(5000, $85913e27ce62cabd$var$maxString5000),
            CHECK_IN: $iPNDK$string().max(5000, $85913e27ce62cabd$var$maxString5000),
            CHECK_OUT: $iPNDK$string().max(5000, $85913e27ce62cabd$var$maxString5000)
        }),
        CODES: $iPNDK$object().shape({
            GARBAGE_RECYCLING_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa),
            DEVELOPMENT_DOOR_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa)
        })
    })
};
const $85913e27ce62cabd$var$advancedBookingSettings = {
    AdvancedBookingSettingsForm: $iPNDK$object().shape({
        RULES: $iPNDK$object().shape({
            ADVANCED_BOOKING: $iPNDK$object().shape((0, $525aff1e51b16df1$export$845ceb08a7321dfe))
        })
    })
};
const $85913e27ce62cabd$var$surcharges = {
    SurchargesForm: $iPNDK$object().shape({
        SURCHARGES: $iPNDK$object().shape({
            PETS: $iPNDK$object().shape({
                IS_ENABLED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                AMOUNT: $iPNDK$number().when("IS_ENABLED", {
                    is: true,
                    then: $iPNDK$number().min(1, $85913e27ce62cabd$var$minNumber).required($85913e27ce62cabd$var$requiredValue)
                })
            }),
            CLEANING: $iPNDK$object().shape({
                IS_ENABLED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                AMOUNT: $iPNDK$number().when("IS_ENABLED", {
                    is: true,
                    then: $iPNDK$number().min(1, $85913e27ce62cabd$var$minNumber).required($85913e27ce62cabd$var$requiredValue)
                })
            })
        }),
        IS_SUITABILITY_PETS_ENABLED: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue)
    })
};
const $85913e27ce62cabd$var$damageDeposit = {
    DamageDepositForm: $iPNDK$object().shape({
        DAMAGE_DEPOSIT: $iPNDK$object().shape({
            TYPE: $iPNDK$object().shape((0, $525aff1e51b16df1$export$eb7087b8a7df6140)).required($85913e27ce62cabd$var$requiredValue),
            AMOUNT: $iPNDK$number().when("TYPE", {
                is: (val)=>val.ID === "1",
                then: (0, $525aff1e51b16df1$export$f4f21ed02b0ddb8f).min(1, $85913e27ce62cabd$var$minNumber),
                otherwise: $iPNDK$number().when("TYPE", {
                    is: (val)=>val.ID === "3",
                    then: (0, $525aff1e51b16df1$export$f4f21ed02b0ddb8f).min(1, $85913e27ce62cabd$var$minNumber)
                })
            })
        })
    })
};
const $85913e27ce62cabd$var$taxes = {
    TaxesForm: $iPNDK$object().shape({
        TAXES: $iPNDK$array().of($iPNDK$object().shape({
            IS_ENABLED: $iPNDK$boolean().required(),
            TAX_NUMBER: $iPNDK$string().test({
                message: $85913e27ce62cabd$var$requiredValue,
                test: function(value) {
                    const isNumberRequired = this.parent.ID === (0, $b9fbf0da9ae592a3$export$6ba288b3069f362).PST_BC || this.parent.ID === (0, $b9fbf0da9ae592a3$export$6ba288b3069f362).GST;
                    const isValueValid = this.parent.IS_ENABLED ? value?.length > 0 : true;
                    return isNumberRequired ? isValueValid : true;
                }
            }),
            ID: $iPNDK$number()
        }))
    })
};
const $85913e27ce62cabd$var$ownerAddress = {
    OwnerAddressForm: $iPNDK$object().shape({
        OWNER: $iPNDK$object().shape({
            COMPANY_NAME: $iPNDK$string().max(75, $85913e27ce62cabd$var$longString),
            FIRST_NAME: $iPNDK$string().max(50, $85913e27ce62cabd$var$longString),
            LAST_NAME: $iPNDK$string().max(50, $85913e27ce62cabd$var$longString),
            EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d),
            ADDRESS: $iPNDK$object().shape((0, $525aff1e51b16df1$export$5bc1108084315903))
        })
    })
};
const $85913e27ce62cabd$export$a11e4d33e3a5bc12 = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).ParkingForm]: $iPNDK$object({
        PARKING: $iPNDK$object().shape({
            DESCRIPTION: $iPNDK$string().max(500, $85913e27ce62cabd$var$longString),
            INSTRUCTIONS: (0, $525aff1e51b16df1$export$6dff77f5fae61e03)(5000),
            HAS_ADDITIONAL_FREE_SPOTS: (0, $525aff1e51b16df1$export$4a21f16c33752377),
            HAS_ADDITIONAL_PAID_SPOTS: (0, $525aff1e51b16df1$export$4a21f16c33752377),
            NUM_SPOTS_PROVIDED: $iPNDK$number().min(0).required($85913e27ce62cabd$var$requiredValue),
            IS_DEFAULT_DESCRIPTION: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
            CODES: $iPNDK$object().shape({
                GARAGE_DOOR_CODE: (0, $525aff1e51b16df1$export$d22eb2ddbe14c2fa)
            })
        })
    })
};
const $85913e27ce62cabd$var$emergencyContacts = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).EmergencyContactsForm]: $iPNDK$object().shape({
        EMERGENCY_CONTACTS: $iPNDK$object().shape({
            PRIMARY: $iPNDK$object().shape({
                IS_COMPANY: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                COMPANY_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: true,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                FIRST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().max(50, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue)
                }),
                LAST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().max(50, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue)
                }),
                EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d),
                PHONE: (0, $525aff1e51b16df1$export$8bc4fdb2734276ba),
                ID: $iPNDK$number().required()
            }),
            OTHERS: $iPNDK$array().of($iPNDK$object().shape({
                ID: $iPNDK$number().required($85913e27ce62cabd$var$requiredValue),
                IS_COMPANY: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                COMPANY_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: true,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                FIRST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().max(50, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue)
                }),
                LAST_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().max(50, $85913e27ce62cabd$var$longString)
                }),
                EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d),
                PHONE: (0, $525aff1e51b16df1$export$8bc4fdb2734276ba),
                TYPE_ID: $iPNDK$number().min(1, $85913e27ce62cabd$var$requiredValue).required($85913e27ce62cabd$var$requiredValue)
            })),
            INSTRUCTIONS: $iPNDK$string()
        })
    })
};
const $85913e27ce62cabd$var$banking = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).BankingForm]: $iPNDK$object().shape({
        BANKING: $iPNDK$object().shape({
            ACCOUNTHOLDER: $iPNDK$object().shape({
                IS_COMPANY: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
                COMPANY_NAME: $iPNDK$string().when("IS_COMPANY", {
                    is: true,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                FIRST_NAME: $iPNDK$string().max(100, "Too Long!").when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                LAST_NAME: $iPNDK$string().max(100, "Too Long!").when("IS_COMPANY", {
                    is: false,
                    then: $iPNDK$string().required($85913e27ce62cabd$var$requiredValue)
                }),
                ADDRESS: $iPNDK$object().shape((0, $525aff1e51b16df1$export$5bc1108084315903))
            }),
            BANK: $iPNDK$object().shape({
                ACCOUNT_NUMBER: $iPNDK$string().required("required").matches((0, $525aff1e51b16df1$export$78791196678f97c0), "Account Number must be a number").min(5, "Must be more than four characters").max(34, "Must be less than 35 characters"),
                TRANSIT: $iPNDK$string().required("required").matches((0, $525aff1e51b16df1$export$78791196678f97c0), "Transit Number must be a number").min(5, "Must be five characters").max(5, "Must be five characters"),
                NAME: $iPNDK$string().min(2, "Must be two characters").max(50, $85913e27ce62cabd$var$longString).required($85913e27ce62cabd$var$requiredValue),
                INSTITUTION: $iPNDK$string().required("required").matches((0, $525aff1e51b16df1$export$78791196678f97c0), "Institution Number must be a number").min(3, "Must be three characters").max(3, "Must be three characters")
            })
        })
    })
};
const $85913e27ce62cabd$var$cleaningProtocol = {
    CleaningProtocolForm: $iPNDK$object().shape({
        CLEANING_PROTOCOL: $iPNDK$object().shape({
            IS_APPLY_TO_EXISTING_BOOKINGS: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
            HAS_AUTOMATIC_BUFFER_DAYS: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredNumber),
            NUMBER_OF_BLOCKOFF_DAYS: $iPNDK$number().when("HAS_AUTOMATIC_BUFFER_DAYS", {
                is: true,
                then: $iPNDK$number().moreThan(-1).required($85913e27ce62cabd$var$requiredValue)
            })
        })
    })
};
const $85913e27ce62cabd$var$partnersForm = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).PartnersForm]: $iPNDK$object().shape({
        PARTNERS: $iPNDK$array().of($iPNDK$object().shape({
            ID: $iPNDK$number().positive().integer().required($85913e27ce62cabd$var$requiredValue)
        }))
    })
};
const $85913e27ce62cabd$var$nonResident = {
    [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).NonResidentStatusForm]: $iPNDK$object().shape({
        NON_RESIDENT: $iPNDK$object().shape({
            IS_NON_RESIDENT: $iPNDK$boolean().required($85913e27ce62cabd$var$requiredValue),
            ITN_INFO: $iPNDK$array().when("IS_NON_RESIDENT", {
                is: true,
                then: $iPNDK$array().of($iPNDK$object().shape({
                    ITN: $iPNDK$string().notRequired().min(9, "ITN must be 9 digits or longer").max(20, "ITN must be 20 digits or less"),
                    PERCENTAGE_OWNERSHIP: $iPNDK$number().notRequired().min(0).max(100),
                    FIRST_NAME: $iPNDK$string().required("Please Enter Your First Name"),
                    LAST_NAME: $iPNDK$string().required("Please Enter Your Last Name"),
                    DOB: $iPNDK$string().notRequired(),
                    YEAR: $iPNDK$string().notRequired(),
                    MONTH: $iPNDK$string().notRequired(),
                    DAY: $iPNDK$string().notRequired()
                }))
            }),
            ITN_DATA: $iPNDK$string().when("IS_NON_RESIDENT", {
                is: true,
                then: $iPNDK$string().test({
                    message: "Percentage Ownership Must Total 100%",
                    test: function() {
                        const itnInfo = this.parent.ITN_INFO;
                        // If no owners, do not worry about this validation
                        if (itnInfo.length === 0) return true;
                        for(let i = 0; i < itnInfo.length; i++){
                            if (isNaN(parseInt(itnInfo[i].PERCENTAGE_OWNERSHIP))) return false;
                        }
                        const percentageTotal = itnInfo.reduce((prev, curr)=>{
                            const currPercentage = curr.PERCENTAGE_OWNERSHIP;
                            const isNum = !isNaN(parseInt(currPercentage));
                            if (isNum) return prev.add(currPercentage);
                            return prev;
                        }, new (0, $iPNDK$bigjs)(0));
                        // We give some leeway to make the total percentage calculation easy on users
                        return percentageTotal.gte(97) && percentageTotal.lte(103);
                    }
                })
            })
        })
    })
};
const $85913e27ce62cabd$export$4902baddc787debb = {
    ...$85913e27ce62cabd$var$advancedBookingSettings,
    ...$85913e27ce62cabd$var$accessToUnit,
    ...$85913e27ce62cabd$export$f4fee419a4a6cfef,
    ...$85913e27ce62cabd$var$allAmenitiesForm,
    ...$85913e27ce62cabd$var$banking,
    ...$85913e27ce62cabd$var$bathroomsOptional,
    ...$85913e27ce62cabd$var$bathroomsRequired,
    ...$85913e27ce62cabd$var$bedroomsOptional,
    ...$85913e27ce62cabd$var$bedroomsRequired,
    ...$85913e27ce62cabd$var$buildingAmenities,
    ...$85913e27ce62cabd$var$buildingAmenitiesOptional,
    ...$85913e27ce62cabd$var$calendarBlockoffs,
    ...$85913e27ce62cabd$var$cancellationPolicy,
    ...$85913e27ce62cabd$var$checkInOut,
    ...$85913e27ce62cabd$var$cleaningProtocol,
    ...$85913e27ce62cabd$var$damageDeposit,
    ...$85913e27ce62cabd$var$emergencyContacts,
    ...$85913e27ce62cabd$var$essentialAmenities,
    ...$85913e27ce62cabd$var$essentialAmenitiesOptional,
    ...$85913e27ce62cabd$var$instructions,
    ...$85913e27ce62cabd$var$locationOptional,
    ...$85913e27ce62cabd$var$locationRequired,
    ...$85913e27ce62cabd$var$nonResident,
    ...$85913e27ce62cabd$var$ownerAddress,
    ...$85913e27ce62cabd$export$a11e4d33e3a5bc12,
    ...$85913e27ce62cabd$var$partnersForm,
    ...$85913e27ce62cabd$export$3b2217e45a573556,
    ...$85913e27ce62cabd$var$privateSafetyAmenities,
    ...$85913e27ce62cabd$var$propertyAddress,
    ...$85913e27ce62cabd$var$propertyTitle,
    ...$85913e27ce62cabd$var$rateSettings,
    ...$85913e27ce62cabd$var$ratesSchedule,
    ...$85913e27ce62cabd$export$d3e8ab45a4e662f7,
    ...$85913e27ce62cabd$var$setUpQuestions,
    ...$85913e27ce62cabd$var$styleSquareFootage,
    ...$85913e27ce62cabd$var$suitabilities,
    ...$85913e27ce62cabd$var$surcharges,
    ...$85913e27ce62cabd$var$taxes
};
const $85913e27ce62cabd$export$4972db2450399ff = (subformName)=>{
    return $iPNDK$object().shape({
        [subformName]: $85913e27ce62cabd$export$4902baddc787debb[subformName]
    });
};
const $85913e27ce62cabd$export$eef420758b40d13d = {
    emptySchema: $iPNDK$object
};


var $fe808470c36fce96$exports = {};

$parcel$export($fe808470c36fce96$exports, "createReservationSchema", () => $fe808470c36fce96$export$b990f13615ac876e);
$parcel$export($fe808470c36fce96$exports, "bookingNotesSchema", () => $fe808470c36fce96$export$f05b27fc690ddecb);
$parcel$export($fe808470c36fce96$exports, "customMessageSchema", () => $fe808470c36fce96$export$e98af0589a9f86ab);
$parcel$export($fe808470c36fce96$exports, "mainPasswordValidation", () => $fe808470c36fce96$export$34b0dbd44219be72);
$parcel$export($fe808470c36fce96$exports, "passwordValidation", () => $fe808470c36fce96$export$7c727d033a0eaea7);
$parcel$export($fe808470c36fce96$exports, "userProfileValidation", () => $fe808470c36fce96$export$48f006aa2603f1a3);
$parcel$export($fe808470c36fce96$exports, "loginValidation", () => $fe808470c36fce96$export$3d76ecefc1f5a25a);
$parcel$export($fe808470c36fce96$exports, "forgotPasswordValidation", () => $fe808470c36fce96$export$215d1b302f9bc10);





const $fe808470c36fce96$export$b990f13615ac876e = $iPNDK$object({
    IS_NEW_GUEST: $iPNDK$boolean(),
    GUEST_FIRST_NAME: $iPNDK$string().when("IS_NEW_GUEST", {
        is: true,
        then: $iPNDK$string().min(1, (0, $334c34aebb0650e5$export$defe85febe8b728c).shortString).max(30, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString).required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue),
        otherwise: $iPNDK$string().min(1, (0, $334c34aebb0650e5$export$defe85febe8b728c).shortString).max(30, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString)
    }),
    ARRIVAL: $iPNDK$date().required("You must Submit an Arrival Date"),
    GUEST_EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d).required("Email is required"),
    PROPERTY_ID: $iPNDK$number().required("You must select a property"),
    NIGHTS: $iPNDK$number().min(1).required().label("Nights"),
    PARTY_SIZE_ADULTS: $iPNDK$number().typeError("You must submit a party size").required("You must submit a party size").positive("Must be grearter than 0"),
    PARTY_SIZE_KIDS: $iPNDK$number().typeError("You must submit a party size"),
    BOOKING_NET: $iPNDK$number().required("You must submit a Subtotal").typeError("You must submit a valid number"),
    PRICE_PER_NIGHT: $iPNDK$number().typeError("You must submit a valid number").required("You must submit a price per night"),
    DAMAGE_DEPOSIT_MODE_ID: $iPNDK$number().required("You must select"),
    DAMAGE_DEPOSIT_AMOUNT: $iPNDK$number().when("DAMAGE_DEPOSIT_MODE_ID", {
        is: (val)=>{
            return val === (0, $b9fbf0da9ae592a3$export$3e6477125daf98da).COLLECT_DAMAGE_UPON_DEPARTURE;
        },
        then: $iPNDK$number(),
        otherwise: $iPNDK$number().typeError("You must submit a number").moreThan(0, "Must be greater than 0").required("You must submit a Damage Deposit Amount")
    }),
    DEPOSIT_PERCENTAGE: $iPNDK$number().required("You must Submit a deposit percentage amount"),
    BALANCE_DUE_DATE: $iPNDK$date().test("max", "Balance Due Date Cannot Come Before Deposit Due Date ", function(value) {
        const { DEPOSIT_DUE_DATE: DEPOSIT_DUE_DATE  } = this.parent;
        const depositDueDate = (0, $iPNDK$dayjs)(DEPOSIT_DUE_DATE);
        const balanceDueDate = (0, $iPNDK$dayjs)(value);
        const diff = balanceDueDate.diff(depositDueDate, "day");
        return diff >= 0;
    })
});
const $fe808470c36fce96$var$maxMessageLength = 8000;
const $fe808470c36fce96$export$f05b27fc690ddecb = $iPNDK$object().shape({
    notes_owner: $iPNDK$string().max($fe808470c36fce96$var$maxMessageLength, "You must submit a note")
});
const $fe808470c36fce96$var$maxEntryCodeLength = 20;
const $fe808470c36fce96$export$e98af0589a9f86ab = $iPNDK$object().shape({
    id: $iPNDK$number().required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue),
    message: (0, $525aff1e51b16df1$export$7caa02bc8b4bb640),
    entry_code: $iPNDK$string().max($fe808470c36fce96$var$maxEntryCodeLength, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString)
});
const $fe808470c36fce96$export$34b0dbd44219be72 = $iPNDK$string().matches(/[a-z]/, "Must contain at least one lowercase letter").matches(/[A-Z]/, "Must contain at least one uppercase letter").min(8, "Must be at least 8 characters long").max(143, "Maximum 143 characters long").required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue);
const $fe808470c36fce96$var$passwordMatchValidation = $iPNDK$string().oneOf([
    $iPNDK$ref("PASSWORD")
], "Both passwords need to be the same").required("Required Field");
const $fe808470c36fce96$var$confirmPasswordValidation = $iPNDK$string().when("PASSWORD", {
    is: (val)=>val && val.length > 0,
    then: $fe808470c36fce96$var$passwordMatchValidation
});
const $fe808470c36fce96$export$7c727d033a0eaea7 = $iPNDK$object({
    PASSWORD: $fe808470c36fce96$export$34b0dbd44219be72,
    PASSWORD_CONFIRM: $fe808470c36fce96$var$confirmPasswordValidation
});
const $fe808470c36fce96$export$48f006aa2603f1a3 = $iPNDK$object().shape({
    IS_COMPANY: (0, $525aff1e51b16df1$export$4a21f16c33752377),
    COMPANY_NAME: $iPNDK$string().when("IS_COMPANY", {
        is: true,
        then: $iPNDK$string().max(75).required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue)
    }),
    FIRST_NAME: $iPNDK$string().when("IS_COMPANY", {
        is: false,
        then: $iPNDK$string().max(50).required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue)
    }),
    LAST_NAME: $iPNDK$string().when("IS_COMPANY", {
        is: false,
        then: $iPNDK$string().max(50, (0, $334c34aebb0650e5$export$defe85febe8b728c).longString).required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue)
    }),
    EMAIL: (0, $525aff1e51b16df1$export$d290fa47940df19d).required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue),
    PHONE: (0, $525aff1e51b16df1$export$8bc4fdb2734276ba),
    ADDRESS: $iPNDK$object().shape((0, $525aff1e51b16df1$export$5bc1108084315903))
});
const $fe808470c36fce96$export$3d76ecefc1f5a25a = $iPNDK$object().shape({
    email: (0, $525aff1e51b16df1$export$d290fa47940df19d).required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue).label("Email"),
    password: $iPNDK$string().required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue).min(4).label("Password")
});
const $fe808470c36fce96$export$215d1b302f9bc10 = $iPNDK$object().shape({
    email: (0, $525aff1e51b16df1$export$d290fa47940df19d).required().label("Email")
});


$parcel$exportWildcard($62a04ac1851f901e$exports, $334c34aebb0650e5$exports);
$parcel$exportWildcard($62a04ac1851f901e$exports, $525aff1e51b16df1$exports);
$parcel$exportWildcard($62a04ac1851f901e$exports, $85913e27ce62cabd$exports);
$parcel$exportWildcard($62a04ac1851f901e$exports, $fe808470c36fce96$exports);


const $b23d16d7784d62b4$var$initialValues = {
    message: ""
};
const $b23d16d7784d62b4$var$validationSchema = $iPNDK$object().shape({
    message: (0, $525aff1e51b16df1$export$7caa02bc8b4bb640).required((0, $334c34aebb0650e5$export$defe85febe8b728c).requiredValue)
});
const $b23d16d7784d62b4$export$cdb9dcad09c1a4fc = ({ children: children , onSubmit: onSubmit  })=>{
    return /*#__PURE__*/ (0, $iPNDK$jsx)((0, $iPNDK$Formik), {
        initialValues: $b23d16d7784d62b4$var$initialValues,
        onSubmit: onSubmit,
        validationSchema: $b23d16d7784d62b4$var$validationSchema,
        children: children
    });
};


var $f986a5115fbb3703$exports = {};

$parcel$export($f986a5115fbb3703$exports, "parkingFields", () => $f986a5115fbb3703$export$c2fa8f45e78599fe);


const $f986a5115fbb3703$var$subformName = (0, $9f770fb655db2e69$export$9dab6df2a66c141e).ParkingForm;
const $f986a5115fbb3703$var$subformPrefix = `${$f986a5115fbb3703$var$subformName}.PARKING`;
const $f986a5115fbb3703$export$c2fa8f45e78599fe = {
    garageCode: {
        label: (0, $046001b603cb87a9$export$e7419043208684dd),
        field: `${$f986a5115fbb3703$var$subformPrefix}.CODES.GARAGE_DOOR_CODE`
    }
};


var $a66e5e8056e7a4a6$exports = {};

$parcel$export($a66e5e8056e7a4a6$exports, "generateParkingText", () => $a66e5e8056e7a4a6$export$21e996c5f62ec17a);
const $a66e5e8056e7a4a6$var$generateNumberOfSpotsText = (numberOfSpotsProvided)=>{
    const hasAssignedParking = numberOfSpotsProvided > 0;
    const hasAssignedParkingText = `${numberOfSpotsProvided} reserved parking stall(s) included at no charge.`;
    const noAssignedParkingText = "There are no reserved parking stalls included.";
    return hasAssignedParking ? hasAssignedParkingText : noAssignedParkingText;
};
const $a66e5e8056e7a4a6$var$generateAdditionalFreeSpotsText = (hasAdditionalFreeSpots)=>{
    const hasFreeSpotsText = "Limited additional parking spots at no charge, however they are first come first serve and are not guaranteed.";
    const noFreeSpotsText = "There are no additional free parking stalls available at this location.";
    return hasAdditionalFreeSpots ? hasFreeSpotsText : noFreeSpotsText;
};
const $a66e5e8056e7a4a6$var$generatePayParkingText = (hasAdditionalPaidSpots)=>{
    const hasAdditionalSpotsText = "Pay parking is available at this location, pricing can be obtained from the building manager.";
    const noAdditionalSpotsText = "No additional pay parking available at this location.";
    return hasAdditionalPaidSpots ? hasAdditionalSpotsText : noAdditionalSpotsText;
};
const $a66e5e8056e7a4a6$export$21e996c5f62ec17a = ({ numberOfSpotsProvided: numberOfSpotsProvided , hasAdditionalFreeSpots: hasAdditionalFreeSpots , hasAdditionalPaidSpots: hasAdditionalPaidSpots  })=>{
    const numberOfSpotsText = $a66e5e8056e7a4a6$var$generateNumberOfSpotsText(numberOfSpotsProvided);
    const additionalFreeSpotsText = $a66e5e8056e7a4a6$var$generateAdditionalFreeSpotsText(hasAdditionalFreeSpots);
    const payParkingText = $a66e5e8056e7a4a6$var$generatePayParkingText(hasAdditionalPaidSpots);
    return `${numberOfSpotsText} ${additionalFreeSpotsText} ${payParkingText} `;
};


var $940b0d6f46dedcd6$exports = {};

$parcel$export($940b0d6f46dedcd6$exports, "generateParkingValues", () => $940b0d6f46dedcd6$export$9aa8745369c34cd9);

const $940b0d6f46dedcd6$export$9aa8745369c34cd9 = ({ PARKING: PARKING , INSTRUCTIONS: { PARKING: parkingInstructions  } , CODES: CODES  })=>({
        [(0, $9f770fb655db2e69$export$9dab6df2a66c141e).ParkingForm]: {
            PARKING: {
                ...PARKING,
                INSTRUCTIONS: parkingInstructions,
                CODES: {
                    GARAGE_DOOR_CODE: CODES.GARAGE_DOOR_CODE
                }
            }
        }
    });


var $92f068d730330618$exports = {};

$parcel$export($92f068d730330618$exports, "reservationCancelRequestFormValues", () => $92f068d730330618$export$1a09ad6dee82afaa);

const $92f068d730330618$var$initialValues = {
    message: "",
    isChecked: false
};
const $92f068d730330618$var$validationSchema = $iPNDK$object({
    message: $iPNDK$string().min(8, "Must be at least 8 characters long").max(1000, "Maximum 1000 characters long").required("Please provide a reason for this request"),
    isChecked: $iPNDK$boolean().required("The terms and conditions must be accepted.").oneOf([
        true
    ], "The terms and conditions must be accepted.")
});
const $92f068d730330618$export$1a09ad6dee82afaa = {
    initialValues: $92f068d730330618$var$initialValues,
    validationSchema: $92f068d730330618$var$validationSchema
};


var $351adc2ed77e5aaa$exports = {};

$parcel$export($351adc2ed77e5aaa$exports, "reservationEditRequestFormValues", () => $351adc2ed77e5aaa$export$2756dea28e9c0be1);

const $351adc2ed77e5aaa$var$initialValues = {
    message: "",
    isChecked: false
};
const $351adc2ed77e5aaa$var$validationSchema = $iPNDK$object({
    message: $iPNDK$string().min(8, "Must be at least 8 characters long").max(1000, "Maximum 1000 characters long").required("Please provide a reason for this request"),
    isChecked: $iPNDK$boolean().required("The terms and conditions must be accepted.").oneOf([
        true
    ], "The terms and conditions must be accepted.")
});
const $351adc2ed77e5aaa$export$2756dea28e9c0be1 = {
    initialValues: $351adc2ed77e5aaa$var$initialValues,
    validationSchema: $351adc2ed77e5aaa$var$validationSchema
};


var $966e131d61cd5b94$exports = {};

$parcel$export($966e131d61cd5b94$exports, "generateCreateMessageSubject", () => $966e131d61cd5b94$export$ec38efcfa6e2d6b1);
var $5b9a33cfff775612$exports = {};

$parcel$export($5b9a33cfff775612$exports, "SubjectIdentifier", () => $5b9a33cfff775612$export$bb4d5f87bab450c);
let $5b9a33cfff775612$export$bb4d5f87bab450c;
(function(SubjectIdentifier1) {
    SubjectIdentifier1["BOOKING"] = "BOOKING";
    SubjectIdentifier1["INQUIRY"] = "INQUIRY";
})($5b9a33cfff775612$export$bb4d5f87bab450c || ($5b9a33cfff775612$export$bb4d5f87bab450c = {}));


function $966e131d61cd5b94$export$ec38efcfa6e2d6b1(subject) {
    if (!subject) return undefined;
    return Object.keys(subject.BOOKING).length === 0 ? {
        TYPE: (0, $5b9a33cfff775612$export$bb4d5f87bab450c).INQUIRY,
        ID: subject.MESSAGE.ID,
        ARRIVAL_DATE: subject.MESSAGE.ARRIVAL_DATE,
        DEPARTURE_DATE: subject.MESSAGE.DEPARTURE_DATE
    } : {
        TYPE: (0, $5b9a33cfff775612$export$bb4d5f87bab450c).BOOKING,
        ID: subject.BOOKING.ID,
        ARRIVAL_DATE: subject.BOOKING.ARRIVAL_DATE,
        DEPARTURE_DATE: subject.BOOKING.DEPARTURE_DATE,
        REFERENCE: subject.BOOKING.REFERENCE
    };
}



var $b952e95babfab6f7$exports = {};

$parcel$export($b952e95babfab6f7$exports, "useInitializeThread", () => $b952e95babfab6f7$export$bcda4812444b78f0);

const $b952e95babfab6f7$export$bcda4812444b78f0 = ({ initialBookingId: initialBookingId , initialMessageId: initialMessageId  })=>{
    const [bookingId, setBookingId] = (0, $iPNDK$useState)(initialBookingId);
    const [messageId, setMessageId] = (0, $iPNDK$useState)(initialMessageId);
    const hasInitialSubjectSelection = Boolean(initialBookingId) || Boolean(initialMessageId);
    const hasCurrentSubjectSelection = Boolean(bookingId) || Boolean(messageId);
    return {
        bookingId: bookingId,
        setBookingId: setBookingId,
        messageId: messageId,
        setMessageId: setMessageId,
        hasInitialSubjectSelection: hasInitialSubjectSelection,
        hasCurrentSubjectSelection: hasCurrentSubjectSelection
    };
};


var $2bfde58f7fc010c8$exports = {};

$parcel$export($2bfde58f7fc010c8$exports, "useMessageContact", () => $2bfde58f7fc010c8$export$9769a567376257e);

const $2bfde58f7fc010c8$export$9769a567376257e = ({ propertyId: propertyId , contactUserId: contactUserId , contactUserTypeId: contactUserTypeId  })=>{
    const userContactQuery = (0, $9ba3881267ff62de$export$aad7a107d20654a8)({
        propertyId: propertyId,
        contactUserId: contactUserId,
        contactUserTypeId: contactUserTypeId
    });
    const userContact = userContactQuery.data ? userContactQuery.data.DATA : undefined;
    return {
        userContactQuery: userContactQuery,
        userContact: userContact
    };
};


var $a22795d9ebdb4d5e$exports = {};

$parcel$export($a22795d9ebdb4d5e$exports, "useMessageMarkAsRead", () => $a22795d9ebdb4d5e$export$23283d14ba88685c);




const $a22795d9ebdb4d5e$export$23283d14ba88685c = ({ contactUserId: contactUserId , contactUserTypeId: contactUserTypeId , userId: userId , userTypeId: userTypeId  })=>{
    const qClient = (0, $iPNDK$useQueryClient)();
    const markThreadAsReadMutation = (0, $f8c5cddd3f76ba08$export$36482d2dcbe38d19)({
        hasToastsEnabled: false
    });
    (0, $iPNDK$useEffect)(()=>{
        markThreadAsReadMutation.mutate({
            id: userId,
            user_type_id: userTypeId,
            contact_user_id: contactUserId,
            contact_user_type_id: contactUserTypeId
        }, {
            onSuccess: ()=>{
                qClient.invalidateQueries((0, $075f45b3096494c7$export$1606b956841c586b).all);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};


var $8c58617e230d9bb3$exports = {};

$parcel$export($8c58617e230d9bb3$exports, "useMessageSubject", () => $8c58617e230d9bb3$export$83f62d2049f749a9);



const $8c58617e230d9bb3$export$83f62d2049f749a9 = ({ userId: userId , userTypeId: userTypeId , hasCurrentSubjectSelection: hasCurrentSubjectSelection , bookingId: bookingId , messageId: messageId  })=>{
    const subjectQuery = (0, $5efb488ac8f43282$export$e4e15d044a2c569e)({
        bookingId: bookingId,
        messageId: messageId,
        userId: userId,
        userTypeId: userTypeId,
        enabled: hasCurrentSubjectSelection
    });
    const subject = subjectQuery.data?.DATA?.SUBJECT;
    const createMessageSubject1 = (0, $966e131d61cd5b94$export$ec38efcfa6e2d6b1)(subject);
    const [selectedSubject, setSelectedSubject] = (0, $iPNDK$useState)(createMessageSubject1);
    const [selectedProperty, setSelectedProperty] = (0, $iPNDK$useState)(subject?.PROPERTY);
    (0, $iPNDK$useEffect)(()=>{
        if (subject && !selectedSubject) {
            const createMessageSubject = (0, $966e131d61cd5b94$export$ec38efcfa6e2d6b1)(subject);
            setSelectedSubject(createMessageSubject);
        }
        if (subject && !selectedProperty) setSelectedProperty(subject.PROPERTY);
    }, [
        selectedProperty,
        selectedSubject,
        subject
    ]);
    return {
        subjectQuery: subjectQuery,
        selectedSubject: selectedSubject,
        setSelectedSubject: setSelectedSubject,
        selectedProperty: selectedProperty,
        setSelectedProperty: setSelectedProperty
    };
};


var $9af52121b6f99d2c$exports = {};

$parcel$export($9af52121b6f99d2c$exports, "useMessageThread", () => $9af52121b6f99d2c$export$708108bcb7301ffe);



const $9af52121b6f99d2c$export$708108bcb7301ffe = ({ userTypeId: userTypeId , userId: userId , contactUserId: contactUserId , contactUserTypeId: contactUserTypeId , ...rest })=>{
    const threadQuery = (0, $156aac85a5b99e55$export$e8d4e2c458aafaf)({
        id: userId,
        userTypeId: userTypeId,
        contactUserId: contactUserId,
        contactUserTypeId: contactUserTypeId,
        ...rest
    });
    const threadData = (0, $iPNDK$useMemo)(()=>{
        return threadQuery.data ? (0, $72dc1ad4ce2b3683$export$a90bfd0a4ae1116f)(threadQuery.data, "THREAD") : [];
    }, [
        threadQuery.data
    ]);
    const lastThreadData = threadData && threadData.length > 0 ? threadData[0] : undefined;
    const [refreshing, setRefreshing] = (0, $iPNDK$useState)(false);
    const refresh = async ()=>{
        try {
            setRefreshing(true);
            await threadQuery.refetch();
        } catch (e) {
            console.error(e);
        } finally{
            setRefreshing(false);
        }
    };
    return {
        threadQuery: threadQuery,
        threadData: threadData,
        lastThreadData: lastThreadData,
        refreshThread: refresh,
        refreshingThread: refreshing
    };
};


var $590653b23d4e079a$exports = {};

$parcel$export($590653b23d4e079a$exports, "useUpdateSubjectSelection", () => $590653b23d4e079a$export$1e6df1b5cb017e3c);

const $590653b23d4e079a$export$1e6df1b5cb017e3c = ({ lastThreadData: lastThreadData , hasCurrentSubjectSelection: hasCurrentSubjectSelection , setBookingId: setBookingId , setMessageId: setMessageId  })=>{
    (0, $iPNDK$useEffect)(()=>{
        if (lastThreadData && !hasCurrentSubjectSelection) {
            if (Object.keys(lastThreadData.BOOKING).length > 0) setBookingId(lastThreadData.BOOKING.ID);
            else setMessageId(lastThreadData.MESSAGE.ID);
        }
    }, [
        hasCurrentSubjectSelection,
        lastThreadData,
        setBookingId,
        setMessageId
    ]);
};



var $7ea737b70b09b7d5$exports = {};
var $aa474ac8e01dbbbc$exports = {};
var $06e97c11651442f4$exports = {};


$parcel$exportWildcard($aa474ac8e01dbbbc$exports, $06e97c11651442f4$exports);


$parcel$exportWildcard($7ea737b70b09b7d5$exports, $aa474ac8e01dbbbc$exports);


$parcel$exportWildcard($6a5610d21c7de291$exports, $363f6af70c77384a$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $616614d9d4651c1d$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $62a802691632c607$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $7cdb244188f67081$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $b28bbbf288bb2fb3$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $374209dcfecaa202$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $7bf8dd342faae788$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $f2f669699f07846a$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $0bc40ca8ae52b6bb$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $a714c13918d8ca5b$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $89862bbf0394a4aa$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $27b49d9012873ecf$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $a000ed2b98d1b055$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $404122bf60b7304e$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $d7bf2ec125c1c282$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $2ad90413c6f0c2b1$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $c66030fb6906ecdb$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $da2dd51e17e61b33$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $6a726573b91359e1$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $4d249cfc08a921f0$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $1402c0a484a6f252$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $c6d76554d8e1e29d$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $f648da45e8e76d84$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $a38ffcb37f95a152$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $ccee87f383d87bf3$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $d48a70f9706ee2e2$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $d00676120cc96262$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $65e33642a42747d2$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $4c1d61297d95031f$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $8ad86f241ad28bc7$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $21bebe11e6996a77$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $a21b1a44f2f656cf$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $30ce8504169fa6b7$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $a5e7a518b63dd2b5$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $f21ebe6183911aea$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $34ca7670912c6cc0$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $075f45b3096494c7$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $f5973776ce302c7e$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $156aac85a5b99e55$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $3657bbf543405025$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $1629d937777f52d0$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $f8c5cddd3f76ba08$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $965e1643685356ab$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $5e8aa9a857d42b8f$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $6ae600d9fcc74b3e$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $b7fef110d856d6b3$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $4056446910bacec4$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $4e2a54ea9d0e29c4$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $6e5878536e063d8a$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $af857901a110569f$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $56754d72d2bf6761$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $9586a10a8051110f$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $5ed9a20c40ee3c8c$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $3be0ab077497ea85$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $54158e5d8ac3a9aa$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $e81d666e9ab3330a$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $9ba3881267ff62de$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $5efb488ac8f43282$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $7ca7363463b01d4a$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $bd3a5490fcd3ceba$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $157b262af7a409fd$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $04e57a2246bdbee0$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $d900f4229f04c942$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $09cc91e025cb54f0$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $5c3888846488886d$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $1980288893925d89$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $30c1da10c566c284$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $db8cb6799be9e216$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $396bc124d7d12353$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $581d20e8b41cc3bb$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $92a2c5a765476c50$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $6a87b8ff1330cbde$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $d5e96504640a735e$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $2c1ba4272f0dcaed$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $81cae684d7d7e63e$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $854fa44a86ca5c27$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $d9623ccf96fc189a$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $b8a85190e7afe5ad$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $555db87d060751cc$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $083131879a09f840$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $b23d16d7784d62b4$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $f986a5115fbb3703$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $a66e5e8056e7a4a6$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $940b0d6f46dedcd6$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $92f068d730330618$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $351adc2ed77e5aaa$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $966e131d61cd5b94$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $5b9a33cfff775612$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $b952e95babfab6f7$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $2bfde58f7fc010c8$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $a22795d9ebdb4d5e$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $8c58617e230d9bb3$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $9af52121b6f99d2c$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $590653b23d4e079a$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $62a04ac1851f901e$exports);
$parcel$exportWildcard($6a5610d21c7de291$exports, $7ea737b70b09b7d5$exports);


var $52e11f599a4f5dca$exports = {};
var $4a0160e1e5b24e49$exports = {};

$parcel$export($4a0160e1e5b24e49$exports, "bookingStatus", () => $4a0160e1e5b24e49$export$b52c96215ed92eba);
$parcel$export($4a0160e1e5b24e49$exports, "bookingInfo", () => $4a0160e1e5b24e49$export$90b5cb7a2e4b0584);
$parcel$export($4a0160e1e5b24e49$exports, "reviewRating", () => $4a0160e1e5b24e49$export$395f71321ad585e0);
$parcel$export($4a0160e1e5b24e49$exports, "reviewResponses", () => $4a0160e1e5b24e49$export$5368f805f6a71f7d);
$parcel$export($4a0160e1e5b24e49$exports, "ELIGIBLE_REVIEW", () => $4a0160e1e5b24e49$export$5cc20b5323ee05eb);
$parcel$export($4a0160e1e5b24e49$exports, "REVIEW", () => $4a0160e1e5b24e49$export$66d28a7d28bf9a8b);
$parcel$export($4a0160e1e5b24e49$exports, "BOOKING_PROPERTY", () => $4a0160e1e5b24e49$export$37743108b2146755);
$parcel$export($4a0160e1e5b24e49$exports, "fullPayment", () => $4a0160e1e5b24e49$export$1751cb5a64e5db9);
$parcel$export($4a0160e1e5b24e49$exports, "BOOKING_STATUS", () => $4a0160e1e5b24e49$export$71dcb83791b96dd8);
$parcel$export($4a0160e1e5b24e49$exports, "CUSTOM_MESSAGE", () => $4a0160e1e5b24e49$export$ed8e20ee59aa51cd);
$parcel$export($4a0160e1e5b24e49$exports, "SPARSE_BOOKING", () => $4a0160e1e5b24e49$export$1bfde61c4816a533);
$parcel$export($4a0160e1e5b24e49$exports, "FULL_BOOKING", () => $4a0160e1e5b24e49$export$96c2251bdcddf5c0);
$parcel$export($4a0160e1e5b24e49$exports, "bookingSurcharge", () => $4a0160e1e5b24e49$export$a6493835bca0af56);
$parcel$export($4a0160e1e5b24e49$exports, "bookingSurchargesTotal", () => $4a0160e1e5b24e49$export$34792c472deb2d73);
$parcel$export($4a0160e1e5b24e49$exports, "bookingTax", () => $4a0160e1e5b24e49$export$632feb45bf00dce4);
$parcel$export($4a0160e1e5b24e49$exports, "BOOKING_GUEST_EXISTS", () => $4a0160e1e5b24e49$export$e06f6fbc328d469c);
var $7e76d0d187f06940$exports = {};

$parcel$export($7e76d0d187f06940$exports, "RATES_SETTINGS", () => $7e76d0d187f06940$export$e65672f8de2d64be);
$parcel$export($7e76d0d187f06940$exports, "ACCESS_TO_UNIT", () => $7e76d0d187f06940$export$2fc451ae562d804e);
$parcel$export($7e76d0d187f06940$exports, "SURCHARGE", () => $7e76d0d187f06940$export$ee59cd75d3b30515);
$parcel$export($7e76d0d187f06940$exports, "PROPERTY_SURCHARGES", () => $7e76d0d187f06940$export$6c09499d8eae7f1b);
$parcel$export($7e76d0d187f06940$exports, "ITN_INFORMATION", () => $7e76d0d187f06940$export$6321771034ce0c0);
$parcel$export($7e76d0d187f06940$exports, "NON_RESIDENT", () => $7e76d0d187f06940$export$6bcbaf56c80d335);
$parcel$export($7e76d0d187f06940$exports, "PROPERTY_CODES", () => $7e76d0d187f06940$export$fcb478d7c9a12a2f);
$parcel$export($7e76d0d187f06940$exports, "PROPERTY_RULES", () => $7e76d0d187f06940$export$294ddf93b115efd1);
$parcel$export($7e76d0d187f06940$exports, "initialPropertyState", () => $7e76d0d187f06940$export$d9095763ed98a14d);
$parcel$export($7e76d0d187f06940$exports, "calendarEvent", () => $7e76d0d187f06940$export$64e4c5bc204b3918);
$parcel$export($7e76d0d187f06940$exports, "sparseRate", () => $7e76d0d187f06940$export$39d988428beabf9e);
$parcel$export($7e76d0d187f06940$exports, "sparseSeason", () => $7e76d0d187f06940$export$7e60fbbaddc2b50e);
$parcel$export($7e76d0d187f06940$exports, "calendarDate", () => $7e76d0d187f06940$export$f55a6e090601daf0);
$parcel$export($7e76d0d187f06940$exports, "reservationDetails", () => $7e76d0d187f06940$export$d2bbe34cae8c0cf7);
$parcel$export($7e76d0d187f06940$exports, "initialLastAndNextGuest", () => $7e76d0d187f06940$export$ce3060be2c5fec9b);
$parcel$export($7e76d0d187f06940$exports, "BANK_DEPOSITS", () => $7e76d0d187f06940$export$13cdc582138f1c6d);
$parcel$export($7e76d0d187f06940$exports, "UNAVAILABLE_DATES", () => $7e76d0d187f06940$export$1bb2cdf36fcdc8c9);
$parcel$export($7e76d0d187f06940$exports, "PHOTO", () => $7e76d0d187f06940$export$5857866d21813cda);
$parcel$export($7e76d0d187f06940$exports, "PROPERTY_DEFAULT_CONTENT", () => $7e76d0d187f06940$export$e8c211579d62c131);
$parcel$export($7e76d0d187f06940$exports, "EXTERNAL_EVENT", () => $7e76d0d187f06940$export$d4e877b8d445a3e1);
$parcel$export($7e76d0d187f06940$exports, "PROPERTY_REVIEWS", () => $7e76d0d187f06940$export$60faf8ebe46b9581);
$parcel$export($7e76d0d187f06940$exports, "RATE_SUGGESTION", () => $7e76d0d187f06940$export$498fe3de1de7bf1a);
$parcel$export($7e76d0d187f06940$exports, "RATE_SUGGESTIONS", () => $7e76d0d187f06940$export$f28016d2cadf8c20);
$parcel$export($7e76d0d187f06940$exports, "RATE_SCHEDULE_GENERATE_OPTIMIZE", () => $7e76d0d187f06940$export$fade679d0da51bb1);
$parcel$export($7e76d0d187f06940$exports, "RATE_SCHEDULE_GENERATE_INSIGHT", () => $7e76d0d187f06940$export$e0ba6e5e6a1e98b1);




const $7e76d0d187f06940$export$e65672f8de2d64be = {
    /** Every month, extend the users rate schedule up to their availability window, cannot be use when availability window is unrestricted */ IS_AVAILABILITY_AUTOMATION_ENABLED: false,
    /** AKA Pricing insights/Smart Pricing data
   * If true then the property has the option to enable optimized pricing */ HAS_RATE_INSIGHTS_DATA: false,
    /** Every month, optimize the users rate schedule using the smart pricing level set
   *  Each date range can have its own smart pricing level, otherwise uses the property-level smart pricing level */ IS_OPTIMIZED_PRICING_ENABLED: false,
    NO_RATES_DATES: [],
    PRICING_STRATEGY: {
        ID: 0,
        RATE_INSIGHTS_LEVEL_ID: 0
    },
    WEEKEND_PREMIUM: {
        ID: 0,
        DOLLAR_AMOUNT: 0,
        PERCENTAGE_AMOUNT: 0
    },
    AVAILABILITY_WINDOW: {
        ID: 0
    },
    DATE_LAST_SAVED: "",
    RATE_GROUPS: {
        HIGH: {},
        LOW: {},
        PRIME: {},
        MID: {}
    },
    DISCOUNT_GROUP: {
        TEN_DAY: 0,
        SEVEN_DAY: 0,
        FIVE_DAY: 0,
        ID: 0
    },
    ID: 0
};
const $7e76d0d187f06940$var$AMENITIES = {
    BUILDING: {
        TYPE: "BUILDING",
        LIST: []
    },
    ESSENTIAL: {
        TYPE: "ESSENTIAL",
        LIST: []
    },
    KITCHEN: {
        TYPE: "KITCHEN",
        LIST: []
    },
    PRIVATE: {
        TYPE: "PRIVATE",
        LIST: []
    },
    SAFETY: {
        TYPE: "SAFETY",
        LIST: []
    }
};
const $7e76d0d187f06940$export$2fc451ae562d804e = {
    CODE: {
        NAME: "",
        ID: 0
    },
    METHOD: {
        NAME: "",
        ID: 0
    },
    /** STANDARD_CODE and FRONT_DOOR_CODE are linked for a property */ STANDARD_CODE: "",
    TYPE: {
        NAME: "",
        ID: 0
    }
};
const $7e76d0d187f06940$var$BANKING = {
    ACCOUNTHOLDER: {
        ADDRESS: (0, $80436cd706766ba7$export$f7d3c097ceca6c15),
        COMPANY_NAME: "",
        FIRST_NAME: "",
        IS_COMPANY: false,
        LAST_NAME: ""
    },
    BANK: {
        ACCOUNT_NUMBER: "",
        INSTITUTION: "",
        NAME: "",
        TRANSIT: "",
        ID: 0
    }
};
const $7e76d0d187f06940$var$CLEANING_PROTOCOL = {
    HAS_AUTOMATIC_BUFFER_DAYS: false,
    IS_APPLY_TO_EXISTING_BOOKINGS: false,
    NUMBER_OF_BLOCKOFF_DAYS: 0
};
const $7e76d0d187f06940$export$ee59cd75d3b30515 = {
    AMOUNT: "",
    ID: 0,
    IS_ENABLED: false,
    NAME: ""
};
const $7e76d0d187f06940$export$6c09499d8eae7f1b = {
    CLEANING: $7e76d0d187f06940$export$ee59cd75d3b30515,
    PETS: $7e76d0d187f06940$export$ee59cd75d3b30515
};
const $7e76d0d187f06940$var$SUITABILITY = {
    ID: 0,
    DESCRIPTION: "",
    IS_SUITABLE: false,
    NAME: ""
};
const $7e76d0d187f06940$var$SUITABILITIES = {
    LONG_TERM_RENTALS: $7e76d0d187f06940$var$SUITABILITY,
    PARTIES_EVENTS: $7e76d0d187f06940$var$SUITABILITY,
    PETS: $7e76d0d187f06940$var$SUITABILITY,
    SMOKING: $7e76d0d187f06940$var$SUITABILITY,
    TRAVEL_RESELLERS: $7e76d0d187f06940$var$SUITABILITY,
    WHEELCHAIR_ACCESSIBLE: $7e76d0d187f06940$var$SUITABILITY
};
const $7e76d0d187f06940$var$TAX = {
    IS_MANDATORY: false,
    IS_PASS_THROUGH_TO_OWNER: false,
    NAME: "",
    ID: 0,
    RATE: 0,
    REGISTRATION_NUMBER: "",
    DESCRIPTION: ""
};
const $7e76d0d187f06940$var$TAXES = [];
const $7e76d0d187f06940$export$6321771034ce0c0 = {
    ID: 0,
    ITN: 0,
    PERCENTAGE_OWNERSHIP: 0,
    DOB: "",
    FIRST_NAME: "",
    LAST_NAME: ""
};
const $7e76d0d187f06940$export$6bcbaf56c80d335 = {
    ITN_INFO: [
        $7e76d0d187f06940$export$6321771034ce0c0
    ],
    IS_NON_RESIDENT: false,
    WITHHOLDING_PERCENTAGE: 0
};
const $7e76d0d187f06940$export$fcb478d7c9a12a2f = {
    BIKE_LOCKER_CODE: "",
    /** Used for building entrance when a single door code is not sufficient */ DEVELOPMENT_DOOR_CODE: "",
    /** Used for sauna and steam room */ DEVELOPMENT_GYM_CODE: "",
    DEVELOPMENT_HOT_TUB_CODE: "",
    /** Used for pool and hot-tub */ DEVELOPMENT_POOL_CODE: "",
    DEVELOPMENT_SAUNA_CODE: "",
    DEVELOPMENT_STEAM_ROOM_CODE: "",
    /** Used for access to unit/building. This is linked to the ACCESS_TO_UNIT STANDARD_CODE field */ FRONT_DOOR_CODE: "",
    GAMES_REC_ROOM_CODE: "",
    GARAGE_DOOR_CODE: "",
    GARBAGE_RECYCLING_CODE: "",
    ID: 0,
    INTERNET_NETWORK_NAME: "",
    INTERNET_PASSWORD: "",
    PHONE_NUMBER: "",
    PROPERTY_ID: "",
    SKI_LOCKER_CODE: "",
    DATE_LAST_UPDATED: ""
};
const $7e76d0d187f06940$export$294ddf93b115efd1 = {
    ADVANCED_BOOKING: {
        NAME: "",
        ID: 0
    },
    CHECK_IN: "",
    CHECK_OUT: "",
    ID: 0,
    MAX_GUESTS: 0,
    MIN_AGE_TO_BOOK: 0,
    QUIET_TIME: ""
};
const $7e76d0d187f06940$var$PROPERTY_GUIDEBOOK_WALKTHROUGH = {
    COMPLETED_STEPS: [],
    COMPLETION_PERCENTAGE: 0,
    NUM_STEPS: 0,
    STEPS: [
        (0, $f58c18151396e867$export$92ac1597760befe6).introduction,
        (0, $f58c18151396e867$export$92ac1597760befe6).welcomeMessage,
        (0, $f58c18151396e867$export$92ac1597760befe6).directions,
        (0, $f58c18151396e867$export$92ac1597760befe6).checkIn,
        (0, $f58c18151396e867$export$92ac1597760befe6).departure,
        (0, $f58c18151396e867$export$92ac1597760befe6).houseKeeping,
        (0, $f58c18151396e867$export$92ac1597760befe6).uniqueCodes,
        (0, $f58c18151396e867$export$92ac1597760befe6).amenities,
        (0, $f58c18151396e867$export$92ac1597760befe6).gettingAround,
        (0, $f58c18151396e867$export$92ac1597760befe6).frontDesk,
        (0, $f58c18151396e867$export$92ac1597760befe6).commonQuestions, 
    ]
};
const $7e76d0d187f06940$var$PROPERTY_CO_HOST = {
    ...(0, $de872e06841c454e$export$ff09b90989b21a8),
    COHOST_PROFILE: {
        PERMISSIONS: {},
        PROPERTY_IDS: []
    }
};
/** The property contact is the primary contact, they are the same */ const $7e76d0d187f06940$var$PROPERTY_CONTACT = {
    ...(0, $de872e06841c454e$export$ff09b90989b21a8),
    PROPERTY_MANAGER_PROFILE: {
        PERMISSIONS: {},
        PROPERTY_IDS: []
    }
};
const $7e76d0d187f06940$export$d9095763ed98a14d = {
    ID: 0,
    ACCESS_TO_UNIT: $7e76d0d187f06940$export$2fc451ae562d804e,
    ADDRESS: (0, $80436cd706766ba7$export$f7d3c097ceca6c15),
    AMENITIES: $7e76d0d187f06940$var$AMENITIES,
    BANKING: $7e76d0d187f06940$var$BANKING,
    BATHROOMS: [],
    BEDROOMS: [],
    BLOCKOFFS: [],
    CANCELLATION_POLICY: $80436cd706766ba7$export$93fb9aa9532d819b,
    CLEANING_PROTOCOL: $7e76d0d187f06940$var$CLEANING_PROTOCOL,
    CODES: $7e76d0d187f06940$export$fcb478d7c9a12a2f,
    CO_HOST: $7e76d0d187f06940$var$PROPERTY_CO_HOST,
    CONTENT: {
        ABOUT_THE_BUILDING: "",
        DESCRIPTION: "",
        KITCHEN: "",
        LOCATION: "",
        SUMMARY: "",
        TITLE: ""
    },
    DAMAGE_DEPOSIT: {
        AMOUNT: "",
        TYPE: {
            ID: 0,
            NAME: ""
        }
    },
    DAYS_TO_EXPIRY: 0,
    DIRECT_VACATIONS: $80436cd706766ba7$export$82cefcd67fde3934,
    EMERGENCY_CONTACTS: {
        PRIMARY: {
            COMPANY_NAME: "",
            DESCRIPTION: "",
            EMAIL: "",
            FIRST_NAME: "",
            ID: 0,
            IS_COMPANY: false,
            LAST_NAME: "",
            PHONE: "",
            TYPE: "",
            TYPE_ID: 1
        },
        OTHERS: []
    },
    EXTERNAL_URLS: {
        URL_AIRBNB: "",
        URL_OTHER: "",
        URL_VRBO: ""
    },
    ICALS: {
        HAS_ICALS: false,
        PRIMARY: {
            ALLURA_URL: "",
            AVAILABILITY_WINDOW: 0,
            IS_AVAILABILITY_WINDOW: false,
            IS_BLOCK_RATELESS: true
        },
        SECONDARY: {
            ALLURA_URL: "",
            AVAILABILITY_WINDOW: 0,
            IS_ACTIVE: true,
            IS_AVAILABILITY_WINDOW: false,
            IS_BLOCK_RATELESS: true
        },
        EXTERNAL: [
            {
                ID: 0,
                LISTING_URL: "",
                NAME: "",
                URL: ""
            }
        ]
    },
    INSTRUCTIONS: {
        ABOUT_THE_BUILDING: "",
        ACTIVITIES: "",
        BUILDING_COMMON_AREAS: "",
        CHECK_IN: "",
        CHECK_OUT: "",
        EMERGENCY_CONTACTS: "",
        FRONT_DESK: "",
        GARBAGE_RECYCLING: "",
        GETTING_AROUND: "",
        GETTING_TO_UNIT: "",
        HEATING: "",
        HOUSEKEEPING: "",
        ID: 0,
        INFANT_SUPPLIES: "",
        KITCHEN: "",
        LATE_CHECK_IN: "",
        LINENS_AND_TOWELS: "",
        OTHER: "",
        PARKING: "",
        RESTAURANTS: "",
        SERVICES: "",
        SKI_IN_SKI_OUT: "",
        TO_FROM_LIFTS: "",
        WELCOME: "",
        WHAT_TO_BRING: ""
    },
    IS_CO_HOST_MANAGER_ENABLED: "",
    IS_ENABLED: false,
    IS_SKI_IN_SKI_OUT: false,
    JOIN_STATUS: {
        COMPLETION_PERCENTAGE_REQUIRED: 0,
        COMPLETION_PERCENTAGE_OPTIONAL: 0,
        DATES: {
            CREATED: "",
            LAST_UPDATED: "",
            ACTIVATED: "",
            ACTIVATION_REQUEST: ""
        },
        HAS_COMPLETED_ONBOARDING: false,
        HAS_LEGACY_ADMIN_ACCESS: false,
        STATUS: "",
        STATUS_ID: 0,
        SUBFORMS_COMPLETED: [],
        SUBFORMS_OPTIONAL_COMPLETED: []
    },
    LISTING_QUALITY: {
        MESSAGE: "",
        RATES_AVAILABILITY: {
            MESSAGE: "",
            PROPERTY_COUNT: 0,
            RECOMMENDED_COUNT: 0,
            SCORE: 0
        },
        PROPERTY_GUIDEBOOK: {
            MESSAGE: "",
            PROPERTY_COUNT: 0,
            RECOMMENDED_COUNT: 0,
            SCORE: 0
        },
        STAR_RATING: 0,
        PHOTOS: {
            MESSAGE: "",
            PROPERTY_COUNT: 0,
            RECOMMENDED_COUNT: 0,
            SCORE: 0
        }
    },
    NAME: "",
    NON_RESIDENT: $7e76d0d187f06940$export$6bcbaf56c80d335,
    OFFERS: {
        IS_NEW_LISTING_OFFER_ENABLED: false,
        IS_NEW_LISTING_OFFER_BLACKOUT_ENABLED: false
    },
    OWNER: {
        ...(0, $de872e06841c454e$export$ff09b90989b21a8)
    },
    PARKING: {
        DESCRIPTION: "",
        HAS_ADDITIONAL_FREE_SPOTS: "",
        HAS_ADDITIONAL_PAID_SPOTS: "",
        INSTRUCTIONS: "",
        IS_DEFAULT_DESCRIPTION: false,
        NUM_SPOTS_PROVIDED: ""
    },
    PARTNERS: [],
    PHOTOS: [],
    POLICIES: {
        ACCOUNT: [],
        GENERAL: [],
        GUEST_STAY: [],
        HOUSE_RULES: [],
        PROPERTY: [],
        RESERVATION: []
    },
    /** Either the owner of the property or the PROPERTY_CONTACT if defined */ PRIMARY_CONTACT: {
        ...(0, $de872e06841c454e$export$ff09b90989b21a8)
    },
    PROPERTY_CONTACT: /** PROPERTY_CONTACT is either sent with info or sent as an empty object
   * The PROPERTY_CONTACT is the rental manager of the property
   * The values are pre-filled so that the rental manager form can use those values  */ $7e76d0d187f06940$var$PROPERTY_CONTACT,
    RATES_SCHEDULE: [],
    RATES_SETTINGS: $7e76d0d187f06940$export$e65672f8de2d64be,
    RESERVATION_SETTINGS: $80436cd706766ba7$export$7158a8c2efc7d19a,
    RULES: $7e76d0d187f06940$export$294ddf93b115efd1,
    SETUP_QUESTIONS: {
        NUM_PROPERTIES: 0,
        PLATFORMS_LISTED: [
            {
                ID: 0,
                URL: ""
            }, 
        ],
        ID: 0
    },
    SIZE_CATEGORY: {
        NAME: "",
        ID: 0
    },
    SQUARE_FEET: "",
    STYLE: {
        NAME: "",
        ID: 0
    },
    SURCHARGES: $7e76d0d187f06940$export$6c09499d8eae7f1b,
    SUBSCRIPTION: {
        COMMISSION_PERCENTAGE: 0,
        CREDIT_CARD_PERCENTAGE: 0,
        DESCRIPTION: "",
        DURATION: "",
        FEE: "",
        GST: "",
        GST_RATE: 0,
        ID: 0,
        NAME: "",
        NUMBER_OF_DAYS: 0,
        RESORT_ID: 0,
        SUBSCRIPTION_TIER_ID: 0
    },
    SUITABILITIES: $7e76d0d187f06940$var$SUITABILITIES,
    TAXES: $7e76d0d187f06940$var$TAXES,
    TAX_NUMBERS: {
        BUSINESS_LICENCE_NUMBER: "",
        GST_NUMBER: "",
        PST_NUMBER: ""
    },
    THUMBNAIL_URL: "",
    URL: "",
    VIDEOS: {
        THREESIXTY: {
            DATA: "",
            ID: 0
        },
        YOUTUBE: []
    },
    WALKTHROUGH: {
        PROPERTY_GUIDEBOOK: $7e76d0d187f06940$var$PROPERTY_GUIDEBOOK_WALKTHROUGH
    }
};
const $7e76d0d187f06940$export$64e4c5bc204b3918 = {
    ARRIVAL: "",
    ARRIVAL_UTC: 0,
    BOOKING_NET: "",
    DEPARTURE: "",
    DEPARTURE_UTC: 0,
    GUEST: {
        EMAIL: "",
        FIRST_NAME: "",
        LAST_NAME: "",
        MEMBER_SINCE: "",
        NAME: "",
        NUM_BOOKINGS: 0,
        NUM_RECOMMENDATIONS: 0,
        NUM_REVIEWS: 0,
        PHONE: "",
        THUMBNAIL: ""
    },
    GUEST_REQUESTS: "",
    HAS_PETS: false,
    ID: 0,
    IS_ALLURA_BOOKING: false,
    NOTES_OWNER: "",
    PAID_TO_DATE: "",
    PARTY_SIZE_ADULTS: 0,
    PARTY_SIZE_KIDS: "",
    PROPERTY: {
        THUMBNAIL_URL: ""
    },
    REFERENCE: "",
    SOURCE: "",
    STATUS: "",
    TITLE: "",
    TYPE: ""
};
const $7e76d0d187f06940$export$39d988428beabf9e = {
    NIGHTS: 0,
    ID: 0,
    RATE: ""
};
const $7e76d0d187f06940$export$7e60fbbaddc2b50e = {
    START: "",
    NAME: "",
    ID: 0,
    COMMENT: "",
    END: "",
    RATES: []
};
const $7e76d0d187f06940$export$f55a6e090601daf0 = {
    IS_BOOKED: false,
    DATE: "",
    DATE_UTC: 0,
    ID: 0,
    TYPE: "",
    SEASON: $7e76d0d187f06940$export$7e60fbbaddc2b50e
};
const $7e76d0d187f06940$export$d2bbe34cae8c0cf7 = {
    ARRIVAL_DATE: "",
    DEPARTURE_DATE: "",
    GUEST_NAME: "",
    GUEST_EMAIL: "",
    GUEST_PHONE: "",
    /** The guest's ID */ ID: 0,
    USER_TYPE_ID: 0,
    REFERENCE: "",
    BOOKING_ID: "",
    BOOKING_STATUS: "",
    CONFIRMED_DATE: ""
};
const $7e76d0d187f06940$export$ce3060be2c5fec9b = {
    HAS_LAST_GUEST: false,
    LAST_GUEST: $7e76d0d187f06940$export$d2bbe34cae8c0cf7,
    HAS_NEXT_GUEST: false,
    NEXT_GUEST: $7e76d0d187f06940$export$d2bbe34cae8c0cf7,
    PROPERTY_ID: ""
};
const $7e76d0d187f06940$export$13cdc582138f1c6d = {
    TRANSFERRED: [
        {
            BANK_ACCOUNT_HOLDER: "",
            BANK_ACCOUNT_NUMBER: "",
            EXPECTED_DEPOSIT_DATE: "",
            TRANSACTION_ID: 0,
            BOOKING_ID: 0,
            REFERENCE: "",
            TRANSFER_DATE: "",
            AMOUNT: 0
        }, 
    ],
    EXPECTED: {
        EXPECTED_PAYOUT: "",
        SUM_IN_TRANSIT: 0
    }
};
const $7e76d0d187f06940$export$1bb2cdf36fcdc8c9 = {
    UNAVAILABILITY_ARRIVAL: [],
    UNAVAILABILITY_DEPARTURE: []
};
const $7e76d0d187f06940$export$5857866d21813cda = {
    ORIGINAL: "",
    CAPTION: "",
    SORT_ORDER: 0,
    THUMB: "",
    FULL: "",
    ID: 0
};
const $7e76d0d187f06940$export$e8c211579d62c131 = {
    DEFAULT_CONTENT: "",
    OTHER_DEFAULTS: [
        ""
    ],
    ID: 0
};
const $7e76d0d187f06940$export$d4e877b8d445a3e1 = {
    SOURCE: "",
    NIGHTS: 0,
    ARRIVAL: "",
    DEPARTURE: "",
    ID: 0,
    SUMMARY: ""
};
const $7e76d0d187f06940$var$REVIEW = {
    ID: 0,
    IS_GUEST_RESPONSE_POSSIBLE: false,
    BOOKING_INFO: {
        RESORT: "",
        PROPERTY_IMAGE: "",
        NIGHTS: 0,
        ARRIVAL: "",
        DEPARTURE: "",
        REFERENCE: "",
        CONFIRMED: "",
        ID: 0,
        DEVELOPMENT: ""
    },
    REVIEW: "",
    STATUS: "",
    STATUS_ID: 0,
    REVIEW_DATE: "",
    GUEST_INFO: {
        MEMBER_SINCE: "",
        COUNTRY: "",
        NUM_BOOKINGS: 0,
        FIRST_NAME: "",
        STATUS: "",
        NUM_HOST_RECOMMENDATIONS: 0,
        LAST_NAME: "",
        ID: 0,
        NUM_RECOMMENDS: 0,
        CITY: "",
        NUM_REVIEWS: 0,
        USER_TYPE_ID: 0,
        THUMBNAIL: ""
    },
    RATINGS: [
        {
            QUESTION: "",
            MAX_SCORE: 0,
            ID: 0,
            TITLE: "",
            SCORE: 0
        }
    ],
    RATINGS_AVERAGE: 0,
    IS_PUBLISHED: false,
    WOULD_RECOMMEND: false,
    PUBLISHED_DATE: "",
    TITLE: "",
    RESPONSES: [
        {
            RESPONSE: "",
            RESPONSE_DATE: "",
            USER_ROLE: "",
            TITLE: ""
        }, 
    ]
};
const $7e76d0d187f06940$export$60faf8ebe46b9581 = {
    PROPERTY_ID: 0,
    AVERAGE_SCORE: 0,
    AVERAGE_SCORES: [
        {
            AVERAGE_SCORE: 0,
            TITLE: ""
        }
    ],
    NUM_REVIEWS: 0,
    REVIEWS: [
        $7e76d0d187f06940$var$REVIEW
    ]
};
const $7e76d0d187f06940$export$498fe3de1de7bf1a = {
    DATE: "",
    LOW: "",
    LOW_MID: "",
    MID: "",
    MID_HIGH: "",
    HIGH: "",
    ID: 0
};
const $7e76d0d187f06940$export$f28016d2cadf8c20 = {
    ID: 0,
    RESORT: "",
    RESORT_ID: 0,
    SIZE_CATEGORY: "",
    SIZE_CATEGORY_ID: 0,
    RATES_SCHEDULE: [
        $7e76d0d187f06940$export$498fe3de1de7bf1a
    ]
};
const $7e76d0d187f06940$export$fade679d0da51bb1 = {
    ID: 0,
    RATES_SCHEDULE: []
};
const $7e76d0d187f06940$export$e0ba6e5e6a1e98b1 = {
    ID: 0,
    RATES_SCHEDULE: []
};



var $e50011cc2264e453$exports = {};

$parcel$export($e50011cc2264e453$exports, "OfferTypeId", () => $e50011cc2264e453$export$2bc4caca4304020f);
$parcel$export($e50011cc2264e453$exports, "OfferAvailabilityId", () => $e50011cc2264e453$export$bad0db35ab88c49e);
$parcel$export($e50011cc2264e453$exports, "OfferDistributionId", () => $e50011cc2264e453$export$49994c1af420aa3);
$parcel$export($e50011cc2264e453$exports, "BookingSourceNameEnum", () => $e50011cc2264e453$export$a7235c2404b3ef3c);
$parcel$export($e50011cc2264e453$exports, "BookingStatusId", () => $e50011cc2264e453$export$27d2d4abb2ec0600);
$parcel$export($e50011cc2264e453$exports, "BookingStatusMessage", () => $e50011cc2264e453$export$acada62635fe78e1);
$parcel$export($e50011cc2264e453$exports, "ReviewStatusId", () => $e50011cc2264e453$export$bd517647869fdc11);
$parcel$export($e50011cc2264e453$exports, "MessageRecipientIdEnum", () => $e50011cc2264e453$export$42063c1720e69a70);
let $e50011cc2264e453$export$2bc4caca4304020f;
(function(OfferTypeId1) {
    OfferTypeId1[OfferTypeId1["PERCENTAGE"] = 1] = "PERCENTAGE";
    OfferTypeId1[OfferTypeId1["DOLLAR"] = 2] = "DOLLAR";
    OfferTypeId1[OfferTypeId1["FREE_NIGHTS"] = 3] = "FREE_NIGHTS";
    OfferTypeId1[OfferTypeId1["GIFT_CERTIFICATE"] = 4] = "GIFT_CERTIFICATE";
})($e50011cc2264e453$export$2bc4caca4304020f || ($e50011cc2264e453$export$2bc4caca4304020f = {}));
let $e50011cc2264e453$export$bad0db35ab88c49e;
(function(OfferAvailabilityId1) {
    OfferAvailabilityId1[OfferAvailabilityId1["AllGuests"] = 1] = "AllGuests";
    OfferAvailabilityId1[OfferAvailabilityId1["RepeatGuests"] = 2] = "RepeatGuests";
    OfferAvailabilityId1[OfferAvailabilityId1["SpecificGuest"] = 3] = "SpecificGuest";
})($e50011cc2264e453$export$bad0db35ab88c49e || ($e50011cc2264e453$export$bad0db35ab88c49e = {}));
let $e50011cc2264e453$export$49994c1af420aa3;
(function(OfferDistributionId1) {
    OfferDistributionId1[OfferDistributionId1["WITHPROPERTYGUIDEBOOK"] = 1] = "WITHPROPERTYGUIDEBOOK";
    OfferDistributionId1[OfferDistributionId1["WHENNONREFUNDABLE"] = 2] = "WHENNONREFUNDABLE";
})($e50011cc2264e453$export$49994c1af420aa3 || ($e50011cc2264e453$export$49994c1af420aa3 = {}));
let $e50011cc2264e453$export$a7235c2404b3ef3c;
(function(BookingSourceNameEnum1) {
    BookingSourceNameEnum1["directVacations"] = "DirectVacations.com";
    BookingSourceNameEnum1["directVacationsLabel"] = "Emails and logos will be sent and branded with DirectVacations.com";
    BookingSourceNameEnum1["alluraDirect"] = "alluraDirect Vacation Rentals";
    BookingSourceNameEnum1["alluraDirectLabel"] = "*Recommended (Trusted Brand) - Emails and logos will be sent and branded with alluraDirect";
})($e50011cc2264e453$export$a7235c2404b3ef3c || ($e50011cc2264e453$export$a7235c2404b3ef3c = {}));
let $e50011cc2264e453$export$27d2d4abb2ec0600;
(function(BookingStatusId1) {
    BookingStatusId1[BookingStatusId1["ReservationRequest"] = 1] = "ReservationRequest";
    BookingStatusId1[BookingStatusId1[/* DepositPaidDue
    DepositDue: guest has not made any payments yet (pending reservation). Occurs:
      1. Gateway closed mode, the owner approves a reservation, guest needs to take action to pay first payment
      2. Owner creates custom discounted price booking for the guest, they need to sign into allura after creation to pay
    PaymentDue: upcoming reservation where
      1. Guest has made no payments or
      2. Guest has made deposit payment (has not payed full amount) or
      3. Guest balance owing is > 0
  */ "DepositPaidDue"] = 2] = "DepositPaidDue";
    BookingStatusId1[BookingStatusId1["BalancePaid"] = 3] = "BalancePaid";
    BookingStatusId1[BookingStatusId1["Cancelled"] = 4] = "Cancelled";
    BookingStatusId1[BookingStatusId1["ReservationRequestDeclined"] = 5] = "ReservationRequestDeclined";
})($e50011cc2264e453$export$27d2d4abb2ec0600 || ($e50011cc2264e453$export$27d2d4abb2ec0600 = {}));
let $e50011cc2264e453$export$acada62635fe78e1;
(function(BookingStatusMessage1) {
    BookingStatusMessage1["ReservationRequested"] = "Reservation Requested";
    BookingStatusMessage1["DepositDue"] = "Deposit Due";
    BookingStatusMessage1["PaymentDue"] = "Payment Due";
    BookingStatusMessage1["Confirmed"] = "Confirmed";
    BookingStatusMessage1["Cancelled"] = "Cancelled";
    BookingStatusMessage1["ReservationDeclined"] = "Reservation Declined";
    BookingStatusMessage1["LatePayment"] = "Late Payment";
    BookingStatusMessage1["Completed"] = "Completed";
    BookingStatusMessage1["UnknownStatusId"] = "Unknown Status";
})($e50011cc2264e453$export$acada62635fe78e1 || ($e50011cc2264e453$export$acada62635fe78e1 = {}));
let $e50011cc2264e453$export$bd517647869fdc11;
(function(ReviewStatusId1) {
    ReviewStatusId1[ReviewStatusId1["ADD_REVIEW"] = 0] = "ADD_REVIEW";
    ReviewStatusId1[ReviewStatusId1["SUBMITTED"] = 1] = "SUBMITTED";
    ReviewStatusId1[ReviewStatusId1["AD_APPROVED"] = 2] = "AD_APPROVED";
    ReviewStatusId1[ReviewStatusId1["AD_REJECTED"] = 3] = "AD_REJECTED";
    ReviewStatusId1[ReviewStatusId1["PUBLISHED"] = 4] = "PUBLISHED";
    ReviewStatusId1[ReviewStatusId1["OWNER_HIDDEN"] = 5] = "OWNER_HIDDEN";
    ReviewStatusId1[ReviewStatusId1["OWNER_DISPUTED"] = 6] = "OWNER_DISPUTED";
})($e50011cc2264e453$export$bd517647869fdc11 || ($e50011cc2264e453$export$bd517647869fdc11 = {}));
let $e50011cc2264e453$export$42063c1720e69a70;
(function(MessageRecipientIdEnum1) {
    MessageRecipientIdEnum1[MessageRecipientIdEnum1["guestToOwner"] = 1] = "guestToOwner";
    MessageRecipientIdEnum1[MessageRecipientIdEnum1["ownerToGuest"] = 2] = "ownerToGuest";
    MessageRecipientIdEnum1[MessageRecipientIdEnum1["guestToAllura"] = 3] = "guestToAllura";
    MessageRecipientIdEnum1[MessageRecipientIdEnum1["ownerToAllura"] = 4] = "ownerToAllura";
    MessageRecipientIdEnum1[MessageRecipientIdEnum1["alluraToOwner"] = 5] = "alluraToOwner";
    MessageRecipientIdEnum1[MessageRecipientIdEnum1["alluraToGuest"] = 6] = "alluraToGuest";
})($e50011cc2264e453$export$42063c1720e69a70 || ($e50011cc2264e453$export$42063c1720e69a70 = {}));




const $4a0160e1e5b24e49$export$b52c96215ed92eba = {
    DATE: "",
    IS_DONE: true,
    LABEL: ""
};
const $4a0160e1e5b24e49$export$90b5cb7a2e4b0584 = {
    RESORT: "",
    NIGHTS: 0,
    ARRIVAL: "",
    DEPARTURE: "",
    DEVELOPMENT: "",
    REFERENCE: "",
    CONFIRMED: "",
    ID: 0,
    PROPERTY_IMAGE: ""
};
const $4a0160e1e5b24e49$var$inquiry = {
    GUEST_ID: 0,
    MESSAGE: "",
    PROPERTY_ID: 0,
    SUBJECT: "",
    TO_EMAILS: "",
    DATE_SENT: "",
    MESSAGE_RECIPIENT_ID: (0, $e50011cc2264e453$export$42063c1720e69a70).guestToOwner,
    FROM_EMAIL: "",
    TIME_SENT: "",
    BOOKING_ID: 0,
    ID: 0,
    INQUIRY_ID: 0
};
const $4a0160e1e5b24e49$export$395f71321ad585e0 = {
    QUESTION: "",
    MAX_SCORE: "",
    ID: 0,
    TITLE: "",
    SCORE: 0
};
const $4a0160e1e5b24e49$export$5368f805f6a71f7d = {
    ID: 0,
    CHECKIN_DATE: "",
    CHECKOUT_DATE: "",
    BOOKING_NUMBER: "",
    HOST_NAME: "",
    HOST_RECOMMENDATION: false,
    HOST_COMMENTS: "",
    HAS_COMMENT_ENABLED: false
};
const $4a0160e1e5b24e49$export$5cc20b5323ee05eb = {
    BOOKING_INFO: $4a0160e1e5b24e49$export$90b5cb7a2e4b0584,
    ID: 0,
    IS_GUEST_RESPONSE_POSSIBLE: false,
    IS_PUBLISHED: false,
    STATUS: "",
    STATUS_ID: 0
};
const $4a0160e1e5b24e49$export$66d28a7d28bf9a8b = Object.freeze({
    ...$4a0160e1e5b24e49$export$5cc20b5323ee05eb,
    PRIVATE_MESSAGE_TO_OWNER: "",
    REVIEW: "",
    GUEST_INFO: {},
    PUBLISHED_DATE: "",
    RATINGS: [],
    RATINGS_AVERAGE: 0,
    RESPONSES: [],
    REVIEW_DATE: "",
    TITLE: "",
    WOULD_RECOMMEND: false
});
const $4a0160e1e5b24e49$var$SURCHARGE = {
    IS_ENABLED: false,
    NAME: "",
    ID: 0,
    AMOUNT: ""
};
const $4a0160e1e5b24e49$var$sparseProperty = {
    RULES: {
        CHECK_IN: "",
        CHECK_OUT: "",
        MAX_GUESTS: "",
        MIN_AGE_TO_BOOK: 0,
        QUIET_TIME: 0
    },
    ADDRESS: {
        UNIT: "",
        RESORT: "",
        DEVELOPMENT: "",
        STREET_NAME: "",
        STREET_NUMBER: ""
    },
    JOIN_STATUS: {
        STATUS_ID: 0
    },
    ID: 0,
    THUMBNAIL_URL: "",
    ACCESS_TO_UNIT: $7e76d0d187f06940$export$2fc451ae562d804e,
    CODES: (0, $7e76d0d187f06940$export$fcb478d7c9a12a2f),
    PRIMARY_CONTACT: {
        COMPANY_NAME: "",
        DESCRIPTION: "",
        EMAIL: "",
        FIRST_NAME: "",
        ID: 0,
        IS_COMPANY: false,
        LAST_NAME: "",
        PHONE: "",
        TYPE: "",
        TYPE_ID: 1,
        THUMBNAIL_URL: ""
    }
};
const $4a0160e1e5b24e49$var$sparseBookingDates = {
    ARRIVAL: "",
    BOOKING: "",
    BOOKING_TIME: "",
    CHECK_IN_SENT: "",
    DEPARTURE: "",
    SERVER_TIMESTAMP: ""
};
const $4a0160e1e5b24e49$var$fullBookingDates = {
    ...$4a0160e1e5b24e49$var$sparseBookingDates,
    NEXT_PAYMENT: "",
    PROPERTY_GUIDEBOOK_SEND: ""
};
const $4a0160e1e5b24e49$export$37743108b2146755 = {
    ...$4a0160e1e5b24e49$var$sparseProperty,
    ADDRESS: (0, $80436cd706766ba7$export$f7d3c097ceca6c15),
    DIRECT_VACATIONS: $80436cd706766ba7$export$82cefcd67fde3934,
    DAMAGE_DEPOSIT: {
        AMOUNT: "",
        DESCRIPTION: "",
        ID: 0,
        IS_COLLECTED: false,
        MODE: ""
    },
    GATEWAY_MODE: {
        ID: 0,
        VALUE: ""
    },
    RULES: (0, $7e76d0d187f06940$export$294ddf93b115efd1),
    IS_ENABLED: false,
    MAX_GUESTS: 0,
    NAME: "",
    SIZE_CATEGORY: "",
    SQUARE_FEET: 0,
    SURCHARGES: {
        PETS: $4a0160e1e5b24e49$var$SURCHARGE,
        CLEANING: $4a0160e1e5b24e49$var$SURCHARGE
    },
    STYLE: "",
    URL: ""
};
const $4a0160e1e5b24e49$var$sparseDamageDeposit = {
    MODE: "",
    MODE_ID: (0, $b9fbf0da9ae592a3$export$3e6477125daf98da).COLLECT_AT_CHECKIN
};
const $4a0160e1e5b24e49$var$fullDamageDeposit = {
    ...$4a0160e1e5b24e49$var$sparseDamageDeposit,
    AMOUNT: "",
    DUE_DATE: "",
    IS_COLLECTED: false
};
const $4a0160e1e5b24e49$var$sparsePayment = {
    AMOUNT_OUTSTANDING: "",
    AMOUNT_REFUNDED: "",
    BALANCE: {
        DUE_DATE: "",
        PAYMENT_DATE: "",
        TOTAL: ""
    },
    BOOKING_NET: "",
    DAMAGE_DEPOSIT: {
        MODE: "",
        MODE_ID: 0
    },
    DEPOSIT: {
        DUE_DATE: "",
        PAYMENT_DATE: "",
        TOTAL: ""
    },
    NEXT_PAYMENT: {
        DUE_DATE: "",
        IS_PAST_DUE: false,
        NAME: "",
        TOTAL: ""
    },
    PAID_TO_DATE: ""
};
const $4a0160e1e5b24e49$export$1751cb5a64e5db9 = {
    ...$4a0160e1e5b24e49$var$sparsePayment,
    DAMAGE_DEPOSIT: $4a0160e1e5b24e49$var$fullDamageDeposit,
    DEPOSIT: {
        AMOUNT: "",
        DUE_DATE: "",
        NET: "",
        PAYMENT_DATE: "",
        PERCENTAGE: 0,
        TOTAL: ""
    },
    BOOKING_NET: "",
    BOOKING_GROSS: "",
    PAID_TO_DATE: "",
    PRICE_PER_NIGHT: "",
    TAXES_AND_FEES_TOTAL: "",
    LOS_DISCOUNT: ""
};
const $4a0160e1e5b24e49$var$sparseFlags = {
    IS_PAST_DUE: false
};
const $4a0160e1e5b24e49$var$fullFlags = {
    ...$4a0160e1e5b24e49$var$sparseFlags,
    IS_ALLURA_BOOKING: false,
    IS_BLOCK_OFF: false,
    IS_DIRECT_VACATIONS: false,
    IS_EDITABLE: false,
    IS_INNTOPIA_BOOKING: false,
    IS_LMVR_PARTNER_BOOKING: false,
    IS_LMVR_PM_BOOKING: false
};
const $4a0160e1e5b24e49$export$71dcb83791b96dd8 = {
    ID: (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue,
    NAME: ""
};
const $4a0160e1e5b24e49$export$ed8e20ee59aa51cd = {
    MESSAGE: "",
    ENTRY_CODE: ""
};
const $4a0160e1e5b24e49$var$PROPERTY_MANAGER_SERVICE_FEE = {
    IS_FEE_ON_SUBTOTAL_TO_OWNER: false,
    NET: "",
    TAXES: [
        (0, $80436cd706766ba7$export$c778997df97e7eb9)
    ],
    TOTAL: ""
};
const $4a0160e1e5b24e49$var$TAX = {
    RATE_TOTAL: 0,
    /** Taxes aplied to the accomodation/booking subtotal (PAYMENT.BOOKING_NET)
   * This can be an empty array due to the rulesets below:
   * 
  # Bookings and Surcharges on Inntopia (Partner Bookings)
  * will have GST applied, if an owner collects GST and has supplied a GST Number
  * if rental in BC, has PST and MRDT applied

  # Bookings on alluraDirect
  * will have GST applied, if an owner collects GST and has supplied a GST Number, and if the booking is under 30 nights, else it is GST exempt and the tax is not applied
  * if rental in BC, has PST and MRDT applied if the booking is under 27 nights, else it is PST/MRDT exempt and those taxes are not applied
  * if rental in PQ, has QST and MTLT applied if owner decides to charge and remit these taxes
   */ BOOKING: [
        (0, $80436cd706766ba7$export$c778997df97e7eb9)
    ],
    BOOKING_AND_FEES: [
        (0, $80436cd706766ba7$export$c778997df97e7eb9)
    ],
    BOOKING_AND_FEES_TOTAL: 0,
    PERCENTAGES: "",
    TOTAL: 0,
    TOTALS: [
        (0, $80436cd706766ba7$export$c778997df97e7eb9)
    ],
    WITHHELD: {
        GST: "",
        PST: "",
        MRDT: ""
    }
};
const $4a0160e1e5b24e49$var$sparsePartySize = {
    ADULTS: 0,
    KIDS: 0
};
const $4a0160e1e5b24e49$var$fullPartySize = {
    ...$4a0160e1e5b24e49$var$sparsePartySize,
    MAX: 0
};
const $4a0160e1e5b24e49$export$1bfde61c4816a533 = {
    CUSTOM_MESSAGE: $4a0160e1e5b24e49$export$ed8e20ee59aa51cd,
    DATES: $4a0160e1e5b24e49$var$sparseBookingDates,
    FLAGS: $4a0160e1e5b24e49$var$sparseFlags,
    GUEST: {
        AGE: "",
        EMAIL: "",
        FIRST_NAME: "",
        GUEST_PROFILE: $de872e06841c454e$export$b27d988044282929,
        ID: -1,
        IS_AGE_VERIFIED: false,
        IS_EMAIL_VERIFIED: false,
        IS_SMS_VERIFIED: false,
        LAST_NAME: "",
        PHONE: "",
        THUMBNAIL: ""
    },
    GUEST_COMMENT: "",
    GUEST_REQUESTS: "",
    ID: 0,
    NIGHTS: 0,
    NIGHTLY_RATES: [
        {
            DATE: "",
            DAY: "",
            RATE: "",
            BASE_RATE: "",
            LOS_DISCOUNT: "",
            OFFER_DISCOUNT: ""
        }, 
    ],
    NOTES_OWNER: "",
    PARTY_SIZE: $4a0160e1e5b24e49$var$sparsePartySize,
    PAYMENT: $4a0160e1e5b24e49$var$sparsePayment,
    PAYMENT_INFORMATION: {
        ACCOMMODATION_SUBTOTAL: "",
        ALLURA_OFFER_DISCOUNT: "",
        BOOKING_NET_BASE_RATE: "",
        BOOKING_NET_BASE_RATE_MINUS_LOS: "",
        LENGTH_OF_STAY_DISCOUNT: "",
        OWNER_OFFER_DISCOUNT: ""
    },
    PROPERTY: $4a0160e1e5b24e49$var$sparseProperty,
    REFERENCE: "",
    REVIEW: {
        ID: 0
    },
    SOURCE: "",
    STATUS: $4a0160e1e5b24e49$export$71dcb83791b96dd8,
    STATUSES: [
        $4a0160e1e5b24e49$export$b52c96215ed92eba
    ],
    SURCHARGES: {
        NET: "",
        TAXES_TOTAL: ""
    },
    TAX: {
        TOTAL: ""
    },
    TOTAL: ""
};
const $4a0160e1e5b24e49$export$96c2251bdcddf5c0 = {
    ...$4a0160e1e5b24e49$export$1bfde61c4816a533,
    /** Total credit card processing fee on this booking.
   *  Deducted from net amount owner recieves for a booking
   *  Calculated from (accomodation + surcharges) x 0.3 = CREDIT_CARD_FEE
   */ COMMISSION: "",
    CREDIT_CARD_FEE: "",
    /** Percentage fee deducted from the accomodation + surcharges total  */ CREDIT_CARD_PERCENTAGE: 0,
    /** The total amount that the owner will receive for this booking after all other deductions and additions */ BANK_DEPOSIT: {
        AMOUNT: "",
        DATE: "",
        ACCOUNT: ""
    },
    BLOCK_OFF_REASON: "",
    CONTACT_TRACING: [
        (0, $80436cd706766ba7$export$f3e08cf4c2119893)
    ],
    DATES: $4a0160e1e5b24e49$var$fullBookingDates,
    FLAGS: $4a0160e1e5b24e49$var$fullFlags,
    GUEST: {
        ...(0, $de872e06841c454e$export$ff09b90989b21a8)
    },
    GUEST_COMMENT: "",
    INQUIRIES: [],
    NR6_PERCENTAGE: "",
    NR6_WITHHELD: "",
    PARTNER: {
        INFLATION_TOTAL: 0
    },
    PARTY_SIZE: $4a0160e1e5b24e49$var$fullPartySize,
    PAYMENT: $4a0160e1e5b24e49$export$1751cb5a64e5db9,
    PROPERTY: $4a0160e1e5b24e49$export$37743108b2146755,
    PROPERTY_GUIDEBOOK_SEND_DATE: "",
    PROPERTY_MANAGER_SERVICE_FEE: $4a0160e1e5b24e49$var$PROPERTY_MANAGER_SERVICE_FEE,
    PROPERTY_OWNER: (0, $80436cd706766ba7$export$bd9a90e1c91075e7),
    REVIEW: $4a0160e1e5b24e49$export$66d28a7d28bf9a8b,
    SERVICE_FEE: (0, $80436cd706766ba7$export$57f3f1ee6c8aba33),
    SURCHARGES: (0, $80436cd706766ba7$export$b7ebbc687a55d27),
    TAX: /** Taxes applied to the accommodation subtotal */ $4a0160e1e5b24e49$var$TAX,
    THUMBNAIL_URL: "",
    TOTALS_PAID: (0, $80436cd706766ba7$export$23542f496ff490c6),
    TRANSACTIONS: [
        (0, $80436cd706766ba7$export$2d62d2646dd2fb3c)
    ],
    TIMELINE: [
        {
            DATE: "",
            TITLE: "",
            IS_COMPLETED: false
        }, 
    ]
};
const $4a0160e1e5b24e49$export$a6493835bca0af56 = {
    FEE: "",
    ID: 0,
    NAME: "",
    TAX: "",
    Taxes: (0, $80436cd706766ba7$export$b3d999cb855c93d9)
};
const $4a0160e1e5b24e49$export$34792c472deb2d73 = {
    TAXES_TOTAL: 0,
    LIST: [],
    NET: "",
    GROSS: "",
    TAXES_TOTALS: ""
};
const $4a0160e1e5b24e49$export$632feb45bf00dce4 = {
    ...(0, $80436cd706766ba7$export$384165d01427152e),
    RATE: 0,
    IS_PASS_THROUGH_TO_OWNER: false
};
const $4a0160e1e5b24e49$export$e06f6fbc328d469c = {
    IS_EXISTING_GUEST: false
};




var $01815dc19ee3b0a7$exports = {};

$parcel$export($01815dc19ee3b0a7$exports, "CREDITS_OVERVIEW", () => $01815dc19ee3b0a7$export$54441444cb96776e);
const $01815dc19ee3b0a7$export$54441444cb96776e = {
    total_credits: "0.00",
    pending_credits: "0.00",
    remaining_credits: "0.00",
    credit_expiry_date: "yyyy-mm-dd",
    refer_guest_link: "https://staging.alluradirect.com/refer/guest/0/",
    refer_owner_link: "https://staging.alluradirect.com/refer/owner/0/",
    offer_amounts: {
        user_referred_owner: "0.00",
        user_referred_guest: "0.00",
        guest_referred_by_user: "0.00",
        owner_referred_by_user: "0.00"
    },
    credit_history: [
        {
            id: 0,
            amount_total: "0.00",
            amount_remaining: "0.00",
            sender: {
                id: 0,
                first_name: "",
                last_name: "",
                company_name: "",
                is_company: false,
                email: ""
            },
            status: {
                status: "",
                id: 0
            },
            reason_given: {
                reason: "",
                id: 0
            },
            detail: "",
            expiry_date: "yyyy-mm-dd",
            created_at: "yyyy-mm-dd"
        }, 
    ]
};



var $0e53b679feffeec8$exports = {};

$parcel$export($0e53b679feffeec8$exports, "CreditStatusEnum", () => $0e53b679feffeec8$export$e9e4aa04377fbbf1);
$parcel$export($0e53b679feffeec8$exports, "CreditReasonGivenEnum", () => $0e53b679feffeec8$export$d7a7ebf0e2733568);
let $0e53b679feffeec8$export$e9e4aa04377fbbf1;
(function(CreditStatusEnum1) {
    CreditStatusEnum1[CreditStatusEnum1["PENDING"] = 1] = "PENDING";
    CreditStatusEnum1[CreditStatusEnum1["APPROVED"] = 2] = "APPROVED";
    CreditStatusEnum1[CreditStatusEnum1["CANCELLED"] = 3] = "CANCELLED";
    CreditStatusEnum1[CreditStatusEnum1["SPENT"] = 4] = "SPENT";
})($0e53b679feffeec8$export$e9e4aa04377fbbf1 || ($0e53b679feffeec8$export$e9e4aa04377fbbf1 = {}));
let $0e53b679feffeec8$export$d7a7ebf0e2733568;
(function(CreditReasonGivenEnum1) {
    CreditReasonGivenEnum1[CreditReasonGivenEnum1["OWNER_RECOMMENDATION"] = 1] = "OWNER_RECOMMENDATION";
    CreditReasonGivenEnum1[CreditReasonGivenEnum1["GUEST_RECOMMENDATION"] = 2] = "GUEST_RECOMMENDATION";
    CreditReasonGivenEnum1[CreditReasonGivenEnum1["ALLURA_CREDIT"] = 3] = "ALLURA_CREDIT";
})($0e53b679feffeec8$export$d7a7ebf0e2733568 || ($0e53b679feffeec8$export$d7a7ebf0e2733568 = {}));


var $750a22b60b746a86$exports = {};

$parcel$export($750a22b60b746a86$exports, "GUEST_FORM_INPUTS", () => $750a22b60b746a86$export$7c0e341011592005);
$parcel$export($750a22b60b746a86$exports, "GUEST_RATING_QUESTION", () => $750a22b60b746a86$export$5fb665406055d82b);
$parcel$export($750a22b60b746a86$exports, "GUEST_REVIEWS", () => $750a22b60b746a86$export$9ee85ba694a91cb5);
$parcel$export($750a22b60b746a86$exports, "GUEST_RECOMMENDATION", () => $750a22b60b746a86$export$a961b100975d0b71);
$parcel$export($750a22b60b746a86$exports, "GUEST_PAYMENT", () => $750a22b60b746a86$export$eddf2c9e9b100d8d);
$parcel$export($750a22b60b746a86$exports, "GUEST_PAYMENT_INFORMATION", () => $750a22b60b746a86$export$cd79cd058442eeaf);
$parcel$export($750a22b60b746a86$exports, "subSection", () => $750a22b60b746a86$export$7aaed169f2f99da);
$parcel$export($750a22b60b746a86$exports, "propertyGuidebook", () => $750a22b60b746a86$export$4b34da448591ba35);
$parcel$export($750a22b60b746a86$exports, "B64_PROPERTY_GUIDEBOOK", () => $750a22b60b746a86$export$4c815afaf397610);




const $750a22b60b746a86$export$7c0e341011592005 = {
    GUEST_ID: 0,
    REVIEW: {
        RATINGS: [],
        RESPONSES: {
            GUEST_MAXIMUM_NUMBER: 0,
            OWNER_MAXIMUM_NUMBER: 0
        },
        STATUSES: []
    }
};
const $750a22b60b746a86$export$5fb665406055d82b = {
    QUESTION: "",
    MAX_SCORE: 0,
    ID: 0,
    TITLE: "",
    SCORE: 0,
    SORT_ORDER: 0
};
const $750a22b60b746a86$export$9ee85ba694a91cb5 = {
    REVIEWS: [],
    RECOMMENDATIONS: []
};
const $750a22b60b746a86$export$a961b100975d0b71 = {
    ARRIVAL: "",
    COMMENTS: "",
    CONFIRMED: "",
    DEPARTURE: "",
    HAS_COMMENTS_ENABLED: false,
    HOST_NAME: "",
    ID: 0,
    IS_RECOMMENDED: false,
    REFERENCE: "",
    BOOKING_ID: 0
};
const $750a22b60b746a86$export$eddf2c9e9b100d8d = {
    ID: 0,
    BOOKING_ID: 0,
    BOOKING: {},
    BOOKING_TYPE: "",
    PAYMENT_RECEIPT: ""
};
const $750a22b60b746a86$export$cd79cd058442eeaf = {
    ID: 0,
    PAYMENT_DUE: {
        BOOKING: {
            AMOUNT_DUE: 0,
            ARRIVAL: "",
            BOOKING_NET: 0,
            BOOKING_TOTAL: 0,
            DAMAGE_DEPOSIT: 0,
            DEPARTURE: "",
            ID: 0,
            NIGHTLY_RATE: 0,
            NIGHTS: 0,
            PAID_TO_DATE: 0,
            PARTY_SIZE: 0,
            TAXES_AND_FEES_TOTAL: 0
        },
        FEES: [],
        TAXES: []
    }
};
const $750a22b60b746a86$export$7aaed169f2f99da = {
    ID: -1,
    HTML: [
        ""
    ],
    DETAILS: [
        {
            NAME: "STRING",
            VALUE: "STRING"
        }
    ]
};
const $750a22b60b746a86$var$generalSubSection = {
    DATA: $750a22b60b746a86$export$7aaed169f2f99da,
    ICON: "",
    DESCRIPTION: "",
    TITLE: ""
};
const $750a22b60b746a86$var$amenitiesSubSection = {
    DATA: [
        (0, $80436cd706766ba7$export$719efbeb97b07aa7)
    ],
    ICON: "",
    DESCRIPTION: "",
    TITLE: ""
};
const $750a22b60b746a86$var$privateBuildingSubSection = {
    DATA: {
        PRIVATE: (0, $80436cd706766ba7$export$719efbeb97b07aa7),
        BUILDING: (0, $80436cd706766ba7$export$719efbeb97b07aa7)
    },
    ICON: "",
    DESCRIPTION: "",
    TITLE: ""
};
const $750a22b60b746a86$var$htmlSubSection = {
    DATA: [
        ""
    ],
    ICON: "",
    DESCRIPTION: "",
    TITLE: ""
};
const $750a22b60b746a86$export$4b34da448591ba35 = Object.freeze({
    PROPERTY_GUIDEBOOK: {
        BOOKING: {
            CUSTOM_MESSAGE: $4a0160e1e5b24e49$export$ed8e20ee59aa51cd,
            STATUS: (0, $4a0160e1e5b24e49$export$71dcb83791b96dd8)
        },
        PROPERTY: {
            ID: 0,
            IS_SKI_IN_SKI_OUT: false,
            THUMBNAIL: "",
            IS_COMPANY: "",
            ARRIVAL: "",
            DEPARTURE: "",
            CHECK_IN_TIME: "",
            CHECK_OUT_TIME: "",
            QUIET_TIME: "",
            BATHROOMS: [],
            BEDROOMS: [],
            LOGO: "",
            COVER_PHOTO: "",
            LISTING_PAGE: "",
            ACCESS_TO_UNIT: $7e76d0d187f06940$export$2fc451ae562d804e,
            ADDRESS: (0, $80436cd706766ba7$export$f7d3c097ceca6c15),
            OWNER: {
                ...(0, $de872e06841c454e$export$ff09b90989b21a8)
            },
            CODES: (0, $7e76d0d187f06940$export$fcb478d7c9a12a2f),
            EMERGENCY_CONTACTS: {
                DESCRIPTION: "",
                CONTACTS: {
                    OTHERS: [],
                    PRIMARY: {}
                }
            },
            PHOTOS: [],
            PRIMARY_CONTACT: {
                ...(0, $de872e06841c454e$export$ff09b90989b21a8)
            }
        },
        SECTIONS: {
            WELCOME: {
                DESCRIPTION_PER_GUEST: "",
                TITLE: "",
                DESCRIPTION_PER_PROPERTY: ""
            },
            ARRIVAL: {
                ACCESS_DETAILS: $750a22b60b746a86$var$generalSubSection,
                DIRECTIONS_TO_PROPERTY: $750a22b60b746a86$var$generalSubSection,
                PARKING: $750a22b60b746a86$var$generalSubSection,
                CHECK_IN_PROCESS: $750a22b60b746a86$var$generalSubSection
            },
            DEPARTURE: {
                CHECK_OUT_PROCESS: $750a22b60b746a86$var$generalSubSection,
                GARBAGE_REMOVAL: $750a22b60b746a86$var$generalSubSection
            },
            PROPERTY_AMENITIES: {
                PRIVATE: $750a22b60b746a86$var$amenitiesSubSection,
                ESSENTIALS: $750a22b60b746a86$var$amenitiesSubSection,
                KITCHEN: $750a22b60b746a86$var$amenitiesSubSection,
                SAFETY: $750a22b60b746a86$var$amenitiesSubSection,
                HEATING_INSTRUCTIONS: $750a22b60b746a86$var$htmlSubSection,
                LINENS_TOWELS: $750a22b60b746a86$var$htmlSubSection
            },
            BUILDING_FACILITIES: {
                ABOUT_BUILDING: $750a22b60b746a86$var$generalSubSection,
                FRONT_DESK: $750a22b60b746a86$var$generalSubSection,
                BUILDING_AMENITIES: $750a22b60b746a86$var$amenitiesSubSection
            },
            EQUIPMENT_STORAGE: {
                SKI_STORAGE: $750a22b60b746a86$var$privateBuildingSubSection,
                BIKE_STORAGE: $750a22b60b746a86$var$privateBuildingSubSection
            },
            GETTING_AROUND: {
                SKI_IN_OUT: $750a22b60b746a86$var$generalSubSection,
                DIRECTIONS_TO_LIFTS: $750a22b60b746a86$var$generalSubSection,
                GETTING_AROUND: $750a22b60b746a86$var$generalSubSection
            },
            RECOMMENDATIONS: {
                WHAT_TO_BRING: $750a22b60b746a86$var$generalSubSection,
                RESTAURANTS: $750a22b60b746a86$var$generalSubSection
            },
            SERVICES_OTHER: {
                AVAILABLE_SERVICES: $750a22b60b746a86$var$generalSubSection,
                HOUSEKEEPING: $750a22b60b746a86$var$generalSubSection,
                OTHER: $750a22b60b746a86$var$generalSubSection
            }
        }
    },
    BOOKING_ID: 0,
    ID: 0
});
const $750a22b60b746a86$export$4c815afaf397610 = {
    PROPERTY_GUIDEBOOK_PDF: ""
};



var $2cb2f9f81b60bd28$exports = {};

$parcel$export($2cb2f9f81b60bd28$exports, "GuestBookingType", () => $2cb2f9f81b60bd28$export$1dfe3596f01a6818);
let $2cb2f9f81b60bd28$export$1dfe3596f01a6818;
(function(GuestBookingType1) {
    GuestBookingType1["SPARSE"] = "sparse";
    GuestBookingType1["FULL"] = "full";
})($2cb2f9f81b60bd28$export$1dfe3596f01a6818 || ($2cb2f9f81b60bd28$export$1dfe3596f01a6818 = {}));


var $a0dadd11ddbce2fa$exports = {};

$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_PROPERTY", () => $a0dadd11ddbce2fa$export$5a4d64e2180a6290);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_MEMBERSHIP_RENEWAL_INFO", () => $a0dadd11ddbce2fa$export$9dc3be2508590a3f);
$parcel$export($a0dadd11ddbce2fa$exports, "FINANCES_SUMMARY", () => $a0dadd11ddbce2fa$export$f6fdede527e71805);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_FINANCES_SUMMARY", () => $a0dadd11ddbce2fa$export$3a455dba4bacf2b3);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_FINANCES_TRANSACTION", () => $a0dadd11ddbce2fa$export$2f94c4bfe0d2a50b);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_FINANCES_TRANSACTIONS", () => $a0dadd11ddbce2fa$export$ea2a6ae4406bcf0f);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_FINANCES_RESERVATIONS_COLUMN", () => $a0dadd11ddbce2fa$export$ca481cf93f0d7b92);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_FINANCES_RESERVATIONS_TRANSACTION", () => $a0dadd11ddbce2fa$export$8a15c95a839b21c9);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_FINANCES_RESERVATIONS", () => $a0dadd11ddbce2fa$export$629a0b7af9255c29);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_MINIMAL_PROPERTY", () => $a0dadd11ddbce2fa$export$8496c5f968947514);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_EXTERNAL_EVENTS", () => $a0dadd11ddbce2fa$export$fcdc7aa9f5d55a0b);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_BLOCKED_DATE", () => $a0dadd11ddbce2fa$export$46a4f4f4150f5ae8);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_MIN_NIGHT_GAP", () => $a0dadd11ddbce2fa$export$a1e9de10f2223e1);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_UNBOOKABLE_DATES", () => $a0dadd11ddbce2fa$export$b1b2a7738ba72081);
$parcel$export($a0dadd11ddbce2fa$exports, "OWNER_MOBILE_WALKTHROUGH", () => $a0dadd11ddbce2fa$export$fe3883e595a80bf3);

var $ed812675660d38b0$exports = {};

$parcel$export($ed812675660d38b0$exports, "MobileWalkThroughNameEnum", () => $ed812675660d38b0$export$a51e0bba10c55da3);
let $ed812675660d38b0$export$a51e0bba10c55da3;
(function(MobileWalkThroughNameEnum1) {
    MobileWalkThroughNameEnum1[/** The user has viewed the download link */ "download"] = "DownloadApp";
    MobileWalkThroughNameEnum1[/** The user has viewed the mobile app introduction app */ "introduction"] = "Introduction";
    MobileWalkThroughNameEnum1[/** The user has installed the mobile app and entered the confirmation code */ "installation"] = "InstallationConfirmation";
})($ed812675660d38b0$export$a51e0bba10c55da3 || ($ed812675660d38b0$export$a51e0bba10c55da3 = {}));




const $a0dadd11ddbce2fa$export$5a4d64e2180a6290 = {
    ACTIVE_SINCE: "",
    ADDRESS: (0, $80436cd706766ba7$export$f7d3c097ceca6c15),
    CAN_RENEW: true,
    COMPLETION_PERCENTAGE: 0,
    DAYS_TO_EXPIRY: 0,
    DAMAGE_DEPOSIT_MODE_ID: 0,
    EXPIRY_DATE: "",
    HAS_COMPLETED_ONBOARDING: false,
    HAS_LEGACY_ADMIN_ACCESS: false,
    HAS_SUBSCRIPTION_RECEIPT: false,
    ID: 0,
    IS_ENABLED: true,
    JOIN_STATUS: "",
    JOIN_STATUS_ID: 0,
    NAME: "",
    NUM_BATHROOMS: 0,
    NUM_BEDROOMS: 0,
    SIZE_CATEGORY: "",
    THUMBNAIL: "",
    SUBSCRIPTION_TIER: {
        NAME: "",
        ID: 0,
        DESCRIPTION: ""
    },
    LISTING_QUALITY: {
        MESSAGE: "",
        STAR_RATING: 0
    },
    SURCHARGES: [],
    RESERVATION_SETTINGS: $80436cd706766ba7$export$7158a8c2efc7d19a
};
const $a0dadd11ddbce2fa$export$9dc3be2508590a3f = {
    IS_ACTIVATION: false,
    IS_ALLURA_ADMIN: false,
    RENEWAL_TYPE: "",
    OWNER: {
        ...(0, $de872e06841c454e$export$ff09b90989b21a8)
    },
    OWNER_ID: "",
    PROPERTY_ID: "",
    PROPERTY_NAME: "",
    RENEWAL_DURATION: "",
    RENEWAL_EXPIRY_DATE: "",
    RENEWAL_FEES: {},
    RENEWAL_PAYMENT_OPTIONS: [],
    STRIPE_PUBLISHABLE_KEY: "",
    STRIPE_CUSTOMER: {},
    SUBSCRIPTION_TIERS: [],
    RENEWAL_PAYMENT_TYPE: ""
};
const $a0dadd11ddbce2fa$var$FINANCES_SUMMARY_SECTION = {
    NON_RESIDENT_WITHHELD: "",
    TAXES: [
        {
            OWNER_REMIT_AMOUNT: "",
            NAME: "",
            ID: 0,
            AMOUNT: ""
        }, 
    ],
    CREDIT_CARD_FEES: "",
    COMMISSION: "",
    RESERVATIONS_COUNT: 0,
    SURCHARGES_AMOUNT: "",
    RESERVATIONS_AMOUNT: ""
};
const $a0dadd11ddbce2fa$export$f6fdede527e71805 = {
    PROPERTY_ID: 0,
    PROPERTY_ADDRESS: "",
    PROPERTY_THUMBNAIL_URL: "",
    UPCOMING: $a0dadd11ddbce2fa$var$FINANCES_SUMMARY_SECTION,
    TOTAL: $a0dadd11ddbce2fa$var$FINANCES_SUMMARY_SECTION,
    PAID: $a0dadd11ddbce2fa$var$FINANCES_SUMMARY_SECTION
};
const $a0dadd11ddbce2fa$export$3a455dba4bacf2b3 = {
    OWNER_ID: 0,
    PROPERTIES: [
        $a0dadd11ddbce2fa$export$f6fdede527e71805
    ],
    GROSS_VALUES: {
        UPCOMING: "",
        TOTAL: "",
        PAID: ""
    }
};
const $a0dadd11ddbce2fa$export$2f94c4bfe0d2a50b = {
    BOOKING_DATES: "",
    BOOKING_ID: 0,
    BOOKING_REFERENCE: "",
    DETAIL_ID: 0,
    GUEST_NAME: "",
    PROPERTY_ID: 0,
    TRANSFER_AMOUNT: "",
    TRANSFER_DATE: "",
    TRANSFER_DETAILS: ""
};
const $a0dadd11ddbce2fa$export$ea2a6ae4406bcf0f = {
    OWNER_ID: 0,
    TRANSACTIONS: [
        $a0dadd11ddbce2fa$export$2f94c4bfe0d2a50b
    ]
};
const $a0dadd11ddbce2fa$export$ca481cf93f0d7b92 = {
    NAME: "",
    KEY: ""
};
const $a0dadd11ddbce2fa$export$8a15c95a839b21c9 = {
    arrival_date: "",
    bank_deposit: "0",
    booking_id: 0,
    booking_ref: "",
    booking_status: "",
    commission_gst: "",
    commission_net: "",
    credit_card_fee: "0",
    damage_deposit: "",
    gst: "",
    guest_name: "",
    mrdt: "",
    non_resident_withheld: "",
    number_of_nights: 0,
    payment_category: "",
    property_id: 0,
    property_manager_service_fee: "",
    property_manager_service_fee_tax: "",
    pst: "",
    qst: "",
    service_fee_total: "",
    surcharge_gst: "",
    surcharge_mrdt: "",
    surcharge_net: "",
    surcharge_pst: "",
    surcharge_qst: "",
    transaction_amount: "",
    transaction_date: "",
    transaction_id: 0,
    transfer_date: ""
};
const $a0dadd11ddbce2fa$export$629a0b7af9255c29 = {
    PROPERTY_ID: "",
    OWNER_ID: 0,
    COLUMNS: [
        $a0dadd11ddbce2fa$export$ca481cf93f0d7b92
    ],
    TRANSACTIONS: [
        $a0dadd11ddbce2fa$export$8a15c95a839b21c9
    ]
};
const $a0dadd11ddbce2fa$export$8496c5f968947514 = {
    ID: 0,
    TITLE: "",
    THUMBNAIL: ""
};
const $a0dadd11ddbce2fa$export$fcdc7aa9f5d55a0b = {
    PROPERTIES: [
        {
            PROPERTY: $a0dadd11ddbce2fa$export$8496c5f968947514,
            EXTERNAL_BOOKINGS: [
                (0, $7e76d0d187f06940$export$d4e877b8d445a3e1)
            ]
        }, 
    ],
    OWNER_ID: ""
};
const $a0dadd11ddbce2fa$export$46a4f4f4150f5ae8 = {
    ARRIVAL: "",
    DEPARTURE: "",
    BOOKING_ID: 0,
    TITLE: "",
    DESCRIPTION: ""
};
const $a0dadd11ddbce2fa$export$a1e9de10f2223e1 = {
    PROPERTY_ID: 0,
    START: "",
    MIN_NIGHTS: 0,
    AVAILABLE_NIGHTS: 0,
    END: ""
};
const $a0dadd11ddbce2fa$export$b1b2a7738ba72081 = {
    OWNER_ID: "",
    PROPERTIES: [
        {
            PROPERTY: $a0dadd11ddbce2fa$export$8496c5f968947514,
            BLOCKED_DATES: [
                $a0dadd11ddbce2fa$export$46a4f4f4150f5ae8
            ],
            MIN_NIGHT_GAPS: [
                $a0dadd11ddbce2fa$export$a1e9de10f2223e1
            ],
            LAST_AVAILABLE_DATE: ""
        }, 
    ]
};
const $a0dadd11ddbce2fa$export$fe3883e595a80bf3 = {
    WALKTHROUGH_MOBILE: {
        COMPLETED_STEPS: [],
        COMPLETION_PERCENTAGE: 0,
        NUM_STEPS: 0,
        STEPS: [
            (0, $ed812675660d38b0$export$a51e0bba10c55da3).download,
            (0, $ed812675660d38b0$export$a51e0bba10c55da3).introduction,
            (0, $ed812675660d38b0$export$a51e0bba10c55da3).installation, 
        ]
    }
};




var $15a2617ecf5a74eb$exports = {};

$parcel$export($15a2617ecf5a74eb$exports, "initialFormInputs", () => $15a2617ecf5a74eb$export$35a3cbb56db24637);
const $15a2617ecf5a74eb$var$TAX = {
    REGION_NAME: "",
    IS_MANDATORY: false,
    IS_REGISTRATION_NUMBER_REQUIRED: false,
    NAME: "",
    ID: 0,
    RESORT_NAME: "",
    RATE: 0,
    COUNTRY_NAME: "",
    DESCRIPTION: ""
};
const $15a2617ecf5a74eb$export$35a3cbb56db24637 = {
    ACCESS_TO_UNIT: {
        TYPES: [
            {
                NAME: "",
                ID: 0
            }, 
        ],
        METHODS: [
            {
                NAME: "",
                ID: 0
            }, 
        ],
        CODES: [
            {
                NAME: "",
                ID: 0
            }, 
        ]
    },
    ADVANCED_BOOKING: [],
    AMENITIES: {
        BATHROOM: {
            CATEGORY: "",
            LIST: [],
            TITLE: ""
        },
        BUILDING: {
            CATEGORY: "",
            LIST: [],
            TITLE: ""
        },
        ESSENTIAL: {
            CATEGORY: "",
            LIST: [],
            TITLE: ""
        },
        KITCHEN: {
            CATEGORY: "",
            LIST: [],
            TITLE: ""
        },
        LAUNDRY: {
            CATEGORY: "",
            LIST: [],
            TITLE: ""
        },
        PRIVATE: {
            CATEGORY: "",
            LIST: [],
            TITLE: ""
        },
        SAFETY: {
            CATEGORY: "",
            LIST: [],
            TITLE: ""
        }
    },
    AMENITY_CATEGORIES: {
        BATHROOM: [],
        BUILDING: [],
        ESSENTIAL: [],
        KITCHEN: [],
        PRIVATE: [],
        SAFETY: []
    },
    BEDROOM_TYPES: [
        {
            SORT_ORDER: 0,
            NAME: "",
            ID: 0,
            DESCRIPTION: "",
            IS_BEDROOM: ""
        }
    ],
    BED_TYPES: [],
    CONTACT_EMAIL_NOTIFICATION_TYPES: [],
    DAMAGE_DEPOSIT_MODES: [],
    DEFAULT_CHANNELS: [],
    EMERGENCY_CONTACT_TYPES: [],
    JOIN_STATUSES: [],
    MILESTONE_MESSAGES: {},
    NON_RESIDENT: {
        MIN_OWNERS: 0,
        MAX_OWNERS: 0
    },
    PARTNERS: {},
    CLEANING_PROTOCOL_URL: "",
    PHOTO_VALIDATION: {
        MAX_SIZE_MB: 0,
        MIN_HEIGHT_PIXELS: 0,
        ACCEPTED_FILE_FORMATS: "",
        ACCEPTED_FILE_FORMATS_EXTENSION: "",
        ACCEPTED_MIME_FORMATS: "",
        LOGO_MAX_SIZE_KB: 0,
        LOGO_MAX_SIZE_MB: 0,
        MAX_NUMBER_PHOTOS: 0,
        MAX_SIZE_BYTES: 0,
        MIN_NUMBER_PHOTOS: 0
    },
    POLICIES: {
        ACCOUNT: [],
        CANCELLATION: [],
        GENERAL: [],
        GUEST_STAY: [],
        RESERVATION: []
    },
    POLICIES_CANCELLATION: [],
    POLICIES_CANCELLATION_SPECIAL: [],
    POLICIES_MANDATORY: [],
    PROPERTY_CATEGORIES: [],
    PROPERTY_MANAGERS: [],
    PROPERTY_STYLES: [],
    RATES_SETTINGS: {
        RATE_GROUP_ITEMS: [],
        AVAILABILITY_WINDOW: [],
        PROPERTY_SETTINGS: [],
        RATE_GROUP_TYPES: [],
        WEEKEND_PREMIUMS: [],
        LAST_ALLURA_EVENT: "",
        EXTEND_RATES_SCHEDULE_MONTHS: [],
        REPLACE_RATES_SCHEDULE_MONTHS: [],
        RATE_INSIGHTS: [
            {
                ID: 0,
                NAME: ""
            }
        ]
    },
    RATES_SETTINGS_SUGGESTIONS: {
        DISCOUNT_GROUP: {
            FIVE_NIGHTS: 0,
            ID: 0,
            SEVEN_NIGHTS: 0,
            TEN_NIGHTS: 0
        },
        WEEKEND_PREMIUM_SUGGESTION: {
            PERCENTAGE_AMOUNT: 0,
            DOLLAR_AMOUNT: 0,
            ID: 0
        },
        LAST_DAY_OF_SUGGESTIONS: "",
        RATE_INSIGHTS_LEVEL_ID: 0
    },
    RATES_SUGGESTIONS: [],
    RESERVATION_SETTINGS: {
        DEPOSIT_PERCENTAGES: [],
        BALANCE_DUE_DATES: [],
        BOOKING_GATEWAY_MODES: []
    },
    REST_API_SEARCH_MIN_DATE: "",
    SUBSCRIPTION_TIERS: [],
    SETUP_QUESTIONS: {
        MOST_IMPORTANT: [],
        PLATFORMS: []
    },
    SUBFORMS_OPTIONAL: [],
    SUBFORMS: {
        OPTIONAL: [],
        REQUIRED: []
    },
    SUITABILITIES: [],
    SURCHARGES: [],
    TAXES: [],
    TAX_NUMBERS: [],
    EXTERNAL_CHANNELS: [],
    SEARCH_FILTERS: {
        SOURCE: [],
        FILTER_BY: [],
        STATUS: []
    },
    UNBOOKABLE_NIGHTS_DATE_RANGE: [
        {
            VALUE: 0,
            LABEL: ""
        }
    ]
};






var $f4b19c2cf783eed0$exports = {};

$parcel$export($f4b19c2cf783eed0$exports, "generatePropertyTransactionsParameters", () => $f4b19c2cf783eed0$export$8ca6c3dfab1d4e7f);
const $f4b19c2cf783eed0$export$8ca6c3dfab1d4e7f = (propertyId, { startDate: startDate , endDate: endDate , status: status , sort: sort , source: source  })=>{
    return `?start=${startDate}&end=${endDate}&status=${status}&filter_by=${sort}&source=${source}&id=${propertyId}`;
};









var $ecc92895b268d3ae$exports = {};

$parcel$export($ecc92895b268d3ae$exports, "generateAPIResponse", () => $ecc92895b268d3ae$export$692bd22b750611f2);
function $ecc92895b268d3ae$export$692bd22b750611f2(data) {
    return {
        DATA: data,
        ERRORS: {
            CLIENT_MESSAGE: "",
            DEVELOPER_MESSAGE: ""
        },
        MESSAGES: {
            CLIENT_MESSAGE: "",
            DEVELOPER_MESSAGE: ""
        },
        SUCCESS: true
    };
}


$parcel$exportWildcard($52e11f599a4f5dca$exports, $4a0160e1e5b24e49$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $2026a49d34582011$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $e50011cc2264e453$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $01815dc19ee3b0a7$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $0785fd2fa3fb450c$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $0e53b679feffeec8$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $750a22b60b746a86$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $39ac3dd98f21da43$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $2cb2f9f81b60bd28$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $a0dadd11ddbce2fa$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $0c891e3f27143fe8$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $ed812675660d38b0$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $15a2617ecf5a74eb$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $4c2910318d75849f$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $7e76d0d187f06940$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $e15de41ca5b185e2$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $f58c18151396e867$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $f4b19c2cf783eed0$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $af33674cdb61992e$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $3b54348c5bf92caa$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $de872e06841c454e$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $7c2cdfac8d14e30c$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $80436cd706766ba7$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $b9fbf0da9ae592a3$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $9f770fb655db2e69$exports);
$parcel$exportWildcard($52e11f599a4f5dca$exports, $ecc92895b268d3ae$exports);


var $37489d2fec791fc9$exports = {};

var $b7f855d1d07bf9f3$exports = {};

$parcel$export($b7f855d1d07bf9f3$exports, "HttpResponseCode", () => $b7f855d1d07bf9f3$export$46df769e9e89db18);
let $b7f855d1d07bf9f3$export$46df769e9e89db18;
(function(HttpResponseCode1) {
    HttpResponseCode1[HttpResponseCode1["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpResponseCode1[HttpResponseCode1["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpResponseCode1[HttpResponseCode1["NOT_FOUND"] = 404] = "NOT_FOUND";
})($b7f855d1d07bf9f3$export$46df769e9e89db18 || ($b7f855d1d07bf9f3$export$46df769e9e89db18 = {}));



var $1570f69a4dc582c1$exports = {};

$parcel$export($1570f69a4dc582c1$exports, "startOfYear", () => $1570f69a4dc582c1$export$f91e89d3d0406102);
$parcel$export($1570f69a4dc582c1$exports, "oneYearInFuture", () => $1570f69a4dc582c1$export$6e3a72107a4f259a);

const $1570f69a4dc582c1$export$f91e89d3d0406102 = new Date(new Date().getFullYear(), 0, 1);
const $1570f69a4dc582c1$export$6e3a72107a4f259a = (0, $iPNDK$dayjs)().add(1, "year").toDate();






var $e6d97bb5a9c18d21$exports = {};



var $d20f3f866de7c5f1$exports = {};

$parcel$export($d20f3f866de7c5f1$exports, "pipe", () => $d20f3f866de7c5f1$export$a4627e546088548d);
$parcel$export($d20f3f866de7c5f1$exports, "compose", () => $d20f3f866de7c5f1$export$f672e0b6f7222cd7);
$parcel$export($d20f3f866de7c5f1$exports, "curry", () => $d20f3f866de7c5f1$export$c3095a23b368d1f2);
const $d20f3f866de7c5f1$export$a4627e546088548d = (...fns)=>(x)=>fns.reduce((v, f)=>f(v), x);
const $d20f3f866de7c5f1$export$f672e0b6f7222cd7 = (...fns)=>(x)=>fns.reduceRight((v, f)=>f(v), x);
function $d20f3f866de7c5f1$export$c3095a23b368d1f2(func) {
    return function curried(...args) {
        if (args.length >= func.length) // @ts-ignore
        return func.apply(this, args);
        else return function(...args2) {
            // @ts-ignore
            return curried.apply(this, args.concat(args2));
        };
    };
}


var $646a5cfd43bc633a$exports = {};

$parcel$export($646a5cfd43bc633a$exports, "generateNestedComputedValue", () => $646a5cfd43bc633a$export$5b9873fb54d72fd2);
const $646a5cfd43bc633a$export$5b9873fb54d72fd2 = (path, obj)=>{
    const isNested = path.includes(".");
    const [head, ...rest] = path.split(".");
    const remainingPath = rest.join(".");
    return isNested ? $646a5cfd43bc633a$export$5b9873fb54d72fd2(remainingPath, obj[head]) : obj[path];
};


var $cf9f973b2cd0a971$exports = {};
var $42946e3b52709c65$exports = {};

$parcel$export($42946e3b52709c65$exports, "preferredCountries", () => $42946e3b52709c65$export$20ffdd11fdaf482a);
$parcel$export($42946e3b52709c65$exports, "formatPhoneNumber", () => $42946e3b52709c65$export$842dcfa371c6bb83);
$parcel$export($42946e3b52709c65$exports, "handleAddPlusToPhoneNumber", () => $42946e3b52709c65$export$7d7cabaaf96774f6);
$parcel$export($42946e3b52709c65$exports, "formatE164PhoneNumber", () => $42946e3b52709c65$export$59bb519ba7fb7201);
$parcel$export($42946e3b52709c65$exports, "parsePhone", () => $42946e3b52709c65$export$48c6adddc5539199);
$parcel$export($42946e3b52709c65$exports, "getAllCountryCallingCodes", () => $42946e3b52709c65$export$fa0fa8369dbda108);

var $716ed8814bfe0dcf$exports = {};

$parcel$export($716ed8814bfe0dcf$exports, "countryCodeToCountryName", () => $716ed8814bfe0dcf$export$bd210a691f92a7c0);
const $716ed8814bfe0dcf$export$bd210a691f92a7c0 = {
    AB: "Abkhazia",
    AC: "Ascension Island",
    AD: "Andorra",
    AE: "United Arab Emirates",
    AF: "Afghanistan",
    AG: "Antigua and Barbuda",
    AI: "Anguilla",
    AL: "Albania",
    AM: "Armenia",
    AO: "Angola",
    AQ: "Antarctica",
    AR: "Argentina",
    AS: "American Samoa",
    AT: "Austria",
    AU: "Australia",
    AW: "Aruba",
    AX: "\xc5land Islands",
    AZ: "Azerbaijan",
    BA: "Bosnia and Herzegovina",
    BB: "Barbados",
    BD: "Bangladesh",
    BE: "Belgium",
    BF: "Burkina Faso",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "Saint Barth\xe9lemy",
    BM: "Bermuda",
    BN: "Brunei Darussalam",
    BO: "Bolivia",
    BQ: "Bonaire, Sint Eustatius and Saba",
    BR: "Brazil",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Bouvet Island",
    BW: "Botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocos (Keeling) Islands",
    CD: "Congo, Democratic Republic of the",
    CF: "Central African Republic",
    CG: "Congo",
    CH: "Switzerland",
    CI: "Cote d'Ivoire",
    CK: "Cook Islands",
    CL: "Chile",
    CM: "Cameroon",
    CN: "China",
    CO: "Colombia",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cape Verde",
    CW: "Cura\xe7ao",
    CX: "Christmas Island",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DE: "Germany",
    DJ: "Djibouti",
    DK: "Denmark",
    DM: "Dominica",
    DO: "Dominican Republic",
    DZ: "Algeria",
    EC: "Ecuador",
    EE: "Estonia",
    EG: "Egypt",
    EH: "Western Sahara",
    ER: "Eritrea",
    ES: "Spain",
    ET: "Ethiopia",
    FI: "Finland",
    FJ: "Fiji",
    FK: "Falkland Islands",
    FM: "Federated States of Micronesia",
    FO: "Faroe Islands",
    FR: "France",
    GA: "Gabon",
    GB: "United Kingdom",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Greenland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "Equatorial Guinea",
    GR: "Greece",
    GS: "South Georgia and the South Sandwich Islands",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hong Kong",
    HM: "Heard Island and McDonald Islands",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IM: "Isle of Man",
    IN: "India",
    IO: "British Indian Ocean Territory",
    IQ: "Iraq",
    IR: "Iran",
    IS: "Iceland",
    IT: "Italy",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenya",
    KG: "Kyrgyzstan",
    KH: "Cambodia",
    KI: "Kiribati",
    KM: "Comoros",
    KN: "Saint Kitts and Nevis",
    KP: "North Korea",
    KR: "South Korea",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Laos",
    LB: "Lebanon",
    LC: "Saint Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Lithuania",
    LU: "Luxembourg",
    LV: "Latvia",
    LY: "Libya",
    MA: "Morocco",
    MC: "Monaco",
    MD: "Moldova",
    ME: "Montenegro",
    MF: "Saint Martin (French Part)",
    MG: "Madagascar",
    MH: "Marshall Islands",
    MK: "North Macedonia",
    ML: "Mali",
    MM: "Burma",
    MN: "Mongolia",
    MO: "Macao",
    MP: "Northern Mariana Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Malaysia",
    MZ: "Mozambique",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Netherlands",
    NO: "Norway",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "New Zealand",
    OM: "Oman",
    OS: "South Ossetia",
    PA: "Panama",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "Papua New Guinea",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Poland",
    PM: "Saint Pierre and Miquelon",
    PN: "Pitcairn",
    PR: "Puerto Rico",
    PS: "Palestine",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RS: "Serbia",
    RU: "Russia",
    RW: "Rwanda",
    SA: "Saudi Arabia",
    SB: "Solomon Islands",
    SC: "Seychelles",
    SD: "Sudan",
    SE: "Sweden",
    SG: "Singapore",
    SH: "Saint Helena",
    SI: "Slovenia",
    SJ: "Svalbard and Jan Mayen",
    SK: "Slovakia",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "South Sudan",
    ST: "Sao Tome and Principe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syria",
    SZ: "Swaziland",
    TA: "Tristan da Cunha",
    TC: "Turks and Caicos Islands",
    TD: "Chad",
    TF: "French Southern Territories",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tajikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    TM: "Turkmenistan",
    TN: "Tunisia",
    TO: "Tonga",
    TR: "Turkey",
    TT: "Trinidad and Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tanzania",
    UA: "Ukraine",
    UG: "Uganda",
    UM: "United States Minor Outlying Islands",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VA: "Holy See (Vatican City State)",
    VC: "Saint Vincent and the Grenadines",
    VE: "Venezuela",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis and Futuna",
    WS: "Samoa",
    XK: "Kosovo",
    YE: "Yemen",
    YT: "Mayotte",
    ZA: "South Africa",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    ZZ: "International"
};


const $42946e3b52709c65$export$20ffdd11fdaf482a = [
    "CA",
    "US",
    "AU"
];
function $42946e3b52709c65$export$842dcfa371c6bb83(phoneNumber) {
    const numberWithPlus = $42946e3b52709c65$export$7d7cabaaf96774f6(phoneNumber);
    const isValidPhoneNumber = (0, $iPNDK$isValidPhoneNumber)(numberWithPlus);
    if (isValidPhoneNumber) {
        const parsedPhoneNumber = (0, $iPNDK$parsePhoneNumber)(numberWithPlus);
        const countryCode = parsedPhoneNumber.country;
        const isNorthAmerican = countryCode === "CA" || countryCode === "US";
        if (isNorthAmerican) return parsedPhoneNumber.formatNational();
        else return parsedPhoneNumber.formatInternational();
    } else return phoneNumber;
}
function $42946e3b52709c65$export$59bb519ba7fb7201({ subscriberNumber: subscriberNumber , countryCallingCode: countryCallingCode  }) {
    return `+${countryCallingCode}${subscriberNumber}`;
}
function $42946e3b52709c65$export$48c6adddc5539199(phoneNumber) {
    const defaultCountryCode = "1";
    const defaultCountry = "CA";
    if (!phoneNumber) return {
        countryCode: defaultCountryCode,
        country: defaultCountry,
        subscriberNumber: ""
    };
    const trimmedPhone = $42946e3b52709c65$var$removeLeadingZerosFromPhoneNumber(phoneNumber.trim());
    const phoneWithoutPlus = $42946e3b52709c65$var$removePlusFromPhoneNumber(trimmedPhone);
    const phoneWithPlus = $42946e3b52709c65$export$7d7cabaaf96774f6(trimmedPhone);
    if (!(0, $iPNDK$isPossiblePhoneNumber)(phoneWithPlus)) return {
        countryCode: defaultCountryCode,
        country: defaultCountry,
        subscriberNumber: phoneWithoutPlus
    };
    const parsedPhoneNumber = (0, $iPNDK$parsePhoneNumber)(phoneWithPlus);
    if (!parsedPhoneNumber) return {
        countryCode: defaultCountryCode,
        country: defaultCountry,
        subscriberNumber: phoneWithoutPlus
    };
    const countryCallingCode = parsedPhoneNumber.countryCallingCode.toString();
    const country = parsedPhoneNumber.country;
    const countryAndCode = countryCallingCode && country;
    return {
        countryCode: countryAndCode ? countryCallingCode : defaultCountryCode,
        country: countryAndCode ? country : defaultCountry,
        subscriberNumber: parsedPhoneNumber.nationalNumber.toString()
    };
}
/** */ function $42946e3b52709c65$var$removePlusFromPhoneNumber(phoneNumber) {
    if (phoneNumber.length === 0) return phoneNumber;
    const firstDigit = phoneNumber[0];
    if (firstDigit === "+") return [
        ...phoneNumber
    ].filter((char)=>char !== "+").join("");
    return phoneNumber;
}
const $42946e3b52709c65$export$7d7cabaaf96774f6 = (phoneNumber)=>{
    const firstDigit = phoneNumber[0];
    if (firstDigit !== "+") return `+${phoneNumber}`;
    return phoneNumber;
};
// https://en.wikipedia.org/wiki/National_conventions_for_writing_telephone_numbers
function $42946e3b52709c65$var$removeLeadingZerosFromPhoneNumber(phoneNumber) {
    if (phoneNumber.length < 3) return phoneNumber;
    if (phoneNumber[0] === "0" && phoneNumber[0] === "0") {
        const [, , ...rest] = phoneNumber.split("");
        return rest.join("");
    }
    return phoneNumber;
}
function $42946e3b52709c65$export$fa0fa8369dbda108() {
    const countryCodes = (0, $iPNDK$getCountries)();
    const supportedCountries = [];
    countryCodes.forEach((countryCode)=>{
        const countryName = (0, $716ed8814bfe0dcf$export$bd210a691f92a7c0)[countryCode];
        const callingCode = (0, $iPNDK$getCountryCallingCode)(countryCode);
        if ((0, $iPNDK$isSupportedCountry)(countryCode) && countryName && callingCode) supportedCountries.push({
            countryCode: countryCode,
            callingCode: callingCode,
            countryName: countryName
        });
    });
    return supportedCountries;
}



$parcel$exportWildcard($cf9f973b2cd0a971$exports, $42946e3b52709c65$exports);
$parcel$exportWildcard($cf9f973b2cd0a971$exports, $716ed8814bfe0dcf$exports);


var $2f84d640f5b2515c$exports = {};

$parcel$export($2f84d640f5b2515c$exports, "replaceEmptyRteHtml", () => $2f84d640f5b2515c$export$7df8fcd3b12f9ee8);
function $2f84d640f5b2515c$export$7df8fcd3b12f9ee8(html) {
    if (!html || typeof html !== "string") return "";
    if (html?.length === 0) return "";
    return html.replace("<p><br></p>", "");
}



var $fc7143b5647f4823$exports = {};

$parcel$export($fc7143b5647f4823$exports, "getEnumValues", () => $fc7143b5647f4823$export$70a5d58ec00f3c11);
$parcel$export($fc7143b5647f4823$exports, "getEnumKeys", () => $fc7143b5647f4823$export$53a940bc3fb087a5);
const $fc7143b5647f4823$var$getEnumMembers = (enumerable)=>{
    return Object.keys(enumerable).map((key)=>enumerable[key]);
};
const $fc7143b5647f4823$export$70a5d58ec00f3c11 = (enumerable)=>{
    const enumMembers = $fc7143b5647f4823$var$getEnumMembers(enumerable);
    // we are only interested in the numeric identifiers as these represent the values
    const enumValues = enumMembers.filter((v)=>typeof v === "number");
    return enumValues;
};
const $fc7143b5647f4823$export$53a940bc3fb087a5 = (enumerable)=>{
    const enumMembers = $fc7143b5647f4823$var$getEnumMembers(enumerable);
    // we are only interested in the string identifiers as these represent the values
    const enumValues = enumMembers.filter((v)=>typeof v === "string");
    return enumValues;
};


var $cc70552020cd30aa$exports = {};

$parcel$export($cc70552020cd30aa$exports, "generateSelectedSubjectDisplay", () => $cc70552020cd30aa$export$9fd647041178316);
$parcel$export($cc70552020cd30aa$exports, "generateReservationSubject", () => $cc70552020cd30aa$export$d0a3c61729499261);
$parcel$export($cc70552020cd30aa$exports, "generateOwnerInquirySubject", () => $cc70552020cd30aa$export$294959f885705260);




function $cc70552020cd30aa$export$9fd647041178316({ subject: subject , isOwnerRole: isOwnerRole  }) {
    let subjectTitle = isOwnerRole ? "Select an Inquiry or Booking" : "Select an Upcoming or Past Reservation";
    if (!subject) return subjectTitle;
    if (subject.TYPE === (0, $5b9a33cfff775612$export$bb4d5f87bab450c).BOOKING) {
        const start = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.ARRIVAL_DATE));
        const end = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.DEPARTURE_DATE));
        subjectTitle = `Booking (${start} - ${end})`;
    } else if (subject.TYPE === (0, $5b9a33cfff775612$export$bb4d5f87bab450c).INQUIRY) {
        if (subject?.ARRIVAL_DATE && subject?.DEPARTURE_DATE) {
            const start = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.ARRIVAL_DATE));
            const end = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.DEPARTURE_DATE));
            subjectTitle = `Inquiry (${start} - ${end})`;
        } else subjectTitle = "Inquiry (No Dates Selected)";
    }
    return subjectTitle;
}
function $cc70552020cd30aa$export$d0a3c61729499261({ subject: subject , isOwnerMode: isOwnerMode  }) {
    if (isOwnerMode) return $cc70552020cd30aa$var$generateOwnerReservationSubject(subject);
    else return $cc70552020cd30aa$var$generateGuestReservationSubject(subject);
}
/** For display in message subject select dialog */ function $cc70552020cd30aa$var$generateOwnerReservationSubject(subject) {
    const title = (0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(subject.CONTACT.NAME);
    const subtitle = $cc70552020cd30aa$var$generateReservationSubtitle(subject);
    const subtitle2 = `${subject.PROPERTY.NAME} (#${subject.BOOKING.REFERENCE})`;
    return {
        title: title,
        subtitle: subtitle,
        subtitle2: subtitle2
    };
}
/** For display in message subject select dialog */ function $cc70552020cd30aa$var$generateGuestReservationSubject(subject) {
    const title = subject.PROPERTY.NAME;
    const subtitle = $cc70552020cd30aa$var$generateReservationSubtitle(subject);
    const subtitle2 = (0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(subject.CONTACT.NAME);
    return {
        title: title,
        subtitle: subtitle,
        subtitle2: subtitle2
    };
}
/** For display in message subject select dialog */ function $cc70552020cd30aa$var$generateReservationSubtitle(subject) {
    const start = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.BOOKING.ARRIVAL_DATE));
    const end = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.BOOKING.DEPARTURE_DATE));
    const subtitle = `${start} - ${end}`;
    return subtitle;
}
function $cc70552020cd30aa$export$294959f885705260(subject) {
    const sentDate = subject.MESSAGE.CREATED_DATE ? "(" + (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.MESSAGE.CREATED_DATE)) + ")" : "";
    const title = `${(0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(subject.CONTACT.NAME)} ${sentDate}`;
    let subtitle = "No Dates Selected";
    if (subject.MESSAGE.ARRIVAL_DATE && subject.MESSAGE.DEPARTURE_DATE) {
        const start = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.MESSAGE.ARRIVAL_DATE));
        const end = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.MESSAGE.DEPARTURE_DATE));
        subtitle = `${start} - ${end}`;
    } else if (subject.BOOKING.ARRIVAL_DATE && subject.BOOKING.DEPARTURE_DATE) {
        const start = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.BOOKING.ARRIVAL_DATE));
        const end = (0, $3a8449e3b3bae2ba$export$863d5be618fefbf3)((0, $iPNDK$dayjs)(subject.BOOKING.DEPARTURE_DATE));
        subtitle = `${start} - ${end}`;
    }
    const subtitle2 = subject.PROPERTY.NAME;
    return {
        title: title,
        subtitle: subtitle,
        subtitle2: subtitle2
    };
}


var $3ab84978c22f06d9$exports = {};

$parcel$export($3ab84978c22f06d9$exports, "generateContactName", () => $3ab84978c22f06d9$export$d657e21b8af95c32);
$parcel$export($3ab84978c22f06d9$exports, "generateLastMessageSentTime", () => $3ab84978c22f06d9$export$32a13a311e5e806b);
$parcel$export($3ab84978c22f06d9$exports, "generateNumberOfUnread", () => $3ab84978c22f06d9$export$e5aae6b8ec83cd56);
$parcel$export($3ab84978c22f06d9$exports, "hasNextReservation", () => $3ab84978c22f06d9$export$ef6568c2993ad507);
$parcel$export($3ab84978c22f06d9$exports, "generateMessageProperty", () => $3ab84978c22f06d9$export$6669e59d447fab6d);


function $3ab84978c22f06d9$export$d657e21b8af95c32(overviewMessage) {
    const { CONTACT: CONTACT  } = overviewMessage;
    return CONTACT.NAME.length === 0 ? CONTACT.EMAIL : (0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(CONTACT.NAME);
}
function $3ab84978c22f06d9$export$32a13a311e5e806b(overviewMessage) {
    const { MESSAGE: MESSAGE  } = overviewMessage;
    return (0, $3a8449e3b3bae2ba$export$493c11ff22f45a24)(MESSAGE.DATE_SENT, MESSAGE.TIME_SENT);
}
function $3ab84978c22f06d9$export$e5aae6b8ec83cd56(overviewMessage) {
    if (overviewMessage.MESSAGE.NUM_UNREAD > 0) return `(${overviewMessage.MESSAGE.NUM_UNREAD})`;
    else return "";
}
function $3ab84978c22f06d9$export$ef6568c2993ad507(overviewMessage) {
    return overviewMessage.CONTACT.DETAILS.HAS_NEXT_RESERVATION;
}
function $3ab84978c22f06d9$export$6669e59d447fab6d(overviewMessage) {
    return overviewMessage.PROPERTY.NAME;
}


var $1ae3977d25cdb37a$exports = {};

$parcel$export($1ae3977d25cdb37a$exports, "accessCodeAvailableDate", () => $1ae3977d25cdb37a$export$b5429876b18fb200);
$parcel$export($1ae3977d25cdb37a$exports, "canViewAccessCode", () => $1ae3977d25cdb37a$export$1d37ecc503a24cf0);
$parcel$export($1ae3977d25cdb37a$exports, "accessCodeDueDate", () => $1ae3977d25cdb37a$export$6100c6a8725665b2);
$parcel$export($1ae3977d25cdb37a$exports, "generateAccessCodeDueDate", () => $1ae3977d25cdb37a$export$8f20775108da54a0);
$parcel$export($1ae3977d25cdb37a$exports, "BookingAccessCodeTextEnum", () => $1ae3977d25cdb37a$export$fa52415dd5e0de36);
$parcel$export($1ae3977d25cdb37a$exports, "generateBookingAccessCodeText", () => $1ae3977d25cdb37a$export$a60d73e549175f6a);
$parcel$export($1ae3977d25cdb37a$exports, "generateAccessCodeLabel", () => $1ae3977d25cdb37a$export$3ba7d7616dd02fa8);
$parcel$export($1ae3977d25cdb37a$exports, "accessToUnitSelectedOptions", () => $1ae3977d25cdb37a$export$bf0e3c8f9fedf45d);




function $1ae3977d25cdb37a$export$b5429876b18fb200(arrival) {
    return (0, $iPNDK$dayjs)(arrival, (0, $3a8449e3b3bae2ba$export$826220848dd188cb)).hour(0);
}
const $1ae3977d25cdb37a$var$isAfterAccessCodeAvailableDate = (departure)=>{
    const dayAfterDeparture = (0, $iPNDK$dayjs)(departure).add(1, "day").hour(0);
    const now = (0, $iPNDK$dayjs)().hour(0);
    return now.isSame(dayAfterDeparture, "day") || now.isAfter(dayAfterDeparture, "day");
};
function $1ae3977d25cdb37a$export$1d37ecc503a24cf0({ bookingStatusId: bookingStatusId , arrival: arrival , departure: departure  }) {
    if (bookingStatusId !== (0, $e50011cc2264e453$export$27d2d4abb2ec0600).BalancePaid) return false;
    const accessCodeAvailable = $1ae3977d25cdb37a$export$b5429876b18fb200(arrival);
    const dayAfterDeparture = (0, $iPNDK$dayjs)(departure).add(1, "day").hour(0);
    const now = (0, $iPNDK$dayjs)().hour(0);
    return now.isSame(accessCodeAvailable, "day") || now.isAfter(accessCodeAvailable, "day") && now.isBefore(dayAfterDeparture);
}
const $1ae3977d25cdb37a$export$6100c6a8725665b2 = (arrival)=>{
    return (0, $iPNDK$dayjs)(arrival, (0, $3a8449e3b3bae2ba$export$826220848dd188cb)).subtract(9, "day").hour(0);
};
function $1ae3977d25cdb37a$export$8f20775108da54a0(arrival) {
    const dueDate = $1ae3977d25cdb37a$export$6100c6a8725665b2(arrival);
    const formattedArrival = (0, $3a8449e3b3bae2ba$export$c7ac8b61d985977f)(dueDate);
    const numDaysUntilArrival = (0, $3a8449e3b3bae2ba$export$f72884f4f37b25df)(dueDate);
    const dueMessage = `Due ${formattedArrival}`;
    if (numDaysUntilArrival <= 0) return `Urgent, Due Immediately`;
    return `${dueMessage}`;
}
let $1ae3977d25cdb37a$export$fa52415dd5e0de36;
(function(BookingAccessCodeTextEnum1) {
    BookingAccessCodeTextEnum1["noLongerAvailable"] = "No Longer Available";
    BookingAccessCodeTextEnum1["payDepositFirst"] = "Make Payment First";
    BookingAccessCodeTextEnum1["providedByHost"] = "Provided by Host";
    BookingAccessCodeTextEnum1["providedByFrontDesk"] = "Provided by Front Desk";
    BookingAccessCodeTextEnum1["guestUnavailableDoorCode"] = "Unavailable, Contact Host";
})($1ae3977d25cdb37a$export$fa52415dd5e0de36 || ($1ae3977d25cdb37a$export$fa52415dd5e0de36 = {}));
function $1ae3977d25cdb37a$export$a60d73e549175f6a({ isOwnerMode: isOwnerMode , bookingStatusId: bookingStatusId , accessToUnit: accessToUnit , arrival: arrival , departure: departure , customDoorCode: customDoorCode  }) {
    if (!isOwnerMode && bookingStatusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).Cancelled || bookingStatusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).ReservationRequestDeclined) return $1ae3977d25cdb37a$export$fa52415dd5e0de36.noLongerAvailable;
    if (!isOwnerMode && bookingStatusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue) return $1ae3977d25cdb37a$export$fa52415dd5e0de36.payDepositFirst;
    if (!isOwnerMode && !$1ae3977d25cdb37a$export$1d37ecc503a24cf0({
        bookingStatusId: bookingStatusId,
        arrival: arrival,
        departure: departure
    })) {
        if ($1ae3977d25cdb37a$var$isAfterAccessCodeAvailableDate(departure)) return $1ae3977d25cdb37a$export$fa52415dd5e0de36.noLongerAvailable;
        const today = (0, $iPNDK$dayjs)().hour(0);
        const viewableDate = $1ae3977d25cdb37a$export$b5429876b18fb200(arrival);
        const relativeTime = viewableDate.from(today);
        return `Available ${relativeTime}`;
    }
    if (customDoorCode) return customDoorCode;
    const { TYPE: TYPE , METHOD: METHOD , CODE: CODE , STANDARD_CODE: STANDARD_CODE  } = accessToUnit;
    switch(TYPE.ID){
        case (0, $4c2910318d75849f$export$c8de32477f2ff66f).AccessCode:
            if (METHOD.ID === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).FrontDesk) return $1ae3977d25cdb37a$export$fa52415dd5e0de36.providedByFrontDesk;
            else if (METHOD.ID === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).Other) return $1ae3977d25cdb37a$export$fa52415dd5e0de36.providedByHost;
            else if (METHOD.ID === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).Email) {
                if (CODE.ID === (0, $4c2910318d75849f$export$a0dd5d6028487596).STANDARD_CODE) return STANDARD_CODE;
                else // (CODE.ID === AccessCodeIdEnum.UNIQUE_PER_GUEST)
                // custom door code entered and unique per guest has not been entered
                return isOwnerMode ? $1ae3977d25cdb37a$export$8f20775108da54a0(arrival) : $1ae3977d25cdb37a$export$fa52415dd5e0de36.guestUnavailableDoorCode;
            } else return $1ae3977d25cdb37a$export$fa52415dd5e0de36.providedByHost;
        case (0, $4c2910318d75849f$export$c8de32477f2ff66f).PhysicalKeyCard:
            if (METHOD.ID === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).FrontDesk) return $1ae3977d25cdb37a$export$fa52415dd5e0de36.providedByFrontDesk;
            else if (METHOD.ID === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).Other) return $1ae3977d25cdb37a$export$fa52415dd5e0de36.providedByHost;
            else if (METHOD.ID === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).LockBox) {
                if (CODE.ID === (0, $4c2910318d75849f$export$a0dd5d6028487596).STANDARD_CODE) return STANDARD_CODE;
                else // (CODE.ID === AccessCodeIdEnum.UNIQUE_PER_GUEST)
                return isOwnerMode ? $1ae3977d25cdb37a$export$8f20775108da54a0(arrival) : $1ae3977d25cdb37a$export$fa52415dd5e0de36.guestUnavailableDoorCode;
            } else return $1ae3977d25cdb37a$export$fa52415dd5e0de36.providedByHost;
        default:
            return $1ae3977d25cdb37a$export$fa52415dd5e0de36.providedByHost;
    }
}
function $1ae3977d25cdb37a$export$3ba7d7616dd02fa8({ accessToUnit: accessToUnit  }) {
    switch(accessToUnit.TYPE.ID){
        case (0, $4c2910318d75849f$export$c8de32477f2ff66f).AccessCode:
            return "Door Code";
        case (0, $4c2910318d75849f$export$c8de32477f2ff66f).PhysicalKeyCard:
            if (accessToUnit.METHOD.ID === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).LockBox) return "Lockbox Access";
            else return "Key/Card Access";
        default:
            return "Unknown Access Type";
    }
}
function $1ae3977d25cdb37a$var$hasSelectedAccessType(typeId) {
    return typeId == (0, $4c2910318d75849f$export$c8de32477f2ff66f).AccessCode || typeId === (0, $4c2910318d75849f$export$c8de32477f2ff66f).PhysicalKeyCard;
}
function $1ae3977d25cdb37a$var$hasSelectedAccessMethod(methodId) {
    return [
        (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).Email,
        (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).FrontDesk,
        (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).LockBox,
        (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).Other, 
    ].includes(methodId);
}
function $1ae3977d25cdb37a$var$hasSelectedAccessCode(codeId) {
    return [
        (0, $4c2910318d75849f$export$a0dd5d6028487596).NO_CODE,
        (0, $4c2910318d75849f$export$a0dd5d6028487596).STANDARD_CODE,
        (0, $4c2910318d75849f$export$a0dd5d6028487596).UNIQUE_PER_GUEST
    ].includes(codeId);
}
function $1ae3977d25cdb37a$export$bf0e3c8f9fedf45d({ codeId: codeId , methodId: methodId , typeId: typeId  }) {
    const hasPropertyAccessType = $1ae3977d25cdb37a$var$hasSelectedAccessType(typeId);
    const hasAccessMethod = $1ae3977d25cdb37a$var$hasSelectedAccessMethod(methodId);
    const hasAccessCodeSelected = $1ae3977d25cdb37a$var$hasSelectedAccessCode(codeId);
    const hasStandardCode = codeId === (0, $4c2910318d75849f$export$a0dd5d6028487596).STANDARD_CODE;
    const hasAccessCode = typeId === (0, $4c2910318d75849f$export$c8de32477f2ff66f).AccessCode;
    const hasAccessCodeEmailMethod = methodId === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).Email;
    const hasKeyLockboxMethod = methodId === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).LockBox;
    const hasFrontDeskMethod = methodId === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).FrontDesk;
    const hasOtherDeskMethod = methodId === (0, $4c2910318d75849f$export$2d4a0ecba6f74b61).Other;
    const hasAccessCodeSection = hasAccessMethod && (hasAccessCodeEmailMethod || hasKeyLockboxMethod);
    return {
        hasSelectedPropertyAccessType: hasPropertyAccessType,
        hasSelectedAccessMethod: hasAccessMethod,
        hasSelectedAccessCode: hasAccessCodeSelected,
        hasStandardCode: hasStandardCode,
        hasAccessCode: hasAccessCode,
        hasAccessCodeEmailMethod: hasAccessCodeEmailMethod,
        hasKeyLockboxMethod: hasKeyLockboxMethod,
        hasFrontDeskMethod: hasFrontDeskMethod,
        hasOtherDeskMethod: hasOtherDeskMethod,
        hasAccessCodeSection: hasAccessCodeSection
    };
}


var $8cd92771222e682c$exports = {};

$parcel$export($8cd92771222e682c$exports, "transactionText", () => $8cd92771222e682c$export$9211131e191c8e49);
$parcel$export($8cd92771222e682c$exports, "isInflatedBooking", () => $8cd92771222e682c$export$45c5eaa443b874a3);
const $8cd92771222e682c$export$9211131e191c8e49 = {
    /** Section of a reservation screen/page where billing, invoice, revenue, bank info is deisplayed */ billingDetails: "Billing Details",
    /** A bill that a guest receives for booking with alluraDirect */ reservationInvoice: "Reservation Invoice",
    /** A bill that a guest receives for booking with an allura partner (Whistler) */ partnerInvoice: "Partner Invoice",
    /** Summary of deposits that the owner has received from a booking */ bankDeposits: "Bank Deposits",
    /** A breakdown of the total amount that the owner will receive from a booking */ revenueReceivedSummary: "Revenue Received (Summary)",
    /** Price per night * number of nights */ accommodation: "Accommodation Subtotal",
    cleaningAndPetFees: "Cleaning/Pet Fees",
    /** Service fee that the guest is charged for booking with alluraDirect */ guestServiceFee: "Service Fee (Guest)",
    /** The total amount due for a booking. Includes fees, taxes etc */ reservationTotal: "Reservation Total",
    partnerCommissionFee: "Partner Commission Fee",
    damageDeposit: "Damage Deposit",
    creditCardFee: "Credit Card Fee",
    bookingCommission: "Booking Commission",
    /** Non-resident only */ nr6Withheld: "NR6 Withheld",
    totalDepositedToBank: "Total Deposited to Bank",
    /** Either the property owner or alluraDirect */ taxRemitter: "Tax Remitter",
    /** Property managers want an additional cut of the booking fee */ propertyManagerServiceFee: "Property Manager Service Fee"
};
function $8cd92771222e682c$export$45c5eaa443b874a3(booking) {
    return Boolean(booking.INFLATED_BOOKING);
}


var $00bb5d2e544b2c13$exports = {};

$parcel$export($00bb5d2e544b2c13$exports, "hasReview", () => $00bb5d2e544b2c13$export$2afd9b1ceeb4b47a);
$parcel$export($00bb5d2e544b2c13$exports, "hasMadePayment", () => $00bb5d2e544b2c13$export$a77f7b22284c500c);
$parcel$export($00bb5d2e544b2c13$exports, "canMakeBookingPayment", () => $00bb5d2e544b2c13$export$c03719ea1402ca53);
$parcel$export($00bb5d2e544b2c13$exports, "hasVisiblePropertyGuideBookBtn", () => $00bb5d2e544b2c13$export$88eb3bff6fa2e050);
$parcel$export($00bb5d2e544b2c13$exports, "isPastReservation", () => $00bb5d2e544b2c13$export$92cb8878b496952c);
$parcel$export($00bb5d2e544b2c13$exports, "hasVisibleRebookPropertyBtn", () => $00bb5d2e544b2c13$export$163a64123f1d1b38);
$parcel$export($00bb5d2e544b2c13$exports, "isCurrentReservation", () => $00bb5d2e544b2c13$export$8db61c631ec8d3f8);
$parcel$export($00bb5d2e544b2c13$exports, "isPendingReservation", () => $00bb5d2e544b2c13$export$df9306c109b82fcf);
$parcel$export($00bb5d2e544b2c13$exports, "canViewPropertyGuidebook", () => $00bb5d2e544b2c13$export$84abfa454a024e78);
$parcel$export($00bb5d2e544b2c13$exports, "propertyGuidebookAvailableDate", () => $00bb5d2e544b2c13$export$92e36e617bf84a3a);
$parcel$export($00bb5d2e544b2c13$exports, "propertyGuidebookAvailableDateFormatted", () => $00bb5d2e544b2c13$export$c3d2cb8994b81f17);
$parcel$export($00bb5d2e544b2c13$exports, "canGuestRequestToModifyBooking", () => $00bb5d2e544b2c13$export$285ef70eda890ef);
$parcel$export($00bb5d2e544b2c13$exports, "canHostModifyBooking", () => $00bb5d2e544b2c13$export$14793448d6063e2f);
$parcel$export($00bb5d2e544b2c13$exports, "canHostModifyBookingStartDate", () => $00bb5d2e544b2c13$export$2e26257701b2d7e9);
$parcel$export($00bb5d2e544b2c13$exports, "canModifyBooking", () => $00bb5d2e544b2c13$export$4a354f042bb4c4d5);
$parcel$export($00bb5d2e544b2c13$exports, "confirmationPropertyGuidebookText", () => $00bb5d2e544b2c13$export$b7bb6836101aaebd);
$parcel$export($00bb5d2e544b2c13$exports, "isPaymentButtonVisible", () => $00bb5d2e544b2c13$export$63efa647b73e8b6f);
$parcel$export($00bb5d2e544b2c13$exports, "canReviewBooking", () => $00bb5d2e544b2c13$export$1706a82848ccea2f);
$parcel$export($00bb5d2e544b2c13$exports, "reservationStatusText", () => $00bb5d2e544b2c13$export$152ed9c66f70fc4a);
$parcel$export($00bb5d2e544b2c13$exports, "balanceText", () => $00bb5d2e544b2c13$export$fe7e2289b41760c9);
$parcel$export($00bb5d2e544b2c13$exports, "hasPerGuestMessage", () => $00bb5d2e544b2c13$export$9951f6aac3527038);
$parcel$export($00bb5d2e544b2c13$exports, "hasCustomEntryCode", () => $00bb5d2e544b2c13$export$37d506624894a1c0);
$parcel$export($00bb5d2e544b2c13$exports, "hasCustomMessage", () => $00bb5d2e544b2c13$export$7645fbf75099c025);
$parcel$export($00bb5d2e544b2c13$exports, "generateCustomMessagePreview", () => $00bb5d2e544b2c13$export$233320293d749da5);
$parcel$export($00bb5d2e544b2c13$exports, "convertBookingServerToParams", () => $00bb5d2e544b2c13$export$fc5d1bab0ab8127d);
$parcel$export($00bb5d2e544b2c13$exports, "generateBookingStatusDetails", () => $00bb5d2e544b2c13$export$2cbe9b6e6bc0a416);
$parcel$export($00bb5d2e544b2c13$exports, "generateSurchargeIds", () => $00bb5d2e544b2c13$export$530b093149d3ddda);
$parcel$export($00bb5d2e544b2c13$exports, "generateSurchargeData", () => $00bb5d2e544b2c13$export$e09b0625208a9686);
$parcel$export($00bb5d2e544b2c13$exports, "calculateIsWithinBalanceDate", () => $00bb5d2e544b2c13$export$7da6b32e5aa90ab6);
$parcel$export($00bb5d2e544b2c13$exports, "generateRateQuoteErrorData", () => $00bb5d2e544b2c13$export$db51906af7c62020);
$parcel$export($00bb5d2e544b2c13$exports, "isDamageDepositCollected", () => $00bb5d2e544b2c13$export$b0d0ff6e9ab3df6e);






(0, $iPNDK$dayjs).extend((0, $iPNDK$dayjsplugincustomParseFormat));
const $00bb5d2e544b2c13$export$2afd9b1ceeb4b47a = (booking)=>booking?.REVIEW.ID > 0;
const $00bb5d2e544b2c13$export$a77f7b22284c500c = (booking)=>parseInt(booking?.PAYMENT.PAID_TO_DATE) !== 0;
const $00bb5d2e544b2c13$export$c03719ea1402ca53 = (bookingStatusId)=>{
    return bookingStatusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue;
};
const $00bb5d2e544b2c13$export$88eb3bff6fa2e050 = (bookingStatusId, bookingDeparture)=>{
    return bookingStatusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).BalancePaid && !$00bb5d2e544b2c13$export$92cb8878b496952c(bookingDeparture);
};
const $00bb5d2e544b2c13$export$163a64123f1d1b38 = (bookingDeparture)=>{
    const today = (0, $iPNDK$dayjs)();
    const departureDate = (0, $iPNDK$dayjs)(bookingDeparture, (0, $3a8449e3b3bae2ba$export$826220848dd188cb));
    return today.isSame(departureDate, "day") || today.isAfter(departureDate, "day");
};
const $00bb5d2e544b2c13$export$8db61c631ec8d3f8 = (arrival, departure)=>{
    const arrivalDate = (0, $iPNDK$dayjs)(arrival, (0, $3a8449e3b3bae2ba$export$826220848dd188cb));
    const departureDate = (0, $iPNDK$dayjs)(departure, (0, $3a8449e3b3bae2ba$export$826220848dd188cb));
    const now = (0, $iPNDK$dayjs)();
    return arrivalDate.isSame(now, "day") || departureDate.isSame(now, "day") || arrivalDate.isBefore(now, "day") && departureDate.isAfter(now, "day");
};
const $00bb5d2e544b2c13$export$92cb8878b496952c = (departure)=>{
    const now = (0, $iPNDK$dayjs)();
    const departureDate = (0, $iPNDK$dayjs)(departure, (0, $3a8449e3b3bae2ba$export$826220848dd188cb));
    return !departureDate.isSame(now, "day") && departureDate.isBefore(now, "day");
};
const $00bb5d2e544b2c13$export$df9306c109b82fcf = ({ STATUS: STATUS , FLAGS: FLAGS , PAYMENT: PAYMENT  })=>{
    if (STATUS.ID === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).ReservationRequest) return true;
    if (STATUS.ID === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue && parseInt(PAYMENT.PAID_TO_DATE) === 0) return true;
    if (FLAGS.IS_PAST_DUE) return true;
    return false;
};
const $00bb5d2e544b2c13$export$84abfa454a024e78 = (statusId, arrival, departure)=>{
    if (statusId !== (0, $e50011cc2264e453$export$27d2d4abb2ec0600).BalancePaid) return false;
    const now = (0, $iPNDK$dayjs)();
    const sevenDaysBeforeArrival = (0, $iPNDK$dayjs)(arrival, (0, $3a8449e3b3bae2ba$export$826220848dd188cb)).subtract(7, "day");
    const dayAfterDeparture = (0, $iPNDK$dayjs)(departure).add(1, "day").hour(0);
    return now.isSame(sevenDaysBeforeArrival, "day") || now.isAfter(sevenDaysBeforeArrival, "day") && now.isBefore(dayAfterDeparture);
};
const $00bb5d2e544b2c13$export$92e36e617bf84a3a = (arrival)=>{
    return (0, $iPNDK$dayjs)(arrival, (0, $3a8449e3b3bae2ba$export$826220848dd188cb)).subtract(7, "day");
};
const $00bb5d2e544b2c13$export$c3d2cb8994b81f17 = (arrival)=>{
    return $00bb5d2e544b2c13$export$92e36e617bf84a3a(arrival).format("MMM D");
};
const $00bb5d2e544b2c13$export$285ef70eda890ef = ({ departure: departure , bookingStatusId: bookingStatusId  })=>{
    if (bookingStatusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).Cancelled) return false;
    const daysUntilDeparture = (0, $3a8449e3b3bae2ba$export$f72884f4f37b25df)(departure);
    // Departure date is today or in past
    if (daysUntilDeparture <= 0) return false;
    return true;
};
const $00bb5d2e544b2c13$export$14793448d6063e2f = ({ departure: departure , bookingStatusId: bookingStatusId  })=>{
    if (bookingStatusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).Cancelled) return false;
    const daysUntilDeparture = (0, $3a8449e3b3bae2ba$export$f72884f4f37b25df)(departure);
    // Departure date is in past
    if (daysUntilDeparture < 0) return false;
    return true;
};
const $00bb5d2e544b2c13$export$2e26257701b2d7e9 = ({ arrival: arrival  })=>{
    const daysUntilArrival = (0, $3a8449e3b3bae2ba$export$f72884f4f37b25df)(arrival);
    return daysUntilArrival >= 0;
};
const $00bb5d2e544b2c13$export$4a354f042bb4c4d5 = (arrival, statusId)=>{
    const daysUntilArrival = (0, $3a8449e3b3bae2ba$export$f72884f4f37b25df)(arrival);
    return daysUntilArrival >= 1 && statusId !== (0, $e50011cc2264e453$export$27d2d4abb2ec0600).Cancelled;
};
const $00bb5d2e544b2c13$export$b7bb6836101aaebd = (statusId, arrival)=>{
    if (statusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue) return "after the remaining balance has been paid";
    const sevenDaysBeforeArrival = (0, $iPNDK$dayjs)(arrival, (0, $3a8449e3b3bae2ba$export$826220848dd188cb)).subtract(7, "day").format((0, $3a8449e3b3bae2ba$export$167143d4db8c79b7));
    return sevenDaysBeforeArrival;
};
const $00bb5d2e544b2c13$export$63efa647b73e8b6f = (statusId)=>{
    // ReservationRequests have payment button disabled
    return statusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue || statusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).ReservationRequest;
};
const $00bb5d2e544b2c13$export$1706a82848ccea2f = (statusId, departure)=>{
    const now = (0, $iPNDK$dayjs)();
    const departureDate = (0, $iPNDK$dayjs)(departure, (0, $3a8449e3b3bae2ba$export$826220848dd188cb));
    const yearDifference = Math.abs((0, $iPNDK$dayjs)().hour(0).diff((0, $iPNDK$dayjs)(departure), "year"));
    const validYearDifference = yearDifference < 2;
    return statusId === (0, $e50011cc2264e453$export$27d2d4abb2ec0600).BalancePaid && (departureDate.isSame(now, "day") || departureDate.isBefore(now, "day")) && validYearDifference;
};
const $00bb5d2e544b2c13$export$152ed9c66f70fc4a = (statusId, isCurrentReservation1, hasMadePayment1)=>{
    switch(statusId){
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).ReservationRequest:
            return (0, $e50011cc2264e453$export$acada62635fe78e1).ReservationRequested;
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue:
            if (isCurrentReservation1) return (0, $e50011cc2264e453$export$acada62635fe78e1).LatePayment;
            if (hasMadePayment1) return (0, $e50011cc2264e453$export$acada62635fe78e1).PaymentDue;
            return (0, $e50011cc2264e453$export$acada62635fe78e1).DepositDue;
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).BalancePaid:
            return (0, $e50011cc2264e453$export$acada62635fe78e1).Confirmed;
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).Cancelled:
            return (0, $e50011cc2264e453$export$acada62635fe78e1).Cancelled;
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).ReservationRequestDeclined:
            return (0, $e50011cc2264e453$export$acada62635fe78e1).ReservationDeclined;
        default:
            return (0, $e50011cc2264e453$export$acada62635fe78e1).UnknownStatusId;
    }
};
const $00bb5d2e544b2c13$export$fe7e2289b41760c9 = ({ amountOutstanding: amountOutstanding , statusId: statusId , balanceDueDate: balanceDueDate , depositDueDate: depositDueDate , hasMadePayment: hasMadePayment2  })=>{
    // Convert negative values (guest is owed damage deposit back) to 0.00.
    const floatAmount = parseFloat(amountOutstanding) > 0 ? parseFloat(amountOutstanding).toFixed(2) : 0..toFixed(2);
    const balanceStr = `${floatAmount}`;
    let detailText = "";
    switch(statusId){
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).ReservationRequest:
            detailText = "Pending Confirmation";
            break;
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).DepositPaidDue:
            if (hasMadePayment2) detailText = `Due by ${balanceDueDate}`;
            else detailText = `Due by ${depositDueDate}`;
            break;
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).BalancePaid:
            detailText = "Paid in Full";
            break;
        case (0, $e50011cc2264e453$export$27d2d4abb2ec0600).Cancelled:
            detailText = "Cancelled";
            break;
        default:
            break;
    }
    return `$${balanceStr} (${detailText})`;
};
function $00bb5d2e544b2c13$export$9951f6aac3527038(customMessage) {
    return $00bb5d2e544b2c13$export$37d506624894a1c0(customMessage.ENTRY_CODE) || $00bb5d2e544b2c13$export$7645fbf75099c025(customMessage.MESSAGE);
}
function $00bb5d2e544b2c13$export$7645fbf75099c025(message) {
    return message.length > 0;
}
function $00bb5d2e544b2c13$export$37d506624894a1c0(entryCode) {
    return entryCode.length > 0;
}
function $00bb5d2e544b2c13$export$233320293d749da5(message) {
    const hasMessage = $00bb5d2e544b2c13$export$7645fbf75099c025(message);
    if (!hasMessage) return "N/A (Message Not Added)";
    return (0, $a8b1bbfd45d27b19$export$6a506b36fdea397d)(message, 100);
}
const $00bb5d2e544b2c13$var$generateSurchargeParams = (surcharges)=>{
    const isPetFeeEnabled = (0, $b9fbf0da9ae592a3$export$10e2677d41a27589).pet in surcharges && surcharges.PETS.IS_ENABLED;
    const isCleaningFeeEnabled = (0, $b9fbf0da9ae592a3$export$10e2677d41a27589).cleaning in surcharges && surcharges.CLEANING.IS_ENABLED;
    let SURCHARGE_IDS = "";
    let SURCHARGE_AMOUNT_PETS = 0;
    let SURCHARGE_AMOUNT_CLEANING = 0;
    if (isPetFeeEnabled && isCleaningFeeEnabled) {
        const { PETS: PETS , CLEANING: CLEANING  } = surcharges;
        SURCHARGE_IDS = `${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).cleaningFee},${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).petFee}`;
        SURCHARGE_AMOUNT_PETS = Number(PETS.FEE);
        SURCHARGE_AMOUNT_CLEANING = Number(CLEANING.FEE);
    } else if (isCleaningFeeEnabled) {
        const { CLEANING: CLEANING  } = surcharges;
        SURCHARGE_IDS = `${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).cleaningFee}`;
        SURCHARGE_AMOUNT_CLEANING = Number(CLEANING.FEE);
    } else if (isPetFeeEnabled) {
        const { PETS: PETS  } = surcharges;
        SURCHARGE_IDS = `${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).petFee}`;
        SURCHARGE_AMOUNT_PETS = Number(PETS.FEE);
    }
    return {
        SURCHARGE_IDS: SURCHARGE_IDS,
        SURCHARGE_AMOUNT_PETS: SURCHARGE_AMOUNT_PETS,
        SURCHARGE_AMOUNT_CLEANING: SURCHARGE_AMOUNT_CLEANING
    };
};
const $00bb5d2e544b2c13$export$fc5d1bab0ab8127d = (booking)=>{
    const { DATES: { ARRIVAL: ARRIVAL  } , FLAGS: { IS_DIRECT_VACATIONS: IS_DIRECT_VACATIONS  } , GUEST: { EMAIL: EMAIL  } , ID: ID , NIGHTS: NIGHTS , NOTES_OWNER: NOTES_OWNER , PARTY_SIZE: { ADULTS: ADULTS , KIDS: KIDS  } , PAYMENT: { BALANCE: { DUE_DATE: balanceDueDate  } , DAMAGE_DEPOSIT: { AMOUNT: damageDepositAmount , MODE_ID: MODE_ID  } , DEPOSIT: { PERCENTAGE: PERCENTAGE , DUE_DATE: DUE_DATE  } , PRICE_PER_NIGHT: PRICE_PER_NIGHT ,  } , PAYMENT_INFORMATION: { BOOKING_NET_BASE_RATE_MINUS_LOS: BOOKING_NET_BASE_RATE_MINUS_LOS  } , PROPERTY: { ID: PROPERTY_ID  } , SURCHARGES: { LIST: LIST  } ,  } = booking;
    const surchargeParams = $00bb5d2e544b2c13$var$generateSurchargeParams(LIST);
    return {
        ...surchargeParams,
        ALLURA_GIFT_CERTIFICATE_CODE: booking.GIFT_CERTIFICATES.ALLURA.OFFER ? booking.GIFT_CERTIFICATES.ALLURA.OFFER.CODE : "",
        ALLURA_GIFT_CERTIFICATE_ID: booking.GIFT_CERTIFICATES.ALLURA.OFFER ? booking.GIFT_CERTIFICATES.ALLURA.OFFER.OFFER_ID : "",
        ALLURA_OFFER_CODE: booking.OFFERS.ALLURA.OFFER ? booking.OFFERS.ALLURA.OFFER.CODE : "",
        ALLURA_OFFER_ID: booking.OFFERS.ALLURA.OFFER ? booking.OFFERS.ALLURA.OFFER.OFFER_ID : "",
        ARRIVAL: ARRIVAL,
        BALANCE_DUE_DATE: balanceDueDate,
        BOOKING_NET: BOOKING_NET_BASE_RATE_MINUS_LOS,
        DAMAGE_DEPOSIT_AMOUNT: damageDepositAmount,
        DAMAGE_DEPOSIT_MODE_ID: MODE_ID,
        DEPOSIT_PERCENTAGE: PERCENTAGE,
        DEPOSIT_DUE_DATE: DUE_DATE,
        GUEST_EMAIL: EMAIL,
        ID: ID,
        IS_DIRECT_VACATIONS: IS_DIRECT_VACATIONS,
        OWNER_GIFT_CERTIFICATE_CODE: booking.GIFT_CERTIFICATES.OWNER.OFFER ? booking.GIFT_CERTIFICATES.OWNER.OFFER.CODE : "",
        OWNER_GIFT_CERTIFICATE_ID: booking.GIFT_CERTIFICATES.OWNER.OFFER ? booking.GIFT_CERTIFICATES.OWNER.OFFER.OFFER_ID : "",
        OWNER_OFFER_CODE: booking.OFFERS.OWNER.OFFER ? booking.OFFERS.OWNER.OFFER.CODE : "",
        OWNER_OFFER_ID: booking.OFFERS.OWNER.OFFER ? booking.OFFERS.OWNER.OFFER.OFFER_ID : "",
        PRICE_PER_NIGHT: Number(PRICE_PER_NIGHT),
        NIGHTS: NIGHTS,
        NOTES_OWNER: NOTES_OWNER,
        PARTY_SIZE_ADULTS: ADULTS,
        PARTY_SIZE_KIDS: KIDS,
        PROPERTY_ID: PROPERTY_ID
    };
};
const $00bb5d2e544b2c13$export$2cbe9b6e6bc0a416 = (booking)=>{
    const { PAYMENT: { AMOUNT_OUTSTANDING: AMOUNT_OUTSTANDING , DEPOSIT: { PAYMENT_DATE: DEPOSIT_PAYMENT_DATE , PERCENTAGE: PERCENTAGE  } , DAMAGE_DEPOSIT: { AMOUNT: AMOUNT  } ,  } ,  } = booking;
    const hasPaidDeposit = Boolean(DEPOSIT_PAYMENT_DATE);
    const hasPaidFull = Number(AMOUNT_OUTSTANDING) === 0;
    const isFullPayment = Number(PERCENTAGE) === 100;
    const hasDamangeDepositAmount = Number(AMOUNT) > 0;
    return {
        hasPaidDeposit: hasPaidDeposit,
        hasPaidFull: hasPaidFull,
        isFullPayment: isFullPayment,
        hasDamangeDepositAmount: hasDamangeDepositAmount
    };
};
const $00bb5d2e544b2c13$export$530b093149d3ddda = (isPetFeeEnabled, isCleaningFeeEnabled)=>{
    const bothFees = `${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).petFee.toString()},${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).cleaningFee.toString()}`;
    const cleaningFeeID = `${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).cleaningFee.toString()}`;
    const petsFeeID = `${(0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).petFee.toString()}`;
    if (isPetFeeEnabled && isCleaningFeeEnabled) return bothFees;
    if (isCleaningFeeEnabled) return cleaningFeeID;
    if (isPetFeeEnabled) return petsFeeID;
    return "";
};
const $00bb5d2e544b2c13$export$e09b0625208a9686 = (surcharges)=>{
    const petFee = surcharges.find((item)=>item.ID === (0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).petFee);
    const cleaningFee = surcharges.find((item)=>item.ID === (0, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd).cleaningFee);
    const { AMOUNT: petFeeAmount , IS_ENABLED: isPetFeeEnabled  } = petFee;
    const { AMOUNT: cleaningFeeAmount , IS_ENABLED: isCleaningFeeEnabled  } = cleaningFee;
    const surchargeIds = $00bb5d2e544b2c13$export$530b093149d3ddda(isPetFeeEnabled, isCleaningFeeEnabled);
    return {
        petFeeAmount: petFeeAmount,
        isPetFeeEnabled: isPetFeeEnabled,
        cleaningFeeAmount: cleaningFeeAmount,
        isCleaningFeeEnabled: isCleaningFeeEnabled,
        surchargeIds: surchargeIds
    };
};
const $00bb5d2e544b2c13$export$7da6b32e5aa90ab6 = (arrival, balanceDaysBefore)=>{
    const nightsUntilArrival = (0, $3a8449e3b3bae2ba$export$24939cc9aa7cde05)({
        date1: new Date(),
        date2: arrival
    });
    return nightsUntilArrival <= balanceDaysBefore;
};
const $00bb5d2e544b2c13$export$db51906af7c62020 = (start, balanceDaysBeforeArrival, propertyDepositPercentage)=>{
    const today = (0, $iPNDK$dayjs)();
    const arrivalDayJs = (0, $iPNDK$dayjs)(start);
    const dateDifference = arrivalDayJs.diff(today, "day");
    const isWithinBalanceDaysBeforeArrival = dateDifference <= balanceDaysBeforeArrival;
    const balanceDueDate = (0, $3a8449e3b3bae2ba$export$160d2a3734a06909)(arrivalDayJs.subtract(balanceDaysBeforeArrival, "day").toDate());
    const BALANCE_DUE_DATE = isWithinBalanceDaysBeforeArrival ? (0, $3a8449e3b3bae2ba$export$160d2a3734a06909)(today) : balanceDueDate;
    const DEPOSIT_PERCENTAGE = isWithinBalanceDaysBeforeArrival ? 100 : propertyDepositPercentage;
    const DEPOSIT_DUE_DATE = (0, $3a8449e3b3bae2ba$export$160d2a3734a06909)(new Date());
    return {
        PRICE_PER_NIGHT: 0,
        BOOKING_NET: "",
        BALANCE_DUE_DATE: BALANCE_DUE_DATE,
        DEPOSIT_DUE_DATE: DEPOSIT_DUE_DATE,
        DEPOSIT_PERCENTAGE: DEPOSIT_PERCENTAGE
    };
};
const $00bb5d2e544b2c13$export$b0d0ff6e9ab3df6e = (booking)=>{
    return booking.PAYMENT.DAMAGE_DEPOSIT.IS_COLLECTED;
};


var $1dd1ec38008cf543$exports = {};

$parcel$export($1dd1ec38008cf543$exports, "generateReadableAddress", () => $1dd1ec38008cf543$export$d94eba43f0f0d984);

function $1dd1ec38008cf543$export$d94eba43f0f0d984(address) {
    return `${address.STREET_NUMBER} ${(0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(address.STREET_NAME)}, ${address.POSTAL?.toUpperCase()}, ${(0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(address.CITY)}, ${address.COUNTRY}`;
}


var $5256ee46813311f1$exports = {};

$parcel$export($5256ee46813311f1$exports, "propertyHasAmenity", () => $5256ee46813311f1$export$1e4708a31779fc93);
$parcel$export($5256ee46813311f1$exports, "getPropertyAmenity", () => $5256ee46813311f1$export$a8e2caab532cdbe3);
$parcel$export($5256ee46813311f1$exports, "amenityHasInstructions", () => $5256ee46813311f1$export$d6240ea95b142);
$parcel$export($5256ee46813311f1$exports, "amenityHasDescription", () => $5256ee46813311f1$export$c93da72bf23dff0c);
$parcel$export($5256ee46813311f1$exports, "isWifiAmenity", () => $5256ee46813311f1$export$dd028bde6dd8818f);
$parcel$export($5256ee46813311f1$exports, "amenityHasAccessCode", () => $5256ee46813311f1$export$4c230bf9a3405679);
$parcel$export($5256ee46813311f1$exports, "generateAmenity", () => $5256ee46813311f1$export$3537c509f2356f9);


function $5256ee46813311f1$export$1e4708a31779fc93({ property: property , formAmenity: formAmenity , section: section  }) {
    const amenity = $5256ee46813311f1$export$a8e2caab532cdbe3({
        property: property,
        formAmenity: formAmenity,
        section: section
    });
    return amenity !== undefined;
}
function $5256ee46813311f1$export$a8e2caab532cdbe3({ property: property , formAmenity: formAmenity , section: section  }) {
    const amenitySection = property.AMENITIES[section].LIST;
    const amenity = amenitySection.find(({ ID: ID  })=>ID === formAmenity.ID);
    return amenity;
}
function $5256ee46813311f1$export$d6240ea95b142(amenity) {
    return (0, $a8b1bbfd45d27b19$export$3ee3e334b3482a86)(amenity.INSTRUCTIONS).length > 0;
}
function $5256ee46813311f1$export$c93da72bf23dff0c(amenity) {
    return amenity.DESCRIPTION.length > 0;
}
function $5256ee46813311f1$export$dd028bde6dd8818f(amenityId) {
    return amenityId === (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).WIFI;
}
function $5256ee46813311f1$export$4c230bf9a3405679(amenityId) {
    const accessCodeAmenities = [
        // Hot tub and pool are synced
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_HOT_TUB,
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_POOL,
        // Sauna and Steam Room are synced
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_SAUNA,
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_STEAM_ROOM,
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_BIKE_STORAGE,
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_SKI_STORAGE,
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_FITNESS_FACILITIES,
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_GAMES_REC_ROOM,
        (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).WIFI, 
    ];
    return Boolean(amenityId) && !$5256ee46813311f1$export$dd028bde6dd8818f(amenityId) && accessCodeAmenities.includes(amenityId);
}
function $5256ee46813311f1$export$3537c509f2356f9({ ID: ID , NAME: NAME , INSTRUCTIONS: INSTRUCTIONS , DESCRIPTION: DESCRIPTION , PROPERTY_AMENITY_ID: // 0 indicates that the property amenity is not enabled
PROPERTY_AMENITY_ID = 0 , ACCESS_CODE: ACCESS_CODE = "" , INTERNET_NETWORK_NAME: INTERNET_NETWORK_NAME = "" , INTERNET_PASSWORD: INTERNET_PASSWORD = ""  }) {
    return {
        ID: ID,
        NAME: NAME,
        INSTRUCTIONS: INSTRUCTIONS,
        DESCRIPTION: DESCRIPTION,
        PROPERTY_AMENITY_ID: PROPERTY_AMENITY_ID,
        ACCESS_CODE: ACCESS_CODE,
        INTERNET_NETWORK_NAME: INTERNET_NETWORK_NAME,
        INTERNET_PASSWORD: INTERNET_PASSWORD
    };
}


var $a84b1293d9fa5558$exports = {};

$parcel$export($a84b1293d9fa5558$exports, "PropertyAmenityCategories", () => $a84b1293d9fa5558$export$9f4542f3d753ad0);
let $a84b1293d9fa5558$export$9f4542f3d753ad0;
(function(PropertyAmenityCategories1) {
    PropertyAmenityCategories1["BUILDING"] = "BUILDING";
    PropertyAmenityCategories1["ESSENTIAL"] = "ESSENTIAL";
    PropertyAmenityCategories1["KITCHEN"] = "KITCHEN";
    PropertyAmenityCategories1["PRIVATE"] = "PRIVATE";
    PropertyAmenityCategories1["SAFETY"] = "SAFETY";
})($a84b1293d9fa5558$export$9f4542f3d753ad0 || ($a84b1293d9fa5558$export$9f4542f3d753ad0 = {}));


var $83c4c25512facf26$exports = {};

$parcel$export($83c4c25512facf26$exports, "CreateMessage", () => $83c4c25512facf26$export$cd1477ab9d657d2b);



const $83c4c25512facf26$export$cd1477ab9d657d2b = {
    generateMessageSubjectTitle (userContact, userType) {
        switch(userType){
            case (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).guest:
                return `${userContact.PROPERTY.NAME} - ${userContact.BOOKING.REFERENCE}`;
            case (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).owner:
                if (userContact.CONTACT.NAME) return `${userContact.CONTACT.NAME}`;
                else return `${userContact.CONTACT.EMAIL}`;
            default:
                return "";
        }
    },
    generateMessageSubjectSubtitle (userContact, userType) {
        const arrivalDepartureSubtitle = `${(0, $3a8449e3b3bae2ba$export$757a5dfffbfdba69)((0, $iPNDK$dayjs)(userContact.BOOKING.ARRIVAL_DATE))} - ${(0, $3a8449e3b3bae2ba$export$757a5dfffbfdba69)((0, $iPNDK$dayjs)(userContact.BOOKING.DEPARTURE_DATE))}`;
        switch(userType){
            case (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).guest:
                return arrivalDepartureSubtitle;
            case (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).owner:
                return arrivalDepartureSubtitle;
            default:
                return "";
        }
    },
    generateMessageSubjectThumbnail (userContact, userType) {
        switch(userType){
            case (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).guest:
                return userContact.PROPERTY.THUMBNAIL;
            case (0, $af33674cdb61992e$export$37c8f1bc2ef2e9b9).owner:
                return userContact.CONTACT.THUMBNAIL;
            default:
                return "";
        }
    }
};


var $4ebca2e3fbd7b3e2$exports = {};

$parcel$export($4ebca2e3fbd7b3e2$exports, "getMapsKey", () => $4ebca2e3fbd7b3e2$export$b0a66abe0bb8f2b1);
$parcel$export($4ebca2e3fbd7b3e2$exports, "generateMapsAddressURL", () => $4ebca2e3fbd7b3e2$export$b8790e04d2cac4ac);
$parcel$export($4ebca2e3fbd7b3e2$exports, "generateQueryFromAddress", () => $4ebca2e3fbd7b3e2$export$37085608197d43cc);
$parcel$export($4ebca2e3fbd7b3e2$exports, "generateMapsEmbedAddressURL", () => $4ebca2e3fbd7b3e2$export$2e2d7a1b663e2c78);
var $b06bca09715070a3$exports = {};

$parcel$export($b06bca09715070a3$exports, "developmentMapsKey", () => $b06bca09715070a3$export$12157e85073da9e);
$parcel$export($b06bca09715070a3$exports, "liveMapsKey", () => $b06bca09715070a3$export$67a0a4d6602f5512);
const $b06bca09715070a3$export$12157e85073da9e = "AIzaSyBWM3cDz-C4uU-WlG3K1jjdLkaFbLPtzek";
const $b06bca09715070a3$export$67a0a4d6602f5512 = "AIzaSyBWM3cDz-C4uU-WlG3K1jjdLkaFbLPtzek";


const $4ebca2e3fbd7b3e2$export$b0a66abe0bb8f2b1 = ({ isLive: isLive  })=>{
    return isLive ? (0, $b06bca09715070a3$export$67a0a4d6602f5512) : (0, $b06bca09715070a3$export$12157e85073da9e);
};
const $4ebca2e3fbd7b3e2$var$BASE_MAPS_URL = "https://maps.google.com/";
const $4ebca2e3fbd7b3e2$var$MAPS_EMBED_URL_V1 = "https://www.google.com/maps/embed/v1/";
function $4ebca2e3fbd7b3e2$export$b8790e04d2cac4ac(address) {
    const query = $4ebca2e3fbd7b3e2$export$37085608197d43cc(address);
    return `${$4ebca2e3fbd7b3e2$var$BASE_MAPS_URL}?q=${query}&libraries=places`;
}
function $4ebca2e3fbd7b3e2$export$2e2d7a1b663e2c78({ address: address , isLive: isLive  }) {
    const type = "place";
    const key = $4ebca2e3fbd7b3e2$export$b0a66abe0bb8f2b1({
        isLive: isLive
    });
    const query = $4ebca2e3fbd7b3e2$export$37085608197d43cc(address);
    return `${$4ebca2e3fbd7b3e2$var$MAPS_EMBED_URL_V1}${type}?key=${key}&q=${query}`;
}
function $4ebca2e3fbd7b3e2$export$37085608197d43cc({ STREET_NUMBER: STREET_NUMBER , STREET_NAME: STREET_NAME , CITY: CITY , REGION: REGION , POSTAL: POSTAL  }) {
    const formattedAddress = `${STREET_NUMBER} ${STREET_NAME}, ${CITY}, ${REGION} ${POSTAL}`;
    const query = encodeURIComponent(formattedAddress);
    return query;
}


var $bf2829f82ac33726$exports = {};

$parcel$export($bf2829f82ac33726$exports, "editorURLParamsEnum", () => $bf2829f82ac33726$export$ecf914f6fd16fa4d);
$parcel$export($bf2829f82ac33726$exports, "getGuidebookAccessCode", () => $bf2829f82ac33726$export$847b7704b594a1c5);
$parcel$export($bf2829f82ac33726$exports, "getGuidebookWifiDetails", () => $bf2829f82ac33726$export$dad0e684932e1051);
$parcel$export($bf2829f82ac33726$exports, "hasGuidebookAmenity", () => $bf2829f82ac33726$export$b6698eb7056ecd11);
$parcel$export($bf2829f82ac33726$exports, "hasGuidebookWifiAmenity", () => $bf2829f82ac33726$export$1143cb93fd115f3c);
$parcel$export($bf2829f82ac33726$exports, "getGuidebookDirectionsToProperty", () => $bf2829f82ac33726$export$4a3ea29d96f701b7);
$parcel$export($bf2829f82ac33726$exports, "guidebookHtmlAsString", () => $bf2829f82ac33726$export$ec405dce66c4e156);
$parcel$export($bf2829f82ac33726$exports, "isAmenitySkiOrBike", () => $bf2829f82ac33726$export$803a3a733d037788);

var $a712f15b2b78b7e9$exports = {};

$parcel$export($a712f15b2b78b7e9$exports, "EditorFieldEnum", () => $a712f15b2b78b7e9$export$298b4e731fc0ce2d);
let $a712f15b2b78b7e9$export$298b4e731fc0ce2d;
(function(EditorFieldEnum1) {
    EditorFieldEnum1[// Arrival instructions
    "welcomeMessage"] = "Welcome Message";
    EditorFieldEnum1["parkingInstructions"] = "Parking Instructions";
    EditorFieldEnum1["checkIn"] = "Check-In Procedure";
    EditorFieldEnum1["gettingToUnit"] = "Directions to Property";
    EditorFieldEnum1["frontDesk"] = "Front-Desk Details";
    EditorFieldEnum1["whatToBring"] = "What to bring with you";
    EditorFieldEnum1["lateCheckIn"] = "Late Check-In Procedure";
    EditorFieldEnum1[// Stay Instructions
    "locationSummary"] = "Location Summary";
    EditorFieldEnum1["heating"] = "Heating";
    EditorFieldEnum1["aboutBuilding"] = "About the Building";
    EditorFieldEnum1["emergencyContactProcedure"] = "Emergency Contact Procedure";
    EditorFieldEnum1["directionsToSkiLift"] = "Directions To Ski Lifts";
    EditorFieldEnum1["skiInOut"] = "Ski In / Ski Out Instructions";
    EditorFieldEnum1["gettingAround"] = "Getting Around the Area";
    EditorFieldEnum1["linens"] = "Extra Towels & Linens";
    EditorFieldEnum1["restaurants"] = "Restaurants";
    EditorFieldEnum1["services"] = "Services & Activities";
    EditorFieldEnum1["houseKeeping"] = "House Keeping Details";
    EditorFieldEnum1["other"] = "Other";
    EditorFieldEnum1[// Departure Instructions
    "checkOut"] = "Check-Out Process";
    EditorFieldEnum1["garbage"] = "Garbage Removal";
})($a712f15b2b78b7e9$export$298b4e731fc0ce2d || ($a712f15b2b78b7e9$export$298b4e731fc0ce2d = {}));



const $bf2829f82ac33726$export$ecf914f6fd16fa4d = {
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).aboutBuilding]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).aboutTheBuilding,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).checkIn]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).checkIn,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).checkOut]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).checkOut,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).directionsToSkiLift]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).toFromLifts,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).emergencyContactProcedure]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).emergencyContacts,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).frontDesk]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).frontDesk,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).garbage]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).garbageAndRecycling,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).gettingAround]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).gettingAround,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).heating]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).heating,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).houseKeeping]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).housekeeping,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).lateCheckIn]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).lateCheckIn,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).linens]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).linensAndTowels,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).locationSummary]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).location,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).other]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).other,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).parkingInstructions]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).parking,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).welcomeMessage]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).welcome,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).restaurants]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).restaurants,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).services]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).services,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).skiInOut]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).skiInSkiOut,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).whatToBring]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).whatToBring,
    [(0, $a712f15b2b78b7e9$export$298b4e731fc0ce2d).gettingToUnit]: (0, $f58c18151396e867$export$c51b307d7f17f9e8).gettingToUnit
};
function $bf2829f82ac33726$export$847b7704b594a1c5(guidebook) {
    const { PROPERTY_GUIDEBOOK: { SECTIONS: { ARRIVAL: { ACCESS_DETAILS: { DATA: { DETAILS: DETAILS  } ,  } ,  } ,  } ,  } ,  } = guidebook;
    const doorCodeName = "Door Code";
    const doorCode = DETAILS.find((accessSection)=>{
        return accessSection.NAME === doorCodeName;
    });
    if (!doorCode) {
        const accessCodeDeliveryName = "Access Code Delivery";
        const accessCodeDelivery = DETAILS.find((accessSection)=>{
            return accessSection.NAME === accessCodeDeliveryName;
        });
        if (!accessCodeDelivery || accessCodeDelivery.VALUE === "Other") return "Please review the access information in the guidebook";
        else return accessCodeDelivery.VALUE;
    }
    return doorCode ? `${doorCode.VALUE}` : "";
}
function $bf2829f82ac33726$export$dad0e684932e1051(guidebook) {
    const { PROPERTY_GUIDEBOOK: { PROPERTY: { CODES: { INTERNET_PASSWORD: INTERNET_PASSWORD , INTERNET_NETWORK_NAME: INTERNET_NETWORK_NAME  } ,  } , SECTIONS: { PROPERTY_AMENITIES: { ESSENTIALS: ESSENTIALS  } ,  } ,  } ,  } = guidebook;
    if (INTERNET_PASSWORD.length > 0) {
        const nameString = INTERNET_NETWORK_NAME ? `Name: ${INTERNET_NETWORK_NAME}` : "";
        const passwordString = `Password: ${INTERNET_PASSWORD}`;
        const finalString = nameString ? `${nameString}\n${passwordString}` : passwordString;
        return finalString;
    }
    const wifiAmenity = ESSENTIALS.DATA.find((amenity)=>amenity.ID === (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).WIFI);
    if (wifiAmenity) return "Wifi Available. Details located in the unit";
    return "This property may not have wifi available. Please contact host";
}
function $bf2829f82ac33726$export$b6698eb7056ecd11(guidebook, amenityId) {
    const { PROPERTY_GUIDEBOOK: { SECTIONS: { BUILDING_FACILITIES: { BUILDING_AMENITIES: BUILDING_AMENITIES  } , PROPERTY_AMENITIES: { ESSENTIALS: ESSENTIALS , KITCHEN: KITCHEN , PRIVATE: PRIVATE , SAFETY: SAFETY  } ,  } ,  } ,  } = guidebook;
    const result = [
        ...BUILDING_AMENITIES.DATA,
        ...ESSENTIALS.DATA,
        ...KITCHEN.DATA,
        ...PRIVATE.DATA,
        ...SAFETY.DATA, 
    ].find((amenity)=>amenity.ID === amenityId);
    return Boolean(result);
}
function $bf2829f82ac33726$export$1143cb93fd115f3c(guidebook) {
    return $bf2829f82ac33726$export$b6698eb7056ecd11(guidebook, (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).WIFI);
}
function $bf2829f82ac33726$export$4a3ea29d96f701b7(guidebook) {
    const { PROPERTY_GUIDEBOOK: { SECTIONS: { ARRIVAL: { DIRECTIONS_TO_PROPERTY: { DATA: { HTML: HTML  } ,  } ,  } ,  } ,  } ,  } = guidebook;
    // Owner location instructions always appear as the first element
    if (HTML.length > 0) return HTML[0];
    return "";
}
function $bf2829f82ac33726$export$ec405dce66c4e156(html) {
    if (typeof html === "string") return html;
    return html.join("<br/>");
}
function $bf2829f82ac33726$export$803a3a733d037788(amenity) {
    return amenity.ID === (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_BIKE_STORAGE || amenity.ID === (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).BUILDING_SKI_STORAGE || amenity.ID === (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).PRIVATE_BIKE_STORAGE || amenity.ID === (0, $b9fbf0da9ae592a3$export$ca089115c6d1f1f).PRIVATE_SKI_STORAGE;
}



var $f960865984b13562$exports = {};

$parcel$export($f960865984b13562$exports, "dashboardLinkStatuses", () => $f960865984b13562$export$861dcb1bd7fa96bf);
$parcel$export($f960865984b13562$exports, "onboardingLinkStatuses", () => $f960865984b13562$export$baa8f6924c47a6);
$parcel$export($f960865984b13562$exports, "calculateIsGatewayOpen", () => $f960865984b13562$export$c73ffc653310bde9);
$parcel$export($f960865984b13562$exports, "calculateIsPremium", () => $f960865984b13562$export$5fb9228be1acec1b);
$parcel$export($f960865984b13562$exports, "calculateIsStandard", () => $f960865984b13562$export$3f1fe1d96d827505);
$parcel$export($f960865984b13562$exports, "calculateIsActive", () => $f960865984b13562$export$195de5b68bab1534);
$parcel$export($f960865984b13562$exports, "calculateIsDisabled", () => $f960865984b13562$export$af8508867d7b4eed);
$parcel$export($f960865984b13562$exports, "calculateIsInactive", () => $f960865984b13562$export$2760acae0a8786ef);
$parcel$export($f960865984b13562$exports, "calculateIsRequestActivation", () => $f960865984b13562$export$dce8fd8b9b69dbc1);
$parcel$export($f960865984b13562$exports, "calculateCanUpgradeToPremium", () => $f960865984b13562$export$68435993ea9cf7ab);
$parcel$export($f960865984b13562$exports, "calculateIsMigrating", () => $f960865984b13562$export$6fccf89dcd2a1725);
$parcel$export($f960865984b13562$exports, "calculateIsComplete", () => $f960865984b13562$export$c145f7b5edabef1);
$parcel$export($f960865984b13562$exports, "calculateCanDeactivate", () => $f960865984b13562$export$14f5e0c287eba35f);
$parcel$export($f960865984b13562$exports, "defaultPropertyTitle", () => $f960865984b13562$export$97961e9c333d05a1);
$parcel$export($f960865984b13562$exports, "generatePropertyTitle", () => $f960865984b13562$export$e184c86caa459c6e);
$parcel$export($f960865984b13562$exports, "generateStreetNumberNameTitle", () => $f960865984b13562$export$df7e1eb037725ce4);
$parcel$export($f960865984b13562$exports, "generateDevelopmentUnitTitle", () => $f960865984b13562$export$2bb9fb4da4c31eea);
$parcel$export($f960865984b13562$exports, "generatePropertySubtitle", () => $f960865984b13562$export$fceae0a5274caf6e);
$parcel$export($f960865984b13562$exports, "bedroomBathroomDisplay", () => $f960865984b13562$export$7155dd7e090f6816);
$parcel$export($f960865984b13562$exports, "chaletOrHouse", () => $f960865984b13562$export$3dafb0fc3dc491c8);
$parcel$export($f960865984b13562$exports, "calculatePropertyUnitNumberDisplay", () => $f960865984b13562$export$76b9cad839afc8c);
$parcel$export($f960865984b13562$exports, "calculateCanSignIn", () => $f960865984b13562$export$ecd3817b9158ca90);
$parcel$export($f960865984b13562$exports, "generatePropertyString", () => $f960865984b13562$export$9e771e51bfacb007);
$parcel$export($f960865984b13562$exports, "isPropertyInWhistler", () => $f960865984b13562$export$7741b297d92354fb);
$parcel$export($f960865984b13562$exports, "isPropertyInBigWhite", () => $f960865984b13562$export$5c9baa036a7db21b);
$parcel$export($f960865984b13562$exports, "hasPropertyContact", () => $f960865984b13562$export$94d3b062bfaac8b5);



const $f960865984b13562$export$861dcb1bd7fa96bf = [
    (0, $f58c18151396e867$export$aa113f941bb73d74).ListingActive,
    (0, $f58c18151396e867$export$aa113f941bb73d74).ListingInactive,
    (0, $f58c18151396e867$export$aa113f941bb73d74).DeactivationRequested, 
];
const $f960865984b13562$export$baa8f6924c47a6 = [
    (0, $f58c18151396e867$export$aa113f941bb73d74).NotStarted,
    (0, $f58c18151396e867$export$aa113f941bb73d74).InProgress,
    (0, $f58c18151396e867$export$aa113f941bb73d74).FormsCompleted,
    (0, $f58c18151396e867$export$aa113f941bb73d74).ActivationRequested,
    (0, $f58c18151396e867$export$aa113f941bb73d74).AskedForMoreInformation,
    (0, $f58c18151396e867$export$aa113f941bb73d74).SetUpInProgress, 
];
const $f960865984b13562$export$c73ffc653310bde9 = (propertyGatewayModeId)=>propertyGatewayModeId === (0, $f58c18151396e867$export$3fea48cce2b57a8b).open;
const $f960865984b13562$export$5fb9228be1acec1b = (subscriptionTierId)=>subscriptionTierId === (0, $f58c18151396e867$export$eb581bc54c390a17).PREMIUM;
const $f960865984b13562$export$3f1fe1d96d827505 = (subscriptionTierId)=>subscriptionTierId === (0, $f58c18151396e867$export$eb581bc54c390a17).STANDARD;
const $f960865984b13562$export$195de5b68bab1534 = (joinStatusId)=>joinStatusId === (0, $f58c18151396e867$export$aa113f941bb73d74).ListingActive;
const $f960865984b13562$export$af8508867d7b4eed = (joinStatusId)=>joinStatusId === (0, $f58c18151396e867$export$aa113f941bb73d74).ListingDisabled;
const $f960865984b13562$export$2760acae0a8786ef = (joinStatusId)=>joinStatusId === (0, $f58c18151396e867$export$aa113f941bb73d74).ListingInactive;
const $f960865984b13562$export$dce8fd8b9b69dbc1 = (joinStatusId)=>joinStatusId === (0, $f58c18151396e867$export$aa113f941bb73d74).ActivationRequested;
const $f960865984b13562$export$68435993ea9cf7ab = (joinStatusId)=>{
    return joinStatusId === (0, $f58c18151396e867$export$aa113f941bb73d74).ListingActive;
};
const $f960865984b13562$export$6fccf89dcd2a1725 = (joinStatusId)=>{
    return joinStatusId === (0, $f58c18151396e867$export$aa113f941bb73d74).SetUpInProgress;
};
const $f960865984b13562$export$c145f7b5edabef1 = (completionPercentage)=>{
    return completionPercentage === 100;
};
const $f960865984b13562$export$14f5e0c287eba35f = (joinStatusId)=>{
    return joinStatusId !== (0, $f58c18151396e867$export$aa113f941bb73d74).DeactivationRequested;
};
const $f960865984b13562$export$97961e9c333d05a1 = "--";
function $f960865984b13562$export$e184c86caa459c6e(info) {
    const { DEVELOPMENT: DEVELOPMENT , UNIT: UNIT , STREET_NUMBER: STREET_NUMBER , STREET_NAME: STREET_NAME  } = info;
    const hasDevelopment = (0, $a8b1bbfd45d27b19$export$7ad75c69830b76d7)(DEVELOPMENT);
    const noLocationInfo = !(0, $a8b1bbfd45d27b19$export$7ad75c69830b76d7)(STREET_NUMBER) || !(0, $a8b1bbfd45d27b19$export$7ad75c69830b76d7)(STREET_NAME);
    if (!hasDevelopment) return $f960865984b13562$export$97961e9c333d05a1;
    if ($f960865984b13562$var$isChaletOrHouse(DEVELOPMENT)) {
        if (noLocationInfo) return $f960865984b13562$export$97961e9c333d05a1;
        return $f960865984b13562$export$df7e1eb037725ce4(STREET_NUMBER, STREET_NAME);
    }
    return $f960865984b13562$export$2bb9fb4da4c31eea(DEVELOPMENT, UNIT);
}
function $f960865984b13562$export$fceae0a5274caf6e({ propertyId: propertyId , numBedrooms: numBedrooms , numBathrooms: numBathrooms  }) {
    return `(#${propertyId}) - ${$f960865984b13562$export$7155dd7e090f6816(numBedrooms, numBathrooms)}`;
}
const $f960865984b13562$export$3dafb0fc3dc491c8 = "Chalet/House";
function $f960865984b13562$var$isChaletOrHouse(development) {
    return development?.toLowerCase() === $f960865984b13562$export$3dafb0fc3dc491c8.toLowerCase();
}
function $f960865984b13562$export$df7e1eb037725ce4(streetNumber, streetName) {
    return `${streetNumber} ${streetName}`;
}
function $f960865984b13562$export$2bb9fb4da4c31eea(development, unit) {
    const hasUnit = (0, $a8b1bbfd45d27b19$export$7ad75c69830b76d7)(unit);
    const unitTitle = hasUnit ? ` ${$f960865984b13562$export$76b9cad839afc8c(unit)}` : "";
    return `${development}${unitTitle}`;
}
function $f960865984b13562$export$7155dd7e090f6816(bedrooms, bathrooms) {
    const hasMultipleBedrooms = bedrooms > 1;
    const hasMultipleBathrooms = bathrooms > 1;
    return `${bedrooms} Bedroom${hasMultipleBedrooms ? "s" : ""} / ${bathrooms} Bathroom${hasMultipleBathrooms ? "s" : ""}`;
}
function $f960865984b13562$export$76b9cad839afc8c(unitNumber) {
    if (unitNumber.length === 0) return "";
    const firstChar = unitNumber[0];
    if (firstChar === "#" || Number.isNaN(parseInt(unitNumber))) return unitNumber;
    return `#${unitNumber}`;
}
function $f960865984b13562$export$ecd3817b9158ca90(joinStatusId, hasCompletedOnboarding) {
    if ($f960865984b13562$export$861dcb1bd7fa96bf.includes(joinStatusId) || $f960865984b13562$export$baa8f6924c47a6.includes(joinStatusId)) return true;
    // allow owner to access dashboard, get reports and info before property is deactivated
    if (joinStatusId === (0, $f58c18151396e867$export$aa113f941bb73d74).DeactivationRequested && hasCompletedOnboarding) return true;
    return false;
}
const $f960865984b13562$export$9e771e51bfacb007 = ({ propertyId: propertyId , propertyDevelopment: propertyDevelopment , propertyUnit: propertyUnit  })=>`#${propertyId} -${propertyDevelopment} #${propertyUnit}`;
function $f960865984b13562$export$7741b297d92354fb({ resortId: resortId  }) {
    return resortId === (0, $4c2910318d75849f$export$7b9501c439aced6c).Whistler;
}
function $f960865984b13562$export$5c9baa036a7db21b({ resortId: resortId  }) {
    return resortId === (0, $4c2910318d75849f$export$7b9501c439aced6c).BigWhite;
}
function $f960865984b13562$export$94d3b062bfaac8b5(property) {
    const propertyContact = property.PROPERTY_CONTACT;
    if (!propertyContact) return false;
    if (Object.keys(propertyContact).length === 0) return false;
    if (propertyContact.ID <= 0) return false;
    if (!propertyContact.PHONE) return false;
    return true;
}


var $1862358f5c08780c$exports = {};

$parcel$export($1862358f5c08780c$exports, "simplifyData", () => $1862358f5c08780c$export$d73bac4e066c2c0c);
function $1862358f5c08780c$export$d73bac4e066c2c0c(data) {
    if (!data) return undefined;
    const { SUCCESS: SUCCESS , DATA: DATA , MESSAGE: MESSAGE  } = data;
    const simplifiedData = DATA ? "Received Data" : "No Data";
    return {
        SUCCESS: SUCCESS,
        DATA: simplifiedData,
        MESSAGE: MESSAGE
    };
}


var $88e6e90e7438fc40$exports = {};

$parcel$export($88e6e90e7438fc40$exports, "RequestTracking", () => $88e6e90e7438fc40$export$bff5fc2244f2d8b8);
$parcel$export($88e6e90e7438fc40$exports, "MAX_REQUESTS_TRACKED", () => $88e6e90e7438fc40$export$347800b3f539a6bb);
$parcel$export($88e6e90e7438fc40$exports, "requestTracking", () => $88e6e90e7438fc40$export$71b0009a88aa26d5);

class $88e6e90e7438fc40$export$bff5fc2244f2d8b8 {
    constructor(maxLen){
        this.maxLen = maxLen;
        this.requests = [];
        if ($88e6e90e7438fc40$export$bff5fc2244f2d8b8._instance) return $88e6e90e7438fc40$export$bff5fc2244f2d8b8._instance;
        $88e6e90e7438fc40$export$bff5fc2244f2d8b8._instance = this;
    }
    push(request) {
        this.requests.push(request);
        if (this.requests.length > this.maxLen) this.requests.shift();
    }
    update(url, request) {
        request.dataReceived = (0, $1862358f5c08780c$export$d73bac4e066c2c0c)(request.dataReceived);
        const match = this.requests.find((req)=>req.url === url);
        if (match === undefined) return;
        Object.keys(request).forEach((key)=>{
            match[key] = request[key];
        });
    }
    getFormattedRequests() {
        if (this.requests.length === 0) return "";
        // reverse the requests to display the last request first
        const reversedRequests = this.requests.reverse();
        const formattedRequests = reversedRequests.map((request)=>{
            return `url: ${request.url},<br/>method: ${request.method},<br/>responseCode: ${request?.responseCode},<br/><br/>dataReceived: ${JSON.stringify(request?.dataReceived)}<br/>`;
        });
        return formattedRequests.join("<br/><br/>");
    }
}
const $88e6e90e7438fc40$export$347800b3f539a6bb = 5;
const $88e6e90e7438fc40$export$71b0009a88aa26d5 = new $88e6e90e7438fc40$export$bff5fc2244f2d8b8($88e6e90e7438fc40$export$347800b3f539a6bb);


var $f922d2384f39f650$exports = {};


var $0fede82c7693d76c$exports = {};

$parcel$export($0fede82c7693d76c$exports, "generateUserName", () => $0fede82c7693d76c$export$f44a190ab9f3a8ae);
$parcel$export($0fede82c7693d76c$exports, "isUserMissingProfileInfo", () => $0fede82c7693d76c$export$b72c26d2fcbf8563);
$parcel$export($0fede82c7693d76c$exports, "hasGuestRole", () => $0fede82c7693d76c$export$227b45a9252874e3);
$parcel$export($0fede82c7693d76c$exports, "hasOwnerRole", () => $0fede82c7693d76c$export$ec5d2cf580c2eae7);
$parcel$export($0fede82c7693d76c$exports, "hasCoHostRole", () => $0fede82c7693d76c$export$5abc7ab31ba6db6c);
$parcel$export($0fede82c7693d76c$exports, "hasPropertyManagerRole", () => $0fede82c7693d76c$export$3cb406ed96d154dc);

function $0fede82c7693d76c$export$f44a190ab9f3a8ae(user) {
    if (user.IS_COMPANY && user.COMPANY_NAME) return user.COMPANY_NAME;
    else {
        // User somehow duplicated their first or last name
        if (user.FIRST_NAME.includes(user.LAST_NAME)) return (0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(user.FIRST_NAME);
        else if (user.LAST_NAME.includes(user.FIRST_NAME)) return (0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(user.LAST_NAME);
        return `${(0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(user.FIRST_NAME)} ${(0, $a8b1bbfd45d27b19$export$9a00dee1beb8f576)(user.LAST_NAME)}`;
    }
}
function $0fede82c7693d76c$export$b72c26d2fcbf8563(user) {
    const { ADDRESS: { STREET_NAME: STREET_NAME , STREET_NUMBER: STREET_NUMBER , CITY: CITY , REGION: REGION , COUNTRY: COUNTRY , POSTAL: POSTAL  } , LAST_NAME: LAST_NAME , FIRST_NAME: FIRST_NAME , PHONE: PHONE , IS_COMPANY: IS_COMPANY , COMPANY_NAME: COMPANY_NAME ,  } = user;
    if (!PHONE) return true;
    if (IS_COMPANY && !COMPANY_NAME) return true;
    if (!IS_COMPANY && (!LAST_NAME || !FIRST_NAME)) return true;
    if (!STREET_NAME || !STREET_NUMBER || !CITY || !REGION || !COUNTRY || !POSTAL) return true;
    return false;
}
function $0fede82c7693d76c$export$227b45a9252874e3(user) {
    if (!user.GUEST_PROFILE) return false;
    return Object.keys(user.GUEST_PROFILE).length > 0;
}
function $0fede82c7693d76c$export$ec5d2cf580c2eae7(user) {
    if (!user.OWNER_PROFILE) return false;
    return Object.keys(user.OWNER_PROFILE).length > 0;
}
function $0fede82c7693d76c$export$5abc7ab31ba6db6c(user) {
    if (!user.COHOST_PROFILE) return false;
    return Object.keys(user.COHOST_PROFILE).length > 0;
}
function $0fede82c7693d76c$export$3cb406ed96d154dc(user) {
    if (!user.PROPERTY_MANAGER_PROFILE) return false;
    return Object.keys(user.PROPERTY_MANAGER_PROFILE).length > 0;
}


var $3772bc8a2a076ead$exports = {};
var $af1fe4b9f533818e$exports = {};

$parcel$export($af1fe4b9f533818e$exports, "fetchOptions", () => $af1fe4b9f533818e$export$e12dbb0aa5635c44);
const $af1fe4b9f533818e$var$cookie = "max-age=604800;domain=localhost";
const $af1fe4b9f533818e$var$headers = {
    cookie: $af1fe4b9f533818e$var$cookie
};
const $af1fe4b9f533818e$export$e12dbb0aa5635c44 = Object.freeze({
    credentials: "include",
    headers: $af1fe4b9f533818e$var$headers
});



var $94bea9c74baca230$exports = {};

$parcel$export($94bea9c74baca230$exports, "getStripeToken", () => $94bea9c74baca230$export$34ca5a6f9c4879dc);
const $94bea9c74baca230$var$liveStripeKey = "pk_uQSZwcGigNoQIy236gJGWniMQxM6R";
const $94bea9c74baca230$var$developmentStripeKey = "pk_o7mAMTN418iNKpWeG6tx7wfQryOOm";
const $94bea9c74baca230$export$34ca5a6f9c4879dc = ({ isLive: isLive  })=>{
    return isLive ? $94bea9c74baca230$var$liveStripeKey : $94bea9c74baca230$var$developmentStripeKey;
};


var $6e6c130c2eb56ae9$exports = {};

$parcel$export($6e6c130c2eb56ae9$exports, "getPlacesApiKey", () => $6e6c130c2eb56ae9$export$90777759c38d1113);
// Google Places
const $6e6c130c2eb56ae9$var$developmentPlacesKey = "AIzaSyAY15oigflJTj8IkU-A1d5eCEObUjG3p-Y";
// TODO: confirm this is correct
const $6e6c130c2eb56ae9$var$livePlacesKey = $6e6c130c2eb56ae9$var$developmentPlacesKey;
const $6e6c130c2eb56ae9$export$90777759c38d1113 = ({ isLive: isLive  })=>{
    return isLive ? $6e6c130c2eb56ae9$var$livePlacesKey : $6e6c130c2eb56ae9$var$developmentPlacesKey;
};


var $ff734364b282bb0f$exports = {};

$parcel$export($ff734364b282bb0f$exports, "ownerSignUpLink", () => $ff734364b282bb0f$export$e133652c6b6fd09d);
$parcel$export($ff734364b282bb0f$exports, "guestSignUpLink", () => $ff734364b282bb0f$export$3a0fba9eb73db4da);
$parcel$export($ff734364b282bb0f$exports, "userLogin", () => $ff734364b282bb0f$export$1eb8f48a6d6077d1);
const $ff734364b282bb0f$export$e133652c6b6fd09d = `https://www.alluradirect.com/list/`;
const $ff734364b282bb0f$export$3a0fba9eb73db4da = `https://www.alluradirect.com/signup/`;
const $ff734364b282bb0f$export$1eb8f48a6d6077d1 = "https://www.alluradirect.com/login-guest/";


var $df997e4b7b5aa2bc$exports = {};

$parcel$export($df997e4b7b5aa2bc$exports, "alluraDirectNorthAmericanPhoneNumber", () => $df997e4b7b5aa2bc$export$265082ee0b036192);
$parcel$export($df997e4b7b5aa2bc$exports, "alluraDirectEmail", () => $df997e4b7b5aa2bc$export$2c392436e9a4998c);
$parcel$export($df997e4b7b5aa2bc$exports, "directVacationsEmail", () => $df997e4b7b5aa2bc$export$bda5a63d05e572eb);
$parcel$export($df997e4b7b5aa2bc$exports, "alluraDirect", () => $df997e4b7b5aa2bc$export$25d3ccfb4c78fd42);
$parcel$export($df997e4b7b5aa2bc$exports, "directVacations", () => $df997e4b7b5aa2bc$export$7ea4340112dd52d1);
$parcel$export($df997e4b7b5aa2bc$exports, "mobilePin", () => $df997e4b7b5aa2bc$export$3e5d48eac7ba1656);
$parcel$export($df997e4b7b5aa2bc$exports, "calculateBrandName", () => $df997e4b7b5aa2bc$export$9a831e77a4335eb0);
$parcel$export($df997e4b7b5aa2bc$exports, "calculateBrandEmail", () => $df997e4b7b5aa2bc$export$6131799eafc939c3);
const $df997e4b7b5aa2bc$export$265082ee0b036192 = "1-866-425-5872";
const $df997e4b7b5aa2bc$export$2c392436e9a4998c = "info@alluradirect.com";
const $df997e4b7b5aa2bc$export$bda5a63d05e572eb = "info@directvacations.com";
const $df997e4b7b5aa2bc$export$25d3ccfb4c78fd42 = "alluraDirect";
const $df997e4b7b5aa2bc$export$7ea4340112dd52d1 = "DirectVacations";
const $df997e4b7b5aa2bc$export$3e5d48eac7ba1656 = "47839";
const $df997e4b7b5aa2bc$export$9a831e77a4335eb0 = (isDV)=>isDV ? $df997e4b7b5aa2bc$export$7ea4340112dd52d1 : $df997e4b7b5aa2bc$export$25d3ccfb4c78fd42;
const $df997e4b7b5aa2bc$export$6131799eafc939c3 = (isDV)=>isDV ? $df997e4b7b5aa2bc$export$bda5a63d05e572eb : $df997e4b7b5aa2bc$export$2c392436e9a4998c;


$parcel$exportWildcard($3772bc8a2a076ead$exports, $af1fe4b9f533818e$exports);
$parcel$exportWildcard($3772bc8a2a076ead$exports, $b06bca09715070a3$exports);
$parcel$exportWildcard($3772bc8a2a076ead$exports, $94bea9c74baca230$exports);
$parcel$exportWildcard($3772bc8a2a076ead$exports, $6e6c130c2eb56ae9$exports);
$parcel$exportWildcard($3772bc8a2a076ead$exports, $ff734364b282bb0f$exports);
$parcel$exportWildcard($3772bc8a2a076ead$exports, $df997e4b7b5aa2bc$exports);


$parcel$exportWildcard($37489d2fec791fc9$exports, $72dc1ad4ce2b3683$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $b7f855d1d07bf9f3$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $6690144fb7fdc900$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $1570f69a4dc582c1$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $3a8449e3b3bae2ba$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $be705db4a89c6c13$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $e6d97bb5a9c18d21$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $d20f3f866de7c5f1$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $646a5cfd43bc633a$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $cf9f973b2cd0a971$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $2f84d640f5b2515c$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $a8b1bbfd45d27b19$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $fc7143b5647f4823$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $cc70552020cd30aa$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $3ab84978c22f06d9$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $1ae3977d25cdb37a$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $8cd92771222e682c$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $00bb5d2e544b2c13$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $1dd1ec38008cf543$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $5256ee46813311f1$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $a84b1293d9fa5558$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $83c4c25512facf26$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $4ebca2e3fbd7b3e2$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $bf2829f82ac33726$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $a712f15b2b78b7e9$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $f960865984b13562$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $1862358f5c08780c$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $88e6e90e7438fc40$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $f922d2384f39f650$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $0fede82c7693d76c$exports);
$parcel$exportWildcard($37489d2fec791fc9$exports, $3772bc8a2a076ead$exports);


var $0f0bcf215d4b549c$exports = {};
var $22d075d202e07dff$exports = {};

$parcel$export($22d075d202e07dff$exports, "GuestURLPathsEnum", () => $22d075d202e07dff$export$b2ecdbaca0c57e5d);
let $22d075d202e07dff$export$b2ecdbaca0c57e5d;
(function(GuestURLPathsEnum1) {
    GuestURLPathsEnum1["booking"] = "guest/booking";
})($22d075d202e07dff$export$b2ecdbaca0c57e5d || ($22d075d202e07dff$export$b2ecdbaca0c57e5d = {}));


var $fdfad3bb7c60d81b$exports = {};

$parcel$export($fdfad3bb7c60d81b$exports, "generateGuestBookingPageLink", () => $fdfad3bb7c60d81b$export$743d1c399e763ab1);

const $fdfad3bb7c60d81b$export$743d1c399e763ab1 = ({ baseUrl: baseUrl , bookingId: bookingId  })=>`${baseUrl}/${(0, $22d075d202e07dff$export$b2ecdbaca0c57e5d).booking}/${bookingId}`;


$parcel$exportWildcard($0f0bcf215d4b549c$exports, $22d075d202e07dff$exports);
$parcel$exportWildcard($0f0bcf215d4b549c$exports, $fdfad3bb7c60d81b$exports);




export {$363f6af70c77384a$export$67934ae0be5ada9e as useCustomMessageMutation, $616614d9d4651c1d$export$5809f48c0e16e123 as useBookingGuestExistsQuery, $62a802691632c607$export$315a9b26340f0763 as useBookingQuery, $7cdb244188f67081$export$83801918f1dd84b2 as guestBookingQueryKey, $7cdb244188f67081$export$17635debff393857 as useGuestBookingQuery, $b28bbbf288bb2fb3$export$37bf5e939be3d10f as guestBookingsQueryKeys, $b28bbbf288bb2fb3$export$6af04eb940943d0d as useGuestBookingsQuery, $374209dcfecaa202$export$b04c4b3ec96dce56 as guestPaymentDueQueryKey, $374209dcfecaa202$export$8e780df423e01629 as useGuestPaymentDueQuery, $7bf8dd342faae788$export$719ba319b45cf061 as rentalAgreementSummaryQueryKey, $7bf8dd342faae788$export$b13ad76215175b12 as useRentalAgreementSummaryQuery, $f2f669699f07846a$export$26f60ad45499ead1 as generateBookingQuoteEndpoint, $f2f669699f07846a$export$304258cb53ef9aa3 as generateBookingQuoteQueryKeyDetail, $f2f669699f07846a$export$b432b9b53bfaf1dd as bookingQuoteQueryKey, $f2f669699f07846a$export$2973c71a6ce395f as useBookingQuoteQuery, $0bc40ca8ae52b6bb$export$e7394aeadb66c4b4 as useBookingCancellationQuery, $a714c13918d8ca5b$export$43431d1c7482aabf as useGetCreditsOverviewQuery, $89862bbf0394a4aa$export$bd710b640bc4fa45 as guestBookingsInfiniteQueryKeys, $89862bbf0394a4aa$export$41b8577d0926ead9 as useGuestBookingsInfiniteQuery, $27b49d9012873ecf$export$2092bec22ac4a458 as useGuestNotificationsQueryKeys, $27b49d9012873ecf$export$b373cc7a722a4698 as useGuestNotificationsInfiniteQuery, $a000ed2b98d1b055$export$83c15cdde3bc18b2 as useGuestDismissNotificationsMutation, $b0f838d5b44f66ab$export$42ae2102072fab as useGuestBookingCancellationPolicyObject, $39d3b0fc1156b169$export$b34a244469b3e532 as useGuestBookingCancellationPolicyHTML, $d7bf2ec125c1c282$export$a8e3a42cb8c7b1f0 as guestPropertyQueryKey, $d7bf2ec125c1c282$export$26358f9ea012a247 as useGuestPropertyQuery, $2ad90413c6f0c2b1$export$412f8941319a94ae as useGuestUnavailableDates, $c66030fb6906ecdb$export$b7f0d5387f8fb762 as useOwnerNotificationsQueryKeys, $c66030fb6906ecdb$export$843e98672cf858ea as useOwnerNotificationsInfiniteQuery, $da2dd51e17e61b33$export$73c8238fbf22dcba as useOwnerMobileWalkthroughMutation, $6a726573b91359e1$export$59c65495fb6e5793 as useOwnerDismissNotificationsMutation, $4d249cfc08a921f0$export$35495b639fd2eb12 as useOwnerPropertyLoginMutation, $1402c0a484a6f252$export$fb94651c0721a416 as useOwnerUnavailableDates, $c6d76554d8e1e29d$export$b2849d2da3a2e0fa as usePropertiesQuery, $f648da45e8e76d84$export$45812cc6610fb11 as useOwnerFinancesSummaryQuery, $a38ffcb37f95a152$export$ab5a2ccf22696a5b as useOwnerFinancesTransactionsQuery, $ccee87f383d87bf3$export$6477c4f33d88ece4 as useOwnerFinancesReservationsQuery, $d48a70f9706ee2e2$export$88d20f026bb28a9f as ownerExternalEventsQueryKey, $d48a70f9706ee2e2$export$4f88fb668729a2a6 as useOwnerExternalEventsQuery, $d00676120cc96262$export$d390c8dc0ef1c1de as ownerUnbookableDatesQueryKey, $d00676120cc96262$export$a0007444547f1f2f as useOwnerUnbookableDatesQuery, $65e33642a42747d2$export$f247437efa5dd173 as useOwnerMobileWalkthroughQuery, $4c1d61297d95031f$export$3aa3eabda9a6011 as propertyReviewsInfiniteQueryKey, $4c1d61297d95031f$export$29bea406db5e298b as usePropertyReviewsInfiniteQuery, $8ad86f241ad28bc7$export$10d1544eb8be6d51 as propertyBookingQueryKey, $8ad86f241ad28bc7$export$24675aafedc57d7c as usePropertyBookingQuery, $21bebe11e6996a77$export$ce9cdd12c2a530a0 as generateUpdatedSendValues, $a21b1a44f2f656cf$export$b7b7717fa94cf2f2 as useWalkthroughGuidebookMutation, $30ce8504169fa6b7$export$8601a0af9fe53966 as usePropertySubformMutation, $a5e7a518b63dd2b5$export$deda107c1edcdea4 as useErrorMutation, $f21ebe6183911aea$export$552a2317b4e6a2f0 as useTermsOfServiceQuery, $34ca7670912c6cc0$export$d3892141c8750b9c as useMessageSubjectInfiniteQuery, $075f45b3096494c7$export$1606b956841c586b as userMessageOverviewQueryKeys, $075f45b3096494c7$export$21dbcbd9ba734e84 as useUserMessageOverviewInfiniteQuery, $f5973776ce302c7e$export$886559c3a9a985c0 as userMessageSubjectsQueryKeys, $f5973776ce302c7e$export$85602b57ec5d14ea as useUserMessageSubjectsInfiniteQuery, $156aac85a5b99e55$export$a67c45a28ec49644 as userMessageThreadQueryKeys, $156aac85a5b99e55$export$e8d4e2c458aafaf as useUserMessageThreadInfiniteQuery, $3657bbf543405025$export$dbe0a99d01c5bff0 as generateEditReservationMessage, $3657bbf543405025$export$b26d2362e032fab1 as generateCancelReservationMessage, $1629d937777f52d0$export$3d9d06124536f20 as useUserCreateMessageMutation, $f8c5cddd3f76ba08$export$36482d2dcbe38d19 as useUserMessageMarkAsReadMutation, $965e1643685356ab$export$885f7157479ef947 as useUserUploadProfilePhotoMutation, $5e8aa9a857d42b8f$export$513635a79aae0fb7 as useUserLoginMutation, $6ae600d9fcc74b3e$export$5eb61a3b8edb5a1a as useUserLogoutLuceeMutation, $b7fef110d856d6b3$export$73b670c952acc441 as useUserCreateExpoToken, $4056446910bacec4$export$fe3878a75eeabbad as useUserUpdateExpoToken, $4e2a54ea9d0e29c4$export$3976ce58344f1dfa as useUserPutMutation, $6e5878536e063d8a$export$575e4d5aa4fad33 as useUserCredentialsPutMutation, $af857901a110569f$export$e1d3e038274f49cd as TwilioVerificationChannelEnum, $56754d72d2bf6761$export$6dc0e37052f4ea45 as useTwilioSendCodeMutation, $9586a10a8051110f$export$795df53f186f50fd as useTwilioCheckCodeMutation, $5ed9a20c40ee3c8c$export$8210442e82e33457 as useUserPasswordResetMutation, $3be0ab077497ea85$export$16505e160c92454d as useUserCheckEmailExistsMutation, $54158e5d8ac3a9aa$export$6141e3360eff91bb as useUserCheckEmailTakenMutation, $e81d666e9ab3330a$export$b69a94c2c9e70ac6 as useUnavailableDates, $9ba3881267ff62de$export$aad7a107d20654a8 as useUserMessageContactQuery, $5efb488ac8f43282$export$e4e15d044a2c569e as useUserMessageSubject, $7ca7363463b01d4a$export$ee1c0bbe3aedd554 as useUserMessageUnreadQuery, $bd3a5490fcd3ceba$export$66d3ed5c3fac1540 as userQueryKey, $bd3a5490fcd3ceba$export$68dae0b0cacaa18a as useUserQuery, $157b262af7a409fd$export$64501d246f4befe7 as useUserCheckEmailTaken, $04e57a2246bdbee0$export$81fc3df80b283228 as queryKeyFactory, $d900f4229f04c942$export$ce2cf70c431e0802 as FetchMethods, $5c3888846488886d$export$a1eb5d1bcb4f35a6 as useAppInfiniteQuery, $1980288893925d89$export$b3678598e95ca24f as useAppMutation, $30c1da10c566c284$export$38db90c50e69cb38 as useAppQueries, $db8cb6799be9e216$export$bbc6c3c0724463f0 as useAppQuery, $396bc124d7d12353$export$dad5d7c6ba8790d4 as contextFactory, $581d20e8b41cc3bb$export$a0101e127fc31d1d as QueryContext, $581d20e8b41cc3bb$export$919315ccd62888e6 as useQueryContext, $581d20e8b41cc3bb$export$96e4d538f00fbce1 as QueryContextProvider, $92a2c5a765476c50$export$183e3865afd77c73 as useSelectedToggle, $6a87b8ff1330cbde$export$cbe85ee05b554577 as useToggle, $d5e96504640a735e$export$12fd5f0e9f4bb192 as useDateRangePicker, $2c1ba4272f0dcaed$export$fc83baa36627246e as calculateDisabledAfterDateSelectingEnd, $2c1ba4272f0dcaed$export$441a38b3fd512aa5 as isUnbookableGapBetweenStartAndEnd, $2c1ba4272f0dcaed$export$68f2995330d10b72 as handleDayClick, $2c1ba4272f0dcaed$export$be33aa2c3017344e as calculateDisabledDates, $2c1ba4272f0dcaed$export$9396e56d0eac0c1e as calculateMinNightsDates, $2c1ba4272f0dcaed$export$d89b9b11c568aede as calculateModifiers, $81cae684d7d7e63e$export$e320e9d6fbe30e5a as AccessToUnitFormikForm, $854fa44a86ca5c27$export$d688d54275248905 as accessToUnitFields, $d9623ccf96fc189a$export$f0a7afbc9486c67a as generateAccessToUnitValues, $b8a85190e7afe5ad$export$a8ba56523d2ea31c as amenityEditFields, $555db87d060751cc$export$28cb29761c5547e7 as generateCheckInOutFields, $083131879a09f840$export$63f01bb595c680ca as generateCheckInOutValues, $b23d16d7784d62b4$export$cdb9dcad09c1a4fc as CreateMessageForm, $f986a5115fbb3703$export$c2fa8f45e78599fe as parkingFields, $a66e5e8056e7a4a6$export$21e996c5f62ec17a as generateParkingText, $940b0d6f46dedcd6$export$9aa8745369c34cd9 as generateParkingValues, $92f068d730330618$export$1a09ad6dee82afaa as reservationCancelRequestFormValues, $351adc2ed77e5aaa$export$2756dea28e9c0be1 as reservationEditRequestFormValues, $966e131d61cd5b94$export$ec38efcfa6e2d6b1 as generateCreateMessageSubject, $5b9a33cfff775612$export$bb4d5f87bab450c as SubjectIdentifier, $b952e95babfab6f7$export$bcda4812444b78f0 as useInitializeThread, $2bfde58f7fc010c8$export$9769a567376257e as useMessageContact, $a22795d9ebdb4d5e$export$23283d14ba88685c as useMessageMarkAsRead, $8c58617e230d9bb3$export$83f62d2049f749a9 as useMessageSubject, $9af52121b6f99d2c$export$708108bcb7301ffe as useMessageThread, $590653b23d4e079a$export$1e6df1b5cb017e3c as useUpdateSubjectSelection, $334c34aebb0650e5$export$defe85febe8b728c as messages, $525aff1e51b16df1$export$d290fa47940df19d as email, $525aff1e51b16df1$export$4a21f16c33752377 as boolean, $525aff1e51b16df1$export$759bcd7d78580e80 as MAX_ACCESS_CODE_LENGTH, $525aff1e51b16df1$export$d22eb2ddbe14c2fa as accessCode, $525aff1e51b16df1$export$6bd1d80ada69ee91 as streetName, $525aff1e51b16df1$export$23220bf251c847db as streetNumber, $525aff1e51b16df1$export$733b5a3fd94b8a0d as city, $525aff1e51b16df1$export$142596e469219c06 as country, $525aff1e51b16df1$export$523c0b569236b342 as unit, $525aff1e51b16df1$export$403dd647bdfe7760 as htmlNotRequired, $525aff1e51b16df1$export$6dff77f5fae61e03 as htmlRequired, $525aff1e51b16df1$export$a8ff84c12d48cfa6 as name, $525aff1e51b16df1$export$76e224aa2fb0aee8 as instruction, $525aff1e51b16df1$export$6d59db4903f20f7d as description, $525aff1e51b16df1$export$58ee0ea85d7a10b9 as phone, $525aff1e51b16df1$export$7caa02bc8b4bb640 as messageSchema, $525aff1e51b16df1$export$f4f21ed02b0ddb8f as currency, $525aff1e51b16df1$export$9d07b7162a2ef51b as squareFeet, $525aff1e51b16df1$export$8bc4fdb2734276ba as requiredString, $525aff1e51b16df1$export$d560c7e4a29451c2 as id, $525aff1e51b16df1$export$40d05a9f5a38ed35 as stringID, $525aff1e51b16df1$export$247f2e4dfb5a570d as maxString2500, $525aff1e51b16df1$export$177edaa5df246fe1 as maxString5000, $525aff1e51b16df1$export$4ad30bab37356871 as taxString, $525aff1e51b16df1$export$2da9be4cfdb689b1 as time, $525aff1e51b16df1$export$c350aa5ff2b00d59 as twentyFourHourTime, $525aff1e51b16df1$export$4ea4739d3fef092b as positiveNumber, $525aff1e51b16df1$export$98e628dec113755e as number, $525aff1e51b16df1$export$337ff92ca6ee3450 as minAge, $525aff1e51b16df1$export$128fa18b7194ef as url, $525aff1e51b16df1$export$5bc1108084315903 as addressValidation, $525aff1e51b16df1$export$845ceb08a7321dfe as buttonGroupValidation, $525aff1e51b16df1$export$4dafd644fdb75661 as buttonGroupValidationNotRequired, $525aff1e51b16df1$export$eb7087b8a7df6140 as idNameValidation, $525aff1e51b16df1$export$78791196678f97c0 as numberRegExp, $525aff1e51b16df1$export$93f2e02fd5a45979 as rateGroup, $525aff1e51b16df1$export$3c580663c40cd0ee as suitability, $525aff1e51b16df1$export$78eb4be3c4d50156 as amenityDescription, $525aff1e51b16df1$export$94d73d4ae52fda88 as amenityInstructions, $525aff1e51b16df1$export$5a210025faae1144 as amenitySchema, $525aff1e51b16df1$export$47e3bb754674a243 as numericValidationRegex, $85913e27ce62cabd$export$f4fee419a4a6cfef as accountOwner, $85913e27ce62cabd$export$d3e8ab45a4e662f7 as rentalManagerCoHost, $85913e27ce62cabd$export$cbfa78e5d20f3083 as minPhotos, $85913e27ce62cabd$export$3b2217e45a573556 as photos, $85913e27ce62cabd$export$a11e4d33e3a5bc12 as parkingFormSchema, $85913e27ce62cabd$export$4902baddc787debb as schema, $85913e27ce62cabd$export$4972db2450399ff as generateSchema, $85913e27ce62cabd$export$eef420758b40d13d as formSchemas, $fe808470c36fce96$export$b990f13615ac876e as createReservationSchema, $fe808470c36fce96$export$f05b27fc690ddecb as bookingNotesSchema, $fe808470c36fce96$export$e98af0589a9f86ab as customMessageSchema, $fe808470c36fce96$export$34b0dbd44219be72 as mainPasswordValidation, $fe808470c36fce96$export$7c727d033a0eaea7 as passwordValidation, $fe808470c36fce96$export$48f006aa2603f1a3 as userProfileValidation, $fe808470c36fce96$export$3d76ecefc1f5a25a as loginValidation, $fe808470c36fce96$export$215d1b302f9bc10 as forgotPasswordValidation, $4a0160e1e5b24e49$export$b52c96215ed92eba as bookingStatus, $4a0160e1e5b24e49$export$90b5cb7a2e4b0584 as bookingInfo, $4a0160e1e5b24e49$export$395f71321ad585e0 as reviewRating, $4a0160e1e5b24e49$export$5368f805f6a71f7d as reviewResponses, $4a0160e1e5b24e49$export$5cc20b5323ee05eb as ELIGIBLE_REVIEW, $4a0160e1e5b24e49$export$66d28a7d28bf9a8b as REVIEW, $4a0160e1e5b24e49$export$37743108b2146755 as BOOKING_PROPERTY, $4a0160e1e5b24e49$export$1751cb5a64e5db9 as fullPayment, $4a0160e1e5b24e49$export$71dcb83791b96dd8 as BOOKING_STATUS, $4a0160e1e5b24e49$export$ed8e20ee59aa51cd as CUSTOM_MESSAGE, $4a0160e1e5b24e49$export$1bfde61c4816a533 as SPARSE_BOOKING, $4a0160e1e5b24e49$export$96c2251bdcddf5c0 as FULL_BOOKING, $4a0160e1e5b24e49$export$a6493835bca0af56 as bookingSurcharge, $4a0160e1e5b24e49$export$34792c472deb2d73 as bookingSurchargesTotal, $4a0160e1e5b24e49$export$632feb45bf00dce4 as bookingTax, $4a0160e1e5b24e49$export$e06f6fbc328d469c as BOOKING_GUEST_EXISTS, $2026a49d34582011$export$4eff5337e639f954 as bookingEndpoint, $2026a49d34582011$export$be4ce9f65a783fe3 as bookingQuoteEndpoint, $2026a49d34582011$export$fe72c2cca9c0efc0 as bookingNotesEndpoint, $2026a49d34582011$export$cd47697ca6b0c965 as reviewPublishEndPoint, $2026a49d34582011$export$7a9d8f51f9e82763 as reviewDisputeEndpoint, $2026a49d34582011$export$502a2dc2cf1f85f2 as reviewResponseEndpoint, $2026a49d34582011$export$77dfc151169acd17 as bookingEmailEndpoint, $2026a49d34582011$export$cdb91b539d7cd16 as bookingcustomMessageEndpoint, $2026a49d34582011$export$fa1702fe7cb16046 as generateBookingEmailEndpoint, $2026a49d34582011$export$9e5d0db7a2a8bc81 as generateBookingCancellationDetailEndpoint, $2026a49d34582011$export$cfbf8165a63f0c4d as generateQuoteEndPoint, $2026a49d34582011$export$4eeb9e22ca0d3a6e as generateBookingContactTracingEndpoint, $2026a49d34582011$export$eee602f57fd7f01e as generateBookingNotesEndpoint, $2026a49d34582011$export$dfed71235557e883 as generateBookingPropertyGuidebook, $2026a49d34582011$export$7a3b2809807a6102 as generateBookingPropertyGuidebookBinaryEndpoint, $2026a49d34582011$export$d5f69b706430230d as generateBookingGuestExists, $e50011cc2264e453$export$2bc4caca4304020f as OfferTypeId, $e50011cc2264e453$export$bad0db35ab88c49e as OfferAvailabilityId, $e50011cc2264e453$export$49994c1af420aa3 as OfferDistributionId, $e50011cc2264e453$export$a7235c2404b3ef3c as BookingSourceNameEnum, $e50011cc2264e453$export$27d2d4abb2ec0600 as BookingStatusId, $e50011cc2264e453$export$acada62635fe78e1 as BookingStatusMessage, $e50011cc2264e453$export$bd517647869fdc11 as ReviewStatusId, $e50011cc2264e453$export$42063c1720e69a70 as MessageRecipientIdEnum, $01815dc19ee3b0a7$export$54441444cb96776e as CREDITS_OVERVIEW, $0785fd2fa3fb450c$export$701915a0dac701da as generateCreditsOverviewEndpoint, $0e53b679feffeec8$export$e9e4aa04377fbbf1 as CreditStatusEnum, $0e53b679feffeec8$export$d7a7ebf0e2733568 as CreditReasonGivenEnum, $750a22b60b746a86$export$7c0e341011592005 as GUEST_FORM_INPUTS, $750a22b60b746a86$export$5fb665406055d82b as GUEST_RATING_QUESTION, $750a22b60b746a86$export$9ee85ba694a91cb5 as GUEST_REVIEWS, $750a22b60b746a86$export$a961b100975d0b71 as GUEST_RECOMMENDATION, $750a22b60b746a86$export$eddf2c9e9b100d8d as GUEST_PAYMENT, $750a22b60b746a86$export$cd79cd058442eeaf as GUEST_PAYMENT_INFORMATION, $750a22b60b746a86$export$7aaed169f2f99da as subSection, $750a22b60b746a86$export$4b34da448591ba35 as propertyGuidebook, $750a22b60b746a86$export$4c815afaf397610 as B64_PROPERTY_GUIDEBOOK, $39ac3dd98f21da43$export$431c9b2445140093 as guestEndpoint, $39ac3dd98f21da43$export$2e138290fde57869 as guestBookingAlertsEndpoint, $39ac3dd98f21da43$export$72bd4cd413917ccb as generateGuestAlertsEndpoint, $39ac3dd98f21da43$export$1140a006e21a2af as guestBookingEndpoint, $39ac3dd98f21da43$export$2c49104e238d15af as generateGuestBookingEndpoint, $39ac3dd98f21da43$export$7b673dc6499cd01e as guestBookingCancelEndpoint, $39ac3dd98f21da43$export$6e345928955a18df as generateGuestBookingCancelEndpoint, $39ac3dd98f21da43$export$99bed181fafc76a6 as guestBookingEditEndpoint, $39ac3dd98f21da43$export$ce94d3e3f45206c9 as generateGuestBookingEditEndpoint, $39ac3dd98f21da43$export$51eaaa7aa8c05f0f as guestCancellationPolicyEndpoint, $39ac3dd98f21da43$export$3c28bd43727dc07f as generateGuestCancellationPolicyEndpoint, $39ac3dd98f21da43$export$6a69478a03c4563 as guestContactTracingEndpoint, $39ac3dd98f21da43$export$86c82836f6f2301f as guestBookingDateChangeEndpoint, $39ac3dd98f21da43$export$30f4744ce963faa5 as generateGuestMakePaymentEndpoint, $39ac3dd98f21da43$export$51566d236f9aa0f7 as guestBookingPaymentDueEndpoint, $39ac3dd98f21da43$export$ef97ee06d59623a3 as generateGuestBookingPaymentDueEndpoint, $39ac3dd98f21da43$export$c5b10620a296ea16 as generateGuestBookingPropertyEndpoint, $39ac3dd98f21da43$export$5ae04136437f5f68 as guestBookingPropertyGuidebook, $39ac3dd98f21da43$export$4693b809b5fa3151 as generateGuestPropertyGuidebookEndpoint, $39ac3dd98f21da43$export$89fd8e8460f9468c as generateGuestPropertyGuidebookPDFEndpoint, $39ac3dd98f21da43$export$bc5d06324965f1dc as generateGuestPropertyGuidebookBinaryPDFEndpoint, $39ac3dd98f21da43$export$15b46e351a808b77 as guestBookingReceiptEndpoint, $39ac3dd98f21da43$export$983903b1de00bc23 as generateGuestBookingReceiptEndpoint, $39ac3dd98f21da43$export$94d3fffb03c2e71e as guestRentalAgreementSummaryEndpoint, $39ac3dd98f21da43$export$fa0677fddbd65e5a as generateGuestRentalAgreementSummaryEndpoint, $39ac3dd98f21da43$export$5f323a8e516aa275 as guestBookingReviewEndpoint, $39ac3dd98f21da43$export$98e826c89b6446ba as guestBookingReviewResponseEndpoint, $39ac3dd98f21da43$export$af8fef3389855904 as generateGuestResponseEndPoint, $39ac3dd98f21da43$export$b471e52cfce3d083 as guestBookingUnavailableDatesEndpoint, $39ac3dd98f21da43$export$e1290e9e61b17a4f as generateGuestUnavailableDatesEndpoint, $39ac3dd98f21da43$export$7b8a7ee4a641447b as guestBookingsEndpoint, $39ac3dd98f21da43$export$cef2c5b8f75ddc4c as generateGuestBookingsEndpoint, $39ac3dd98f21da43$export$d09e76381de27946 as guestCredentialsEndpoint, $39ac3dd98f21da43$export$1f26e963002c964e as guestInquiryEndpoint, $39ac3dd98f21da43$export$b022ea80b3aac2c6 as guestFormInputEndpoint, $39ac3dd98f21da43$export$e93b0cf8761da9 as generateGuestFormInputEndPoint, $39ac3dd98f21da43$export$de6d3e112495828d as guestOfferCodeEndpoint, $39ac3dd98f21da43$export$4408ef2ee91572c2 as generateGuestOfferCodeEndpoint, $39ac3dd98f21da43$export$d61bea2c95c3de27 as guestOffersEndpoint, $39ac3dd98f21da43$export$d5fba4666e4d0fd5 as generateGuestOffersEndpoint, $39ac3dd98f21da43$export$41daf929bd7546b7 as guestLoginEndpoint, $39ac3dd98f21da43$export$5e0c7d69936a787e as guestLogoutEndpoint, $39ac3dd98f21da43$export$8ace7b6edaa6c70 as generateGuestNotificationsEndpoint, $39ac3dd98f21da43$export$7c08efd7afb09a9d as guestDismissNotificationsEndpoint, $39ac3dd98f21da43$export$d1b11f0980cad682 as guestPrivacyEndpoint, $39ac3dd98f21da43$export$e1578c6c64ea74cf as guestReferralEndpoint, $39ac3dd98f21da43$export$9e3fb8b6b70fe706 as guestReviewEndpoint, $39ac3dd98f21da43$export$fa4f2fe03d39a121 as generateGuestNewReviewEndpoint, $39ac3dd98f21da43$export$73cdc604d713d437 as generateGuestReviewEndpoint, $39ac3dd98f21da43$export$1fab7db0f6dc6c26 as guestReviewsEndpoint, $39ac3dd98f21da43$export$4b82750e3e6f5ba3 as generateGuestReviewsEndpoint, $39ac3dd98f21da43$export$516bda56c76382f2 as generateGuestEligibleReviewsEndpoint, $2cb2f9f81b60bd28$export$1dfe3596f01a6818 as GuestBookingType, $a0dadd11ddbce2fa$export$5a4d64e2180a6290 as OWNER_PROPERTY, $a0dadd11ddbce2fa$export$9dc3be2508590a3f as OWNER_MEMBERSHIP_RENEWAL_INFO, $a0dadd11ddbce2fa$export$f6fdede527e71805 as FINANCES_SUMMARY, $a0dadd11ddbce2fa$export$3a455dba4bacf2b3 as OWNER_FINANCES_SUMMARY, $a0dadd11ddbce2fa$export$2f94c4bfe0d2a50b as OWNER_FINANCES_TRANSACTION, $a0dadd11ddbce2fa$export$ea2a6ae4406bcf0f as OWNER_FINANCES_TRANSACTIONS, $a0dadd11ddbce2fa$export$ca481cf93f0d7b92 as OWNER_FINANCES_RESERVATIONS_COLUMN, $a0dadd11ddbce2fa$export$8a15c95a839b21c9 as OWNER_FINANCES_RESERVATIONS_TRANSACTION, $a0dadd11ddbce2fa$export$629a0b7af9255c29 as OWNER_FINANCES_RESERVATIONS, $a0dadd11ddbce2fa$export$8496c5f968947514 as OWNER_MINIMAL_PROPERTY, $a0dadd11ddbce2fa$export$fcdc7aa9f5d55a0b as OWNER_EXTERNAL_EVENTS, $a0dadd11ddbce2fa$export$46a4f4f4150f5ae8 as OWNER_BLOCKED_DATE, $a0dadd11ddbce2fa$export$a1e9de10f2223e1 as OWNER_MIN_NIGHT_GAP, $a0dadd11ddbce2fa$export$b1b2a7738ba72081 as OWNER_UNBOOKABLE_DATES, $a0dadd11ddbce2fa$export$fe3883e595a80bf3 as OWNER_MOBILE_WALKTHROUGH, $0c891e3f27143fe8$export$ed8d54e9436be243 as ownerContactAlluraEndpoint, $0c891e3f27143fe8$export$7979dca97c4a09b as ownerCredentialsEndpoint, $0c891e3f27143fe8$export$c770570593a173d0 as ownerLoginEndpoint, $0c891e3f27143fe8$export$2a393b37f8b198ee as ownerLogoutEndpoint, $0c891e3f27143fe8$export$9235c67a4f2b682d as ownerMobileWalkthroughEndpoint, $0c891e3f27143fe8$export$81924240aba23827 as ownerPutEndpoint, $0c891e3f27143fe8$export$f07044789965acd3 as ownerReferalEndpoint, $0c891e3f27143fe8$export$a58d3a8266032e2d as requestPropertyDeactivationEndPoint, $0c891e3f27143fe8$export$cbb6979bebb9c571 as ownerPropertyLoginEndpoint, $0c891e3f27143fe8$export$62fddebcf9c8ee80 as ownerPropertyCreateEndpoint, $0c891e3f27143fe8$export$17c44cdd06f5526a as generateOwnerGuestsEndpoint, $0c891e3f27143fe8$export$ee629c1d04058cc1 as generateOwnerMobileWalkthroughEndpoint, $0c891e3f27143fe8$export$290bc0139a69679c as generatePriorityBookingsEndpoint, $0c891e3f27143fe8$export$c9fca87eceae683d as membershipRenewalInfo, $0c891e3f27143fe8$export$3a91b6c05252a0f5 as renewalTransaction, $0c891e3f27143fe8$export$8165800ff7472bbe as generateOwnerNotificationsEndPoint, $0c891e3f27143fe8$export$f64735ab134c9251 as ownerDismissNotificationsEndpoint, $0c891e3f27143fe8$export$a08e46af354b77bc as generateOwnerPropertiesEndPoint, $0c891e3f27143fe8$export$804d8d9adcc0aed5 as generateOwnerBookingsEndpoint, $0c891e3f27143fe8$export$5402b107bf6810ed as generateOwnerFinancesSummaryEndpoint, $0c891e3f27143fe8$export$560d9adc42c6c267 as generateOwnerFinancesTransactionsEndpoint, $0c891e3f27143fe8$export$9c2202ac817af1a4 as generateOwnerFinancesReservationsEndpoint, $0c891e3f27143fe8$export$aa9620ac32411108 as generateOwnerFinancesReservationsCsvEndpoint, $0c891e3f27143fe8$export$4325e7de7bbf5f05 as generateOwnerFinancesTransactionsCsvEndpoint, $0c891e3f27143fe8$export$44786126ffe5dc29 as generateOwnerExternalBookingsEndpoint, $0c891e3f27143fe8$export$21f5d1e2f3030631 as generateOwnerUnbookableDates, $ed812675660d38b0$export$a51e0bba10c55da3 as MobileWalkThroughNameEnum, $15a2617ecf5a74eb$export$35a3cbb56db24637 as initialFormInputs, $4c2910318d75849f$export$7b9501c439aced6c as ResortIdEnum, $4c2910318d75849f$export$e8f93f3aa2f4c8a4 as PartnerIdEnum, $4c2910318d75849f$export$b3c0ba35fe2b3a94 as CancellationPolicySpecicalCircumstanceIDEnum, $4c2910318d75849f$export$2ecac916542a0065 as SearchFilterSourceEnum, $4c2910318d75849f$export$a7e77b20da627286 as SearchFiltersSortEnum, $4c2910318d75849f$export$b257d594d204b130 as SearchFiltersStatusEnum, $4c2910318d75849f$export$c8de32477f2ff66f as AccessCodeTypeIDEnum, $4c2910318d75849f$export$2d4a0ecba6f74b61 as AccessMethodIdEnum, $4c2910318d75849f$export$a0dd5d6028487596 as AccessCodeIdEnum, $7e76d0d187f06940$export$e65672f8de2d64be as RATES_SETTINGS, $7e76d0d187f06940$export$2fc451ae562d804e as ACCESS_TO_UNIT, $7e76d0d187f06940$export$ee59cd75d3b30515 as SURCHARGE, $7e76d0d187f06940$export$6c09499d8eae7f1b as PROPERTY_SURCHARGES, $7e76d0d187f06940$export$6321771034ce0c0 as ITN_INFORMATION, $7e76d0d187f06940$export$6bcbaf56c80d335 as NON_RESIDENT, $7e76d0d187f06940$export$fcb478d7c9a12a2f as PROPERTY_CODES, $7e76d0d187f06940$export$294ddf93b115efd1 as PROPERTY_RULES, $7e76d0d187f06940$export$d9095763ed98a14d as initialPropertyState, $7e76d0d187f06940$export$64e4c5bc204b3918 as calendarEvent, $7e76d0d187f06940$export$39d988428beabf9e as sparseRate, $7e76d0d187f06940$export$7e60fbbaddc2b50e as sparseSeason, $7e76d0d187f06940$export$f55a6e090601daf0 as calendarDate, $7e76d0d187f06940$export$d2bbe34cae8c0cf7 as reservationDetails, $7e76d0d187f06940$export$ce3060be2c5fec9b as initialLastAndNextGuest, $7e76d0d187f06940$export$13cdc582138f1c6d as BANK_DEPOSITS, $7e76d0d187f06940$export$1bb2cdf36fcdc8c9 as UNAVAILABLE_DATES, $7e76d0d187f06940$export$5857866d21813cda as PHOTO, $7e76d0d187f06940$export$e8c211579d62c131 as PROPERTY_DEFAULT_CONTENT, $7e76d0d187f06940$export$d4e877b8d445a3e1 as EXTERNAL_EVENT, $7e76d0d187f06940$export$60faf8ebe46b9581 as PROPERTY_REVIEWS, $7e76d0d187f06940$export$498fe3de1de7bf1a as RATE_SUGGESTION, $7e76d0d187f06940$export$f28016d2cadf8c20 as RATE_SUGGESTIONS, $7e76d0d187f06940$export$fade679d0da51bb1 as RATE_SCHEDULE_GENERATE_OPTIMIZE, $7e76d0d187f06940$export$e0ba6e5e6a1e98b1 as RATE_SCHEDULE_GENERATE_INSIGHT, $e15de41ca5b185e2$export$aadd5873ed3eb0a9 as additionalContactEndpoint, $e15de41ca5b185e2$export$3303ec1fdff02a79 as bookingsFilteredEndPoint, $e15de41ca5b185e2$export$1adac3ffd69c52c4 as bookingsPaginatedEndPoint, $e15de41ca5b185e2$export$ef60b8f88a5bae47 as calendarDatesEndpoint, $e15de41ca5b185e2$export$9d51734ff699182c as cancellationPoliciesEndpoint, $e15de41ca5b185e2$export$63dc1bc5f6311c25 as checkinEmailPreviewSendEndpoint, $e15de41ca5b185e2$export$165758497584710c as contentEndpoint, $e15de41ca5b185e2$export$8a21b744be4eceec as directVacationLogoEndpoint, $e15de41ca5b185e2$export$d906595e68b25fbc as directVacationSubdomainEndpoint, $e15de41ca5b185e2$export$944ab5648f9de932 as externalUrlsEndpoint, $e15de41ca5b185e2$export$6da8321ca4a496ec as formEndpoint, $e15de41ca5b185e2$export$1e71601f89ebe16e as instructionsEndpoint, $e15de41ca5b185e2$export$9eb82b7824e5dd04 as photoSortEndpoint, $e15de41ca5b185e2$export$3c2c60a58101835d as photosEndpoint, $e15de41ca5b185e2$export$7bee553f09f3bac1 as propertyAmenityEndpoint, $e15de41ca5b185e2$export$fb417a0ab4848855 as propertyBlockoffEndpoint, $e15de41ca5b185e2$export$cddb2a04459beb7b as propertyDefaultContentEndpoint, $e15de41ca5b185e2$export$f3a6164b81299928 as propertyWalkthroughGuidebookEndpoint, $e15de41ca5b185e2$export$68b9f535dd6d354c as propertyICalEndpoint, $e15de41ca5b185e2$export$7fff7d6ded248882 as propertyNonResidentEmail, $e15de41ca5b185e2$export$d4e84423c6d944da as propertyPoliciesEndpoint, $e15de41ca5b185e2$export$b845c70a33b15f42 as propertyRateGroupEndpoint, $e15de41ca5b185e2$export$79b83e54141a5fed as propertyRatesScheduleGenerateEndpoint, $e15de41ca5b185e2$export$d5bcdfe94d5c1562 as propertyTransactionsEndpoint, $e15de41ca5b185e2$export$7fa125c30efe2e4d as propertyVideosEndpoint, $e15de41ca5b185e2$export$17b51878a0a31c87 as rateScheduleEndpoint, $e15de41ca5b185e2$export$250c9f01051e965c as rentalAgreementSummaryEndpoint, $e15de41ca5b185e2$export$121d7a716be5f06e as resendSubscriptionReceiptEndPoint, $e15de41ca5b185e2$export$58e0cb00f24cc8f3 as reservationRequestEndpoint, $e15de41ca5b185e2$export$4f25634e4176fe8a as reservationSettings, $e15de41ca5b185e2$export$f72fb329c420e262 as season, $e15de41ca5b185e2$export$eaf7e24ac4a8bddc as subformEndpoint, $e15de41ca5b185e2$export$cbc18e2f0f3c422f as generateBookingsFilteredEndpoint, $e15de41ca5b185e2$export$ea291c08a781f86d as generatePropertyGuidebookEndpoint, $e15de41ca5b185e2$export$677d92663e6c9702 as generatePropertyGuidebookPDFEndpoint, $e15de41ca5b185e2$export$f38251b9cee2c092 as generateLegacyCheckInHTML, $e15de41ca5b185e2$export$d7daed75cabb6158 as generateBookingReservationEndpoint, $e15de41ca5b185e2$export$b1a019ef0b9d9c55 as generateRateScheduleRateGroup, $e15de41ca5b185e2$export$b4f7dd00106f4e45 as generateRateScheduleInsight, $e15de41ca5b185e2$export$508b48b1fca2233e as rateScheduleOptimizeEndpoint, $e15de41ca5b185e2$export$b6332f8545187af as generatePropertyCodesEndpoint, $e15de41ca5b185e2$export$f5000ba6800436e4 as generatePropertyRatesScheduleGenerateEndpoint, $e15de41ca5b185e2$export$d05cf022d0ab7576 as generatePhotosEndPoint, $e15de41ca5b185e2$export$f3777fcf4347a5e4 as generateFormInputEndpoint, $e15de41ca5b185e2$export$58ed2e7b62cd77df as generateBookingsPaginatedEndPoint, $e15de41ca5b185e2$export$e6c967c7a3157c17 as generateExternalEventsEndPoint, $e15de41ca5b185e2$export$5da7f2af0f6f2866 as generateResyncICalEndPoint, $e15de41ca5b185e2$export$d439d8afdae174fa as generatePropertyEndPoint, $e15de41ca5b185e2$export$9f5725612a8acbef as generatePropertyEndPointQuery, $e15de41ca5b185e2$export$2392f883c0d42e50 as generatePropertyNotificationsEndPoint, $e15de41ca5b185e2$export$53e102228cc1a763 as propertyDismissNotificationsEndpoint, $e15de41ca5b185e2$export$f7e2a9deba265545 as generatePropertyDismissNotificationEndpoint, $e15de41ca5b185e2$export$a707cd72801d58c1 as generateReviewsEndPoint, $e15de41ca5b185e2$export$21b9e07c53b03d0a as generateActivationEndPoint, $e15de41ca5b185e2$export$faaf651cb1c1cc08 as generateUnavailabilityEndpoint, $e15de41ca5b185e2$export$9b59b882fec09fbc as generateLastAndNextGuestEndpoint, $e15de41ca5b185e2$export$7acf4e877f505419 as generateBankDepositsEndPoint, $e15de41ca5b185e2$export$d7e2dae541011158 as generatePropertyDefaultContentEndpoint, $e15de41ca5b185e2$export$19b0adbfaded7879 as generateExternalUrlsEndpoint, $e15de41ca5b185e2$export$be31c437417f9eea as generateCheckInEmailPreviewEndpoint, $e15de41ca5b185e2$export$383708ed9a9d0e95 as generateRentalAgreementSummaryEndpoint, $e15de41ca5b185e2$export$e4bd279bd004f6f3 as generateCalendarEventsEndpoint, $e15de41ca5b185e2$export$76a91356b9c78084 as generateCalendarDatesEndpoint, $e15de41ca5b185e2$export$7838eaf7de460919 as generateReservationRequest, $e15de41ca5b185e2$export$42e2d76e5fe1e90d as generateRateSuggestionEndpoint, $e15de41ca5b185e2$export$c3c8c105fac41d59 as generatePropertyBlockoffsEndpoint, $f58c18151396e867$export$7a61fe57c08abf60 as BedroomTypeIDEnum, $f58c18151396e867$export$2d343ad99964f7c as EventTypeEnum, $f58c18151396e867$export$aa113f941bb73d74 as JoinStatusIDEnum, $f58c18151396e867$export$eb581bc54c390a17 as PropertySubscriptionTierIdEnum, $f58c18151396e867$export$4fd94061e730ad38 as RatesSettingsWeekendPremiumId, $f58c18151396e867$export$437476ba8a9c4308 as RatePropertySettingEnum, $f58c18151396e867$export$85d9e2b1f34611d7 as RateAvailabilityIdEnum, $f58c18151396e867$export$1d0378704cdd8de7 as RateGroupTypesIdEnum, $f58c18151396e867$export$c16066753dac818b as SeasonType, $f58c18151396e867$export$52635478f64a5a51 as SurchargeId, $f58c18151396e867$export$3fea48cce2b57a8b as BookingGateWayModeIdEnum, $f58c18151396e867$export$3920d96caa2fc27e as PropertyFeesIdEnum, $f58c18151396e867$export$7b9c01e6e4bc49c6 as PropertyDefaultContentTypes, $f58c18151396e867$export$b465bf62bb901487 as GenerateRateMode, $f58c18151396e867$export$c51b307d7f17f9e8 as PropertyInstructionsEnum, $f58c18151396e867$export$9a5f53ec1a50b124 as RateInsightLevelIdEnum, $f58c18151396e867$export$eff54ef88b94774d as PricingStrategyEnum, $f58c18151396e867$export$92ac1597760befe6 as GuidebookWizardFormNamesEnum, $f58c18151396e867$export$13d65d67292f85af as PlatformListedId, $f4b19c2cf783eed0$export$8ca6c3dfab1d4e7f as generatePropertyTransactionsParameters, $af33674cdb61992e$export$37c8f1bc2ef2e9b9 as UserRoleIDEnum, $af33674cdb61992e$export$e05722a566bbc7bd as UserTypeEnum, $af33674cdb61992e$export$629a479ee61a4b1c as UserMessageType, $3b54348c5bf92caa$export$97e2f39d4877deae as userPutEndpoint, $3b54348c5bf92caa$export$7119b2a4f38d2087 as userEndpoint, $3b54348c5bf92caa$export$fb9bc9df7f34e09f as userCredentialsEndpoint, $3b54348c5bf92caa$export$99c2d64e1a90b7df as userLoginEndpoint, $3b54348c5bf92caa$export$11facad7913bda02 as userPasswordSyncEndpoint, $3b54348c5bf92caa$export$30289506872908c9 as userProfilePhotoEndpoint, $3b54348c5bf92caa$export$2655fe4540b8b94e as userMessageEndpoint, $3b54348c5bf92caa$export$a77d5295244c0a1c as twilioSendCodeEndpoint, $3b54348c5bf92caa$export$27f9c16834747437 as twilioSendCodeEndpointCheck, $3b54348c5bf92caa$export$877778df9bf039fc as userPasswordResetEndpoint, $3b54348c5bf92caa$export$349b71c505d5f05 as generateUserProfilePhotoEndpoint, $3b54348c5bf92caa$export$e728a9a3f4a78bd6 as generateUserMessageUnreadEndpoint, $3b54348c5bf92caa$export$ca1429d0689bce78 as userMessageMarkAsReadEndpoint, $3b54348c5bf92caa$export$265b5cd3b0e616c2 as generateUserMessageContactEndpoint, $3b54348c5bf92caa$export$18a10673c8c4007 as generateUserMessageSubjectEndpoint, $3b54348c5bf92caa$export$b6c148a6971eb44b as generateUserMessageSubjectsEndpoint, $3b54348c5bf92caa$export$73e2fb10e909740c as generateUserMessageOverviewEndpoint, $3b54348c5bf92caa$export$529514ed8c56265c as generateUserMessageThreadEndpoint, $3b54348c5bf92caa$export$d69cdda500787bd6 as userExpoTokenEndpoint, $3b54348c5bf92caa$export$ebb0629ebb761139 as generateUserCheckEmailTaken, $3b54348c5bf92caa$export$e9ae87c929cf0520 as generateUserCheckEmailExists, $de872e06841c454e$export$b27d988044282929 as GUEST_PROFILE, $de872e06841c454e$export$dc285ff9a92ba8b0 as OWNER_PROFILE, $de872e06841c454e$export$6c893ebd2bfba6be as PROPERTY_MANAGER_PROFILE, $de872e06841c454e$export$a7ce0630542bae82 as COHOST_PROFILE, $de872e06841c454e$export$ff09b90989b21a8 as USER, $de872e06841c454e$export$145c04625c32c6f3 as MESSAGE, $de872e06841c454e$export$4d6cb86fc4b48362 as MESSAGE_BOOKING, $de872e06841c454e$export$3d9fef5d7039bac2 as MESSAGE_PROPERTY, $de872e06841c454e$export$5d5414ba339996bd as MESSAGE_CONTACT, $de872e06841c454e$export$62d0a6d9a23c818 as USER_LOGIN, $de872e06841c454e$export$901f69c43e4f0a63 as GUEST_OWNER_LOGIN, $de872e06841c454e$export$dfe369a01c7032f4 as USER_MESSAGE_SUBJECT, $de872e06841c454e$export$6755bfb67f26df31 as USER_MESSAGE_OVERVIEW, $de872e06841c454e$export$41a1bfdc55d0c02a as MESSAGE_THREAD, $de872e06841c454e$export$78f74086b8e7868a as MESSAGE_UNREAD_COUNT, $7c2cdfac8d14e30c$export$35c5726ddc6b8970 as defaultLocationURLParams, $7c2cdfac8d14e30c$export$b3606ef5d5040c9c as generateOwnerLocationEndPoint, $7c2cdfac8d14e30c$export$e325af78336489eb as generateGuestLocationEndPoint, $7c2cdfac8d14e30c$export$8f4c3ade4819c760 as errorsEndPoint, $7c2cdfac8d14e30c$export$9b362cc650f43180 as generateCancellationPolicyEndpoint, $7c2cdfac8d14e30c$export$ccdd533040c6e3b3 as generateTermsOfServiceAgreementEndpoint, $80436cd706766ba7$export$f7d3c097ceca6c15 as address, $80436cd706766ba7$export$719efbeb97b07aa7 as amenity, $80436cd706766ba7$export$93fb9aa9532d819b as CANCELLATION_POLICY, $80436cd706766ba7$export$2adf6238a2d0dafa as notification, $80436cd706766ba7$export$d6f542c4004796a7 as NOTIFICATION_ENDPOINT_RESPONSE, $80436cd706766ba7$export$97035b66a86bacc7 as BLACKOUT_PERIOD, $80436cd706766ba7$export$997e912fc8340bdc as OFFER, $80436cd706766ba7$export$384165d01427152e as tax, $80436cd706766ba7$export$b3d999cb855c93d9 as taxSurcharge, $80436cd706766ba7$export$f3e08cf4c2119893 as contactTracingGuest, $80436cd706766ba7$export$fa086120b3c0f2a as surchargeTaxItem, $80436cd706766ba7$export$c778997df97e7eb9 as taxItem, $80436cd706766ba7$export$1f1fdc5cd5eff57 as BOOKING_SURCHARGES_LIST, $80436cd706766ba7$export$b7ebbc687a55d27 as BOOKING_SURCHARGES, $80436cd706766ba7$export$82cefcd67fde3934 as DIRECT_VACATIONS, $80436cd706766ba7$export$20abdeb7a4a80414 as propertyGuidebookPDF, $80436cd706766ba7$export$bd9a90e1c91075e7 as propertyOwner, $80436cd706766ba7$export$a17702445465e88 as propertyRules, $80436cd706766ba7$export$57f3f1ee6c8aba33 as serviceFee, $80436cd706766ba7$export$595ec8374a0e527f as accommodationTaxItem, $80436cd706766ba7$export$23542f496ff490c6 as totalsPaid, $80436cd706766ba7$export$b204ab576813c92b as serviceFeeTaxItem, $80436cd706766ba7$export$2d62d2646dd2fb3c as transaction, $80436cd706766ba7$export$cd273ef51e695c33 as initialLocationData, $80436cd706766ba7$export$7158a8c2efc7d19a as RESERVATION_SETTINGS, $b9fbf0da9ae592a3$export$7abcfbf1506b8afd as SurchargeIDEnum, $b9fbf0da9ae592a3$export$10e2677d41a27589 as SurchargeNameEnum, $b9fbf0da9ae592a3$export$8690e4d320ed0153 as TaxIDEnum, $b9fbf0da9ae592a3$export$30eb8df08b0ba90a as NotificationCategoriesEnum, $b9fbf0da9ae592a3$export$979471efb8d9682 as NotificationCategoryIdEnum, $b9fbf0da9ae592a3$export$14684659e132560d as NotificationEndpointFilterCategory, $b9fbf0da9ae592a3$export$443a1f41470876f9 as NotificationEndpointFilterStatus, $b9fbf0da9ae592a3$export$6f72bc6ab39ca5cd as NotificationLevelsEnum, $b9fbf0da9ae592a3$export$3e6477125daf98da as DamageDepositModeId, $b9fbf0da9ae592a3$export$6ba288b3069f362 as PropertyTaxIDEnum, $b9fbf0da9ae592a3$export$ca089115c6d1f1f as PropertyAmenityId, $b9fbf0da9ae592a3$export$820ef0da71e57e4b as LocationURLParamsEnum, $b9fbf0da9ae592a3$export$811d140419a2df as ToastVariants, $b9fbf0da9ae592a3$export$ff1b23e7fbed6ad5 as NotificationStatus, $9f770fb655db2e69$export$9dab6df2a66c141e as RequiredSubformsEnum, $9f770fb655db2e69$export$d78bec73c06e8a45 as OptionalSubformsEnum, $ecc92895b268d3ae$export$692bd22b750611f2 as generateAPIResponse, $72dc1ad4ce2b3683$export$59238e610c6e598a as encodeParams, $72dc1ad4ce2b3683$export$672675b98543445b as generateFormData, $72dc1ad4ce2b3683$export$f4336949202e6c0e as generateBodyParams, $72dc1ad4ce2b3683$export$4df535868dd446ac as generateFormDataBodyParams, $72dc1ad4ce2b3683$export$f2e1282f226723ac as generateURLParams, $72dc1ad4ce2b3683$export$bb0ece766f8aad9c as generateParamsString, $72dc1ad4ce2b3683$export$a90bfd0a4ae1116f as flattenApiPages, $b7f855d1d07bf9f3$export$46df769e9e89db18 as HttpResponseCode, $6690144fb7fdc900$export$5d49d615ad5ea2b0 as arrayMove, $6690144fb7fdc900$export$bf8eb9635f3a8a5e as createEmptyArray, $6690144fb7fdc900$export$2fae38c2d7691313 as flattenArray, $1570f69a4dc582c1$export$f91e89d3d0406102 as startOfYear, $1570f69a4dc582c1$export$6e3a72107a4f259a as oneYearInFuture, $3a8449e3b3bae2ba$export$dfbcccfd0b783b29 as convertDateToGMTDate, $3a8449e3b3bae2ba$export$fb38eb2839474437 as handleAddDay, $3a8449e3b3bae2ba$export$ef91e323752a1558 as handleAddDays, $3a8449e3b3bae2ba$export$4f52513b2a0e963e as handleRemoveDay, $3a8449e3b3bae2ba$export$b218f86596dcef41 as daysInCurrentMonth, $3a8449e3b3bae2ba$export$246e2c3053735ba3 as calculateIsDateInPast, $3a8449e3b3bae2ba$export$86745c327318cfef as calculateIsDateBeforeMandatoryGST, $3a8449e3b3bae2ba$export$ce4502cb3021386c as convertDateStringToDate, $3a8449e3b3bae2ba$export$c03bb0116ee09d4b as isValidDate, $3a8449e3b3bae2ba$export$c7544b58e05b90ad as checkIsValidDate, $3a8449e3b3bae2ba$export$7b2837d688734df9 as calculateIsFinalMonthOfData, $3a8449e3b3bae2ba$export$8fc89e286906ac02 as hourOrDayDifferenceString, $3a8449e3b3bae2ba$export$8145d95a6751dce as calculateDayDifference, $3a8449e3b3bae2ba$export$5e38aa4b8ee31f00 as calculateMonthDifference, $3a8449e3b3bae2ba$export$24939cc9aa7cde05 as calculateNights, $3a8449e3b3bae2ba$export$f72884f4f37b25df as numberOfDaysUntil, $3a8449e3b3bae2ba$export$46c8e772a237695f as calculateDifferenceInDays, $3a8449e3b3bae2ba$export$f81342be94e50812 as serverDaysFromToday, $3a8449e3b3bae2ba$export$826220848dd188cb as serverStringFormat, $3a8449e3b3bae2ba$export$e829c2c099c8711a as convert24HourTo12Hour, $3a8449e3b3bae2ba$export$dd2fd71f811b2d7a as parseDOB, $3a8449e3b3bae2ba$export$9e8556f36139d5f6 as convertDateToUTCSeconds, $3a8449e3b3bae2ba$export$7ca0fdd3000f8fb4 as isDayWithinRange, $3a8449e3b3bae2ba$export$eecb2aa703319c46 as isRangeWithinRange, $3a8449e3b3bae2ba$export$74dd93fa2faa7936 as isWeekendDate, $3a8449e3b3bae2ba$export$493c11ff22f45a24 as getRelativeTime, $3a8449e3b3bae2ba$export$2364d538c15eb8db as getDateTime, $3a8449e3b3bae2ba$export$bb0419111572148b as shortMonthDayFormat, $3a8449e3b3bae2ba$export$9dd9ebdffb2edf89 as shortMonthFormat, $3a8449e3b3bae2ba$export$e2addb5d619b4ab1 as longMonthYearFormat, $3a8449e3b3bae2ba$export$167143d4db8c79b7 as longMonthFormat, $3a8449e3b3bae2ba$export$918574f3886b1a3 as longMonthOrdinalFormat, $3a8449e3b3bae2ba$export$996c3039b022a9b1 as shortMonthOrdinalFormat, $3a8449e3b3bae2ba$export$ee82dd2f959db81f as longStringFormat, $3a8449e3b3bae2ba$export$f19b0e4313ec40d5 as handleDateObjToStringYYYMMDD, $3a8449e3b3bae2ba$export$c7ac8b61d985977f as dateFormatShortMonthDay, $3a8449e3b3bae2ba$export$9eaae163d77bc50f as dateFormatDialog, $3a8449e3b3bae2ba$export$863d5be618fefbf3 as dateFormatLong, $3a8449e3b3bae2ba$export$dffa7941d4d22046 as dateFormatLongMonth, $3a8449e3b3bae2ba$export$b724f82ddfaf7047 as dateFormatLongString, $3a8449e3b3bae2ba$export$abe814fcd065a580 as dateFormatMontDay, $3a8449e3b3bae2ba$export$253f51d00c3c150b as dateFormatMonthDayYearDayOfWeek, $3a8449e3b3bae2ba$export$c9efe0c3d34a02f4 as dateFormatMonthYear, $3a8449e3b3bae2ba$export$160d2a3734a06909 as dateFormatServer, $3a8449e3b3bae2ba$export$64486ae5ea8a9faf as dayjsFormatServer, $3a8449e3b3bae2ba$export$68cfbbb172c7e133 as dayjsFormatLongOrdinal, $3a8449e3b3bae2ba$export$757a5dfffbfdba69 as dayjsFormatShortOrdinal, $be705db4a89c6c13$export$1631253861b5faaa as dayjsInitializer, $d20f3f866de7c5f1$export$a4627e546088548d as pipe, $d20f3f866de7c5f1$export$f672e0b6f7222cd7 as compose, $d20f3f866de7c5f1$export$c3095a23b368d1f2 as curry, $646a5cfd43bc633a$export$5b9873fb54d72fd2 as generateNestedComputedValue, $42946e3b52709c65$export$20ffdd11fdaf482a as preferredCountries, $42946e3b52709c65$export$842dcfa371c6bb83 as formatPhoneNumber, $42946e3b52709c65$export$7d7cabaaf96774f6 as handleAddPlusToPhoneNumber, $42946e3b52709c65$export$59bb519ba7fb7201 as formatE164PhoneNumber, $42946e3b52709c65$export$48c6adddc5539199 as parsePhone, $42946e3b52709c65$export$fa0fa8369dbda108 as getAllCountryCallingCodes, $716ed8814bfe0dcf$export$bd210a691f92a7c0 as countryCodeToCountryName, $2f84d640f5b2515c$export$7df8fcd3b12f9ee8 as replaceEmptyRteHtml, $a8b1bbfd45d27b19$export$4025311563f30ab2 as stringNewlinesToBrTags, $a8b1bbfd45d27b19$export$63ad841d70774900 as toDecimal, $a8b1bbfd45d27b19$export$7ad75c69830b76d7 as hasContent, $a8b1bbfd45d27b19$export$6a506b36fdea397d as truncate, $a8b1bbfd45d27b19$export$3ee3e334b3482a86 as handleStripHTML, $a8b1bbfd45d27b19$export$b5bc0899e47379a1 as isStringHTMLString, $a8b1bbfd45d27b19$export$6abce5f3b246f7d4 as handleStripHTMLAndSpaces, $a8b1bbfd45d27b19$export$9a00dee1beb8f576 as capitalize, $a8b1bbfd45d27b19$export$fac90c2fb201ce9e as snakeCaseToSpace, $a8b1bbfd45d27b19$export$cefb40c9962541b5 as pluralize, $a8b1bbfd45d27b19$export$808d468a9674eb92 as generateCountString, $fc7143b5647f4823$export$70a5d58ec00f3c11 as getEnumValues, $fc7143b5647f4823$export$53a940bc3fb087a5 as getEnumKeys, $cc70552020cd30aa$export$9fd647041178316 as generateSelectedSubjectDisplay, $cc70552020cd30aa$export$d0a3c61729499261 as generateReservationSubject, $cc70552020cd30aa$export$294959f885705260 as generateOwnerInquirySubject, $3ab84978c22f06d9$export$d657e21b8af95c32 as generateContactName, $3ab84978c22f06d9$export$32a13a311e5e806b as generateLastMessageSentTime, $3ab84978c22f06d9$export$e5aae6b8ec83cd56 as generateNumberOfUnread, $3ab84978c22f06d9$export$ef6568c2993ad507 as hasNextReservation, $3ab84978c22f06d9$export$6669e59d447fab6d as generateMessageProperty, $1ae3977d25cdb37a$export$b5429876b18fb200 as accessCodeAvailableDate, $1ae3977d25cdb37a$export$1d37ecc503a24cf0 as canViewAccessCode, $1ae3977d25cdb37a$export$6100c6a8725665b2 as accessCodeDueDate, $1ae3977d25cdb37a$export$8f20775108da54a0 as generateAccessCodeDueDate, $1ae3977d25cdb37a$export$fa52415dd5e0de36 as BookingAccessCodeTextEnum, $1ae3977d25cdb37a$export$a60d73e549175f6a as generateBookingAccessCodeText, $1ae3977d25cdb37a$export$3ba7d7616dd02fa8 as generateAccessCodeLabel, $1ae3977d25cdb37a$export$bf0e3c8f9fedf45d as accessToUnitSelectedOptions, $8cd92771222e682c$export$9211131e191c8e49 as transactionText, $8cd92771222e682c$export$45c5eaa443b874a3 as isInflatedBooking, $00bb5d2e544b2c13$export$2afd9b1ceeb4b47a as hasReview, $00bb5d2e544b2c13$export$a77f7b22284c500c as hasMadePayment, $00bb5d2e544b2c13$export$c03719ea1402ca53 as canMakeBookingPayment, $00bb5d2e544b2c13$export$88eb3bff6fa2e050 as hasVisiblePropertyGuideBookBtn, $00bb5d2e544b2c13$export$92cb8878b496952c as isPastReservation, $00bb5d2e544b2c13$export$163a64123f1d1b38 as hasVisibleRebookPropertyBtn, $00bb5d2e544b2c13$export$8db61c631ec8d3f8 as isCurrentReservation, $00bb5d2e544b2c13$export$df9306c109b82fcf as isPendingReservation, $00bb5d2e544b2c13$export$84abfa454a024e78 as canViewPropertyGuidebook, $00bb5d2e544b2c13$export$92e36e617bf84a3a as propertyGuidebookAvailableDate, $00bb5d2e544b2c13$export$c3d2cb8994b81f17 as propertyGuidebookAvailableDateFormatted, $00bb5d2e544b2c13$export$285ef70eda890ef as canGuestRequestToModifyBooking, $00bb5d2e544b2c13$export$14793448d6063e2f as canHostModifyBooking, $00bb5d2e544b2c13$export$2e26257701b2d7e9 as canHostModifyBookingStartDate, $00bb5d2e544b2c13$export$4a354f042bb4c4d5 as canModifyBooking, $00bb5d2e544b2c13$export$b7bb6836101aaebd as confirmationPropertyGuidebookText, $00bb5d2e544b2c13$export$63efa647b73e8b6f as isPaymentButtonVisible, $00bb5d2e544b2c13$export$1706a82848ccea2f as canReviewBooking, $00bb5d2e544b2c13$export$152ed9c66f70fc4a as reservationStatusText, $00bb5d2e544b2c13$export$fe7e2289b41760c9 as balanceText, $00bb5d2e544b2c13$export$9951f6aac3527038 as hasPerGuestMessage, $00bb5d2e544b2c13$export$37d506624894a1c0 as hasCustomEntryCode, $00bb5d2e544b2c13$export$7645fbf75099c025 as hasCustomMessage, $00bb5d2e544b2c13$export$233320293d749da5 as generateCustomMessagePreview, $00bb5d2e544b2c13$export$fc5d1bab0ab8127d as convertBookingServerToParams, $00bb5d2e544b2c13$export$2cbe9b6e6bc0a416 as generateBookingStatusDetails, $00bb5d2e544b2c13$export$530b093149d3ddda as generateSurchargeIds, $00bb5d2e544b2c13$export$e09b0625208a9686 as generateSurchargeData, $00bb5d2e544b2c13$export$7da6b32e5aa90ab6 as calculateIsWithinBalanceDate, $00bb5d2e544b2c13$export$db51906af7c62020 as generateRateQuoteErrorData, $00bb5d2e544b2c13$export$b0d0ff6e9ab3df6e as isDamageDepositCollected, $1dd1ec38008cf543$export$d94eba43f0f0d984 as generateReadableAddress, $5256ee46813311f1$export$1e4708a31779fc93 as propertyHasAmenity, $5256ee46813311f1$export$a8e2caab532cdbe3 as getPropertyAmenity, $5256ee46813311f1$export$d6240ea95b142 as amenityHasInstructions, $5256ee46813311f1$export$c93da72bf23dff0c as amenityHasDescription, $5256ee46813311f1$export$dd028bde6dd8818f as isWifiAmenity, $5256ee46813311f1$export$4c230bf9a3405679 as amenityHasAccessCode, $5256ee46813311f1$export$3537c509f2356f9 as generateAmenity, $a84b1293d9fa5558$export$9f4542f3d753ad0 as PropertyAmenityCategories, $83c4c25512facf26$export$cd1477ab9d657d2b as CreateMessage, $4ebca2e3fbd7b3e2$export$b0a66abe0bb8f2b1 as getMapsKey, $4ebca2e3fbd7b3e2$export$b8790e04d2cac4ac as generateMapsAddressURL, $4ebca2e3fbd7b3e2$export$37085608197d43cc as generateQueryFromAddress, $4ebca2e3fbd7b3e2$export$2e2d7a1b663e2c78 as generateMapsEmbedAddressURL, $bf2829f82ac33726$export$ecf914f6fd16fa4d as editorURLParamsEnum, $bf2829f82ac33726$export$847b7704b594a1c5 as getGuidebookAccessCode, $bf2829f82ac33726$export$dad0e684932e1051 as getGuidebookWifiDetails, $bf2829f82ac33726$export$b6698eb7056ecd11 as hasGuidebookAmenity, $bf2829f82ac33726$export$1143cb93fd115f3c as hasGuidebookWifiAmenity, $bf2829f82ac33726$export$4a3ea29d96f701b7 as getGuidebookDirectionsToProperty, $bf2829f82ac33726$export$ec405dce66c4e156 as guidebookHtmlAsString, $bf2829f82ac33726$export$803a3a733d037788 as isAmenitySkiOrBike, $a712f15b2b78b7e9$export$298b4e731fc0ce2d as EditorFieldEnum, $f960865984b13562$export$861dcb1bd7fa96bf as dashboardLinkStatuses, $f960865984b13562$export$baa8f6924c47a6 as onboardingLinkStatuses, $f960865984b13562$export$c73ffc653310bde9 as calculateIsGatewayOpen, $f960865984b13562$export$5fb9228be1acec1b as calculateIsPremium, $f960865984b13562$export$3f1fe1d96d827505 as calculateIsStandard, $f960865984b13562$export$195de5b68bab1534 as calculateIsActive, $f960865984b13562$export$af8508867d7b4eed as calculateIsDisabled, $f960865984b13562$export$2760acae0a8786ef as calculateIsInactive, $f960865984b13562$export$dce8fd8b9b69dbc1 as calculateIsRequestActivation, $f960865984b13562$export$68435993ea9cf7ab as calculateCanUpgradeToPremium, $f960865984b13562$export$6fccf89dcd2a1725 as calculateIsMigrating, $f960865984b13562$export$c145f7b5edabef1 as calculateIsComplete, $f960865984b13562$export$14f5e0c287eba35f as calculateCanDeactivate, $f960865984b13562$export$97961e9c333d05a1 as defaultPropertyTitle, $f960865984b13562$export$e184c86caa459c6e as generatePropertyTitle, $f960865984b13562$export$df7e1eb037725ce4 as generateStreetNumberNameTitle, $f960865984b13562$export$2bb9fb4da4c31eea as generateDevelopmentUnitTitle, $f960865984b13562$export$fceae0a5274caf6e as generatePropertySubtitle, $f960865984b13562$export$7155dd7e090f6816 as bedroomBathroomDisplay, $f960865984b13562$export$3dafb0fc3dc491c8 as chaletOrHouse, $f960865984b13562$export$76b9cad839afc8c as calculatePropertyUnitNumberDisplay, $f960865984b13562$export$ecd3817b9158ca90 as calculateCanSignIn, $f960865984b13562$export$9e771e51bfacb007 as generatePropertyString, $f960865984b13562$export$7741b297d92354fb as isPropertyInWhistler, $f960865984b13562$export$5c9baa036a7db21b as isPropertyInBigWhite, $f960865984b13562$export$94d3b062bfaac8b5 as hasPropertyContact, $1862358f5c08780c$export$d73bac4e066c2c0c as simplifyData, $88e6e90e7438fc40$export$bff5fc2244f2d8b8 as RequestTracking, $88e6e90e7438fc40$export$347800b3f539a6bb as MAX_REQUESTS_TRACKED, $88e6e90e7438fc40$export$71b0009a88aa26d5 as requestTracking, $0fede82c7693d76c$export$f44a190ab9f3a8ae as generateUserName, $0fede82c7693d76c$export$b72c26d2fcbf8563 as isUserMissingProfileInfo, $0fede82c7693d76c$export$227b45a9252874e3 as hasGuestRole, $0fede82c7693d76c$export$ec5d2cf580c2eae7 as hasOwnerRole, $0fede82c7693d76c$export$5abc7ab31ba6db6c as hasCoHostRole, $0fede82c7693d76c$export$3cb406ed96d154dc as hasPropertyManagerRole, $af1fe4b9f533818e$export$e12dbb0aa5635c44 as fetchOptions, $b06bca09715070a3$export$12157e85073da9e as developmentMapsKey, $b06bca09715070a3$export$67a0a4d6602f5512 as liveMapsKey, $94bea9c74baca230$export$34ca5a6f9c4879dc as getStripeToken, $6e6c130c2eb56ae9$export$90777759c38d1113 as getPlacesApiKey, $ff734364b282bb0f$export$e133652c6b6fd09d as ownerSignUpLink, $ff734364b282bb0f$export$3a0fba9eb73db4da as guestSignUpLink, $ff734364b282bb0f$export$1eb8f48a6d6077d1 as userLogin, $df997e4b7b5aa2bc$export$265082ee0b036192 as alluraDirectNorthAmericanPhoneNumber, $df997e4b7b5aa2bc$export$2c392436e9a4998c as alluraDirectEmail, $df997e4b7b5aa2bc$export$bda5a63d05e572eb as directVacationsEmail, $df997e4b7b5aa2bc$export$25d3ccfb4c78fd42 as alluraDirect, $df997e4b7b5aa2bc$export$7ea4340112dd52d1 as directVacations, $df997e4b7b5aa2bc$export$3e5d48eac7ba1656 as mobilePin, $df997e4b7b5aa2bc$export$9a831e77a4335eb0 as calculateBrandName, $df997e4b7b5aa2bc$export$6131799eafc939c3 as calculateBrandEmail, $22d075d202e07dff$export$b2ecdbaca0c57e5d as GuestURLPathsEnum, $fdfad3bb7c60d81b$export$743d1c399e763ab1 as generateGuestBookingPageLink};
//# sourceMappingURL=module.js.map
